// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/services/web/company.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Activity, ActivityFilters } from "../../types/activity";
import {
  ArtifactCompanyProfile,
  ArtifactCompetitiveAnalysis,
  ArtifactIdea,
  ArtifactRepoSummary,
  ArtifactsList,
  SpecDetails,
  SpecPathsInfo,
} from "../../types/artifacts";
import {
  AttachmentDetails,
  CompanyContextSection,
  companyContextSectionFromJSON,
  companyContextSectionToJSON,
  ExternalLink,
  ExternalLinkPreview,
} from "../../types/attachments";
import {
  Comment,
  CommentAssociations,
  CommentThread,
  RepoResearchComment,
  RepoResearchCommentsByArea,
  RepoResearchCommentsGroupedCounts,
  ThreadWithComments,
} from "../../types/comments";
import {
  CompanyDetails,
  CompanySettings,
  CompanyUser,
  ProjectsViewSettings,
  RoadmapDefaultView,
  UserCompanyInvite,
} from "../../types/company";
import {
  DocumentEntity,
  DocumentInitialInput,
  DocumentType,
  documentTypeFromJSON,
  documentTypeToJSON,
  ProjectDetails,
  ProjectEntity,
  ProjectWithDocs,
  Release,
} from "../../types/documents";
import { Group } from "../../types/grouping";
import {
  AttachConfluenceItem,
  AttachNotionItem,
  CodeResearchOrgMeta,
  ConfluencePageSummary,
  ConfluenceRoot,
  GitProvider,
  gitProviderFromJSON,
  gitProviderToJSON,
  GitRepository,
  GoogleDriveFile,
  GoogleDriveFolder,
  IntegrationInfo,
  IntegrationProperties,
  JiraField,
  LinkedDocumentInfo,
  NotionPageSummary,
  RepoMetadata,
  RepositorySummary,
  SignedLinkTarget,
  TicketProvider,
  ticketProviderFromJSON,
  ticketProviderToJSON,
  WebSiteSummary,
} from "../../types/integrations";
import { DevJob, PendingJob } from "../../types/jobs";
import { PulseDigest, PulseEnrollment, PulseFeedItem } from "../../types/pulse";
import { RunItem } from "../../types/runs";
import { HistoryHeatmapData } from "../../types/stats";
import { Tag } from "../../types/tags";
import { ProjectTemplate } from "../../types/templates";
import { PersonalDigestContext } from "../../types/user";
import { WorkLogItem } from "../../types/worklog";
import { WorkspaceChat, WorkspaceChatDetails } from "../../types/workspace_chats";

export const protobufPackage = "api.devplan.services.web.company";

export enum PlgDomainMatchStatus {
  PLG_DOMAIN_MATCH_STATUS_UNSPECIFIED = 0,
  PLG_DOMAIN_MATCH_STATUS_NONE = 1,
  PLG_DOMAIN_MATCH_STATUS_REQUEST_AVAILABLE = 2,
  PLG_DOMAIN_MATCH_STATUS_REQUEST_PENDING = 3,
  PLG_DOMAIN_MATCH_STATUS_ALREADY_INVITED = 4,
}

export function plgDomainMatchStatusFromJSON(object: any): PlgDomainMatchStatus {
  switch (object) {
    case 0:
    case "PLG_DOMAIN_MATCH_STATUS_UNSPECIFIED":
      return PlgDomainMatchStatus.PLG_DOMAIN_MATCH_STATUS_UNSPECIFIED;
    case 1:
    case "PLG_DOMAIN_MATCH_STATUS_NONE":
      return PlgDomainMatchStatus.PLG_DOMAIN_MATCH_STATUS_NONE;
    case 2:
    case "PLG_DOMAIN_MATCH_STATUS_REQUEST_AVAILABLE":
      return PlgDomainMatchStatus.PLG_DOMAIN_MATCH_STATUS_REQUEST_AVAILABLE;
    case 3:
    case "PLG_DOMAIN_MATCH_STATUS_REQUEST_PENDING":
      return PlgDomainMatchStatus.PLG_DOMAIN_MATCH_STATUS_REQUEST_PENDING;
    case 4:
    case "PLG_DOMAIN_MATCH_STATUS_ALREADY_INVITED":
      return PlgDomainMatchStatus.PLG_DOMAIN_MATCH_STATUS_ALREADY_INVITED;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum PlgDomainMatchStatus");
  }
}

export function plgDomainMatchStatusToJSON(object: PlgDomainMatchStatus): string {
  switch (object) {
    case PlgDomainMatchStatus.PLG_DOMAIN_MATCH_STATUS_UNSPECIFIED:
      return "PLG_DOMAIN_MATCH_STATUS_UNSPECIFIED";
    case PlgDomainMatchStatus.PLG_DOMAIN_MATCH_STATUS_NONE:
      return "PLG_DOMAIN_MATCH_STATUS_NONE";
    case PlgDomainMatchStatus.PLG_DOMAIN_MATCH_STATUS_REQUEST_AVAILABLE:
      return "PLG_DOMAIN_MATCH_STATUS_REQUEST_AVAILABLE";
    case PlgDomainMatchStatus.PLG_DOMAIN_MATCH_STATUS_REQUEST_PENDING:
      return "PLG_DOMAIN_MATCH_STATUS_REQUEST_PENDING";
    case PlgDomainMatchStatus.PLG_DOMAIN_MATCH_STATUS_ALREADY_INVITED:
      return "PLG_DOMAIN_MATCH_STATUS_ALREADY_INVITED";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum PlgDomainMatchStatus");
  }
}

export enum HomeReportPreviewMode {
  HOME_REPORT_PREVIEW_MODE_UNSPECIFIED = 0,
  HOME_REPORT_PREVIEW_MODE_PERSONAL = 1,
  HOME_REPORT_PREVIEW_MODE_WORKSPACE = 2,
  HOME_REPORT_PREVIEW_MODE_ALL = 3,
}

export function homeReportPreviewModeFromJSON(object: any): HomeReportPreviewMode {
  switch (object) {
    case 0:
    case "HOME_REPORT_PREVIEW_MODE_UNSPECIFIED":
      return HomeReportPreviewMode.HOME_REPORT_PREVIEW_MODE_UNSPECIFIED;
    case 1:
    case "HOME_REPORT_PREVIEW_MODE_PERSONAL":
      return HomeReportPreviewMode.HOME_REPORT_PREVIEW_MODE_PERSONAL;
    case 2:
    case "HOME_REPORT_PREVIEW_MODE_WORKSPACE":
      return HomeReportPreviewMode.HOME_REPORT_PREVIEW_MODE_WORKSPACE;
    case 3:
    case "HOME_REPORT_PREVIEW_MODE_ALL":
      return HomeReportPreviewMode.HOME_REPORT_PREVIEW_MODE_ALL;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum HomeReportPreviewMode");
  }
}

export function homeReportPreviewModeToJSON(object: HomeReportPreviewMode): string {
  switch (object) {
    case HomeReportPreviewMode.HOME_REPORT_PREVIEW_MODE_UNSPECIFIED:
      return "HOME_REPORT_PREVIEW_MODE_UNSPECIFIED";
    case HomeReportPreviewMode.HOME_REPORT_PREVIEW_MODE_PERSONAL:
      return "HOME_REPORT_PREVIEW_MODE_PERSONAL";
    case HomeReportPreviewMode.HOME_REPORT_PREVIEW_MODE_WORKSPACE:
      return "HOME_REPORT_PREVIEW_MODE_WORKSPACE";
    case HomeReportPreviewMode.HOME_REPORT_PREVIEW_MODE_ALL:
      return "HOME_REPORT_PREVIEW_MODE_ALL";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum HomeReportPreviewMode");
  }
}

/** Visibility of a chat channel in its provider workspace. */
export enum ChannelVisibility {
  CHANNEL_VISIBILITY_UNSPECIFIED = 0,
  CHANNEL_VISIBILITY_PUBLIC = 1,
  CHANNEL_VISIBILITY_PRIVATE = 2,
  CHANNEL_VISIBILITY_SHARED = 3,
}

export function channelVisibilityFromJSON(object: any): ChannelVisibility {
  switch (object) {
    case 0:
    case "CHANNEL_VISIBILITY_UNSPECIFIED":
      return ChannelVisibility.CHANNEL_VISIBILITY_UNSPECIFIED;
    case 1:
    case "CHANNEL_VISIBILITY_PUBLIC":
      return ChannelVisibility.CHANNEL_VISIBILITY_PUBLIC;
    case 2:
    case "CHANNEL_VISIBILITY_PRIVATE":
      return ChannelVisibility.CHANNEL_VISIBILITY_PRIVATE;
    case 3:
    case "CHANNEL_VISIBILITY_SHARED":
      return ChannelVisibility.CHANNEL_VISIBILITY_SHARED;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ChannelVisibility");
  }
}

export function channelVisibilityToJSON(object: ChannelVisibility): string {
  switch (object) {
    case ChannelVisibility.CHANNEL_VISIBILITY_UNSPECIFIED:
      return "CHANNEL_VISIBILITY_UNSPECIFIED";
    case ChannelVisibility.CHANNEL_VISIBILITY_PUBLIC:
      return "CHANNEL_VISIBILITY_PUBLIC";
    case ChannelVisibility.CHANNEL_VISIBILITY_PRIVATE:
      return "CHANNEL_VISIBILITY_PRIVATE";
    case ChannelVisibility.CHANNEL_VISIBILITY_SHARED:
      return "CHANNEL_VISIBILITY_SHARED";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ChannelVisibility");
  }
}

/** How Teams meeting-transcript ingestion admits meetings. */
export enum TeamsMeetingNotesMode {
  TEAMS_MEETING_NOTES_MODE_UNSPECIFIED = 0,
  TEAMS_MEETING_NOTES_MODE_OFF = 1,
  /**
   * TEAMS_MEETING_NOTES_MODE_ALL_ORG_MEETINGS - Tenant-wide: every calendar-scheduled meeting the tenant's Graph access
   * policy covers (getAllTranscripts subscription).
   */
  TEAMS_MEETING_NOTES_MODE_ALL_ORG_MEETINGS = 2,
  /**
   * TEAMS_MEETING_NOTES_MODE_SELECTED_MEETINGS - Per-meeting consent (RSC): only meetings the Devplan Teams app was
   * explicitly added to.
   */
  TEAMS_MEETING_NOTES_MODE_SELECTED_MEETINGS = 3,
}

export function teamsMeetingNotesModeFromJSON(object: any): TeamsMeetingNotesMode {
  switch (object) {
    case 0:
    case "TEAMS_MEETING_NOTES_MODE_UNSPECIFIED":
      return TeamsMeetingNotesMode.TEAMS_MEETING_NOTES_MODE_UNSPECIFIED;
    case 1:
    case "TEAMS_MEETING_NOTES_MODE_OFF":
      return TeamsMeetingNotesMode.TEAMS_MEETING_NOTES_MODE_OFF;
    case 2:
    case "TEAMS_MEETING_NOTES_MODE_ALL_ORG_MEETINGS":
      return TeamsMeetingNotesMode.TEAMS_MEETING_NOTES_MODE_ALL_ORG_MEETINGS;
    case 3:
    case "TEAMS_MEETING_NOTES_MODE_SELECTED_MEETINGS":
      return TeamsMeetingNotesMode.TEAMS_MEETING_NOTES_MODE_SELECTED_MEETINGS;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum TeamsMeetingNotesMode");
  }
}

export function teamsMeetingNotesModeToJSON(object: TeamsMeetingNotesMode): string {
  switch (object) {
    case TeamsMeetingNotesMode.TEAMS_MEETING_NOTES_MODE_UNSPECIFIED:
      return "TEAMS_MEETING_NOTES_MODE_UNSPECIFIED";
    case TeamsMeetingNotesMode.TEAMS_MEETING_NOTES_MODE_OFF:
      return "TEAMS_MEETING_NOTES_MODE_OFF";
    case TeamsMeetingNotesMode.TEAMS_MEETING_NOTES_MODE_ALL_ORG_MEETINGS:
      return "TEAMS_MEETING_NOTES_MODE_ALL_ORG_MEETINGS";
    case TeamsMeetingNotesMode.TEAMS_MEETING_NOTES_MODE_SELECTED_MEETINGS:
      return "TEAMS_MEETING_NOTES_MODE_SELECTED_MEETINGS";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum TeamsMeetingNotesMode");
  }
}

export enum ContextArea {
  CONTEXT_AREA_UNSPECIFIED = 0,
  CONTEXT_AREA_MEETING_NOTES = 1,
}

export function contextAreaFromJSON(object: any): ContextArea {
  switch (object) {
    case 0:
    case "CONTEXT_AREA_UNSPECIFIED":
      return ContextArea.CONTEXT_AREA_UNSPECIFIED;
    case 1:
    case "CONTEXT_AREA_MEETING_NOTES":
      return ContextArea.CONTEXT_AREA_MEETING_NOTES;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ContextArea");
  }
}

export function contextAreaToJSON(object: ContextArea): string {
  switch (object) {
    case ContextArea.CONTEXT_AREA_UNSPECIFIED:
      return "CONTEXT_AREA_UNSPECIFIED";
    case ContextArea.CONTEXT_AREA_MEETING_NOTES:
      return "CONTEXT_AREA_MEETING_NOTES";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ContextArea");
  }
}

export enum WorkspaceGraphRootType {
  WORKSPACE_GRAPH_ROOT_TYPE_UNSPECIFIED = 0,
  WORKSPACE_GRAPH_ROOT_TYPE_PROJECT = 1,
  WORKSPACE_GRAPH_ROOT_TYPE_FEATURE = 2,
}

export function workspaceGraphRootTypeFromJSON(object: any): WorkspaceGraphRootType {
  switch (object) {
    case 0:
    case "WORKSPACE_GRAPH_ROOT_TYPE_UNSPECIFIED":
      return WorkspaceGraphRootType.WORKSPACE_GRAPH_ROOT_TYPE_UNSPECIFIED;
    case 1:
    case "WORKSPACE_GRAPH_ROOT_TYPE_PROJECT":
      return WorkspaceGraphRootType.WORKSPACE_GRAPH_ROOT_TYPE_PROJECT;
    case 2:
    case "WORKSPACE_GRAPH_ROOT_TYPE_FEATURE":
      return WorkspaceGraphRootType.WORKSPACE_GRAPH_ROOT_TYPE_FEATURE;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum WorkspaceGraphRootType");
  }
}

export function workspaceGraphRootTypeToJSON(object: WorkspaceGraphRootType): string {
  switch (object) {
    case WorkspaceGraphRootType.WORKSPACE_GRAPH_ROOT_TYPE_UNSPECIFIED:
      return "WORKSPACE_GRAPH_ROOT_TYPE_UNSPECIFIED";
    case WorkspaceGraphRootType.WORKSPACE_GRAPH_ROOT_TYPE_PROJECT:
      return "WORKSPACE_GRAPH_ROOT_TYPE_PROJECT";
    case WorkspaceGraphRootType.WORKSPACE_GRAPH_ROOT_TYPE_FEATURE:
      return "WORKSPACE_GRAPH_ROOT_TYPE_FEATURE";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum WorkspaceGraphRootType");
  }
}

export enum WorkspaceGraphPropertyValueType {
  WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_UNSPECIFIED = 0,
  WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_STRING = 1,
  WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_NUMBER = 2,
  WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_BOOLEAN = 3,
  WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_NULL = 4,
  WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_JSON = 5,
}

export function workspaceGraphPropertyValueTypeFromJSON(object: any): WorkspaceGraphPropertyValueType {
  switch (object) {
    case 0:
    case "WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_UNSPECIFIED":
      return WorkspaceGraphPropertyValueType.WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_UNSPECIFIED;
    case 1:
    case "WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_STRING":
      return WorkspaceGraphPropertyValueType.WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_STRING;
    case 2:
    case "WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_NUMBER":
      return WorkspaceGraphPropertyValueType.WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_NUMBER;
    case 3:
    case "WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_BOOLEAN":
      return WorkspaceGraphPropertyValueType.WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_BOOLEAN;
    case 4:
    case "WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_NULL":
      return WorkspaceGraphPropertyValueType.WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_NULL;
    case 5:
    case "WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_JSON":
      return WorkspaceGraphPropertyValueType.WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_JSON;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum WorkspaceGraphPropertyValueType");
  }
}

export function workspaceGraphPropertyValueTypeToJSON(object: WorkspaceGraphPropertyValueType): string {
  switch (object) {
    case WorkspaceGraphPropertyValueType.WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_UNSPECIFIED:
      return "WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_UNSPECIFIED";
    case WorkspaceGraphPropertyValueType.WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_STRING:
      return "WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_STRING";
    case WorkspaceGraphPropertyValueType.WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_NUMBER:
      return "WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_NUMBER";
    case WorkspaceGraphPropertyValueType.WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_BOOLEAN:
      return "WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_BOOLEAN";
    case WorkspaceGraphPropertyValueType.WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_NULL:
      return "WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_NULL";
    case WorkspaceGraphPropertyValueType.WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_JSON:
      return "WORKSPACE_GRAPH_PROPERTY_VALUE_TYPE_JSON";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum WorkspaceGraphPropertyValueType");
  }
}

export enum PlgRewardKind {
  PLG_REWARD_KIND_UNSPECIFIED = 0,
  PLG_REWARD_KIND_GOALS = 1,
  PLG_REWARD_KIND_COMPANY_INFO = 2,
  PLG_REWARD_KIND_COMPOSIO = 3,
}

export function plgRewardKindFromJSON(object: any): PlgRewardKind {
  switch (object) {
    case 0:
    case "PLG_REWARD_KIND_UNSPECIFIED":
      return PlgRewardKind.PLG_REWARD_KIND_UNSPECIFIED;
    case 1:
    case "PLG_REWARD_KIND_GOALS":
      return PlgRewardKind.PLG_REWARD_KIND_GOALS;
    case 2:
    case "PLG_REWARD_KIND_COMPANY_INFO":
      return PlgRewardKind.PLG_REWARD_KIND_COMPANY_INFO;
    case 3:
    case "PLG_REWARD_KIND_COMPOSIO":
      return PlgRewardKind.PLG_REWARD_KIND_COMPOSIO;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum PlgRewardKind");
  }
}

export function plgRewardKindToJSON(object: PlgRewardKind): string {
  switch (object) {
    case PlgRewardKind.PLG_REWARD_KIND_UNSPECIFIED:
      return "PLG_REWARD_KIND_UNSPECIFIED";
    case PlgRewardKind.PLG_REWARD_KIND_GOALS:
      return "PLG_REWARD_KIND_GOALS";
    case PlgRewardKind.PLG_REWARD_KIND_COMPANY_INFO:
      return "PLG_REWARD_KIND_COMPANY_INFO";
    case PlgRewardKind.PLG_REWARD_KIND_COMPOSIO:
      return "PLG_REWARD_KIND_COMPOSIO";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum PlgRewardKind");
  }
}

export interface GetAllProjectDocsResponse {
  documents: DocumentEntity[];
}

export interface GetChildDocsResponse {
  documents: DocumentEntity[];
}

export interface GetDocResponse {
  document: DocumentEntity | undefined;
}

export interface GetCompanyDetailsResponse {
  details?: CompanyDetails | undefined;
}

export interface GetPlgOnboardingDefaultsResponse {
  suggestedWebsite: string;
  requiresManualWebsite: boolean;
  domainMatchStatus: PlgDomainMatchStatus;
  domainMatchUserCount: number;
  domainMatchDomain: string;
}

export interface CreatePlgDomainJoinRequestResponse {
  status: PlgDomainMatchStatus;
}

export interface GetPlgDomainJoinRequestResponse {
  requestId: string;
  requesterEmail: string;
  pending: boolean;
}

export interface ApprovePlgDomainJoinRequestResponse {
  inviteCreated: boolean;
}

export interface GetCompanyResearchReportsResponse {
  companyProfile?: ArtifactCompanyProfile | undefined;
  competitiveAnalysis?: ArtifactCompetitiveAnalysis | undefined;
}

export interface GetHomeReportPreviewStatusRequest {
  mode: HomeReportPreviewMode;
}

export interface StartHomeReportPreviewRequest {
  mode: HomeReportPreviewMode;
}

export interface HomeReportPreviewStatusResponse {
  jobId: string;
  latestRunJson: string;
  error: string;
}

export interface GetDigestHistoryResponse {
  reportsJson: string[];
  workspaceReportsJson: string[];
  personalReportsJson: string[];
  teamReportsJson: string[];
}

export interface GenerateDashboardRequest {
  prompt: string;
}

export interface GetProjectResponse {
  project?: ProjectEntity | undefined;
}

export interface GetIntegrationsResponse {
  infos: LinkedDocumentInfo[];
}

export interface GetIntegrationPropertiesResponse {
  properties?: IntegrationProperties | undefined;
  info?: IntegrationInfo | undefined;
}

export interface GetGitHubManageUrlResponse {
  url?: string | undefined;
}

/** A Slack channel visible to the connected bot. */
export interface SlackChannelView {
  id: string;
  name: string;
  isMember: boolean;
  visibility: ChannelVisibility;
}

export interface ListSlackChannelsResponse {
  channels: SlackChannelView[];
}

/** A Teams channel available for ingestion or outbound delivery. */
export interface TeamsChannelView {
  id: string;
  displayName: string;
  /**
   * Desired ingestion state: a subscription row exists (an admin toggled it on).
   * May be true before the Graph subscription is actually live.
   */
  selected: boolean;
  /**
   * Legacy ingestion-backed delivery signal: the Graph subscription create
   * succeeded and a Bot Framework serviceUrl was captured.
   */
  deliverable: boolean;
  visibility: ChannelVisibility;
  /**
   * True when the bot has enough tenant-level state to attempt an outbound
   * digest post. This is independent of message-ingestion subscriptions.
   */
  deliveryEligible: boolean;
}

export interface TeamsTeamView {
  id: string;
  displayName: string;
  channels: TeamsChannelView[];
}

/**
 * A meeting the Devplan app was added to that could not be attributed to one
 * workspace (multi-workspace tenant, ambiguous installer). Fails closed until
 * a workspace admin claims it.
 */
export interface TeamsPendingMeetingInstall {
  chatId: string;
  installerName: string;
  /** Meeting-chat topic, best-effort; may be empty. */
  title: string;
}

/** Response for listing the tenant's teams + channels for the ingestion picker. */
export interface ListTeamsChannelsResponse {
  teams: TeamsTeamView[];
  /**
   * Whether meeting-transcript ingestion is enabled in any mode (the
   * "Meeting notes" section on the Teams manage page).
   */
  meetingNotesEnabled: boolean;
  meetingNotesMode: TeamsMeetingNotesMode;
  /**
   * Live per-meeting installs (selected-meetings mode): how many meetings the
   * Devplan app is currently added to.
   */
  meetingInstallCount: number;
  /** Unattributed installs this workspace can claim. */
  pendingMeetingInstalls: TeamsPendingMeetingInstall[];
}

/**
 * Claim an unattributed per-meeting install into this workspace (explicit
 * workspace selection for multi-workspace tenants).
 */
export interface ClaimTeamsMeetingInstallRequest {
  chatId: string;
}

export interface ClaimTeamsMeetingInstallResponse {
}

/** Set the ingestion mode for Teams meeting transcripts into meeting notes. */
export interface ToggleTeamsMeetingNotesRequest {
  /** Legacy on/off toggle; used only when mode is unspecified (on = all-org). */
  enabled: boolean;
  mode: TeamsMeetingNotesMode;
}

export interface ToggleTeamsMeetingNotesResponse {
  /**
   * True when ingestion is armed after the toggle. all_org_meetings: the
   * tenant getAllTranscripts Graph subscription is live (false = create failed
   * and was deferred to the renewal job). selected_meetings: always true —
   * ingestion is poll-based per install, there is no tenant subscription.
   */
  subscribed: boolean;
}

/** Toggle Graph change-notification ingestion for a single Teams channel. */
export interface ToggleTeamsChannelRequest {
  teamId: string;
  channelId: string;
  enabled: boolean;
}

export interface ToggleTeamsChannelResponse {
  /**
   * True when a Graph subscription is active after the toggle. When enabling,
   * this may be false if the subscription create failed and was deferred to the
   * renewal job.
   */
  subscribed: boolean;
}

export interface GetCompanyUsersResponse {
  users: CompanyUser[];
}

export interface GetPersonalDigestContextsResponse {
  contexts: PersonalDigestContext[];
}

export interface GetIdeasResponse {
  ideas: ArtifactIdea[];
}

export interface GetRepoSummariesResponse {
  /** Deprecated: leaving for backward compatibility with CLI. */
  summaries: ArtifactRepoSummary[];
  repoSummaries: RepositorySummary[];
  codeResearchMetas: CodeResearchOrgMeta[];
}

export interface GetSitesSummariesResponse {
  siteSummaries: WebSiteSummary[];
}

export interface GetRepoResearchRequest {
  repoId: string;
  provider: GitProvider;
  dirKey: string;
}

export interface GetRepoResearchResponse {
  research?: string | undefined;
}

export interface GetArtifactsListResponse {
  list?: ArtifactsList | undefined;
}

export interface UpsertArtifactsListRequest {
  list: ArtifactsList | undefined;
}

export interface UpsertArtifactsListResponse {
  list: ArtifactsList | undefined;
}

export interface UpsertCommentRequest {
  comment:
    | Comment
    | undefined;
  /** Only taken into account when a comments thread is created. */
  associations?: CommentAssociations | undefined;
}

export interface UpsertCommentResponse {
  thread:
    | ThreadWithComments
    | undefined;
  /** Id of the upserted comment. */
  commentId: string;
}

export interface DeleteCommentRequest {
  id: string;
}

export interface DeleteCommentResponse {
  thread?: ThreadWithComments | undefined;
}

export interface GetThreadCommentsResponse {
  thread?: ThreadWithComments | undefined;
}

export interface UpdateCommentsThreadRequest {
  thread: CommentThread | undefined;
}

export interface UpdateCommentsThreadResponse {
  thread: CommentThread | undefined;
}

export interface GetDocumentCommentThreadsResponse {
  threads: ThreadWithComments[];
}

export interface DeleteUserFromCompanyResponse {
  users: CompanyUser[];
}

export interface UpdateUserCompanyRolesRequest {
  newRoles: string[];
}

export interface UpdateUserCompanyRolesResponse {
  users: CompanyUser[];
}

export interface GetCompanyInvitesResponse {
  invites: UserCompanyInvite[];
}

export interface GetCompanyInvitesForUserResponse {
  invites: UserCompanyInvite[];
}

export interface SendCompanyInvitesRequest {
  emails: string[];
  role: string;
}

export interface SendCompanyInvitesResponse {
  invites: UserCompanyInvite[];
}

export interface DeleteUserCompanyInviteRequest {
  email: string;
}

export interface DeleteUserCompanyInviteResponse {
  invites: UserCompanyInvite[];
}

export interface CreateCompanyRequest {
  company: CompanyDetails | undefined;
  createSeparateForMatchingDomain: boolean;
}

export interface CreateCompanyResponse {
  company: CompanyDetails | undefined;
}

export interface UpsertGroupRequest {
  group: Group | undefined;
}

export interface UpsertGroupResponse {
  group: Group | undefined;
}

export interface GetGroupResponse {
  group?: Group | undefined;
}

export interface ListGroupsResponse {
  groups: Group[];
}

export interface RepositoryMetaActionRequest {
  action: { $case: "reprocess"; value: RepositoryMetaActionRequest_Reprocess } | undefined;
}

export interface RepositoryMetaActionRequest_Reprocess {
  repoId?: string | undefined;
}

export interface RepositoryMetaActionResponse {
}

export interface SelectRepositoriesRequest {
  provider: GitProvider;
  repositoryIds: string[];
}

export interface SelectRepositoriesResponse {
  repositories: GitRepository[];
  newlyEnabledRepositoryIds: string[];
}

export interface GetProjectsWithDocsResponse {
  projects: ProjectWithDocs[];
}

export interface SetProjectArchiveStatusRequest {
  isArchived: boolean;
}

export interface SetProjectArchiveStatusResponse {
  project: ProjectEntity | undefined;
}

export interface ListRepoMetadataResponse {
  metadata: RepoMetadata[];
}

export interface UpdateRepoMetadataRequest {
  metadata: RepoMetadata | undefined;
}

export interface RescanRepoRequest {
}

export interface RescanRepoResponse {
}

export interface RescanSiteRequest {
  url: string;
}

export interface RescanSiteResponse {
}

export interface UpdateRepoMetadataResponse {
  metadata: RepoMetadata | undefined;
}

export interface GenerateProjectNameResponse {
  project: ProjectEntity | undefined;
}

export interface CreateProjectWithRequirementsRequest {
  projectTemplateId: string;
  title?: string | undefined;
  initialInput: DocumentInitialInput | undefined;
  uploadedSpec: boolean;
  description?: string | undefined;
  kind?: string | undefined;
  tagIds: string[];
  /** Optional initial owner user id (stored in ProjectDetails.owner). */
  owner?:
    | string
    | undefined;
  /** Optional initial release id (stored in ProjectDetails.release_id). */
  releaseId?:
    | string
    | undefined;
  /**
   * Optional initial delivery-phase finish date — surfaces as the project's
   * target/delivery date (stored in ProjectDetails.delivery.finish).
   */
  targetDate?:
    | Date
    | undefined;
  /**
   * Optional section key in the workspace projects group. When supplied, the
   * server inserts the new project into that section's childItems atomically as
   * part of the create transaction (instead of relying on the client's default
   * Backlog placement plus a follow-up group update).
   */
  sectionKey?:
    | string
    | undefined;
  /**
   * When true, persist `description` as initial PRD content instead of only using
   * it as project initial input / metadata.
   */
  descriptionAsPrdContent: boolean;
}

export interface CreateProjectWithRequirementsResponse {
  /** Id of the created project */
  projectId: string;
  project?: ProjectEntity | undefined;
}

export interface CreateSignedLinkRequest {
  target: SignedLinkTarget | undefined;
}

export interface CreateSignedLinkResponse {
  /** Id of the created signed link. */
  id: string;
  url: string;
}

export interface CreateEmptyDocumentRequest {
  projectId: string;
  templateId: string;
  title: string;
  type: DocumentType;
  /** If true, then new doc will only be created if the doc with the same template and type doesn't exist yet. */
  unique: boolean;
}

export interface CreateEmptyDocumentResponse {
  document: DocumentEntity | undefined;
}

export interface UpdatePulseEnrollmentRequest {
  enrollment: PulseEnrollment | undefined;
}

export interface UpdatePulseEnrollmentResponse {
  enrollment: PulseEnrollment | undefined;
}

export interface GetPulseEnrollmentRequest {
  companyId: number;
}

export interface GetPulseEnrollmentResponse {
  enrollment: PulseEnrollment | undefined;
}

export interface GetPulseDigestsRequest {
  fromDate: Date | undefined;
  toDate: Date | undefined;
}

export interface GetPulseDigestsResponse {
  digests: PulseDigest[];
}

export interface GetCompanySettingsResponse {
  settings: CompanySettings | undefined;
}

export interface UpdateCodeResearchEnrollRequest {
  enroll: boolean;
}

export interface UpdateCodeResearchEnrollResponse {
  settings: CompanySettings | undefined;
}

export interface SetSpecsEnabledRequest {
  specsEnabled: boolean;
}

export interface SetSpecsEnabledResponse {
  settings: CompanySettings | undefined;
}

/** Request body for saving the company-wide default Roadmap view settings. */
export interface SetRoadmapDefaultRequest {
  roadmapDefault: RoadmapDefaultView | undefined;
}

/**
 * Response containing the updated CompanySettings after saving the company-wide
 * default Roadmap view.
 */
export interface SetRoadmapDefaultResponse {
  settings: CompanySettings | undefined;
}

export interface GetRequiredJiraFieldsRequest {
  jiraProjectKey: string;
  issueType: string;
}

export interface GetRequiredJiraFieldsResponse {
  fields: JiraField[];
}

/** Request for fetching an external link preview */
export interface GetExternalLinkPreviewRequest {
  /** The external link to fetch preview for */
  link: ExternalLink | undefined;
}

/** Response containing external link preview data */
export interface GetExternalLinkPreviewResponse {
  preview?: ExternalLinkPreview | undefined;
}

export interface GetTemplatesRequest {
}

export interface GetTemplatesResponse {
  projectTemplates: ProjectTemplate[];
}

export interface GetDevRuleResponse {
  rule: string;
}

export interface GetDevRecipeResponse {
  /** JSON-serialized recipe. */
  jsonRecipe: string;
}

export interface GetTaskRecipeResponse {
  /** JSON-serialized recipe. */
  jsonRecipe: string;
}

export interface GetUserStoryRecipeResponse {
  /** JSON-serialized recipe. */
  jsonRecipe: string;
}

export interface SubmitWorkLogRequest {
  item: WorkLogItem | undefined;
}

export interface SubmitWorkLogResponse {
  id: string;
}

export interface GetProjectWorkLogEntriesResponse {
  entries: WorkLogItem[];
}

export interface UploadSpecRequest {
  content: string;
  name: string;
  checksum: string;
}

export interface UploadSpecResponse {
  id: string;
}

export interface GetTaskSpecsResponse {
  specs: SpecDetails[];
  pathsInfo: SpecPathsInfo | undefined;
}

export interface StartDevJobRequest {
  job: DevJob | undefined;
}

export interface StartDevJobResponse {
  jobId: string;
}

export interface GetJobStatusRequest {
  jobId: string;
}

export interface GetJobStatusResponse {
  /** Json-serialized codeup job status. */
  statusJson: string;
}

export interface GetTagsResponse {
  tags: Tag[];
}

export interface CreateTagRequest {
  tag: Tag | undefined;
}

export interface CreateTagResponse {
  tag: Tag | undefined;
}

export interface UpdateTagRequest {
  tag: Tag | undefined;
}

export interface UpdateTagResponse {
  tag: Tag | undefined;
}

export interface DeleteTagRequest {
  tagId: string;
}

export interface DeleteTagResponse {
}

export interface GetReleasesResponse {
  releases: Release[];
}

export interface CreateReleaseRequest {
  release: Release | undefined;
}

export interface CreateReleaseResponse {
  release: Release | undefined;
}

/**
 * Patch a release. Each updatable field is independently optional — only
 * fields that are set on the request affect the stored release, so a
 * rename-only PUT won't clobber other state.
 */
export interface UpdateReleaseRequest {
  id: string;
  /** Set to update the name. Absent = leave name unchanged. */
  name?:
    | string
    | undefined;
  /** Set to update the archived flag. Absent = leave unchanged. */
  archived?:
    | boolean
    | undefined;
  /**
   * Set this wrapper to update the target date. Absent (wrapper unset) =
   * leave unchanged. Wrapper set with `value` unset = clear. Wrapper set
   * with `value` populated = set.
   */
  targetDate?:
    | ReleaseTargetDateUpdate
    | undefined;
  /**
   * Set this wrapper to replace the project ordering. Absent = leave
   * unchanged. Wrapper set with empty `project_ids` = clear the order.
   */
  projectOrder?: ReleaseProjectOrderUpdate | undefined;
}

export interface ReleaseTargetDateUpdate {
  value?: Date | undefined;
}

export interface ReleaseProjectOrderUpdate {
  projectIds: string[];
}

export interface UpdateReleaseResponse {
  release: Release | undefined;
}

export interface ArchiveReleaseRequest {
  releaseId: string;
  archived: boolean;
}

export interface ArchiveReleaseResponse {
  release: Release | undefined;
}

export interface FetchJobsRequest {
}

export interface FetchJobResponse {
  jobJson?: string | undefined;
}

export interface FetchJobRunResponse {
  jobJson?: string | undefined;
  jobRunJson?: string | undefined;
  compressedLogs: Uint8Array;
}

export interface FetchJobRunsResponse {
  runsJson: string[];
}

export interface GetProjectsViewSettingsRequest {
  companyId: number;
  viewId: string;
}

export interface GetProjectsViewSettingsResponse {
  settings: ProjectsViewSettings | undefined;
}

export interface UpdateProjectsViewSettingsRequest {
  settings: ProjectsViewSettings | undefined;
}

export interface UpdateProjectsViewSettingsResponse {
  settings: ProjectsViewSettings | undefined;
}

export interface SecretMetadataPayload {
  name: string;
  metadataJson: string;
}

export interface ListSecretsResponse {
  secrets: SecretMetadataPayload[];
}

export interface CreateSecretRequest {
  name: string;
  value: string;
}

export interface CreateSecretResponse {
  secret: SecretMetadataPayload | undefined;
}

export interface UpdateSecretValueRequest {
  secretId: string;
  value: string;
}

export interface UpdateSecretValueResponse {
  secret: SecretMetadataPayload | undefined;
}

export interface DeleteSecretRequest {
  secretId: string;
}

export interface DeleteSecretResponse {
}

export interface RunRepoSetupTestRequest {
  repoFullName: string;
  provider: string;
}

export interface RunRepoSetupTestResponse {
}

export interface PromoteIdeaRequest {
  projectTemplateId: string;
}

export interface PromoteIdeaResponse {
  document: DocumentEntity | undefined;
  warning?: string | undefined;
}

export interface GetRepoResearchCommentsRequest {
  repoId: string;
}

export interface GetRepoResearchCommentsResponse {
  comments: RepoResearchComment[];
  groupedCounts: RepoResearchCommentsGroupedCounts | undefined;
}

export interface CreateRepoResearchCommentRequest {
  comment: RepoResearchComment | undefined;
}

export interface CreateRepoResearchCommentResponse {
  comment: RepoResearchComment | undefined;
}

export interface UpdateRepoResearchCommentRequest {
  comment: RepoResearchComment | undefined;
}

export interface UpdateRepoResearchCommentResponse {
  comment: RepoResearchComment | undefined;
}

export interface DeleteRepoResearchCommentRequest {
  commentId: string;
}

export interface DeleteRepoResearchCommentResponse {
}

export interface DeleteAllRepoResearchCommentsRequest {
}

export interface DeleteAllRepoResearchCommentsResponse {
}

/**
 * Request for generating and uploading repository scan guidance from user feedback
 * (primarily inline comments to research areas).
 */
export interface GenerateAndUpsertRepoResearchGuidanceRequest {
  repoId: string;
  /** Inline comments grouped by research area. */
  commentsByArea:
    | RepoResearchCommentsByArea
    | undefined;
  /** Repository-level comments not attached to specific research area. */
  repoSummaryComments: RepoResearchComment[];
  /** Optional additional general instructions or feedback. */
  additionalInstructions?:
    | string
    | undefined;
  /**
   * When true, delete comments that were processed into this guidance.
   * Default false.
   */
  clearProcessedComments?: boolean | undefined;
}

export interface GenerateAndUpsertRepoResearchGuidanceResponse {
  /** Whether the guidance was successfully uploaded to Codeup. */
  guidanceUploaded: boolean;
  /** Whether the guidance was successfully uploaded to Codeup. */
  commentsDeleted: boolean;
}

export interface GetRepoResearchGuidanceRequest {
  repoId: string;
  provider: GitProvider;
}

export interface GetRepoResearchGuidanceResponse {
  content?: string | undefined;
}

/** Request to upsert guidance content directly */
export interface UpsertRepoResearchGuidanceContentRequest {
  repoId: string;
  content: string;
  provider: GitProvider;
}

export interface UpsertRepoResearchGuidanceContentResponse {
  success: boolean;
}

/** Attachment presign request for direct GCS upload */
export interface AttachmentPresignRequest {
  /** Original filename extension */
  fileExtension: string;
  /** MIME type of the file (e.g., application/pdf, text/markdown) */
  fileType: string;
  /** Size of the file in bytes */
  fileSize: number;
  /** Original file name as uploaded by user */
  originalFileName: string;
  /** Optional user-provided description (primarily for image attachments) */
  userDescription?: string | undefined;
}

/** Attachment presign response with signed URL for direct upload */
export interface AttachmentPresignResponse {
  /** UUID identifier for the attachment */
  attachmentId: string;
  /** Time-limited signed URL for direct PUT upload to GCS */
  signedUrl: string;
}

/** Activity History - Fetch request with filters that can be applied */
export interface FetchActivityRequest {
  filters: ActivityFilters | undefined;
}

/** Activity History - Project-scoped activity feed response */
export interface GetProjectActivityResponse {
  /** List of activity entries for the project */
  activities: Activity[];
  /** Cursor for fetching next page (empty if no more results) */
  nextCursor?: string | undefined;
}

/** Activity History - General activity feed response (cross-entity) */
export interface GetActivityResponse {
  /** List of activity entries */
  activities: Activity[];
  /** Cursor for fetching next page (empty if no more results) */
  nextCursor?: string | undefined;
}

/** Restore document content from activity snapshots */
export interface RestoreActivityRequest {
  lookup:
    | //
    /** one or more explicit activity IDs */
    { $case: "byIds"; value: ActivityIdList }
    | //
    /** all activities in a batch group */
    { $case: "batchId"; value: string }
    | undefined;
}

export interface ActivityIdList {
  ids: string[];
}

/** Response after restoring document content from activity snapshots */
export interface RestoreActivityResponse {
  /** Number of documents successfully restored */
  restoredCount: number;
}

/** Request for listing attachments for a project */
export interface GetProjectAttachmentsRequest {
  /** Project ID to list attachments for */
  projectId: string;
}

/** Response containing list of attachments for a project */
export interface GetProjectAttachmentsResponse {
  /** List of attachments with metadata and download URLs */
  attachments: AttachmentDetails[];
}

/** Request for deleting an attachment */
export interface DeleteAttachmentRequest {
  /** UUID of the attachment to delete */
  attachmentId: string;
}

/** Response for attachment deletion (empty on success) */
export interface DeleteAttachmentResponse {
}

/** Request for getting a download URL for an attachment */
export interface GetAttachmentDownloadUrlRequest {
  /** UUID of the attachment to get download URL for */
  attachmentId: string;
}

/** Response containing a time-limited download URL */
export interface GetAttachmentDownloadUrlResponse {
  /** Time-limited signed URL for downloading the attachment */
  downloadUrl: string;
}

/** Request to process an attachment via the AI agent */
export interface ProcessAttachmentRequest {
  /** UUID of the attachment to process */
  attachmentId: string;
  /** Optional project to attach the processed attachment to */
  projectId?:
    | string
    | undefined;
  /** Optional company context section for company-info uploads. */
  companyContextSection?: CompanyContextSection | undefined;
}

/** Response for attachment processing */
export interface ProcessAttachmentResponse {
}

/** Response containing a list of catalogue features for a workspace. */
export interface GetCatalogueFeaturesResponse {
  featuresJson: string[];
  productCatalogueJson: string;
  featureUpdatesJson: string[];
}

export interface GetCatalogueFeatureUpdatesResponse {
  featureUpdatesJson: string[];
}

export interface CreateCatalogueSectionRequest {
  title: string;
  description: string;
}

export interface RenameCatalogueSectionRequest {
  title: string;
  description: string;
}

export interface MoveCatalogueFeaturesRequest {
  featureIds: string[];
  targetSectionIndex: number;
}

export interface MutateProductCatalogueResponse {
  productCatalogueJson: string;
}

/** Response indicating whether a workspace has any catalogue features. */
export interface CheckCatalogueExistsResponse {
  hasCatalogue: boolean;
}

export interface CatalogFeedbackDraft {
  id: string;
  companyId: number;
  details: CatalogFeedbackDraftDetails | undefined;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
}

export interface CatalogFeedbackDraftDetails {
  comment: string;
  cleanupError?: string | undefined;
}

export interface GetCatalogFeedbackDraftResponse {
  draft: CatalogFeedbackDraft | undefined;
}

export interface UpdateCatalogFeedbackDraftRequest {
  comment: string;
}

export interface UpdateCatalogFeedbackDraftResponse {
  draft: CatalogFeedbackDraft | undefined;
}

export interface SubmitCatalogFeedbackRequest {
  comment: string;
}

export interface SubmitCatalogFeedbackResponse {
  pendingJobId: string;
  message: string;
}

/** Response containing active runs (tasks with worklogs or job runs) */
export interface GetRunsResponse {
  runs: RunItem[];
  projects: ProjectEntity[];
  tasks: DocumentEntity[];
  /** Parent features of tasks (for assignee lookup) and features included in story runs */
  features: DocumentEntity[];
}

export interface ListPendingJobsRequest {
}

export interface ListPendingJobsResponse {
  jobs: PendingJob[];
}

export interface StartQuickWinInitRequest {
  description: string;
}

export interface StartQuickWinInitResponse {
  pendingJobId: string;
  projectId: string;
}

export interface GetQuickWinInitStatusResponse {
  status: string;
  projectId?: string | undefined;
}

export interface StartBugInitRequest {
  description: string;
}

export interface StartBugInitResponse {
  pendingJobId: string;
  projectId: string;
}

export interface GetBugInitStatusResponse {
  status: string;
  projectId?: string | undefined;
}

export interface GetPulseFeedResponse {
  items: PulseFeedItem[];
  hasCatalogue: boolean;
}

/**
 * Payload carries protojson-serialized codeup.insight.Signal messages. The UI
 * deserializes with Signal.fromJSON and applies its own search/filter.
 */
export interface GetSignalsResponse {
  signalsJson: string[];
}

/**
 * Request for hydrating a set of DiscussionTopic entities by id. The UI
 * passes the list of ids it has observed across the visible evidence and
 * receives the corresponding topic content so it can surface things like
 * the Slack thread permalink alongside the evidence row.
 */
export interface GetDiscussionTopicsByIdsRequest {
  topicIds: string[];
}

/**
 * Response carries protojson-serialized codeup.insight.DiscussionTopic
 * messages. The UI deserializes with DiscussionTopic.fromJSON.
 */
export interface GetDiscussionTopicsByIdsResponse {
  topicsJson: string[];
}

/** Request for fetching a provider-backed call note by its provider-scoped id. */
export interface GetCallNoteByProviderRefRequest {
  providerType: string;
  noteId: string;
}

/**
 * Response carries a protojson-serialized codeup.call_note.CallNoteRecord.
 * The UI deserializes with CallNoteRecord.fromJSON.
 */
export interface GetCallNoteByProviderRefResponse {
  callNoteJson?: string | undefined;
}

/**
 * Each entry pairs a protojson-serialized codeup.insight.Insight with
 * rationale-bearing linked signal/change rows connected to it.
 */
export interface GetInsightsResponse {
  entries: InsightEntry[];
}

export interface InsightEntry {
  insightJson: string;
  linkedSignalsJson: string[];
  linkedChangesJson: string[];
}

export interface ArchiveInsightRequest {
  /**
   * Desired lifecycle state. Omitted requests retain the archive endpoint's
   * historical default of archiving the insight.
   */
  archived?: boolean | undefined;
}

export interface GetChangesReportsResponse {
  reportsJson: string[];
  changesJson: string[];
  personsJson: string[];
  /**
   * ProtoJSON-serialized codeup.api.ProjectLinkedItems messages for changes
   * referenced by the returned reports.
   */
  projectLinksJson: string[];
}

/**
 * Payload carries a protojson-serialized codeup.insight.ProjectSummary message
 * or is empty when no current snapshot exists for the project. UI deserializes
 * with ProjectSummary.fromJSON.
 */
export interface GetCurrentProjectSummaryResponse {
  summaryJson?: string | undefined;
}

/**
 * Payload carries a protojson-serialized codeup.planning.GoalSummary message
 * or is empty when no current generated snapshot exists for the goal. UI
 * deserializes with GoalSummary.fromJSON.
 */
export interface GetCurrentGoalSummaryResponse {
  summaryJson?: string | undefined;
}

export interface BatchGetGoalSummariesRequest {
  goalIds: string[];
}

/**
 * Payload carries protojson-serialized codeup.planning.GoalSummary messages.
 * Goals without a current generated snapshot are omitted.
 */
export interface BatchGetGoalSummariesResponse {
  summariesJson: string[];
}

/**
 * Batch request to fetch the current ProjectSummary for many projects in one
 * call. Issued by Roadmap/Kanban views to populate completion indicators.
 */
export interface BatchGetProjectSummariesRequest {
  projectIds: string[];
}

/**
 * Payload carries protojson-serialized codeup.insight.ProjectSummary messages.
 * Order is not guaranteed; UI indexes by ProjectSummary.project_id. Projects
 * without a current snapshot are omitted from the response. UI deserializes
 * each entry with ProjectSummary.fromJSON.
 */
export interface BatchGetProjectSummariesResponse {
  summariesJson: string[];
}

export interface BatchGetProjectAnalysisStateResponse {
  hasActiveAnalysisJob: boolean;
}

/**
 * Payload carries protojson-serialized codeup.insight.ProjectUpdate messages,
 * ordered by created_at descending. UI deserializes each entry with
 * ProjectUpdate.fromJSON.
 */
export interface ListProjectUpdatesResponse {
  updatesJson: string[];
}

/**
 * Payload carries protojson-serialized codeup.planning.GoalUpdate messages,
 * ordered by created_at descending. UI deserializes each entry with
 * GoalUpdate.fromJSON.
 */
export interface ListGoalUpdatesResponse {
  updatesJson: string[];
}

/**
 * Payload carries protojson-serialized codeup.insight.InsightUpdate messages,
 * ordered by created_at descending. UI deserializes each entry with
 * InsightUpdate.fromJSON.
 */
export interface ListInsightUpdatesResponse {
  updatesJson: string[];
}

/**
 * Unified payload for the project-detail Summary "Signals" sub-tab. The server
 * joins codeup's ListProjectChangeAndSignalLinks output with listSignals and
 * listChangesReports hydration and returns only the signals/changes/persons
 * referenced by the requested project. Entries are protojson-serialized so the
 * UI can deserialize them with Signal.fromJSON, ResolvedChange.fromJSON, and
 * ResolvedPerson.fromJSON. Per-row timestamps come from Signal.created_at /
 * ResolvedChange.created_at — the codeup store backfills both from DB columns.
 */
export interface GetProjectSignalsAndChangesResponse {
  signalsJson: string[];
  changesJson: string[];
  personsJson: string[];
}

export interface ListWorkspaceChatsRequest {
  companyId: number;
}

export interface ListWorkspaceChatsResponse {
  chats: WorkspaceChat[];
}

export interface CreateWorkspaceChatRequest {
  companyId: number;
  details: WorkspaceChatDetails | undefined;
}

export interface CreateWorkspaceChatResponse {
  chat: WorkspaceChat | undefined;
  warning?: string | undefined;
}

export interface GetWorkspaceChatRequest {
  id: string;
  companyId: number;
}

export interface GetWorkspaceChatResponse {
  chat: WorkspaceChat | undefined;
}

export interface UpdateWorkspaceChatRequest {
  id: string;
  companyId: number;
  title?: string | undefined;
  favorite?: boolean | undefined;
}

export interface UpdateWorkspaceChatResponse {
  chat: WorkspaceChat | undefined;
}

export interface DeleteWorkspaceChatResponse {
}

export interface GenerateWorkspaceChatTitleRequest {
  message: string;
}

export interface GenerateWorkspaceChatTitleResponse {
  chat: WorkspaceChat | undefined;
}

export interface GetWorkspaceChatActionPromptResponse {
  prompt: string;
}

/** History Heatmap - request for aggregated activity counts */
export interface HistoryHeatmapRequest {
  /** "weekly" or "daily" */
  cadence: string;
  /** Start of the time range */
  startDate:
    | Date
    | undefined;
  /** End of the time range */
  endDate: Date | undefined;
}

/** History Heatmap - response containing aggregated heatmap data */
export interface HistoryHeatmapResponse {
  data: HistoryHeatmapData | undefined;
}

export interface ListGoogleDriveFoldersRequest {
  query?: string | undefined;
  pageToken?: string | undefined;
  parentId?: string | undefined;
}

export interface ListGoogleDriveFoldersResponse {
  folders: GoogleDriveFolder[];
  nextPageToken?: string | undefined;
  files: GoogleDriveFile[];
}

export interface AddGoogleDriveFolderRequest {
  folderId: string;
  area: ContextArea;
  /**
   * When true, the folder is attached to the workspace documents area of the
   * codeup ContextConfiguration. When false/absent, `area` selects a legacy
   * area (meeting notes).
   */
  workspace: boolean;
}

export interface AddGoogleDriveFolderResponse {
  folderId: string;
  folderName: string;
  success: boolean;
  error?: string | undefined;
}

export interface RemoveGoogleDriveFolderRequest {
  folderId: string;
  area: ContextArea;
  /** When true, the folder is detached from the workspace documents area. */
  workspace: boolean;
}

export interface RemoveGoogleDriveFolderResponse {
  success: boolean;
}

export interface AddGoogleDriveFileResponse {
  fileId: string;
  fileName: string;
  url: string;
  mimeType: string;
  success: boolean;
  error?: string | undefined;
}

export interface AttachGoogleDriveFolderInput {
  folderId: string;
}

export interface AttachGoogleDriveFileInput {
  fileId: string;
  parentTitle: string;
}

export interface AttachGoogleDriveItemsRequest {
  folders: AttachGoogleDriveFolderInput[];
  files: AttachGoogleDriveFileInput[];
  area: ContextArea;
  workspace: boolean;
}

export interface AttachGoogleDriveItemsResponse {
  folders: AddGoogleDriveFolderResponse[];
  files: AddGoogleDriveFileResponse[];
}

export interface RemoveGoogleDriveFileRequest {
  fileId: string;
}

export interface RemoveGoogleDriveFileResponse {
  success: boolean;
}

export interface RemoveNotionRootRequest {
  rootId: string;
}

export interface RemoveNotionRootResponse {
  success: boolean;
}

export interface UpdateProjectPhaseDatesRequest {
  details: ProjectDetails | undefined;
}

export interface UpdateProjectPhaseDatesResponse {
  project: ProjectEntity | undefined;
}

/**
 * Update only the project's user-facing description. Distinct from a general
 * project update because the server side also mirrors the new value into the
 * PRD's `initialInput`, so that a description edit before chat start flows
 * into the first agent message.
 */
export interface UpdateProjectDescriptionRequest {
  description: string;
}

export interface UpdateProjectDescriptionResponse {
  project: ProjectEntity | undefined;
}

export interface AttachNotionItemsRequest {
  items: AttachNotionItem[];
}

export interface AttachNotionItemsResponse {
  /** Codeup codeup.context_configuration.NotionAttachmentRef encoded as JSON. */
  attachmentsJson: string[];
}

export interface ListNotionAttachmentsResponse {
  /** Codeup codeup.context_configuration.NotionAttachmentRef encoded as JSON. */
  attachmentsJson: string[];
}

export interface DetachNotionItemResponse {
  success: boolean;
}

export interface ListNotionDatabaseChildrenResponse {
  children: NotionPageSummary[];
}

export interface RemoveConfluenceRootRequest {
  rootId: string;
}

export interface AttachConfluenceItemsRequest {
  items: AttachConfluenceItem[];
}

export interface AttachConfluenceItemsResponse {
  /** Codeup codeup.context_configuration.ConfluenceAttachmentRef encoded as JSON. */
  attachmentsJson: string[];
}

export interface ListConfluenceAttachmentsResponse {
  /** Codeup codeup.context_configuration.ConfluenceAttachmentRef encoded as JSON. */
  attachmentsJson: string[];
}

export interface DetachConfluenceItemResponse {
  success: boolean;
}

export interface ListConfluenceSpaceChildrenResponse {
  children: ConfluencePageSummary[];
}

export interface ListConfluenceRootsResponse {
  roots: ConfluenceRoot[];
  cloudId: string;
}

export interface GetWorkspaceGraphSubgraphRequest {
  rootType: WorkspaceGraphRootType;
  rootId: string;
  maxDegree: number;
  nodeCap: number;
  edgeCap: number;
}

export interface WorkspaceGraphProperty {
  name: string;
  valueType: WorkspaceGraphPropertyValueType;
  value: string;
}

export interface WorkspaceGraphNode {
  id: string;
  type: string;
  label: string;
  properties: WorkspaceGraphProperty[];
  root: boolean;
}

export interface WorkspaceGraphEdge {
  id: string;
  sourceId: string;
  targetId: string;
  type: string;
  properties: WorkspaceGraphProperty[];
}

export interface GetWorkspaceGraphSubgraphResponse {
  nodes: WorkspaceGraphNode[];
  edges: WorkspaceGraphEdge[];
  truncated: boolean;
  nodeCap: number;
  edgeCap: number;
}

export interface GrantPlgRewardRequest {
  kind: PlgRewardKind;
}

export interface GrantPlgRewardResponse {
}

export interface CreateTicketBatchRequest {
  tickets: TicketDraft[];
}

export interface TicketDraft {
  provider: TicketProvider;
  title: string;
  description: string;
  /** Jira project key or Linear team id. */
  destinationId: string;
}

export interface TicketCreationResult {
  index: number;
  provider: TicketProvider;
  success: boolean;
  ticketId?: string | undefined;
  identifier?: string | undefined;
  url?: string | undefined;
  error?: string | undefined;
}

export interface CreateTicketBatchResponse {
  results: TicketCreationResult[];
}

export interface GetDashboardGenerationPromptResponse {
  prompt: string;
}

function createBaseGetAllProjectDocsResponse(): GetAllProjectDocsResponse {
  return { documents: [] };
}

export const GetAllProjectDocsResponse: MessageFns<GetAllProjectDocsResponse> = {
  encode(message: GetAllProjectDocsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.documents) {
      DocumentEntity.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllProjectDocsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllProjectDocsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.documents.push(DocumentEntity.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllProjectDocsResponse {
    return {
      documents: globalThis.Array.isArray(object?.documents)
        ? object.documents.map((e: any) => DocumentEntity.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetAllProjectDocsResponse): unknown {
    const obj: any = {};
    if (message.documents?.length) {
      obj.documents = message.documents.map((e) => DocumentEntity.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetAllProjectDocsResponse>): GetAllProjectDocsResponse {
    return GetAllProjectDocsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetAllProjectDocsResponse>): GetAllProjectDocsResponse {
    const message = createBaseGetAllProjectDocsResponse();
    message.documents = object.documents?.map((e) => DocumentEntity.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetChildDocsResponse(): GetChildDocsResponse {
  return { documents: [] };
}

export const GetChildDocsResponse: MessageFns<GetChildDocsResponse> = {
  encode(message: GetChildDocsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.documents) {
      DocumentEntity.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetChildDocsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetChildDocsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.documents.push(DocumentEntity.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetChildDocsResponse {
    return {
      documents: globalThis.Array.isArray(object?.documents)
        ? object.documents.map((e: any) => DocumentEntity.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetChildDocsResponse): unknown {
    const obj: any = {};
    if (message.documents?.length) {
      obj.documents = message.documents.map((e) => DocumentEntity.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetChildDocsResponse>): GetChildDocsResponse {
    return GetChildDocsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetChildDocsResponse>): GetChildDocsResponse {
    const message = createBaseGetChildDocsResponse();
    message.documents = object.documents?.map((e) => DocumentEntity.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetDocResponse(): GetDocResponse {
  return { document: undefined };
}

export const GetDocResponse: MessageFns<GetDocResponse> = {
  encode(message: GetDocResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.document !== undefined) {
      DocumentEntity.encode(message.document, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDocResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDocResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.document = DocumentEntity.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDocResponse {
    return { document: isSet(object.document) ? DocumentEntity.fromJSON(object.document) : undefined };
  },

  toJSON(message: GetDocResponse): unknown {
    const obj: any = {};
    if (message.document !== undefined) {
      obj.document = DocumentEntity.toJSON(message.document);
    }
    return obj;
  },

  create(base?: DeepPartial<GetDocResponse>): GetDocResponse {
    return GetDocResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetDocResponse>): GetDocResponse {
    const message = createBaseGetDocResponse();
    message.document = (object.document !== undefined && object.document !== null)
      ? DocumentEntity.fromPartial(object.document)
      : undefined;
    return message;
  },
};

function createBaseGetCompanyDetailsResponse(): GetCompanyDetailsResponse {
  return { details: undefined };
}

export const GetCompanyDetailsResponse: MessageFns<GetCompanyDetailsResponse> = {
  encode(message: GetCompanyDetailsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.details !== undefined) {
      CompanyDetails.encode(message.details, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCompanyDetailsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCompanyDetailsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.details = CompanyDetails.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCompanyDetailsResponse {
    return { details: isSet(object.details) ? CompanyDetails.fromJSON(object.details) : undefined };
  },

  toJSON(message: GetCompanyDetailsResponse): unknown {
    const obj: any = {};
    if (message.details !== undefined) {
      obj.details = CompanyDetails.toJSON(message.details);
    }
    return obj;
  },

  create(base?: DeepPartial<GetCompanyDetailsResponse>): GetCompanyDetailsResponse {
    return GetCompanyDetailsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetCompanyDetailsResponse>): GetCompanyDetailsResponse {
    const message = createBaseGetCompanyDetailsResponse();
    message.details = (object.details !== undefined && object.details !== null)
      ? CompanyDetails.fromPartial(object.details)
      : undefined;
    return message;
  },
};

function createBaseGetPlgOnboardingDefaultsResponse(): GetPlgOnboardingDefaultsResponse {
  return {
    suggestedWebsite: "",
    requiresManualWebsite: false,
    domainMatchStatus: 0,
    domainMatchUserCount: 0,
    domainMatchDomain: "",
  };
}

export const GetPlgOnboardingDefaultsResponse: MessageFns<GetPlgOnboardingDefaultsResponse> = {
  encode(message: GetPlgOnboardingDefaultsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.suggestedWebsite !== "") {
      writer.uint32(10).string(message.suggestedWebsite);
    }
    if (message.requiresManualWebsite !== false) {
      writer.uint32(16).bool(message.requiresManualWebsite);
    }
    if (message.domainMatchStatus !== 0) {
      writer.uint32(24).int32(message.domainMatchStatus);
    }
    if (message.domainMatchUserCount !== 0) {
      writer.uint32(32).int32(message.domainMatchUserCount);
    }
    if (message.domainMatchDomain !== "") {
      writer.uint32(42).string(message.domainMatchDomain);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPlgOnboardingDefaultsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPlgOnboardingDefaultsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.suggestedWebsite = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.requiresManualWebsite = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.domainMatchStatus = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.domainMatchUserCount = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.domainMatchDomain = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPlgOnboardingDefaultsResponse {
    return {
      suggestedWebsite: isSet(object.suggestedWebsite)
        ? globalThis.String(object.suggestedWebsite)
        : isSet(object.suggested_website)
        ? globalThis.String(object.suggested_website)
        : "",
      requiresManualWebsite: isSet(object.requiresManualWebsite)
        ? globalThis.Boolean(object.requiresManualWebsite)
        : isSet(object.requires_manual_website)
        ? globalThis.Boolean(object.requires_manual_website)
        : false,
      domainMatchStatus: isSet(object.domainMatchStatus)
        ? plgDomainMatchStatusFromJSON(object.domainMatchStatus)
        : isSet(object.domain_match_status)
        ? plgDomainMatchStatusFromJSON(object.domain_match_status)
        : 0,
      domainMatchUserCount: isSet(object.domainMatchUserCount)
        ? globalThis.Number(object.domainMatchUserCount)
        : isSet(object.domain_match_user_count)
        ? globalThis.Number(object.domain_match_user_count)
        : 0,
      domainMatchDomain: isSet(object.domainMatchDomain)
        ? globalThis.String(object.domainMatchDomain)
        : isSet(object.domain_match_domain)
        ? globalThis.String(object.domain_match_domain)
        : "",
    };
  },

  toJSON(message: GetPlgOnboardingDefaultsResponse): unknown {
    const obj: any = {};
    if (message.suggestedWebsite !== "") {
      obj.suggestedWebsite = message.suggestedWebsite;
    }
    if (message.requiresManualWebsite !== false) {
      obj.requiresManualWebsite = message.requiresManualWebsite;
    }
    if (message.domainMatchStatus !== 0) {
      obj.domainMatchStatus = plgDomainMatchStatusToJSON(message.domainMatchStatus);
    }
    if (message.domainMatchUserCount !== 0) {
      obj.domainMatchUserCount = Math.round(message.domainMatchUserCount);
    }
    if (message.domainMatchDomain !== "") {
      obj.domainMatchDomain = message.domainMatchDomain;
    }
    return obj;
  },

  create(base?: DeepPartial<GetPlgOnboardingDefaultsResponse>): GetPlgOnboardingDefaultsResponse {
    return GetPlgOnboardingDefaultsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetPlgOnboardingDefaultsResponse>): GetPlgOnboardingDefaultsResponse {
    const message = createBaseGetPlgOnboardingDefaultsResponse();
    message.suggestedWebsite = object.suggestedWebsite ?? "";
    message.requiresManualWebsite = object.requiresManualWebsite ?? false;
    message.domainMatchStatus = object.domainMatchStatus ?? 0;
    message.domainMatchUserCount = object.domainMatchUserCount ?? 0;
    message.domainMatchDomain = object.domainMatchDomain ?? "";
    return message;
  },
};

function createBaseCreatePlgDomainJoinRequestResponse(): CreatePlgDomainJoinRequestResponse {
  return { status: 0 };
}

export const CreatePlgDomainJoinRequestResponse: MessageFns<CreatePlgDomainJoinRequestResponse> = {
  encode(message: CreatePlgDomainJoinRequestResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreatePlgDomainJoinRequestResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreatePlgDomainJoinRequestResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreatePlgDomainJoinRequestResponse {
    return { status: isSet(object.status) ? plgDomainMatchStatusFromJSON(object.status) : 0 };
  },

  toJSON(message: CreatePlgDomainJoinRequestResponse): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = plgDomainMatchStatusToJSON(message.status);
    }
    return obj;
  },

  create(base?: DeepPartial<CreatePlgDomainJoinRequestResponse>): CreatePlgDomainJoinRequestResponse {
    return CreatePlgDomainJoinRequestResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreatePlgDomainJoinRequestResponse>): CreatePlgDomainJoinRequestResponse {
    const message = createBaseCreatePlgDomainJoinRequestResponse();
    message.status = object.status ?? 0;
    return message;
  },
};

function createBaseGetPlgDomainJoinRequestResponse(): GetPlgDomainJoinRequestResponse {
  return { requestId: "", requesterEmail: "", pending: false };
}

export const GetPlgDomainJoinRequestResponse: MessageFns<GetPlgDomainJoinRequestResponse> = {
  encode(message: GetPlgDomainJoinRequestResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.requestId !== "") {
      writer.uint32(10).string(message.requestId);
    }
    if (message.requesterEmail !== "") {
      writer.uint32(18).string(message.requesterEmail);
    }
    if (message.pending !== false) {
      writer.uint32(24).bool(message.pending);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPlgDomainJoinRequestResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPlgDomainJoinRequestResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.requestId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.requesterEmail = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.pending = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPlgDomainJoinRequestResponse {
    return {
      requestId: isSet(object.requestId)
        ? globalThis.String(object.requestId)
        : isSet(object.request_id)
        ? globalThis.String(object.request_id)
        : "",
      requesterEmail: isSet(object.requesterEmail)
        ? globalThis.String(object.requesterEmail)
        : isSet(object.requester_email)
        ? globalThis.String(object.requester_email)
        : "",
      pending: isSet(object.pending) ? globalThis.Boolean(object.pending) : false,
    };
  },

  toJSON(message: GetPlgDomainJoinRequestResponse): unknown {
    const obj: any = {};
    if (message.requestId !== "") {
      obj.requestId = message.requestId;
    }
    if (message.requesterEmail !== "") {
      obj.requesterEmail = message.requesterEmail;
    }
    if (message.pending !== false) {
      obj.pending = message.pending;
    }
    return obj;
  },

  create(base?: DeepPartial<GetPlgDomainJoinRequestResponse>): GetPlgDomainJoinRequestResponse {
    return GetPlgDomainJoinRequestResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetPlgDomainJoinRequestResponse>): GetPlgDomainJoinRequestResponse {
    const message = createBaseGetPlgDomainJoinRequestResponse();
    message.requestId = object.requestId ?? "";
    message.requesterEmail = object.requesterEmail ?? "";
    message.pending = object.pending ?? false;
    return message;
  },
};

function createBaseApprovePlgDomainJoinRequestResponse(): ApprovePlgDomainJoinRequestResponse {
  return { inviteCreated: false };
}

export const ApprovePlgDomainJoinRequestResponse: MessageFns<ApprovePlgDomainJoinRequestResponse> = {
  encode(message: ApprovePlgDomainJoinRequestResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.inviteCreated !== false) {
      writer.uint32(8).bool(message.inviteCreated);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApprovePlgDomainJoinRequestResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApprovePlgDomainJoinRequestResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.inviteCreated = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApprovePlgDomainJoinRequestResponse {
    return {
      inviteCreated: isSet(object.inviteCreated)
        ? globalThis.Boolean(object.inviteCreated)
        : isSet(object.invite_created)
        ? globalThis.Boolean(object.invite_created)
        : false,
    };
  },

  toJSON(message: ApprovePlgDomainJoinRequestResponse): unknown {
    const obj: any = {};
    if (message.inviteCreated !== false) {
      obj.inviteCreated = message.inviteCreated;
    }
    return obj;
  },

  create(base?: DeepPartial<ApprovePlgDomainJoinRequestResponse>): ApprovePlgDomainJoinRequestResponse {
    return ApprovePlgDomainJoinRequestResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApprovePlgDomainJoinRequestResponse>): ApprovePlgDomainJoinRequestResponse {
    const message = createBaseApprovePlgDomainJoinRequestResponse();
    message.inviteCreated = object.inviteCreated ?? false;
    return message;
  },
};

function createBaseGetCompanyResearchReportsResponse(): GetCompanyResearchReportsResponse {
  return { companyProfile: undefined, competitiveAnalysis: undefined };
}

export const GetCompanyResearchReportsResponse: MessageFns<GetCompanyResearchReportsResponse> = {
  encode(message: GetCompanyResearchReportsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyProfile !== undefined) {
      ArtifactCompanyProfile.encode(message.companyProfile, writer.uint32(10).fork()).join();
    }
    if (message.competitiveAnalysis !== undefined) {
      ArtifactCompetitiveAnalysis.encode(message.competitiveAnalysis, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCompanyResearchReportsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCompanyResearchReportsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.companyProfile = ArtifactCompanyProfile.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.competitiveAnalysis = ArtifactCompetitiveAnalysis.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCompanyResearchReportsResponse {
    return {
      companyProfile: isSet(object.companyProfile)
        ? ArtifactCompanyProfile.fromJSON(object.companyProfile)
        : isSet(object.company_profile)
        ? ArtifactCompanyProfile.fromJSON(object.company_profile)
        : undefined,
      competitiveAnalysis: isSet(object.competitiveAnalysis)
        ? ArtifactCompetitiveAnalysis.fromJSON(object.competitiveAnalysis)
        : isSet(object.competitive_analysis)
        ? ArtifactCompetitiveAnalysis.fromJSON(object.competitive_analysis)
        : undefined,
    };
  },

  toJSON(message: GetCompanyResearchReportsResponse): unknown {
    const obj: any = {};
    if (message.companyProfile !== undefined) {
      obj.companyProfile = ArtifactCompanyProfile.toJSON(message.companyProfile);
    }
    if (message.competitiveAnalysis !== undefined) {
      obj.competitiveAnalysis = ArtifactCompetitiveAnalysis.toJSON(message.competitiveAnalysis);
    }
    return obj;
  },

  create(base?: DeepPartial<GetCompanyResearchReportsResponse>): GetCompanyResearchReportsResponse {
    return GetCompanyResearchReportsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetCompanyResearchReportsResponse>): GetCompanyResearchReportsResponse {
    const message = createBaseGetCompanyResearchReportsResponse();
    message.companyProfile = (object.companyProfile !== undefined && object.companyProfile !== null)
      ? ArtifactCompanyProfile.fromPartial(object.companyProfile)
      : undefined;
    message.competitiveAnalysis = (object.competitiveAnalysis !== undefined && object.competitiveAnalysis !== null)
      ? ArtifactCompetitiveAnalysis.fromPartial(object.competitiveAnalysis)
      : undefined;
    return message;
  },
};

function createBaseGetHomeReportPreviewStatusRequest(): GetHomeReportPreviewStatusRequest {
  return { mode: 0 };
}

export const GetHomeReportPreviewStatusRequest: MessageFns<GetHomeReportPreviewStatusRequest> = {
  encode(message: GetHomeReportPreviewStatusRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mode !== 0) {
      writer.uint32(8).int32(message.mode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetHomeReportPreviewStatusRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetHomeReportPreviewStatusRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetHomeReportPreviewStatusRequest {
    return { mode: isSet(object.mode) ? homeReportPreviewModeFromJSON(object.mode) : 0 };
  },

  toJSON(message: GetHomeReportPreviewStatusRequest): unknown {
    const obj: any = {};
    if (message.mode !== 0) {
      obj.mode = homeReportPreviewModeToJSON(message.mode);
    }
    return obj;
  },

  create(base?: DeepPartial<GetHomeReportPreviewStatusRequest>): GetHomeReportPreviewStatusRequest {
    return GetHomeReportPreviewStatusRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetHomeReportPreviewStatusRequest>): GetHomeReportPreviewStatusRequest {
    const message = createBaseGetHomeReportPreviewStatusRequest();
    message.mode = object.mode ?? 0;
    return message;
  },
};

function createBaseStartHomeReportPreviewRequest(): StartHomeReportPreviewRequest {
  return { mode: 0 };
}

export const StartHomeReportPreviewRequest: MessageFns<StartHomeReportPreviewRequest> = {
  encode(message: StartHomeReportPreviewRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mode !== 0) {
      writer.uint32(8).int32(message.mode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartHomeReportPreviewRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartHomeReportPreviewRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartHomeReportPreviewRequest {
    return { mode: isSet(object.mode) ? homeReportPreviewModeFromJSON(object.mode) : 0 };
  },

  toJSON(message: StartHomeReportPreviewRequest): unknown {
    const obj: any = {};
    if (message.mode !== 0) {
      obj.mode = homeReportPreviewModeToJSON(message.mode);
    }
    return obj;
  },

  create(base?: DeepPartial<StartHomeReportPreviewRequest>): StartHomeReportPreviewRequest {
    return StartHomeReportPreviewRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartHomeReportPreviewRequest>): StartHomeReportPreviewRequest {
    const message = createBaseStartHomeReportPreviewRequest();
    message.mode = object.mode ?? 0;
    return message;
  },
};

function createBaseHomeReportPreviewStatusResponse(): HomeReportPreviewStatusResponse {
  return { jobId: "", latestRunJson: "", error: "" };
}

export const HomeReportPreviewStatusResponse: MessageFns<HomeReportPreviewStatusResponse> = {
  encode(message: HomeReportPreviewStatusResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobId !== "") {
      writer.uint32(10).string(message.jobId);
    }
    if (message.latestRunJson !== "") {
      writer.uint32(18).string(message.latestRunJson);
    }
    if (message.error !== "") {
      writer.uint32(26).string(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HomeReportPreviewStatusResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHomeReportPreviewStatusResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jobId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.latestRunJson = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.error = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HomeReportPreviewStatusResponse {
    return {
      jobId: isSet(object.jobId)
        ? globalThis.String(object.jobId)
        : isSet(object.job_id)
        ? globalThis.String(object.job_id)
        : "",
      latestRunJson: isSet(object.latestRunJson)
        ? globalThis.String(object.latestRunJson)
        : isSet(object.latest_run_json)
        ? globalThis.String(object.latest_run_json)
        : "",
      error: isSet(object.error) ? globalThis.String(object.error) : "",
    };
  },

  toJSON(message: HomeReportPreviewStatusResponse): unknown {
    const obj: any = {};
    if (message.jobId !== "") {
      obj.jobId = message.jobId;
    }
    if (message.latestRunJson !== "") {
      obj.latestRunJson = message.latestRunJson;
    }
    if (message.error !== "") {
      obj.error = message.error;
    }
    return obj;
  },

  create(base?: DeepPartial<HomeReportPreviewStatusResponse>): HomeReportPreviewStatusResponse {
    return HomeReportPreviewStatusResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HomeReportPreviewStatusResponse>): HomeReportPreviewStatusResponse {
    const message = createBaseHomeReportPreviewStatusResponse();
    message.jobId = object.jobId ?? "";
    message.latestRunJson = object.latestRunJson ?? "";
    message.error = object.error ?? "";
    return message;
  },
};

function createBaseGetDigestHistoryResponse(): GetDigestHistoryResponse {
  return { reportsJson: [], workspaceReportsJson: [], personalReportsJson: [], teamReportsJson: [] };
}

export const GetDigestHistoryResponse: MessageFns<GetDigestHistoryResponse> = {
  encode(message: GetDigestHistoryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.reportsJson) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.workspaceReportsJson) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.personalReportsJson) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.teamReportsJson) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDigestHistoryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDigestHistoryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.reportsJson.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.workspaceReportsJson.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.personalReportsJson.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.teamReportsJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDigestHistoryResponse {
    return {
      reportsJson: globalThis.Array.isArray(object?.reportsJson)
        ? object.reportsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.reports_json)
        ? object.reports_json.map((e: any) => globalThis.String(e))
        : [],
      workspaceReportsJson: globalThis.Array.isArray(object?.workspaceReportsJson)
        ? object.workspaceReportsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.workspace_reports_json)
        ? object.workspace_reports_json.map((e: any) => globalThis.String(e))
        : [],
      personalReportsJson: globalThis.Array.isArray(object?.personalReportsJson)
        ? object.personalReportsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.personal_reports_json)
        ? object.personal_reports_json.map((e: any) => globalThis.String(e))
        : [],
      teamReportsJson: globalThis.Array.isArray(object?.teamReportsJson)
        ? object.teamReportsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.team_reports_json)
        ? object.team_reports_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetDigestHistoryResponse): unknown {
    const obj: any = {};
    if (message.reportsJson?.length) {
      obj.reportsJson = message.reportsJson;
    }
    if (message.workspaceReportsJson?.length) {
      obj.workspaceReportsJson = message.workspaceReportsJson;
    }
    if (message.personalReportsJson?.length) {
      obj.personalReportsJson = message.personalReportsJson;
    }
    if (message.teamReportsJson?.length) {
      obj.teamReportsJson = message.teamReportsJson;
    }
    return obj;
  },

  create(base?: DeepPartial<GetDigestHistoryResponse>): GetDigestHistoryResponse {
    return GetDigestHistoryResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetDigestHistoryResponse>): GetDigestHistoryResponse {
    const message = createBaseGetDigestHistoryResponse();
    message.reportsJson = object.reportsJson?.map((e) => e) || [];
    message.workspaceReportsJson = object.workspaceReportsJson?.map((e) => e) || [];
    message.personalReportsJson = object.personalReportsJson?.map((e) => e) || [];
    message.teamReportsJson = object.teamReportsJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseGenerateDashboardRequest(): GenerateDashboardRequest {
  return { prompt: "" };
}

export const GenerateDashboardRequest: MessageFns<GenerateDashboardRequest> = {
  encode(message: GenerateDashboardRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.prompt !== "") {
      writer.uint32(10).string(message.prompt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateDashboardRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateDashboardRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.prompt = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateDashboardRequest {
    return { prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : "" };
  },

  toJSON(message: GenerateDashboardRequest): unknown {
    const obj: any = {};
    if (message.prompt !== "") {
      obj.prompt = message.prompt;
    }
    return obj;
  },

  create(base?: DeepPartial<GenerateDashboardRequest>): GenerateDashboardRequest {
    return GenerateDashboardRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GenerateDashboardRequest>): GenerateDashboardRequest {
    const message = createBaseGenerateDashboardRequest();
    message.prompt = object.prompt ?? "";
    return message;
  },
};

function createBaseGetProjectResponse(): GetProjectResponse {
  return { project: undefined };
}

export const GetProjectResponse: MessageFns<GetProjectResponse> = {
  encode(message: GetProjectResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.project !== undefined) {
      ProjectEntity.encode(message.project, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetProjectResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetProjectResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.project = ProjectEntity.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetProjectResponse {
    return { project: isSet(object.project) ? ProjectEntity.fromJSON(object.project) : undefined };
  },

  toJSON(message: GetProjectResponse): unknown {
    const obj: any = {};
    if (message.project !== undefined) {
      obj.project = ProjectEntity.toJSON(message.project);
    }
    return obj;
  },

  create(base?: DeepPartial<GetProjectResponse>): GetProjectResponse {
    return GetProjectResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetProjectResponse>): GetProjectResponse {
    const message = createBaseGetProjectResponse();
    message.project = (object.project !== undefined && object.project !== null)
      ? ProjectEntity.fromPartial(object.project)
      : undefined;
    return message;
  },
};

function createBaseGetIntegrationsResponse(): GetIntegrationsResponse {
  return { infos: [] };
}

export const GetIntegrationsResponse: MessageFns<GetIntegrationsResponse> = {
  encode(message: GetIntegrationsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.infos) {
      LinkedDocumentInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetIntegrationsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetIntegrationsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.infos.push(LinkedDocumentInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetIntegrationsResponse {
    return {
      infos: globalThis.Array.isArray(object?.infos)
        ? object.infos.map((e: any) => LinkedDocumentInfo.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetIntegrationsResponse): unknown {
    const obj: any = {};
    if (message.infos?.length) {
      obj.infos = message.infos.map((e) => LinkedDocumentInfo.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetIntegrationsResponse>): GetIntegrationsResponse {
    return GetIntegrationsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetIntegrationsResponse>): GetIntegrationsResponse {
    const message = createBaseGetIntegrationsResponse();
    message.infos = object.infos?.map((e) => LinkedDocumentInfo.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetIntegrationPropertiesResponse(): GetIntegrationPropertiesResponse {
  return { properties: undefined, info: undefined };
}

export const GetIntegrationPropertiesResponse: MessageFns<GetIntegrationPropertiesResponse> = {
  encode(message: GetIntegrationPropertiesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.properties !== undefined) {
      IntegrationProperties.encode(message.properties, writer.uint32(10).fork()).join();
    }
    if (message.info !== undefined) {
      IntegrationInfo.encode(message.info, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetIntegrationPropertiesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetIntegrationPropertiesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.properties = IntegrationProperties.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.info = IntegrationInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetIntegrationPropertiesResponse {
    return {
      properties: isSet(object.properties) ? IntegrationProperties.fromJSON(object.properties) : undefined,
      info: isSet(object.info) ? IntegrationInfo.fromJSON(object.info) : undefined,
    };
  },

  toJSON(message: GetIntegrationPropertiesResponse): unknown {
    const obj: any = {};
    if (message.properties !== undefined) {
      obj.properties = IntegrationProperties.toJSON(message.properties);
    }
    if (message.info !== undefined) {
      obj.info = IntegrationInfo.toJSON(message.info);
    }
    return obj;
  },

  create(base?: DeepPartial<GetIntegrationPropertiesResponse>): GetIntegrationPropertiesResponse {
    return GetIntegrationPropertiesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetIntegrationPropertiesResponse>): GetIntegrationPropertiesResponse {
    const message = createBaseGetIntegrationPropertiesResponse();
    message.properties = (object.properties !== undefined && object.properties !== null)
      ? IntegrationProperties.fromPartial(object.properties)
      : undefined;
    message.info = (object.info !== undefined && object.info !== null)
      ? IntegrationInfo.fromPartial(object.info)
      : undefined;
    return message;
  },
};

function createBaseGetGitHubManageUrlResponse(): GetGitHubManageUrlResponse {
  return { url: undefined };
}

export const GetGitHubManageUrlResponse: MessageFns<GetGitHubManageUrlResponse> = {
  encode(message: GetGitHubManageUrlResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.url !== undefined) {
      writer.uint32(10).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetGitHubManageUrlResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetGitHubManageUrlResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetGitHubManageUrlResponse {
    return { url: isSet(object.url) ? globalThis.String(object.url) : undefined };
  },

  toJSON(message: GetGitHubManageUrlResponse): unknown {
    const obj: any = {};
    if (message.url !== undefined) {
      obj.url = message.url;
    }
    return obj;
  },

  create(base?: DeepPartial<GetGitHubManageUrlResponse>): GetGitHubManageUrlResponse {
    return GetGitHubManageUrlResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetGitHubManageUrlResponse>): GetGitHubManageUrlResponse {
    const message = createBaseGetGitHubManageUrlResponse();
    message.url = object.url ?? undefined;
    return message;
  },
};

function createBaseSlackChannelView(): SlackChannelView {
  return { id: "", name: "", isMember: false, visibility: 0 };
}

export const SlackChannelView: MessageFns<SlackChannelView> = {
  encode(message: SlackChannelView, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.isMember !== false) {
      writer.uint32(24).bool(message.isMember);
    }
    if (message.visibility !== 0) {
      writer.uint32(32).int32(message.visibility);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SlackChannelView {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSlackChannelView();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isMember = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.visibility = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SlackChannelView {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      isMember: isSet(object.isMember)
        ? globalThis.Boolean(object.isMember)
        : isSet(object.is_member)
        ? globalThis.Boolean(object.is_member)
        : false,
      visibility: isSet(object.visibility) ? channelVisibilityFromJSON(object.visibility) : 0,
    };
  },

  toJSON(message: SlackChannelView): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.isMember !== false) {
      obj.isMember = message.isMember;
    }
    if (message.visibility !== 0) {
      obj.visibility = channelVisibilityToJSON(message.visibility);
    }
    return obj;
  },

  create(base?: DeepPartial<SlackChannelView>): SlackChannelView {
    return SlackChannelView.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SlackChannelView>): SlackChannelView {
    const message = createBaseSlackChannelView();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.isMember = object.isMember ?? false;
    message.visibility = object.visibility ?? 0;
    return message;
  },
};

function createBaseListSlackChannelsResponse(): ListSlackChannelsResponse {
  return { channels: [] };
}

export const ListSlackChannelsResponse: MessageFns<ListSlackChannelsResponse> = {
  encode(message: ListSlackChannelsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.channels) {
      SlackChannelView.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListSlackChannelsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListSlackChannelsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.channels.push(SlackChannelView.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListSlackChannelsResponse {
    return {
      channels: globalThis.Array.isArray(object?.channels)
        ? object.channels.map((e: any) => SlackChannelView.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListSlackChannelsResponse): unknown {
    const obj: any = {};
    if (message.channels?.length) {
      obj.channels = message.channels.map((e) => SlackChannelView.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ListSlackChannelsResponse>): ListSlackChannelsResponse {
    return ListSlackChannelsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListSlackChannelsResponse>): ListSlackChannelsResponse {
    const message = createBaseListSlackChannelsResponse();
    message.channels = object.channels?.map((e) => SlackChannelView.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTeamsChannelView(): TeamsChannelView {
  return { id: "", displayName: "", selected: false, deliverable: false, visibility: 0, deliveryEligible: false };
}

export const TeamsChannelView: MessageFns<TeamsChannelView> = {
  encode(message: TeamsChannelView, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.displayName !== "") {
      writer.uint32(18).string(message.displayName);
    }
    if (message.selected !== false) {
      writer.uint32(24).bool(message.selected);
    }
    if (message.deliverable !== false) {
      writer.uint32(32).bool(message.deliverable);
    }
    if (message.visibility !== 0) {
      writer.uint32(40).int32(message.visibility);
    }
    if (message.deliveryEligible !== false) {
      writer.uint32(48).bool(message.deliveryEligible);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TeamsChannelView {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeamsChannelView();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.displayName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.selected = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.deliverable = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.visibility = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.deliveryEligible = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeamsChannelView {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      displayName: isSet(object.displayName)
        ? globalThis.String(object.displayName)
        : isSet(object.display_name)
        ? globalThis.String(object.display_name)
        : "",
      selected: isSet(object.selected) ? globalThis.Boolean(object.selected) : false,
      deliverable: isSet(object.deliverable) ? globalThis.Boolean(object.deliverable) : false,
      visibility: isSet(object.visibility) ? channelVisibilityFromJSON(object.visibility) : 0,
      deliveryEligible: isSet(object.deliveryEligible)
        ? globalThis.Boolean(object.deliveryEligible)
        : isSet(object.delivery_eligible)
        ? globalThis.Boolean(object.delivery_eligible)
        : false,
    };
  },

  toJSON(message: TeamsChannelView): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.selected !== false) {
      obj.selected = message.selected;
    }
    if (message.deliverable !== false) {
      obj.deliverable = message.deliverable;
    }
    if (message.visibility !== 0) {
      obj.visibility = channelVisibilityToJSON(message.visibility);
    }
    if (message.deliveryEligible !== false) {
      obj.deliveryEligible = message.deliveryEligible;
    }
    return obj;
  },

  create(base?: DeepPartial<TeamsChannelView>): TeamsChannelView {
    return TeamsChannelView.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TeamsChannelView>): TeamsChannelView {
    const message = createBaseTeamsChannelView();
    message.id = object.id ?? "";
    message.displayName = object.displayName ?? "";
    message.selected = object.selected ?? false;
    message.deliverable = object.deliverable ?? false;
    message.visibility = object.visibility ?? 0;
    message.deliveryEligible = object.deliveryEligible ?? false;
    return message;
  },
};

function createBaseTeamsTeamView(): TeamsTeamView {
  return { id: "", displayName: "", channels: [] };
}

export const TeamsTeamView: MessageFns<TeamsTeamView> = {
  encode(message: TeamsTeamView, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.displayName !== "") {
      writer.uint32(18).string(message.displayName);
    }
    for (const v of message.channels) {
      TeamsChannelView.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TeamsTeamView {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeamsTeamView();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.displayName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.channels.push(TeamsChannelView.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeamsTeamView {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      displayName: isSet(object.displayName)
        ? globalThis.String(object.displayName)
        : isSet(object.display_name)
        ? globalThis.String(object.display_name)
        : "",
      channels: globalThis.Array.isArray(object?.channels)
        ? object.channels.map((e: any) => TeamsChannelView.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TeamsTeamView): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.displayName !== "") {
      obj.displayName = message.displayName;
    }
    if (message.channels?.length) {
      obj.channels = message.channels.map((e) => TeamsChannelView.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<TeamsTeamView>): TeamsTeamView {
    return TeamsTeamView.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TeamsTeamView>): TeamsTeamView {
    const message = createBaseTeamsTeamView();
    message.id = object.id ?? "";
    message.displayName = object.displayName ?? "";
    message.channels = object.channels?.map((e) => TeamsChannelView.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTeamsPendingMeetingInstall(): TeamsPendingMeetingInstall {
  return { chatId: "", installerName: "", title: "" };
}

export const TeamsPendingMeetingInstall: MessageFns<TeamsPendingMeetingInstall> = {
  encode(message: TeamsPendingMeetingInstall, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatId !== "") {
      writer.uint32(10).string(message.chatId);
    }
    if (message.installerName !== "") {
      writer.uint32(18).string(message.installerName);
    }
    if (message.title !== "") {
      writer.uint32(26).string(message.title);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TeamsPendingMeetingInstall {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeamsPendingMeetingInstall();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.installerName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.title = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeamsPendingMeetingInstall {
    return {
      chatId: isSet(object.chatId)
        ? globalThis.String(object.chatId)
        : isSet(object.chat_id)
        ? globalThis.String(object.chat_id)
        : "",
      installerName: isSet(object.installerName)
        ? globalThis.String(object.installerName)
        : isSet(object.installer_name)
        ? globalThis.String(object.installer_name)
        : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
    };
  },

  toJSON(message: TeamsPendingMeetingInstall): unknown {
    const obj: any = {};
    if (message.chatId !== "") {
      obj.chatId = message.chatId;
    }
    if (message.installerName !== "") {
      obj.installerName = message.installerName;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    return obj;
  },

  create(base?: DeepPartial<TeamsPendingMeetingInstall>): TeamsPendingMeetingInstall {
    return TeamsPendingMeetingInstall.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TeamsPendingMeetingInstall>): TeamsPendingMeetingInstall {
    const message = createBaseTeamsPendingMeetingInstall();
    message.chatId = object.chatId ?? "";
    message.installerName = object.installerName ?? "";
    message.title = object.title ?? "";
    return message;
  },
};

function createBaseListTeamsChannelsResponse(): ListTeamsChannelsResponse {
  return {
    teams: [],
    meetingNotesEnabled: false,
    meetingNotesMode: 0,
    meetingInstallCount: 0,
    pendingMeetingInstalls: [],
  };
}

export const ListTeamsChannelsResponse: MessageFns<ListTeamsChannelsResponse> = {
  encode(message: ListTeamsChannelsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.teams) {
      TeamsTeamView.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.meetingNotesEnabled !== false) {
      writer.uint32(16).bool(message.meetingNotesEnabled);
    }
    if (message.meetingNotesMode !== 0) {
      writer.uint32(24).int32(message.meetingNotesMode);
    }
    if (message.meetingInstallCount !== 0) {
      writer.uint32(32).int32(message.meetingInstallCount);
    }
    for (const v of message.pendingMeetingInstalls) {
      TeamsPendingMeetingInstall.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListTeamsChannelsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListTeamsChannelsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.teams.push(TeamsTeamView.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.meetingNotesEnabled = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.meetingNotesMode = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.meetingInstallCount = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.pendingMeetingInstalls.push(TeamsPendingMeetingInstall.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListTeamsChannelsResponse {
    return {
      teams: globalThis.Array.isArray(object?.teams) ? object.teams.map((e: any) => TeamsTeamView.fromJSON(e)) : [],
      meetingNotesEnabled: isSet(object.meetingNotesEnabled)
        ? globalThis.Boolean(object.meetingNotesEnabled)
        : isSet(object.meeting_notes_enabled)
        ? globalThis.Boolean(object.meeting_notes_enabled)
        : false,
      meetingNotesMode: isSet(object.meetingNotesMode)
        ? teamsMeetingNotesModeFromJSON(object.meetingNotesMode)
        : isSet(object.meeting_notes_mode)
        ? teamsMeetingNotesModeFromJSON(object.meeting_notes_mode)
        : 0,
      meetingInstallCount: isSet(object.meetingInstallCount)
        ? globalThis.Number(object.meetingInstallCount)
        : isSet(object.meeting_install_count)
        ? globalThis.Number(object.meeting_install_count)
        : 0,
      pendingMeetingInstalls: globalThis.Array.isArray(object?.pendingMeetingInstalls)
        ? object.pendingMeetingInstalls.map((e: any) => TeamsPendingMeetingInstall.fromJSON(e))
        : globalThis.Array.isArray(object?.pending_meeting_installs)
        ? object.pending_meeting_installs.map((e: any) => TeamsPendingMeetingInstall.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListTeamsChannelsResponse): unknown {
    const obj: any = {};
    if (message.teams?.length) {
      obj.teams = message.teams.map((e) => TeamsTeamView.toJSON(e));
    }
    if (message.meetingNotesEnabled !== false) {
      obj.meetingNotesEnabled = message.meetingNotesEnabled;
    }
    if (message.meetingNotesMode !== 0) {
      obj.meetingNotesMode = teamsMeetingNotesModeToJSON(message.meetingNotesMode);
    }
    if (message.meetingInstallCount !== 0) {
      obj.meetingInstallCount = Math.round(message.meetingInstallCount);
    }
    if (message.pendingMeetingInstalls?.length) {
      obj.pendingMeetingInstalls = message.pendingMeetingInstalls.map((e) => TeamsPendingMeetingInstall.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ListTeamsChannelsResponse>): ListTeamsChannelsResponse {
    return ListTeamsChannelsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListTeamsChannelsResponse>): ListTeamsChannelsResponse {
    const message = createBaseListTeamsChannelsResponse();
    message.teams = object.teams?.map((e) => TeamsTeamView.fromPartial(e)) || [];
    message.meetingNotesEnabled = object.meetingNotesEnabled ?? false;
    message.meetingNotesMode = object.meetingNotesMode ?? 0;
    message.meetingInstallCount = object.meetingInstallCount ?? 0;
    message.pendingMeetingInstalls =
      object.pendingMeetingInstalls?.map((e) => TeamsPendingMeetingInstall.fromPartial(e)) || [];
    return message;
  },
};

function createBaseClaimTeamsMeetingInstallRequest(): ClaimTeamsMeetingInstallRequest {
  return { chatId: "" };
}

export const ClaimTeamsMeetingInstallRequest: MessageFns<ClaimTeamsMeetingInstallRequest> = {
  encode(message: ClaimTeamsMeetingInstallRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatId !== "") {
      writer.uint32(10).string(message.chatId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClaimTeamsMeetingInstallRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClaimTeamsMeetingInstallRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClaimTeamsMeetingInstallRequest {
    return {
      chatId: isSet(object.chatId)
        ? globalThis.String(object.chatId)
        : isSet(object.chat_id)
        ? globalThis.String(object.chat_id)
        : "",
    };
  },

  toJSON(message: ClaimTeamsMeetingInstallRequest): unknown {
    const obj: any = {};
    if (message.chatId !== "") {
      obj.chatId = message.chatId;
    }
    return obj;
  },

  create(base?: DeepPartial<ClaimTeamsMeetingInstallRequest>): ClaimTeamsMeetingInstallRequest {
    return ClaimTeamsMeetingInstallRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ClaimTeamsMeetingInstallRequest>): ClaimTeamsMeetingInstallRequest {
    const message = createBaseClaimTeamsMeetingInstallRequest();
    message.chatId = object.chatId ?? "";
    return message;
  },
};

function createBaseClaimTeamsMeetingInstallResponse(): ClaimTeamsMeetingInstallResponse {
  return {};
}

export const ClaimTeamsMeetingInstallResponse: MessageFns<ClaimTeamsMeetingInstallResponse> = {
  encode(_: ClaimTeamsMeetingInstallResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClaimTeamsMeetingInstallResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClaimTeamsMeetingInstallResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ClaimTeamsMeetingInstallResponse {
    return {};
  },

  toJSON(_: ClaimTeamsMeetingInstallResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<ClaimTeamsMeetingInstallResponse>): ClaimTeamsMeetingInstallResponse {
    return ClaimTeamsMeetingInstallResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<ClaimTeamsMeetingInstallResponse>): ClaimTeamsMeetingInstallResponse {
    const message = createBaseClaimTeamsMeetingInstallResponse();
    return message;
  },
};

function createBaseToggleTeamsMeetingNotesRequest(): ToggleTeamsMeetingNotesRequest {
  return { enabled: false, mode: 0 };
}

export const ToggleTeamsMeetingNotesRequest: MessageFns<ToggleTeamsMeetingNotesRequest> = {
  encode(message: ToggleTeamsMeetingNotesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== false) {
      writer.uint32(8).bool(message.enabled);
    }
    if (message.mode !== 0) {
      writer.uint32(16).int32(message.mode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToggleTeamsMeetingNotesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToggleTeamsMeetingNotesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToggleTeamsMeetingNotesRequest {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      mode: isSet(object.mode) ? teamsMeetingNotesModeFromJSON(object.mode) : 0,
    };
  },

  toJSON(message: ToggleTeamsMeetingNotesRequest): unknown {
    const obj: any = {};
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.mode !== 0) {
      obj.mode = teamsMeetingNotesModeToJSON(message.mode);
    }
    return obj;
  },

  create(base?: DeepPartial<ToggleTeamsMeetingNotesRequest>): ToggleTeamsMeetingNotesRequest {
    return ToggleTeamsMeetingNotesRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ToggleTeamsMeetingNotesRequest>): ToggleTeamsMeetingNotesRequest {
    const message = createBaseToggleTeamsMeetingNotesRequest();
    message.enabled = object.enabled ?? false;
    message.mode = object.mode ?? 0;
    return message;
  },
};

function createBaseToggleTeamsMeetingNotesResponse(): ToggleTeamsMeetingNotesResponse {
  return { subscribed: false };
}

export const ToggleTeamsMeetingNotesResponse: MessageFns<ToggleTeamsMeetingNotesResponse> = {
  encode(message: ToggleTeamsMeetingNotesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.subscribed !== false) {
      writer.uint32(8).bool(message.subscribed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToggleTeamsMeetingNotesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToggleTeamsMeetingNotesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.subscribed = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToggleTeamsMeetingNotesResponse {
    return { subscribed: isSet(object.subscribed) ? globalThis.Boolean(object.subscribed) : false };
  },

  toJSON(message: ToggleTeamsMeetingNotesResponse): unknown {
    const obj: any = {};
    if (message.subscribed !== false) {
      obj.subscribed = message.subscribed;
    }
    return obj;
  },

  create(base?: DeepPartial<ToggleTeamsMeetingNotesResponse>): ToggleTeamsMeetingNotesResponse {
    return ToggleTeamsMeetingNotesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ToggleTeamsMeetingNotesResponse>): ToggleTeamsMeetingNotesResponse {
    const message = createBaseToggleTeamsMeetingNotesResponse();
    message.subscribed = object.subscribed ?? false;
    return message;
  },
};

function createBaseToggleTeamsChannelRequest(): ToggleTeamsChannelRequest {
  return { teamId: "", channelId: "", enabled: false };
}

export const ToggleTeamsChannelRequest: MessageFns<ToggleTeamsChannelRequest> = {
  encode(message: ToggleTeamsChannelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.teamId !== "") {
      writer.uint32(10).string(message.teamId);
    }
    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }
    if (message.enabled !== false) {
      writer.uint32(24).bool(message.enabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToggleTeamsChannelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToggleTeamsChannelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.teamId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.channelId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToggleTeamsChannelRequest {
    return {
      teamId: isSet(object.teamId)
        ? globalThis.String(object.teamId)
        : isSet(object.team_id)
        ? globalThis.String(object.team_id)
        : "",
      channelId: isSet(object.channelId)
        ? globalThis.String(object.channelId)
        : isSet(object.channel_id)
        ? globalThis.String(object.channel_id)
        : "",
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
    };
  },

  toJSON(message: ToggleTeamsChannelRequest): unknown {
    const obj: any = {};
    if (message.teamId !== "") {
      obj.teamId = message.teamId;
    }
    if (message.channelId !== "") {
      obj.channelId = message.channelId;
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    return obj;
  },

  create(base?: DeepPartial<ToggleTeamsChannelRequest>): ToggleTeamsChannelRequest {
    return ToggleTeamsChannelRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ToggleTeamsChannelRequest>): ToggleTeamsChannelRequest {
    const message = createBaseToggleTeamsChannelRequest();
    message.teamId = object.teamId ?? "";
    message.channelId = object.channelId ?? "";
    message.enabled = object.enabled ?? false;
    return message;
  },
};

function createBaseToggleTeamsChannelResponse(): ToggleTeamsChannelResponse {
  return { subscribed: false };
}

export const ToggleTeamsChannelResponse: MessageFns<ToggleTeamsChannelResponse> = {
  encode(message: ToggleTeamsChannelResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.subscribed !== false) {
      writer.uint32(8).bool(message.subscribed);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToggleTeamsChannelResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToggleTeamsChannelResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.subscribed = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToggleTeamsChannelResponse {
    return { subscribed: isSet(object.subscribed) ? globalThis.Boolean(object.subscribed) : false };
  },

  toJSON(message: ToggleTeamsChannelResponse): unknown {
    const obj: any = {};
    if (message.subscribed !== false) {
      obj.subscribed = message.subscribed;
    }
    return obj;
  },

  create(base?: DeepPartial<ToggleTeamsChannelResponse>): ToggleTeamsChannelResponse {
    return ToggleTeamsChannelResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ToggleTeamsChannelResponse>): ToggleTeamsChannelResponse {
    const message = createBaseToggleTeamsChannelResponse();
    message.subscribed = object.subscribed ?? false;
    return message;
  },
};

function createBaseGetCompanyUsersResponse(): GetCompanyUsersResponse {
  return { users: [] };
}

export const GetCompanyUsersResponse: MessageFns<GetCompanyUsersResponse> = {
  encode(message: GetCompanyUsersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.users) {
      CompanyUser.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCompanyUsersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCompanyUsersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.users.push(CompanyUser.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCompanyUsersResponse {
    return {
      users: globalThis.Array.isArray(object?.users) ? object.users.map((e: any) => CompanyUser.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetCompanyUsersResponse): unknown {
    const obj: any = {};
    if (message.users?.length) {
      obj.users = message.users.map((e) => CompanyUser.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetCompanyUsersResponse>): GetCompanyUsersResponse {
    return GetCompanyUsersResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetCompanyUsersResponse>): GetCompanyUsersResponse {
    const message = createBaseGetCompanyUsersResponse();
    message.users = object.users?.map((e) => CompanyUser.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetPersonalDigestContextsResponse(): GetPersonalDigestContextsResponse {
  return { contexts: [] };
}

export const GetPersonalDigestContextsResponse: MessageFns<GetPersonalDigestContextsResponse> = {
  encode(message: GetPersonalDigestContextsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.contexts) {
      PersonalDigestContext.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPersonalDigestContextsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPersonalDigestContextsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.contexts.push(PersonalDigestContext.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPersonalDigestContextsResponse {
    return {
      contexts: globalThis.Array.isArray(object?.contexts)
        ? object.contexts.map((e: any) => PersonalDigestContext.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetPersonalDigestContextsResponse): unknown {
    const obj: any = {};
    if (message.contexts?.length) {
      obj.contexts = message.contexts.map((e) => PersonalDigestContext.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetPersonalDigestContextsResponse>): GetPersonalDigestContextsResponse {
    return GetPersonalDigestContextsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetPersonalDigestContextsResponse>): GetPersonalDigestContextsResponse {
    const message = createBaseGetPersonalDigestContextsResponse();
    message.contexts = object.contexts?.map((e) => PersonalDigestContext.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetIdeasResponse(): GetIdeasResponse {
  return { ideas: [] };
}

export const GetIdeasResponse: MessageFns<GetIdeasResponse> = {
  encode(message: GetIdeasResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.ideas) {
      ArtifactIdea.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetIdeasResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetIdeasResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ideas.push(ArtifactIdea.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetIdeasResponse {
    return {
      ideas: globalThis.Array.isArray(object?.ideas) ? object.ideas.map((e: any) => ArtifactIdea.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetIdeasResponse): unknown {
    const obj: any = {};
    if (message.ideas?.length) {
      obj.ideas = message.ideas.map((e) => ArtifactIdea.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetIdeasResponse>): GetIdeasResponse {
    return GetIdeasResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetIdeasResponse>): GetIdeasResponse {
    const message = createBaseGetIdeasResponse();
    message.ideas = object.ideas?.map((e) => ArtifactIdea.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetRepoSummariesResponse(): GetRepoSummariesResponse {
  return { summaries: [], repoSummaries: [], codeResearchMetas: [] };
}

export const GetRepoSummariesResponse: MessageFns<GetRepoSummariesResponse> = {
  encode(message: GetRepoSummariesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.summaries) {
      ArtifactRepoSummary.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.repoSummaries) {
      RepositorySummary.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.codeResearchMetas) {
      CodeResearchOrgMeta.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRepoSummariesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRepoSummariesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.summaries.push(ArtifactRepoSummary.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.repoSummaries.push(RepositorySummary.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.codeResearchMetas.push(CodeResearchOrgMeta.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRepoSummariesResponse {
    return {
      summaries: globalThis.Array.isArray(object?.summaries)
        ? object.summaries.map((e: any) => ArtifactRepoSummary.fromJSON(e))
        : [],
      repoSummaries: globalThis.Array.isArray(object?.repoSummaries)
        ? object.repoSummaries.map((e: any) => RepositorySummary.fromJSON(e))
        : globalThis.Array.isArray(object?.repo_summaries)
        ? object.repo_summaries.map((e: any) => RepositorySummary.fromJSON(e))
        : [],
      codeResearchMetas: globalThis.Array.isArray(object?.codeResearchMetas)
        ? object.codeResearchMetas.map((e: any) => CodeResearchOrgMeta.fromJSON(e))
        : globalThis.Array.isArray(object?.code_research_metas)
        ? object.code_research_metas.map((e: any) => CodeResearchOrgMeta.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetRepoSummariesResponse): unknown {
    const obj: any = {};
    if (message.summaries?.length) {
      obj.summaries = message.summaries.map((e) => ArtifactRepoSummary.toJSON(e));
    }
    if (message.repoSummaries?.length) {
      obj.repoSummaries = message.repoSummaries.map((e) => RepositorySummary.toJSON(e));
    }
    if (message.codeResearchMetas?.length) {
      obj.codeResearchMetas = message.codeResearchMetas.map((e) => CodeResearchOrgMeta.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetRepoSummariesResponse>): GetRepoSummariesResponse {
    return GetRepoSummariesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetRepoSummariesResponse>): GetRepoSummariesResponse {
    const message = createBaseGetRepoSummariesResponse();
    message.summaries = object.summaries?.map((e) => ArtifactRepoSummary.fromPartial(e)) || [];
    message.repoSummaries = object.repoSummaries?.map((e) => RepositorySummary.fromPartial(e)) || [];
    message.codeResearchMetas = object.codeResearchMetas?.map((e) => CodeResearchOrgMeta.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetSitesSummariesResponse(): GetSitesSummariesResponse {
  return { siteSummaries: [] };
}

export const GetSitesSummariesResponse: MessageFns<GetSitesSummariesResponse> = {
  encode(message: GetSitesSummariesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.siteSummaries) {
      WebSiteSummary.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSitesSummariesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSitesSummariesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.siteSummaries.push(WebSiteSummary.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSitesSummariesResponse {
    return {
      siteSummaries: globalThis.Array.isArray(object?.siteSummaries)
        ? object.siteSummaries.map((e: any) => WebSiteSummary.fromJSON(e))
        : globalThis.Array.isArray(object?.site_summaries)
        ? object.site_summaries.map((e: any) => WebSiteSummary.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetSitesSummariesResponse): unknown {
    const obj: any = {};
    if (message.siteSummaries?.length) {
      obj.siteSummaries = message.siteSummaries.map((e) => WebSiteSummary.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetSitesSummariesResponse>): GetSitesSummariesResponse {
    return GetSitesSummariesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetSitesSummariesResponse>): GetSitesSummariesResponse {
    const message = createBaseGetSitesSummariesResponse();
    message.siteSummaries = object.siteSummaries?.map((e) => WebSiteSummary.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetRepoResearchRequest(): GetRepoResearchRequest {
  return { repoId: "", provider: 0, dirKey: "" };
}

export const GetRepoResearchRequest: MessageFns<GetRepoResearchRequest> = {
  encode(message: GetRepoResearchRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.repoId !== "") {
      writer.uint32(10).string(message.repoId);
    }
    if (message.provider !== 0) {
      writer.uint32(16).int32(message.provider);
    }
    if (message.dirKey !== "") {
      writer.uint32(26).string(message.dirKey);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRepoResearchRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRepoResearchRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.repoId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.dirKey = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRepoResearchRequest {
    return {
      repoId: isSet(object.repoId)
        ? globalThis.String(object.repoId)
        : isSet(object.repo_id)
        ? globalThis.String(object.repo_id)
        : "",
      provider: isSet(object.provider) ? gitProviderFromJSON(object.provider) : 0,
      dirKey: isSet(object.dirKey)
        ? globalThis.String(object.dirKey)
        : isSet(object.dir_key)
        ? globalThis.String(object.dir_key)
        : "",
    };
  },

  toJSON(message: GetRepoResearchRequest): unknown {
    const obj: any = {};
    if (message.repoId !== "") {
      obj.repoId = message.repoId;
    }
    if (message.provider !== 0) {
      obj.provider = gitProviderToJSON(message.provider);
    }
    if (message.dirKey !== "") {
      obj.dirKey = message.dirKey;
    }
    return obj;
  },

  create(base?: DeepPartial<GetRepoResearchRequest>): GetRepoResearchRequest {
    return GetRepoResearchRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetRepoResearchRequest>): GetRepoResearchRequest {
    const message = createBaseGetRepoResearchRequest();
    message.repoId = object.repoId ?? "";
    message.provider = object.provider ?? 0;
    message.dirKey = object.dirKey ?? "";
    return message;
  },
};

function createBaseGetRepoResearchResponse(): GetRepoResearchResponse {
  return { research: undefined };
}

export const GetRepoResearchResponse: MessageFns<GetRepoResearchResponse> = {
  encode(message: GetRepoResearchResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.research !== undefined) {
      writer.uint32(10).string(message.research);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRepoResearchResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRepoResearchResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.research = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRepoResearchResponse {
    return { research: isSet(object.research) ? globalThis.String(object.research) : undefined };
  },

  toJSON(message: GetRepoResearchResponse): unknown {
    const obj: any = {};
    if (message.research !== undefined) {
      obj.research = message.research;
    }
    return obj;
  },

  create(base?: DeepPartial<GetRepoResearchResponse>): GetRepoResearchResponse {
    return GetRepoResearchResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetRepoResearchResponse>): GetRepoResearchResponse {
    const message = createBaseGetRepoResearchResponse();
    message.research = object.research ?? undefined;
    return message;
  },
};

function createBaseGetArtifactsListResponse(): GetArtifactsListResponse {
  return { list: undefined };
}

export const GetArtifactsListResponse: MessageFns<GetArtifactsListResponse> = {
  encode(message: GetArtifactsListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.list !== undefined) {
      ArtifactsList.encode(message.list, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetArtifactsListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetArtifactsListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.list = ArtifactsList.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetArtifactsListResponse {
    return { list: isSet(object.list) ? ArtifactsList.fromJSON(object.list) : undefined };
  },

  toJSON(message: GetArtifactsListResponse): unknown {
    const obj: any = {};
    if (message.list !== undefined) {
      obj.list = ArtifactsList.toJSON(message.list);
    }
    return obj;
  },

  create(base?: DeepPartial<GetArtifactsListResponse>): GetArtifactsListResponse {
    return GetArtifactsListResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetArtifactsListResponse>): GetArtifactsListResponse {
    const message = createBaseGetArtifactsListResponse();
    message.list = (object.list !== undefined && object.list !== null)
      ? ArtifactsList.fromPartial(object.list)
      : undefined;
    return message;
  },
};

function createBaseUpsertArtifactsListRequest(): UpsertArtifactsListRequest {
  return { list: undefined };
}

export const UpsertArtifactsListRequest: MessageFns<UpsertArtifactsListRequest> = {
  encode(message: UpsertArtifactsListRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.list !== undefined) {
      ArtifactsList.encode(message.list, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpsertArtifactsListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpsertArtifactsListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.list = ArtifactsList.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpsertArtifactsListRequest {
    return { list: isSet(object.list) ? ArtifactsList.fromJSON(object.list) : undefined };
  },

  toJSON(message: UpsertArtifactsListRequest): unknown {
    const obj: any = {};
    if (message.list !== undefined) {
      obj.list = ArtifactsList.toJSON(message.list);
    }
    return obj;
  },

  create(base?: DeepPartial<UpsertArtifactsListRequest>): UpsertArtifactsListRequest {
    return UpsertArtifactsListRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpsertArtifactsListRequest>): UpsertArtifactsListRequest {
    const message = createBaseUpsertArtifactsListRequest();
    message.list = (object.list !== undefined && object.list !== null)
      ? ArtifactsList.fromPartial(object.list)
      : undefined;
    return message;
  },
};

function createBaseUpsertArtifactsListResponse(): UpsertArtifactsListResponse {
  return { list: undefined };
}

export const UpsertArtifactsListResponse: MessageFns<UpsertArtifactsListResponse> = {
  encode(message: UpsertArtifactsListResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.list !== undefined) {
      ArtifactsList.encode(message.list, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpsertArtifactsListResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpsertArtifactsListResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.list = ArtifactsList.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpsertArtifactsListResponse {
    return { list: isSet(object.list) ? ArtifactsList.fromJSON(object.list) : undefined };
  },

  toJSON(message: UpsertArtifactsListResponse): unknown {
    const obj: any = {};
    if (message.list !== undefined) {
      obj.list = ArtifactsList.toJSON(message.list);
    }
    return obj;
  },

  create(base?: DeepPartial<UpsertArtifactsListResponse>): UpsertArtifactsListResponse {
    return UpsertArtifactsListResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpsertArtifactsListResponse>): UpsertArtifactsListResponse {
    const message = createBaseUpsertArtifactsListResponse();
    message.list = (object.list !== undefined && object.list !== null)
      ? ArtifactsList.fromPartial(object.list)
      : undefined;
    return message;
  },
};

function createBaseUpsertCommentRequest(): UpsertCommentRequest {
  return { comment: undefined, associations: undefined };
}

export const UpsertCommentRequest: MessageFns<UpsertCommentRequest> = {
  encode(message: UpsertCommentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.comment !== undefined) {
      Comment.encode(message.comment, writer.uint32(10).fork()).join();
    }
    if (message.associations !== undefined) {
      CommentAssociations.encode(message.associations, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpsertCommentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpsertCommentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.comment = Comment.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.associations = CommentAssociations.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpsertCommentRequest {
    return {
      comment: isSet(object.comment) ? Comment.fromJSON(object.comment) : undefined,
      associations: isSet(object.associations) ? CommentAssociations.fromJSON(object.associations) : undefined,
    };
  },

  toJSON(message: UpsertCommentRequest): unknown {
    const obj: any = {};
    if (message.comment !== undefined) {
      obj.comment = Comment.toJSON(message.comment);
    }
    if (message.associations !== undefined) {
      obj.associations = CommentAssociations.toJSON(message.associations);
    }
    return obj;
  },

  create(base?: DeepPartial<UpsertCommentRequest>): UpsertCommentRequest {
    return UpsertCommentRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpsertCommentRequest>): UpsertCommentRequest {
    const message = createBaseUpsertCommentRequest();
    message.comment = (object.comment !== undefined && object.comment !== null)
      ? Comment.fromPartial(object.comment)
      : undefined;
    message.associations = (object.associations !== undefined && object.associations !== null)
      ? CommentAssociations.fromPartial(object.associations)
      : undefined;
    return message;
  },
};

function createBaseUpsertCommentResponse(): UpsertCommentResponse {
  return { thread: undefined, commentId: "" };
}

export const UpsertCommentResponse: MessageFns<UpsertCommentResponse> = {
  encode(message: UpsertCommentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.thread !== undefined) {
      ThreadWithComments.encode(message.thread, writer.uint32(10).fork()).join();
    }
    if (message.commentId !== "") {
      writer.uint32(18).string(message.commentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpsertCommentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpsertCommentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.thread = ThreadWithComments.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.commentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpsertCommentResponse {
    return {
      thread: isSet(object.thread) ? ThreadWithComments.fromJSON(object.thread) : undefined,
      commentId: isSet(object.commentId)
        ? globalThis.String(object.commentId)
        : isSet(object.comment_id)
        ? globalThis.String(object.comment_id)
        : "",
    };
  },

  toJSON(message: UpsertCommentResponse): unknown {
    const obj: any = {};
    if (message.thread !== undefined) {
      obj.thread = ThreadWithComments.toJSON(message.thread);
    }
    if (message.commentId !== "") {
      obj.commentId = message.commentId;
    }
    return obj;
  },

  create(base?: DeepPartial<UpsertCommentResponse>): UpsertCommentResponse {
    return UpsertCommentResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpsertCommentResponse>): UpsertCommentResponse {
    const message = createBaseUpsertCommentResponse();
    message.thread = (object.thread !== undefined && object.thread !== null)
      ? ThreadWithComments.fromPartial(object.thread)
      : undefined;
    message.commentId = object.commentId ?? "";
    return message;
  },
};

function createBaseDeleteCommentRequest(): DeleteCommentRequest {
  return { id: "" };
}

export const DeleteCommentRequest: MessageFns<DeleteCommentRequest> = {
  encode(message: DeleteCommentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteCommentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteCommentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteCommentRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: DeleteCommentRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteCommentRequest>): DeleteCommentRequest {
    return DeleteCommentRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteCommentRequest>): DeleteCommentRequest {
    const message = createBaseDeleteCommentRequest();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseDeleteCommentResponse(): DeleteCommentResponse {
  return { thread: undefined };
}

export const DeleteCommentResponse: MessageFns<DeleteCommentResponse> = {
  encode(message: DeleteCommentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.thread !== undefined) {
      ThreadWithComments.encode(message.thread, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteCommentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteCommentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.thread = ThreadWithComments.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteCommentResponse {
    return { thread: isSet(object.thread) ? ThreadWithComments.fromJSON(object.thread) : undefined };
  },

  toJSON(message: DeleteCommentResponse): unknown {
    const obj: any = {};
    if (message.thread !== undefined) {
      obj.thread = ThreadWithComments.toJSON(message.thread);
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteCommentResponse>): DeleteCommentResponse {
    return DeleteCommentResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteCommentResponse>): DeleteCommentResponse {
    const message = createBaseDeleteCommentResponse();
    message.thread = (object.thread !== undefined && object.thread !== null)
      ? ThreadWithComments.fromPartial(object.thread)
      : undefined;
    return message;
  },
};

function createBaseGetThreadCommentsResponse(): GetThreadCommentsResponse {
  return { thread: undefined };
}

export const GetThreadCommentsResponse: MessageFns<GetThreadCommentsResponse> = {
  encode(message: GetThreadCommentsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.thread !== undefined) {
      ThreadWithComments.encode(message.thread, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetThreadCommentsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetThreadCommentsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.thread = ThreadWithComments.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetThreadCommentsResponse {
    return { thread: isSet(object.thread) ? ThreadWithComments.fromJSON(object.thread) : undefined };
  },

  toJSON(message: GetThreadCommentsResponse): unknown {
    const obj: any = {};
    if (message.thread !== undefined) {
      obj.thread = ThreadWithComments.toJSON(message.thread);
    }
    return obj;
  },

  create(base?: DeepPartial<GetThreadCommentsResponse>): GetThreadCommentsResponse {
    return GetThreadCommentsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetThreadCommentsResponse>): GetThreadCommentsResponse {
    const message = createBaseGetThreadCommentsResponse();
    message.thread = (object.thread !== undefined && object.thread !== null)
      ? ThreadWithComments.fromPartial(object.thread)
      : undefined;
    return message;
  },
};

function createBaseUpdateCommentsThreadRequest(): UpdateCommentsThreadRequest {
  return { thread: undefined };
}

export const UpdateCommentsThreadRequest: MessageFns<UpdateCommentsThreadRequest> = {
  encode(message: UpdateCommentsThreadRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.thread !== undefined) {
      CommentThread.encode(message.thread, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCommentsThreadRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCommentsThreadRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.thread = CommentThread.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateCommentsThreadRequest {
    return { thread: isSet(object.thread) ? CommentThread.fromJSON(object.thread) : undefined };
  },

  toJSON(message: UpdateCommentsThreadRequest): unknown {
    const obj: any = {};
    if (message.thread !== undefined) {
      obj.thread = CommentThread.toJSON(message.thread);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateCommentsThreadRequest>): UpdateCommentsThreadRequest {
    return UpdateCommentsThreadRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateCommentsThreadRequest>): UpdateCommentsThreadRequest {
    const message = createBaseUpdateCommentsThreadRequest();
    message.thread = (object.thread !== undefined && object.thread !== null)
      ? CommentThread.fromPartial(object.thread)
      : undefined;
    return message;
  },
};

function createBaseUpdateCommentsThreadResponse(): UpdateCommentsThreadResponse {
  return { thread: undefined };
}

export const UpdateCommentsThreadResponse: MessageFns<UpdateCommentsThreadResponse> = {
  encode(message: UpdateCommentsThreadResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.thread !== undefined) {
      CommentThread.encode(message.thread, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCommentsThreadResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCommentsThreadResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.thread = CommentThread.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateCommentsThreadResponse {
    return { thread: isSet(object.thread) ? CommentThread.fromJSON(object.thread) : undefined };
  },

  toJSON(message: UpdateCommentsThreadResponse): unknown {
    const obj: any = {};
    if (message.thread !== undefined) {
      obj.thread = CommentThread.toJSON(message.thread);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateCommentsThreadResponse>): UpdateCommentsThreadResponse {
    return UpdateCommentsThreadResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateCommentsThreadResponse>): UpdateCommentsThreadResponse {
    const message = createBaseUpdateCommentsThreadResponse();
    message.thread = (object.thread !== undefined && object.thread !== null)
      ? CommentThread.fromPartial(object.thread)
      : undefined;
    return message;
  },
};

function createBaseGetDocumentCommentThreadsResponse(): GetDocumentCommentThreadsResponse {
  return { threads: [] };
}

export const GetDocumentCommentThreadsResponse: MessageFns<GetDocumentCommentThreadsResponse> = {
  encode(message: GetDocumentCommentThreadsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.threads) {
      ThreadWithComments.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDocumentCommentThreadsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDocumentCommentThreadsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.threads.push(ThreadWithComments.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDocumentCommentThreadsResponse {
    return {
      threads: globalThis.Array.isArray(object?.threads)
        ? object.threads.map((e: any) => ThreadWithComments.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetDocumentCommentThreadsResponse): unknown {
    const obj: any = {};
    if (message.threads?.length) {
      obj.threads = message.threads.map((e) => ThreadWithComments.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetDocumentCommentThreadsResponse>): GetDocumentCommentThreadsResponse {
    return GetDocumentCommentThreadsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetDocumentCommentThreadsResponse>): GetDocumentCommentThreadsResponse {
    const message = createBaseGetDocumentCommentThreadsResponse();
    message.threads = object.threads?.map((e) => ThreadWithComments.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDeleteUserFromCompanyResponse(): DeleteUserFromCompanyResponse {
  return { users: [] };
}

export const DeleteUserFromCompanyResponse: MessageFns<DeleteUserFromCompanyResponse> = {
  encode(message: DeleteUserFromCompanyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.users) {
      CompanyUser.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteUserFromCompanyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteUserFromCompanyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.users.push(CompanyUser.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteUserFromCompanyResponse {
    return {
      users: globalThis.Array.isArray(object?.users) ? object.users.map((e: any) => CompanyUser.fromJSON(e)) : [],
    };
  },

  toJSON(message: DeleteUserFromCompanyResponse): unknown {
    const obj: any = {};
    if (message.users?.length) {
      obj.users = message.users.map((e) => CompanyUser.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteUserFromCompanyResponse>): DeleteUserFromCompanyResponse {
    return DeleteUserFromCompanyResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteUserFromCompanyResponse>): DeleteUserFromCompanyResponse {
    const message = createBaseDeleteUserFromCompanyResponse();
    message.users = object.users?.map((e) => CompanyUser.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateUserCompanyRolesRequest(): UpdateUserCompanyRolesRequest {
  return { newRoles: [] };
}

export const UpdateUserCompanyRolesRequest: MessageFns<UpdateUserCompanyRolesRequest> = {
  encode(message: UpdateUserCompanyRolesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.newRoles) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateUserCompanyRolesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateUserCompanyRolesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.newRoles.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateUserCompanyRolesRequest {
    return {
      newRoles: globalThis.Array.isArray(object?.newRoles)
        ? object.newRoles.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.new_roles)
        ? object.new_roles.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: UpdateUserCompanyRolesRequest): unknown {
    const obj: any = {};
    if (message.newRoles?.length) {
      obj.newRoles = message.newRoles;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateUserCompanyRolesRequest>): UpdateUserCompanyRolesRequest {
    return UpdateUserCompanyRolesRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateUserCompanyRolesRequest>): UpdateUserCompanyRolesRequest {
    const message = createBaseUpdateUserCompanyRolesRequest();
    message.newRoles = object.newRoles?.map((e) => e) || [];
    return message;
  },
};

function createBaseUpdateUserCompanyRolesResponse(): UpdateUserCompanyRolesResponse {
  return { users: [] };
}

export const UpdateUserCompanyRolesResponse: MessageFns<UpdateUserCompanyRolesResponse> = {
  encode(message: UpdateUserCompanyRolesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.users) {
      CompanyUser.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateUserCompanyRolesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateUserCompanyRolesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.users.push(CompanyUser.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateUserCompanyRolesResponse {
    return {
      users: globalThis.Array.isArray(object?.users) ? object.users.map((e: any) => CompanyUser.fromJSON(e)) : [],
    };
  },

  toJSON(message: UpdateUserCompanyRolesResponse): unknown {
    const obj: any = {};
    if (message.users?.length) {
      obj.users = message.users.map((e) => CompanyUser.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateUserCompanyRolesResponse>): UpdateUserCompanyRolesResponse {
    return UpdateUserCompanyRolesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateUserCompanyRolesResponse>): UpdateUserCompanyRolesResponse {
    const message = createBaseUpdateUserCompanyRolesResponse();
    message.users = object.users?.map((e) => CompanyUser.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCompanyInvitesResponse(): GetCompanyInvitesResponse {
  return { invites: [] };
}

export const GetCompanyInvitesResponse: MessageFns<GetCompanyInvitesResponse> = {
  encode(message: GetCompanyInvitesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.invites) {
      UserCompanyInvite.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCompanyInvitesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCompanyInvitesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.invites.push(UserCompanyInvite.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCompanyInvitesResponse {
    return {
      invites: globalThis.Array.isArray(object?.invites)
        ? object.invites.map((e: any) => UserCompanyInvite.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCompanyInvitesResponse): unknown {
    const obj: any = {};
    if (message.invites?.length) {
      obj.invites = message.invites.map((e) => UserCompanyInvite.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetCompanyInvitesResponse>): GetCompanyInvitesResponse {
    return GetCompanyInvitesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetCompanyInvitesResponse>): GetCompanyInvitesResponse {
    const message = createBaseGetCompanyInvitesResponse();
    message.invites = object.invites?.map((e) => UserCompanyInvite.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCompanyInvitesForUserResponse(): GetCompanyInvitesForUserResponse {
  return { invites: [] };
}

export const GetCompanyInvitesForUserResponse: MessageFns<GetCompanyInvitesForUserResponse> = {
  encode(message: GetCompanyInvitesForUserResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.invites) {
      UserCompanyInvite.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCompanyInvitesForUserResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCompanyInvitesForUserResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.invites.push(UserCompanyInvite.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCompanyInvitesForUserResponse {
    return {
      invites: globalThis.Array.isArray(object?.invites)
        ? object.invites.map((e: any) => UserCompanyInvite.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCompanyInvitesForUserResponse): unknown {
    const obj: any = {};
    if (message.invites?.length) {
      obj.invites = message.invites.map((e) => UserCompanyInvite.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetCompanyInvitesForUserResponse>): GetCompanyInvitesForUserResponse {
    return GetCompanyInvitesForUserResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetCompanyInvitesForUserResponse>): GetCompanyInvitesForUserResponse {
    const message = createBaseGetCompanyInvitesForUserResponse();
    message.invites = object.invites?.map((e) => UserCompanyInvite.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSendCompanyInvitesRequest(): SendCompanyInvitesRequest {
  return { emails: [], role: "" };
}

export const SendCompanyInvitesRequest: MessageFns<SendCompanyInvitesRequest> = {
  encode(message: SendCompanyInvitesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.emails) {
      writer.uint32(10).string(v!);
    }
    if (message.role !== "") {
      writer.uint32(18).string(message.role);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendCompanyInvitesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendCompanyInvitesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.emails.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.role = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendCompanyInvitesRequest {
    return {
      emails: globalThis.Array.isArray(object?.emails) ? object.emails.map((e: any) => globalThis.String(e)) : [],
      role: isSet(object.role) ? globalThis.String(object.role) : "",
    };
  },

  toJSON(message: SendCompanyInvitesRequest): unknown {
    const obj: any = {};
    if (message.emails?.length) {
      obj.emails = message.emails;
    }
    if (message.role !== "") {
      obj.role = message.role;
    }
    return obj;
  },

  create(base?: DeepPartial<SendCompanyInvitesRequest>): SendCompanyInvitesRequest {
    return SendCompanyInvitesRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SendCompanyInvitesRequest>): SendCompanyInvitesRequest {
    const message = createBaseSendCompanyInvitesRequest();
    message.emails = object.emails?.map((e) => e) || [];
    message.role = object.role ?? "";
    return message;
  },
};

function createBaseSendCompanyInvitesResponse(): SendCompanyInvitesResponse {
  return { invites: [] };
}

export const SendCompanyInvitesResponse: MessageFns<SendCompanyInvitesResponse> = {
  encode(message: SendCompanyInvitesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.invites) {
      UserCompanyInvite.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendCompanyInvitesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendCompanyInvitesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.invites.push(UserCompanyInvite.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendCompanyInvitesResponse {
    return {
      invites: globalThis.Array.isArray(object?.invites)
        ? object.invites.map((e: any) => UserCompanyInvite.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SendCompanyInvitesResponse): unknown {
    const obj: any = {};
    if (message.invites?.length) {
      obj.invites = message.invites.map((e) => UserCompanyInvite.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<SendCompanyInvitesResponse>): SendCompanyInvitesResponse {
    return SendCompanyInvitesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SendCompanyInvitesResponse>): SendCompanyInvitesResponse {
    const message = createBaseSendCompanyInvitesResponse();
    message.invites = object.invites?.map((e) => UserCompanyInvite.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDeleteUserCompanyInviteRequest(): DeleteUserCompanyInviteRequest {
  return { email: "" };
}

export const DeleteUserCompanyInviteRequest: MessageFns<DeleteUserCompanyInviteRequest> = {
  encode(message: DeleteUserCompanyInviteRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteUserCompanyInviteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteUserCompanyInviteRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteUserCompanyInviteRequest {
    return { email: isSet(object.email) ? globalThis.String(object.email) : "" };
  },

  toJSON(message: DeleteUserCompanyInviteRequest): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteUserCompanyInviteRequest>): DeleteUserCompanyInviteRequest {
    return DeleteUserCompanyInviteRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteUserCompanyInviteRequest>): DeleteUserCompanyInviteRequest {
    const message = createBaseDeleteUserCompanyInviteRequest();
    message.email = object.email ?? "";
    return message;
  },
};

function createBaseDeleteUserCompanyInviteResponse(): DeleteUserCompanyInviteResponse {
  return { invites: [] };
}

export const DeleteUserCompanyInviteResponse: MessageFns<DeleteUserCompanyInviteResponse> = {
  encode(message: DeleteUserCompanyInviteResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.invites) {
      UserCompanyInvite.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteUserCompanyInviteResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteUserCompanyInviteResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.invites.push(UserCompanyInvite.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteUserCompanyInviteResponse {
    return {
      invites: globalThis.Array.isArray(object?.invites)
        ? object.invites.map((e: any) => UserCompanyInvite.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DeleteUserCompanyInviteResponse): unknown {
    const obj: any = {};
    if (message.invites?.length) {
      obj.invites = message.invites.map((e) => UserCompanyInvite.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteUserCompanyInviteResponse>): DeleteUserCompanyInviteResponse {
    return DeleteUserCompanyInviteResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteUserCompanyInviteResponse>): DeleteUserCompanyInviteResponse {
    const message = createBaseDeleteUserCompanyInviteResponse();
    message.invites = object.invites?.map((e) => UserCompanyInvite.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateCompanyRequest(): CreateCompanyRequest {
  return { company: undefined, createSeparateForMatchingDomain: false };
}

export const CreateCompanyRequest: MessageFns<CreateCompanyRequest> = {
  encode(message: CreateCompanyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.company !== undefined) {
      CompanyDetails.encode(message.company, writer.uint32(10).fork()).join();
    }
    if (message.createSeparateForMatchingDomain !== false) {
      writer.uint32(16).bool(message.createSeparateForMatchingDomain);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCompanyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateCompanyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.company = CompanyDetails.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.createSeparateForMatchingDomain = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateCompanyRequest {
    return {
      company: isSet(object.company) ? CompanyDetails.fromJSON(object.company) : undefined,
      createSeparateForMatchingDomain: isSet(object.createSeparateForMatchingDomain)
        ? globalThis.Boolean(object.createSeparateForMatchingDomain)
        : isSet(object.create_separate_for_matching_domain)
        ? globalThis.Boolean(object.create_separate_for_matching_domain)
        : false,
    };
  },

  toJSON(message: CreateCompanyRequest): unknown {
    const obj: any = {};
    if (message.company !== undefined) {
      obj.company = CompanyDetails.toJSON(message.company);
    }
    if (message.createSeparateForMatchingDomain !== false) {
      obj.createSeparateForMatchingDomain = message.createSeparateForMatchingDomain;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateCompanyRequest>): CreateCompanyRequest {
    return CreateCompanyRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateCompanyRequest>): CreateCompanyRequest {
    const message = createBaseCreateCompanyRequest();
    message.company = (object.company !== undefined && object.company !== null)
      ? CompanyDetails.fromPartial(object.company)
      : undefined;
    message.createSeparateForMatchingDomain = object.createSeparateForMatchingDomain ?? false;
    return message;
  },
};

function createBaseCreateCompanyResponse(): CreateCompanyResponse {
  return { company: undefined };
}

export const CreateCompanyResponse: MessageFns<CreateCompanyResponse> = {
  encode(message: CreateCompanyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.company !== undefined) {
      CompanyDetails.encode(message.company, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCompanyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateCompanyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.company = CompanyDetails.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateCompanyResponse {
    return { company: isSet(object.company) ? CompanyDetails.fromJSON(object.company) : undefined };
  },

  toJSON(message: CreateCompanyResponse): unknown {
    const obj: any = {};
    if (message.company !== undefined) {
      obj.company = CompanyDetails.toJSON(message.company);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateCompanyResponse>): CreateCompanyResponse {
    return CreateCompanyResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateCompanyResponse>): CreateCompanyResponse {
    const message = createBaseCreateCompanyResponse();
    message.company = (object.company !== undefined && object.company !== null)
      ? CompanyDetails.fromPartial(object.company)
      : undefined;
    return message;
  },
};

function createBaseUpsertGroupRequest(): UpsertGroupRequest {
  return { group: undefined };
}

export const UpsertGroupRequest: MessageFns<UpsertGroupRequest> = {
  encode(message: UpsertGroupRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.group !== undefined) {
      Group.encode(message.group, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpsertGroupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpsertGroupRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.group = Group.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpsertGroupRequest {
    return { group: isSet(object.group) ? Group.fromJSON(object.group) : undefined };
  },

  toJSON(message: UpsertGroupRequest): unknown {
    const obj: any = {};
    if (message.group !== undefined) {
      obj.group = Group.toJSON(message.group);
    }
    return obj;
  },

  create(base?: DeepPartial<UpsertGroupRequest>): UpsertGroupRequest {
    return UpsertGroupRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpsertGroupRequest>): UpsertGroupRequest {
    const message = createBaseUpsertGroupRequest();
    message.group = (object.group !== undefined && object.group !== null) ? Group.fromPartial(object.group) : undefined;
    return message;
  },
};

function createBaseUpsertGroupResponse(): UpsertGroupResponse {
  return { group: undefined };
}

export const UpsertGroupResponse: MessageFns<UpsertGroupResponse> = {
  encode(message: UpsertGroupResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.group !== undefined) {
      Group.encode(message.group, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpsertGroupResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpsertGroupResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.group = Group.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpsertGroupResponse {
    return { group: isSet(object.group) ? Group.fromJSON(object.group) : undefined };
  },

  toJSON(message: UpsertGroupResponse): unknown {
    const obj: any = {};
    if (message.group !== undefined) {
      obj.group = Group.toJSON(message.group);
    }
    return obj;
  },

  create(base?: DeepPartial<UpsertGroupResponse>): UpsertGroupResponse {
    return UpsertGroupResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpsertGroupResponse>): UpsertGroupResponse {
    const message = createBaseUpsertGroupResponse();
    message.group = (object.group !== undefined && object.group !== null) ? Group.fromPartial(object.group) : undefined;
    return message;
  },
};

function createBaseGetGroupResponse(): GetGroupResponse {
  return { group: undefined };
}

export const GetGroupResponse: MessageFns<GetGroupResponse> = {
  encode(message: GetGroupResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.group !== undefined) {
      Group.encode(message.group, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetGroupResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetGroupResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.group = Group.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetGroupResponse {
    return { group: isSet(object.group) ? Group.fromJSON(object.group) : undefined };
  },

  toJSON(message: GetGroupResponse): unknown {
    const obj: any = {};
    if (message.group !== undefined) {
      obj.group = Group.toJSON(message.group);
    }
    return obj;
  },

  create(base?: DeepPartial<GetGroupResponse>): GetGroupResponse {
    return GetGroupResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetGroupResponse>): GetGroupResponse {
    const message = createBaseGetGroupResponse();
    message.group = (object.group !== undefined && object.group !== null) ? Group.fromPartial(object.group) : undefined;
    return message;
  },
};

function createBaseListGroupsResponse(): ListGroupsResponse {
  return { groups: [] };
}

export const ListGroupsResponse: MessageFns<ListGroupsResponse> = {
  encode(message: ListGroupsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.groups) {
      Group.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListGroupsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListGroupsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.groups.push(Group.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListGroupsResponse {
    return { groups: globalThis.Array.isArray(object?.groups) ? object.groups.map((e: any) => Group.fromJSON(e)) : [] };
  },

  toJSON(message: ListGroupsResponse): unknown {
    const obj: any = {};
    if (message.groups?.length) {
      obj.groups = message.groups.map((e) => Group.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ListGroupsResponse>): ListGroupsResponse {
    return ListGroupsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListGroupsResponse>): ListGroupsResponse {
    const message = createBaseListGroupsResponse();
    message.groups = object.groups?.map((e) => Group.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRepositoryMetaActionRequest(): RepositoryMetaActionRequest {
  return { action: undefined };
}

export const RepositoryMetaActionRequest: MessageFns<RepositoryMetaActionRequest> = {
  encode(message: RepositoryMetaActionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.action?.$case) {
      case "reprocess":
        RepositoryMetaActionRequest_Reprocess.encode(message.action.value, writer.uint32(802).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepositoryMetaActionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepositoryMetaActionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.action = {
            $case: "reprocess",
            value: RepositoryMetaActionRequest_Reprocess.decode(reader, reader.uint32()),
          };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepositoryMetaActionRequest {
    return {
      action: isSet(object.reprocess)
        ? { $case: "reprocess", value: RepositoryMetaActionRequest_Reprocess.fromJSON(object.reprocess) }
        : undefined,
    };
  },

  toJSON(message: RepositoryMetaActionRequest): unknown {
    const obj: any = {};
    if (message.action?.$case === "reprocess") {
      obj.reprocess = RepositoryMetaActionRequest_Reprocess.toJSON(message.action.value);
    }
    return obj;
  },

  create(base?: DeepPartial<RepositoryMetaActionRequest>): RepositoryMetaActionRequest {
    return RepositoryMetaActionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RepositoryMetaActionRequest>): RepositoryMetaActionRequest {
    const message = createBaseRepositoryMetaActionRequest();
    switch (object.action?.$case) {
      case "reprocess": {
        if (object.action?.value !== undefined && object.action?.value !== null) {
          message.action = {
            $case: "reprocess",
            value: RepositoryMetaActionRequest_Reprocess.fromPartial(object.action.value),
          };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseRepositoryMetaActionRequest_Reprocess(): RepositoryMetaActionRequest_Reprocess {
  return { repoId: undefined };
}

export const RepositoryMetaActionRequest_Reprocess: MessageFns<RepositoryMetaActionRequest_Reprocess> = {
  encode(message: RepositoryMetaActionRequest_Reprocess, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.repoId !== undefined) {
      writer.uint32(10).string(message.repoId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepositoryMetaActionRequest_Reprocess {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepositoryMetaActionRequest_Reprocess();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.repoId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepositoryMetaActionRequest_Reprocess {
    return {
      repoId: isSet(object.repoId)
        ? globalThis.String(object.repoId)
        : isSet(object.repo_id)
        ? globalThis.String(object.repo_id)
        : undefined,
    };
  },

  toJSON(message: RepositoryMetaActionRequest_Reprocess): unknown {
    const obj: any = {};
    if (message.repoId !== undefined) {
      obj.repoId = message.repoId;
    }
    return obj;
  },

  create(base?: DeepPartial<RepositoryMetaActionRequest_Reprocess>): RepositoryMetaActionRequest_Reprocess {
    return RepositoryMetaActionRequest_Reprocess.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RepositoryMetaActionRequest_Reprocess>): RepositoryMetaActionRequest_Reprocess {
    const message = createBaseRepositoryMetaActionRequest_Reprocess();
    message.repoId = object.repoId ?? undefined;
    return message;
  },
};

function createBaseRepositoryMetaActionResponse(): RepositoryMetaActionResponse {
  return {};
}

export const RepositoryMetaActionResponse: MessageFns<RepositoryMetaActionResponse> = {
  encode(_: RepositoryMetaActionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepositoryMetaActionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepositoryMetaActionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RepositoryMetaActionResponse {
    return {};
  },

  toJSON(_: RepositoryMetaActionResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<RepositoryMetaActionResponse>): RepositoryMetaActionResponse {
    return RepositoryMetaActionResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<RepositoryMetaActionResponse>): RepositoryMetaActionResponse {
    const message = createBaseRepositoryMetaActionResponse();
    return message;
  },
};

function createBaseSelectRepositoriesRequest(): SelectRepositoriesRequest {
  return { provider: 0, repositoryIds: [] };
}

export const SelectRepositoriesRequest: MessageFns<SelectRepositoriesRequest> = {
  encode(message: SelectRepositoriesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.provider !== 0) {
      writer.uint32(8).int32(message.provider);
    }
    for (const v of message.repositoryIds) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SelectRepositoriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSelectRepositoriesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.repositoryIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SelectRepositoriesRequest {
    return {
      provider: isSet(object.provider) ? gitProviderFromJSON(object.provider) : 0,
      repositoryIds: globalThis.Array.isArray(object?.repositoryIds)
        ? object.repositoryIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.repository_ids)
        ? object.repository_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: SelectRepositoriesRequest): unknown {
    const obj: any = {};
    if (message.provider !== 0) {
      obj.provider = gitProviderToJSON(message.provider);
    }
    if (message.repositoryIds?.length) {
      obj.repositoryIds = message.repositoryIds;
    }
    return obj;
  },

  create(base?: DeepPartial<SelectRepositoriesRequest>): SelectRepositoriesRequest {
    return SelectRepositoriesRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SelectRepositoriesRequest>): SelectRepositoriesRequest {
    const message = createBaseSelectRepositoriesRequest();
    message.provider = object.provider ?? 0;
    message.repositoryIds = object.repositoryIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseSelectRepositoriesResponse(): SelectRepositoriesResponse {
  return { repositories: [], newlyEnabledRepositoryIds: [] };
}

export const SelectRepositoriesResponse: MessageFns<SelectRepositoriesResponse> = {
  encode(message: SelectRepositoriesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.repositories) {
      GitRepository.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.newlyEnabledRepositoryIds) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SelectRepositoriesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSelectRepositoriesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.repositories.push(GitRepository.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.newlyEnabledRepositoryIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SelectRepositoriesResponse {
    return {
      repositories: globalThis.Array.isArray(object?.repositories)
        ? object.repositories.map((e: any) => GitRepository.fromJSON(e))
        : [],
      newlyEnabledRepositoryIds: globalThis.Array.isArray(object?.newlyEnabledRepositoryIds)
        ? object.newlyEnabledRepositoryIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.newly_enabled_repository_ids)
        ? object.newly_enabled_repository_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: SelectRepositoriesResponse): unknown {
    const obj: any = {};
    if (message.repositories?.length) {
      obj.repositories = message.repositories.map((e) => GitRepository.toJSON(e));
    }
    if (message.newlyEnabledRepositoryIds?.length) {
      obj.newlyEnabledRepositoryIds = message.newlyEnabledRepositoryIds;
    }
    return obj;
  },

  create(base?: DeepPartial<SelectRepositoriesResponse>): SelectRepositoriesResponse {
    return SelectRepositoriesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SelectRepositoriesResponse>): SelectRepositoriesResponse {
    const message = createBaseSelectRepositoriesResponse();
    message.repositories = object.repositories?.map((e) => GitRepository.fromPartial(e)) || [];
    message.newlyEnabledRepositoryIds = object.newlyEnabledRepositoryIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetProjectsWithDocsResponse(): GetProjectsWithDocsResponse {
  return { projects: [] };
}

export const GetProjectsWithDocsResponse: MessageFns<GetProjectsWithDocsResponse> = {
  encode(message: GetProjectsWithDocsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.projects) {
      ProjectWithDocs.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetProjectsWithDocsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetProjectsWithDocsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.projects.push(ProjectWithDocs.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetProjectsWithDocsResponse {
    return {
      projects: globalThis.Array.isArray(object?.projects)
        ? object.projects.map((e: any) => ProjectWithDocs.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetProjectsWithDocsResponse): unknown {
    const obj: any = {};
    if (message.projects?.length) {
      obj.projects = message.projects.map((e) => ProjectWithDocs.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetProjectsWithDocsResponse>): GetProjectsWithDocsResponse {
    return GetProjectsWithDocsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetProjectsWithDocsResponse>): GetProjectsWithDocsResponse {
    const message = createBaseGetProjectsWithDocsResponse();
    message.projects = object.projects?.map((e) => ProjectWithDocs.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSetProjectArchiveStatusRequest(): SetProjectArchiveStatusRequest {
  return { isArchived: false };
}

export const SetProjectArchiveStatusRequest: MessageFns<SetProjectArchiveStatusRequest> = {
  encode(message: SetProjectArchiveStatusRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isArchived !== false) {
      writer.uint32(8).bool(message.isArchived);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetProjectArchiveStatusRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetProjectArchiveStatusRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.isArchived = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetProjectArchiveStatusRequest {
    return {
      isArchived: isSet(object.isArchived)
        ? globalThis.Boolean(object.isArchived)
        : isSet(object.is_archived)
        ? globalThis.Boolean(object.is_archived)
        : false,
    };
  },

  toJSON(message: SetProjectArchiveStatusRequest): unknown {
    const obj: any = {};
    if (message.isArchived !== false) {
      obj.isArchived = message.isArchived;
    }
    return obj;
  },

  create(base?: DeepPartial<SetProjectArchiveStatusRequest>): SetProjectArchiveStatusRequest {
    return SetProjectArchiveStatusRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetProjectArchiveStatusRequest>): SetProjectArchiveStatusRequest {
    const message = createBaseSetProjectArchiveStatusRequest();
    message.isArchived = object.isArchived ?? false;
    return message;
  },
};

function createBaseSetProjectArchiveStatusResponse(): SetProjectArchiveStatusResponse {
  return { project: undefined };
}

export const SetProjectArchiveStatusResponse: MessageFns<SetProjectArchiveStatusResponse> = {
  encode(message: SetProjectArchiveStatusResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.project !== undefined) {
      ProjectEntity.encode(message.project, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetProjectArchiveStatusResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetProjectArchiveStatusResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.project = ProjectEntity.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetProjectArchiveStatusResponse {
    return { project: isSet(object.project) ? ProjectEntity.fromJSON(object.project) : undefined };
  },

  toJSON(message: SetProjectArchiveStatusResponse): unknown {
    const obj: any = {};
    if (message.project !== undefined) {
      obj.project = ProjectEntity.toJSON(message.project);
    }
    return obj;
  },

  create(base?: DeepPartial<SetProjectArchiveStatusResponse>): SetProjectArchiveStatusResponse {
    return SetProjectArchiveStatusResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetProjectArchiveStatusResponse>): SetProjectArchiveStatusResponse {
    const message = createBaseSetProjectArchiveStatusResponse();
    message.project = (object.project !== undefined && object.project !== null)
      ? ProjectEntity.fromPartial(object.project)
      : undefined;
    return message;
  },
};

function createBaseListRepoMetadataResponse(): ListRepoMetadataResponse {
  return { metadata: [] };
}

export const ListRepoMetadataResponse: MessageFns<ListRepoMetadataResponse> = {
  encode(message: ListRepoMetadataResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.metadata) {
      RepoMetadata.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListRepoMetadataResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListRepoMetadataResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata.push(RepoMetadata.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListRepoMetadataResponse {
    return {
      metadata: globalThis.Array.isArray(object?.metadata)
        ? object.metadata.map((e: any) => RepoMetadata.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListRepoMetadataResponse): unknown {
    const obj: any = {};
    if (message.metadata?.length) {
      obj.metadata = message.metadata.map((e) => RepoMetadata.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ListRepoMetadataResponse>): ListRepoMetadataResponse {
    return ListRepoMetadataResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListRepoMetadataResponse>): ListRepoMetadataResponse {
    const message = createBaseListRepoMetadataResponse();
    message.metadata = object.metadata?.map((e) => RepoMetadata.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateRepoMetadataRequest(): UpdateRepoMetadataRequest {
  return { metadata: undefined };
}

export const UpdateRepoMetadataRequest: MessageFns<UpdateRepoMetadataRequest> = {
  encode(message: UpdateRepoMetadataRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      RepoMetadata.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateRepoMetadataRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateRepoMetadataRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = RepoMetadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateRepoMetadataRequest {
    return { metadata: isSet(object.metadata) ? RepoMetadata.fromJSON(object.metadata) : undefined };
  },

  toJSON(message: UpdateRepoMetadataRequest): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = RepoMetadata.toJSON(message.metadata);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateRepoMetadataRequest>): UpdateRepoMetadataRequest {
    return UpdateRepoMetadataRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateRepoMetadataRequest>): UpdateRepoMetadataRequest {
    const message = createBaseUpdateRepoMetadataRequest();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? RepoMetadata.fromPartial(object.metadata)
      : undefined;
    return message;
  },
};

function createBaseRescanRepoRequest(): RescanRepoRequest {
  return {};
}

export const RescanRepoRequest: MessageFns<RescanRepoRequest> = {
  encode(_: RescanRepoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RescanRepoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRescanRepoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RescanRepoRequest {
    return {};
  },

  toJSON(_: RescanRepoRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<RescanRepoRequest>): RescanRepoRequest {
    return RescanRepoRequest.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<RescanRepoRequest>): RescanRepoRequest {
    const message = createBaseRescanRepoRequest();
    return message;
  },
};

function createBaseRescanRepoResponse(): RescanRepoResponse {
  return {};
}

export const RescanRepoResponse: MessageFns<RescanRepoResponse> = {
  encode(_: RescanRepoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RescanRepoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRescanRepoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RescanRepoResponse {
    return {};
  },

  toJSON(_: RescanRepoResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<RescanRepoResponse>): RescanRepoResponse {
    return RescanRepoResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<RescanRepoResponse>): RescanRepoResponse {
    const message = createBaseRescanRepoResponse();
    return message;
  },
};

function createBaseRescanSiteRequest(): RescanSiteRequest {
  return { url: "" };
}

export const RescanSiteRequest: MessageFns<RescanSiteRequest> = {
  encode(message: RescanSiteRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RescanSiteRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRescanSiteRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RescanSiteRequest {
    return { url: isSet(object.url) ? globalThis.String(object.url) : "" };
  },

  toJSON(message: RescanSiteRequest): unknown {
    const obj: any = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create(base?: DeepPartial<RescanSiteRequest>): RescanSiteRequest {
    return RescanSiteRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RescanSiteRequest>): RescanSiteRequest {
    const message = createBaseRescanSiteRequest();
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseRescanSiteResponse(): RescanSiteResponse {
  return {};
}

export const RescanSiteResponse: MessageFns<RescanSiteResponse> = {
  encode(_: RescanSiteResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RescanSiteResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRescanSiteResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RescanSiteResponse {
    return {};
  },

  toJSON(_: RescanSiteResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<RescanSiteResponse>): RescanSiteResponse {
    return RescanSiteResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<RescanSiteResponse>): RescanSiteResponse {
    const message = createBaseRescanSiteResponse();
    return message;
  },
};

function createBaseUpdateRepoMetadataResponse(): UpdateRepoMetadataResponse {
  return { metadata: undefined };
}

export const UpdateRepoMetadataResponse: MessageFns<UpdateRepoMetadataResponse> = {
  encode(message: UpdateRepoMetadataResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      RepoMetadata.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateRepoMetadataResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateRepoMetadataResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = RepoMetadata.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateRepoMetadataResponse {
    return { metadata: isSet(object.metadata) ? RepoMetadata.fromJSON(object.metadata) : undefined };
  },

  toJSON(message: UpdateRepoMetadataResponse): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = RepoMetadata.toJSON(message.metadata);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateRepoMetadataResponse>): UpdateRepoMetadataResponse {
    return UpdateRepoMetadataResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateRepoMetadataResponse>): UpdateRepoMetadataResponse {
    const message = createBaseUpdateRepoMetadataResponse();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? RepoMetadata.fromPartial(object.metadata)
      : undefined;
    return message;
  },
};

function createBaseGenerateProjectNameResponse(): GenerateProjectNameResponse {
  return { project: undefined };
}

export const GenerateProjectNameResponse: MessageFns<GenerateProjectNameResponse> = {
  encode(message: GenerateProjectNameResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.project !== undefined) {
      ProjectEntity.encode(message.project, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateProjectNameResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateProjectNameResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.project = ProjectEntity.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateProjectNameResponse {
    return { project: isSet(object.project) ? ProjectEntity.fromJSON(object.project) : undefined };
  },

  toJSON(message: GenerateProjectNameResponse): unknown {
    const obj: any = {};
    if (message.project !== undefined) {
      obj.project = ProjectEntity.toJSON(message.project);
    }
    return obj;
  },

  create(base?: DeepPartial<GenerateProjectNameResponse>): GenerateProjectNameResponse {
    return GenerateProjectNameResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GenerateProjectNameResponse>): GenerateProjectNameResponse {
    const message = createBaseGenerateProjectNameResponse();
    message.project = (object.project !== undefined && object.project !== null)
      ? ProjectEntity.fromPartial(object.project)
      : undefined;
    return message;
  },
};

function createBaseCreateProjectWithRequirementsRequest(): CreateProjectWithRequirementsRequest {
  return {
    projectTemplateId: "",
    title: undefined,
    initialInput: undefined,
    uploadedSpec: false,
    description: undefined,
    kind: undefined,
    tagIds: [],
    owner: undefined,
    releaseId: undefined,
    targetDate: undefined,
    sectionKey: undefined,
    descriptionAsPrdContent: false,
  };
}

export const CreateProjectWithRequirementsRequest: MessageFns<CreateProjectWithRequirementsRequest> = {
  encode(message: CreateProjectWithRequirementsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.projectTemplateId !== "") {
      writer.uint32(10).string(message.projectTemplateId);
    }
    if (message.title !== undefined) {
      writer.uint32(18).string(message.title);
    }
    if (message.initialInput !== undefined) {
      DocumentInitialInput.encode(message.initialInput, writer.uint32(26).fork()).join();
    }
    if (message.uploadedSpec !== false) {
      writer.uint32(32).bool(message.uploadedSpec);
    }
    if (message.description !== undefined) {
      writer.uint32(42).string(message.description);
    }
    if (message.kind !== undefined) {
      writer.uint32(50).string(message.kind);
    }
    for (const v of message.tagIds) {
      writer.uint32(58).string(v!);
    }
    if (message.owner !== undefined) {
      writer.uint32(66).string(message.owner);
    }
    if (message.releaseId !== undefined) {
      writer.uint32(74).string(message.releaseId);
    }
    if (message.targetDate !== undefined) {
      Timestamp.encode(toTimestamp(message.targetDate), writer.uint32(82).fork()).join();
    }
    if (message.sectionKey !== undefined) {
      writer.uint32(90).string(message.sectionKey);
    }
    if (message.descriptionAsPrdContent !== false) {
      writer.uint32(96).bool(message.descriptionAsPrdContent);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateProjectWithRequirementsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateProjectWithRequirementsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.projectTemplateId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.initialInput = DocumentInitialInput.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.uploadedSpec = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.kind = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.tagIds.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.owner = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.releaseId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.targetDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.sectionKey = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.descriptionAsPrdContent = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateProjectWithRequirementsRequest {
    return {
      projectTemplateId: isSet(object.projectTemplateId)
        ? globalThis.String(object.projectTemplateId)
        : isSet(object.project_template_id)
        ? globalThis.String(object.project_template_id)
        : "",
      title: isSet(object.title) ? globalThis.String(object.title) : undefined,
      initialInput: isSet(object.initialInput)
        ? DocumentInitialInput.fromJSON(object.initialInput)
        : isSet(object.initial_input)
        ? DocumentInitialInput.fromJSON(object.initial_input)
        : undefined,
      uploadedSpec: isSet(object.uploadedSpec)
        ? globalThis.Boolean(object.uploadedSpec)
        : isSet(object.uploaded_spec)
        ? globalThis.Boolean(object.uploaded_spec)
        : false,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      kind: isSet(object.kind) ? globalThis.String(object.kind) : undefined,
      tagIds: globalThis.Array.isArray(object?.tagIds)
        ? object.tagIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.tag_ids)
        ? object.tag_ids.map((e: any) => globalThis.String(e))
        : [],
      owner: isSet(object.owner) ? globalThis.String(object.owner) : undefined,
      releaseId: isSet(object.releaseId)
        ? globalThis.String(object.releaseId)
        : isSet(object.release_id)
        ? globalThis.String(object.release_id)
        : undefined,
      targetDate: isSet(object.targetDate)
        ? fromJsonTimestamp(object.targetDate)
        : isSet(object.target_date)
        ? fromJsonTimestamp(object.target_date)
        : undefined,
      sectionKey: isSet(object.sectionKey)
        ? globalThis.String(object.sectionKey)
        : isSet(object.section_key)
        ? globalThis.String(object.section_key)
        : undefined,
      descriptionAsPrdContent: isSet(object.descriptionAsPrdContent)
        ? globalThis.Boolean(object.descriptionAsPrdContent)
        : isSet(object.description_as_prd_content)
        ? globalThis.Boolean(object.description_as_prd_content)
        : false,
    };
  },

  toJSON(message: CreateProjectWithRequirementsRequest): unknown {
    const obj: any = {};
    if (message.projectTemplateId !== "") {
      obj.projectTemplateId = message.projectTemplateId;
    }
    if (message.title !== undefined) {
      obj.title = message.title;
    }
    if (message.initialInput !== undefined) {
      obj.initialInput = DocumentInitialInput.toJSON(message.initialInput);
    }
    if (message.uploadedSpec !== false) {
      obj.uploadedSpec = message.uploadedSpec;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.kind !== undefined) {
      obj.kind = message.kind;
    }
    if (message.tagIds?.length) {
      obj.tagIds = message.tagIds;
    }
    if (message.owner !== undefined) {
      obj.owner = message.owner;
    }
    if (message.releaseId !== undefined) {
      obj.releaseId = message.releaseId;
    }
    if (message.targetDate !== undefined) {
      obj.targetDate = message.targetDate.toISOString();
    }
    if (message.sectionKey !== undefined) {
      obj.sectionKey = message.sectionKey;
    }
    if (message.descriptionAsPrdContent !== false) {
      obj.descriptionAsPrdContent = message.descriptionAsPrdContent;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateProjectWithRequirementsRequest>): CreateProjectWithRequirementsRequest {
    return CreateProjectWithRequirementsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateProjectWithRequirementsRequest>): CreateProjectWithRequirementsRequest {
    const message = createBaseCreateProjectWithRequirementsRequest();
    message.projectTemplateId = object.projectTemplateId ?? "";
    message.title = object.title ?? undefined;
    message.initialInput = (object.initialInput !== undefined && object.initialInput !== null)
      ? DocumentInitialInput.fromPartial(object.initialInput)
      : undefined;
    message.uploadedSpec = object.uploadedSpec ?? false;
    message.description = object.description ?? undefined;
    message.kind = object.kind ?? undefined;
    message.tagIds = object.tagIds?.map((e) => e) || [];
    message.owner = object.owner ?? undefined;
    message.releaseId = object.releaseId ?? undefined;
    message.targetDate = object.targetDate ?? undefined;
    message.sectionKey = object.sectionKey ?? undefined;
    message.descriptionAsPrdContent = object.descriptionAsPrdContent ?? false;
    return message;
  },
};

function createBaseCreateProjectWithRequirementsResponse(): CreateProjectWithRequirementsResponse {
  return { projectId: "", project: undefined };
}

export const CreateProjectWithRequirementsResponse: MessageFns<CreateProjectWithRequirementsResponse> = {
  encode(message: CreateProjectWithRequirementsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.projectId !== "") {
      writer.uint32(10).string(message.projectId);
    }
    if (message.project !== undefined) {
      ProjectEntity.encode(message.project, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateProjectWithRequirementsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateProjectWithRequirementsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.project = ProjectEntity.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateProjectWithRequirementsResponse {
    return {
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : "",
      project: isSet(object.project) ? ProjectEntity.fromJSON(object.project) : undefined,
    };
  },

  toJSON(message: CreateProjectWithRequirementsResponse): unknown {
    const obj: any = {};
    if (message.projectId !== "") {
      obj.projectId = message.projectId;
    }
    if (message.project !== undefined) {
      obj.project = ProjectEntity.toJSON(message.project);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateProjectWithRequirementsResponse>): CreateProjectWithRequirementsResponse {
    return CreateProjectWithRequirementsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateProjectWithRequirementsResponse>): CreateProjectWithRequirementsResponse {
    const message = createBaseCreateProjectWithRequirementsResponse();
    message.projectId = object.projectId ?? "";
    message.project = (object.project !== undefined && object.project !== null)
      ? ProjectEntity.fromPartial(object.project)
      : undefined;
    return message;
  },
};

function createBaseCreateSignedLinkRequest(): CreateSignedLinkRequest {
  return { target: undefined };
}

export const CreateSignedLinkRequest: MessageFns<CreateSignedLinkRequest> = {
  encode(message: CreateSignedLinkRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.target !== undefined) {
      SignedLinkTarget.encode(message.target, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateSignedLinkRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateSignedLinkRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.target = SignedLinkTarget.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateSignedLinkRequest {
    return { target: isSet(object.target) ? SignedLinkTarget.fromJSON(object.target) : undefined };
  },

  toJSON(message: CreateSignedLinkRequest): unknown {
    const obj: any = {};
    if (message.target !== undefined) {
      obj.target = SignedLinkTarget.toJSON(message.target);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateSignedLinkRequest>): CreateSignedLinkRequest {
    return CreateSignedLinkRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateSignedLinkRequest>): CreateSignedLinkRequest {
    const message = createBaseCreateSignedLinkRequest();
    message.target = (object.target !== undefined && object.target !== null)
      ? SignedLinkTarget.fromPartial(object.target)
      : undefined;
    return message;
  },
};

function createBaseCreateSignedLinkResponse(): CreateSignedLinkResponse {
  return { id: "", url: "" };
}

export const CreateSignedLinkResponse: MessageFns<CreateSignedLinkResponse> = {
  encode(message: CreateSignedLinkResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.url !== "") {
      writer.uint32(18).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateSignedLinkResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateSignedLinkResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateSignedLinkResponse {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
    };
  },

  toJSON(message: CreateSignedLinkResponse): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateSignedLinkResponse>): CreateSignedLinkResponse {
    return CreateSignedLinkResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateSignedLinkResponse>): CreateSignedLinkResponse {
    const message = createBaseCreateSignedLinkResponse();
    message.id = object.id ?? "";
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseCreateEmptyDocumentRequest(): CreateEmptyDocumentRequest {
  return { projectId: "", templateId: "", title: "", type: 0, unique: false };
}

export const CreateEmptyDocumentRequest: MessageFns<CreateEmptyDocumentRequest> = {
  encode(message: CreateEmptyDocumentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.projectId !== "") {
      writer.uint32(10).string(message.projectId);
    }
    if (message.templateId !== "") {
      writer.uint32(18).string(message.templateId);
    }
    if (message.title !== "") {
      writer.uint32(26).string(message.title);
    }
    if (message.type !== 0) {
      writer.uint32(32).int32(message.type);
    }
    if (message.unique !== false) {
      writer.uint32(40).bool(message.unique);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateEmptyDocumentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateEmptyDocumentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.templateId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.unique = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateEmptyDocumentRequest {
    return {
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : "",
      templateId: isSet(object.templateId)
        ? globalThis.String(object.templateId)
        : isSet(object.template_id)
        ? globalThis.String(object.template_id)
        : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      type: isSet(object.type) ? documentTypeFromJSON(object.type) : 0,
      unique: isSet(object.unique) ? globalThis.Boolean(object.unique) : false,
    };
  },

  toJSON(message: CreateEmptyDocumentRequest): unknown {
    const obj: any = {};
    if (message.projectId !== "") {
      obj.projectId = message.projectId;
    }
    if (message.templateId !== "") {
      obj.templateId = message.templateId;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.type !== 0) {
      obj.type = documentTypeToJSON(message.type);
    }
    if (message.unique !== false) {
      obj.unique = message.unique;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateEmptyDocumentRequest>): CreateEmptyDocumentRequest {
    return CreateEmptyDocumentRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateEmptyDocumentRequest>): CreateEmptyDocumentRequest {
    const message = createBaseCreateEmptyDocumentRequest();
    message.projectId = object.projectId ?? "";
    message.templateId = object.templateId ?? "";
    message.title = object.title ?? "";
    message.type = object.type ?? 0;
    message.unique = object.unique ?? false;
    return message;
  },
};

function createBaseCreateEmptyDocumentResponse(): CreateEmptyDocumentResponse {
  return { document: undefined };
}

export const CreateEmptyDocumentResponse: MessageFns<CreateEmptyDocumentResponse> = {
  encode(message: CreateEmptyDocumentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.document !== undefined) {
      DocumentEntity.encode(message.document, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateEmptyDocumentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateEmptyDocumentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.document = DocumentEntity.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateEmptyDocumentResponse {
    return { document: isSet(object.document) ? DocumentEntity.fromJSON(object.document) : undefined };
  },

  toJSON(message: CreateEmptyDocumentResponse): unknown {
    const obj: any = {};
    if (message.document !== undefined) {
      obj.document = DocumentEntity.toJSON(message.document);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateEmptyDocumentResponse>): CreateEmptyDocumentResponse {
    return CreateEmptyDocumentResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateEmptyDocumentResponse>): CreateEmptyDocumentResponse {
    const message = createBaseCreateEmptyDocumentResponse();
    message.document = (object.document !== undefined && object.document !== null)
      ? DocumentEntity.fromPartial(object.document)
      : undefined;
    return message;
  },
};

function createBaseUpdatePulseEnrollmentRequest(): UpdatePulseEnrollmentRequest {
  return { enrollment: undefined };
}

export const UpdatePulseEnrollmentRequest: MessageFns<UpdatePulseEnrollmentRequest> = {
  encode(message: UpdatePulseEnrollmentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enrollment !== undefined) {
      PulseEnrollment.encode(message.enrollment, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdatePulseEnrollmentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdatePulseEnrollmentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.enrollment = PulseEnrollment.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdatePulseEnrollmentRequest {
    return { enrollment: isSet(object.enrollment) ? PulseEnrollment.fromJSON(object.enrollment) : undefined };
  },

  toJSON(message: UpdatePulseEnrollmentRequest): unknown {
    const obj: any = {};
    if (message.enrollment !== undefined) {
      obj.enrollment = PulseEnrollment.toJSON(message.enrollment);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdatePulseEnrollmentRequest>): UpdatePulseEnrollmentRequest {
    return UpdatePulseEnrollmentRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdatePulseEnrollmentRequest>): UpdatePulseEnrollmentRequest {
    const message = createBaseUpdatePulseEnrollmentRequest();
    message.enrollment = (object.enrollment !== undefined && object.enrollment !== null)
      ? PulseEnrollment.fromPartial(object.enrollment)
      : undefined;
    return message;
  },
};

function createBaseUpdatePulseEnrollmentResponse(): UpdatePulseEnrollmentResponse {
  return { enrollment: undefined };
}

export const UpdatePulseEnrollmentResponse: MessageFns<UpdatePulseEnrollmentResponse> = {
  encode(message: UpdatePulseEnrollmentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enrollment !== undefined) {
      PulseEnrollment.encode(message.enrollment, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdatePulseEnrollmentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdatePulseEnrollmentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.enrollment = PulseEnrollment.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdatePulseEnrollmentResponse {
    return { enrollment: isSet(object.enrollment) ? PulseEnrollment.fromJSON(object.enrollment) : undefined };
  },

  toJSON(message: UpdatePulseEnrollmentResponse): unknown {
    const obj: any = {};
    if (message.enrollment !== undefined) {
      obj.enrollment = PulseEnrollment.toJSON(message.enrollment);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdatePulseEnrollmentResponse>): UpdatePulseEnrollmentResponse {
    return UpdatePulseEnrollmentResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdatePulseEnrollmentResponse>): UpdatePulseEnrollmentResponse {
    const message = createBaseUpdatePulseEnrollmentResponse();
    message.enrollment = (object.enrollment !== undefined && object.enrollment !== null)
      ? PulseEnrollment.fromPartial(object.enrollment)
      : undefined;
    return message;
  },
};

function createBaseGetPulseEnrollmentRequest(): GetPulseEnrollmentRequest {
  return { companyId: 0 };
}

export const GetPulseEnrollmentRequest: MessageFns<GetPulseEnrollmentRequest> = {
  encode(message: GetPulseEnrollmentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPulseEnrollmentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPulseEnrollmentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPulseEnrollmentRequest {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
    };
  },

  toJSON(message: GetPulseEnrollmentRequest): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    return obj;
  },

  create(base?: DeepPartial<GetPulseEnrollmentRequest>): GetPulseEnrollmentRequest {
    return GetPulseEnrollmentRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetPulseEnrollmentRequest>): GetPulseEnrollmentRequest {
    const message = createBaseGetPulseEnrollmentRequest();
    message.companyId = object.companyId ?? 0;
    return message;
  },
};

function createBaseGetPulseEnrollmentResponse(): GetPulseEnrollmentResponse {
  return { enrollment: undefined };
}

export const GetPulseEnrollmentResponse: MessageFns<GetPulseEnrollmentResponse> = {
  encode(message: GetPulseEnrollmentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enrollment !== undefined) {
      PulseEnrollment.encode(message.enrollment, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPulseEnrollmentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPulseEnrollmentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.enrollment = PulseEnrollment.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPulseEnrollmentResponse {
    return { enrollment: isSet(object.enrollment) ? PulseEnrollment.fromJSON(object.enrollment) : undefined };
  },

  toJSON(message: GetPulseEnrollmentResponse): unknown {
    const obj: any = {};
    if (message.enrollment !== undefined) {
      obj.enrollment = PulseEnrollment.toJSON(message.enrollment);
    }
    return obj;
  },

  create(base?: DeepPartial<GetPulseEnrollmentResponse>): GetPulseEnrollmentResponse {
    return GetPulseEnrollmentResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetPulseEnrollmentResponse>): GetPulseEnrollmentResponse {
    const message = createBaseGetPulseEnrollmentResponse();
    message.enrollment = (object.enrollment !== undefined && object.enrollment !== null)
      ? PulseEnrollment.fromPartial(object.enrollment)
      : undefined;
    return message;
  },
};

function createBaseGetPulseDigestsRequest(): GetPulseDigestsRequest {
  return { fromDate: undefined, toDate: undefined };
}

export const GetPulseDigestsRequest: MessageFns<GetPulseDigestsRequest> = {
  encode(message: GetPulseDigestsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fromDate !== undefined) {
      Timestamp.encode(toTimestamp(message.fromDate), writer.uint32(10).fork()).join();
    }
    if (message.toDate !== undefined) {
      Timestamp.encode(toTimestamp(message.toDate), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPulseDigestsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPulseDigestsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fromDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.toDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPulseDigestsRequest {
    return {
      fromDate: isSet(object.fromDate)
        ? fromJsonTimestamp(object.fromDate)
        : isSet(object.from_date)
        ? fromJsonTimestamp(object.from_date)
        : undefined,
      toDate: isSet(object.toDate)
        ? fromJsonTimestamp(object.toDate)
        : isSet(object.to_date)
        ? fromJsonTimestamp(object.to_date)
        : undefined,
    };
  },

  toJSON(message: GetPulseDigestsRequest): unknown {
    const obj: any = {};
    if (message.fromDate !== undefined) {
      obj.fromDate = message.fromDate.toISOString();
    }
    if (message.toDate !== undefined) {
      obj.toDate = message.toDate.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<GetPulseDigestsRequest>): GetPulseDigestsRequest {
    return GetPulseDigestsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetPulseDigestsRequest>): GetPulseDigestsRequest {
    const message = createBaseGetPulseDigestsRequest();
    message.fromDate = object.fromDate ?? undefined;
    message.toDate = object.toDate ?? undefined;
    return message;
  },
};

function createBaseGetPulseDigestsResponse(): GetPulseDigestsResponse {
  return { digests: [] };
}

export const GetPulseDigestsResponse: MessageFns<GetPulseDigestsResponse> = {
  encode(message: GetPulseDigestsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.digests) {
      PulseDigest.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPulseDigestsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPulseDigestsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.digests.push(PulseDigest.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPulseDigestsResponse {
    return {
      digests: globalThis.Array.isArray(object?.digests) ? object.digests.map((e: any) => PulseDigest.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetPulseDigestsResponse): unknown {
    const obj: any = {};
    if (message.digests?.length) {
      obj.digests = message.digests.map((e) => PulseDigest.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetPulseDigestsResponse>): GetPulseDigestsResponse {
    return GetPulseDigestsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetPulseDigestsResponse>): GetPulseDigestsResponse {
    const message = createBaseGetPulseDigestsResponse();
    message.digests = object.digests?.map((e) => PulseDigest.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetCompanySettingsResponse(): GetCompanySettingsResponse {
  return { settings: undefined };
}

export const GetCompanySettingsResponse: MessageFns<GetCompanySettingsResponse> = {
  encode(message: GetCompanySettingsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.settings !== undefined) {
      CompanySettings.encode(message.settings, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCompanySettingsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCompanySettingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.settings = CompanySettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCompanySettingsResponse {
    return { settings: isSet(object.settings) ? CompanySettings.fromJSON(object.settings) : undefined };
  },

  toJSON(message: GetCompanySettingsResponse): unknown {
    const obj: any = {};
    if (message.settings !== undefined) {
      obj.settings = CompanySettings.toJSON(message.settings);
    }
    return obj;
  },

  create(base?: DeepPartial<GetCompanySettingsResponse>): GetCompanySettingsResponse {
    return GetCompanySettingsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetCompanySettingsResponse>): GetCompanySettingsResponse {
    const message = createBaseGetCompanySettingsResponse();
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? CompanySettings.fromPartial(object.settings)
      : undefined;
    return message;
  },
};

function createBaseUpdateCodeResearchEnrollRequest(): UpdateCodeResearchEnrollRequest {
  return { enroll: false };
}

export const UpdateCodeResearchEnrollRequest: MessageFns<UpdateCodeResearchEnrollRequest> = {
  encode(message: UpdateCodeResearchEnrollRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enroll !== false) {
      writer.uint32(8).bool(message.enroll);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCodeResearchEnrollRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCodeResearchEnrollRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enroll = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateCodeResearchEnrollRequest {
    return { enroll: isSet(object.enroll) ? globalThis.Boolean(object.enroll) : false };
  },

  toJSON(message: UpdateCodeResearchEnrollRequest): unknown {
    const obj: any = {};
    if (message.enroll !== false) {
      obj.enroll = message.enroll;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateCodeResearchEnrollRequest>): UpdateCodeResearchEnrollRequest {
    return UpdateCodeResearchEnrollRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateCodeResearchEnrollRequest>): UpdateCodeResearchEnrollRequest {
    const message = createBaseUpdateCodeResearchEnrollRequest();
    message.enroll = object.enroll ?? false;
    return message;
  },
};

function createBaseUpdateCodeResearchEnrollResponse(): UpdateCodeResearchEnrollResponse {
  return { settings: undefined };
}

export const UpdateCodeResearchEnrollResponse: MessageFns<UpdateCodeResearchEnrollResponse> = {
  encode(message: UpdateCodeResearchEnrollResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.settings !== undefined) {
      CompanySettings.encode(message.settings, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCodeResearchEnrollResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCodeResearchEnrollResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.settings = CompanySettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateCodeResearchEnrollResponse {
    return { settings: isSet(object.settings) ? CompanySettings.fromJSON(object.settings) : undefined };
  },

  toJSON(message: UpdateCodeResearchEnrollResponse): unknown {
    const obj: any = {};
    if (message.settings !== undefined) {
      obj.settings = CompanySettings.toJSON(message.settings);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateCodeResearchEnrollResponse>): UpdateCodeResearchEnrollResponse {
    return UpdateCodeResearchEnrollResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateCodeResearchEnrollResponse>): UpdateCodeResearchEnrollResponse {
    const message = createBaseUpdateCodeResearchEnrollResponse();
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? CompanySettings.fromPartial(object.settings)
      : undefined;
    return message;
  },
};

function createBaseSetSpecsEnabledRequest(): SetSpecsEnabledRequest {
  return { specsEnabled: false };
}

export const SetSpecsEnabledRequest: MessageFns<SetSpecsEnabledRequest> = {
  encode(message: SetSpecsEnabledRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.specsEnabled !== false) {
      writer.uint32(8).bool(message.specsEnabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetSpecsEnabledRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetSpecsEnabledRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.specsEnabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetSpecsEnabledRequest {
    return {
      specsEnabled: isSet(object.specsEnabled)
        ? globalThis.Boolean(object.specsEnabled)
        : isSet(object.specs_enabled)
        ? globalThis.Boolean(object.specs_enabled)
        : false,
    };
  },

  toJSON(message: SetSpecsEnabledRequest): unknown {
    const obj: any = {};
    if (message.specsEnabled !== false) {
      obj.specsEnabled = message.specsEnabled;
    }
    return obj;
  },

  create(base?: DeepPartial<SetSpecsEnabledRequest>): SetSpecsEnabledRequest {
    return SetSpecsEnabledRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetSpecsEnabledRequest>): SetSpecsEnabledRequest {
    const message = createBaseSetSpecsEnabledRequest();
    message.specsEnabled = object.specsEnabled ?? false;
    return message;
  },
};

function createBaseSetSpecsEnabledResponse(): SetSpecsEnabledResponse {
  return { settings: undefined };
}

export const SetSpecsEnabledResponse: MessageFns<SetSpecsEnabledResponse> = {
  encode(message: SetSpecsEnabledResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.settings !== undefined) {
      CompanySettings.encode(message.settings, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetSpecsEnabledResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetSpecsEnabledResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.settings = CompanySettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetSpecsEnabledResponse {
    return { settings: isSet(object.settings) ? CompanySettings.fromJSON(object.settings) : undefined };
  },

  toJSON(message: SetSpecsEnabledResponse): unknown {
    const obj: any = {};
    if (message.settings !== undefined) {
      obj.settings = CompanySettings.toJSON(message.settings);
    }
    return obj;
  },

  create(base?: DeepPartial<SetSpecsEnabledResponse>): SetSpecsEnabledResponse {
    return SetSpecsEnabledResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetSpecsEnabledResponse>): SetSpecsEnabledResponse {
    const message = createBaseSetSpecsEnabledResponse();
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? CompanySettings.fromPartial(object.settings)
      : undefined;
    return message;
  },
};

function createBaseSetRoadmapDefaultRequest(): SetRoadmapDefaultRequest {
  return { roadmapDefault: undefined };
}

export const SetRoadmapDefaultRequest: MessageFns<SetRoadmapDefaultRequest> = {
  encode(message: SetRoadmapDefaultRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.roadmapDefault !== undefined) {
      RoadmapDefaultView.encode(message.roadmapDefault, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetRoadmapDefaultRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetRoadmapDefaultRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.roadmapDefault = RoadmapDefaultView.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetRoadmapDefaultRequest {
    return {
      roadmapDefault: isSet(object.roadmapDefault)
        ? RoadmapDefaultView.fromJSON(object.roadmapDefault)
        : isSet(object.roadmap_default)
        ? RoadmapDefaultView.fromJSON(object.roadmap_default)
        : undefined,
    };
  },

  toJSON(message: SetRoadmapDefaultRequest): unknown {
    const obj: any = {};
    if (message.roadmapDefault !== undefined) {
      obj.roadmapDefault = RoadmapDefaultView.toJSON(message.roadmapDefault);
    }
    return obj;
  },

  create(base?: DeepPartial<SetRoadmapDefaultRequest>): SetRoadmapDefaultRequest {
    return SetRoadmapDefaultRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetRoadmapDefaultRequest>): SetRoadmapDefaultRequest {
    const message = createBaseSetRoadmapDefaultRequest();
    message.roadmapDefault = (object.roadmapDefault !== undefined && object.roadmapDefault !== null)
      ? RoadmapDefaultView.fromPartial(object.roadmapDefault)
      : undefined;
    return message;
  },
};

function createBaseSetRoadmapDefaultResponse(): SetRoadmapDefaultResponse {
  return { settings: undefined };
}

export const SetRoadmapDefaultResponse: MessageFns<SetRoadmapDefaultResponse> = {
  encode(message: SetRoadmapDefaultResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.settings !== undefined) {
      CompanySettings.encode(message.settings, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetRoadmapDefaultResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetRoadmapDefaultResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.settings = CompanySettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetRoadmapDefaultResponse {
    return { settings: isSet(object.settings) ? CompanySettings.fromJSON(object.settings) : undefined };
  },

  toJSON(message: SetRoadmapDefaultResponse): unknown {
    const obj: any = {};
    if (message.settings !== undefined) {
      obj.settings = CompanySettings.toJSON(message.settings);
    }
    return obj;
  },

  create(base?: DeepPartial<SetRoadmapDefaultResponse>): SetRoadmapDefaultResponse {
    return SetRoadmapDefaultResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetRoadmapDefaultResponse>): SetRoadmapDefaultResponse {
    const message = createBaseSetRoadmapDefaultResponse();
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? CompanySettings.fromPartial(object.settings)
      : undefined;
    return message;
  },
};

function createBaseGetRequiredJiraFieldsRequest(): GetRequiredJiraFieldsRequest {
  return { jiraProjectKey: "", issueType: "" };
}

export const GetRequiredJiraFieldsRequest: MessageFns<GetRequiredJiraFieldsRequest> = {
  encode(message: GetRequiredJiraFieldsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jiraProjectKey !== "") {
      writer.uint32(10).string(message.jiraProjectKey);
    }
    if (message.issueType !== "") {
      writer.uint32(18).string(message.issueType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRequiredJiraFieldsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRequiredJiraFieldsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jiraProjectKey = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.issueType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRequiredJiraFieldsRequest {
    return {
      jiraProjectKey: isSet(object.jiraProjectKey)
        ? globalThis.String(object.jiraProjectKey)
        : isSet(object.jira_project_key)
        ? globalThis.String(object.jira_project_key)
        : "",
      issueType: isSet(object.issueType)
        ? globalThis.String(object.issueType)
        : isSet(object.issue_type)
        ? globalThis.String(object.issue_type)
        : "",
    };
  },

  toJSON(message: GetRequiredJiraFieldsRequest): unknown {
    const obj: any = {};
    if (message.jiraProjectKey !== "") {
      obj.jiraProjectKey = message.jiraProjectKey;
    }
    if (message.issueType !== "") {
      obj.issueType = message.issueType;
    }
    return obj;
  },

  create(base?: DeepPartial<GetRequiredJiraFieldsRequest>): GetRequiredJiraFieldsRequest {
    return GetRequiredJiraFieldsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetRequiredJiraFieldsRequest>): GetRequiredJiraFieldsRequest {
    const message = createBaseGetRequiredJiraFieldsRequest();
    message.jiraProjectKey = object.jiraProjectKey ?? "";
    message.issueType = object.issueType ?? "";
    return message;
  },
};

function createBaseGetRequiredJiraFieldsResponse(): GetRequiredJiraFieldsResponse {
  return { fields: [] };
}

export const GetRequiredJiraFieldsResponse: MessageFns<GetRequiredJiraFieldsResponse> = {
  encode(message: GetRequiredJiraFieldsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.fields) {
      JiraField.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRequiredJiraFieldsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRequiredJiraFieldsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fields.push(JiraField.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRequiredJiraFieldsResponse {
    return {
      fields: globalThis.Array.isArray(object?.fields) ? object.fields.map((e: any) => JiraField.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetRequiredJiraFieldsResponse): unknown {
    const obj: any = {};
    if (message.fields?.length) {
      obj.fields = message.fields.map((e) => JiraField.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetRequiredJiraFieldsResponse>): GetRequiredJiraFieldsResponse {
    return GetRequiredJiraFieldsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetRequiredJiraFieldsResponse>): GetRequiredJiraFieldsResponse {
    const message = createBaseGetRequiredJiraFieldsResponse();
    message.fields = object.fields?.map((e) => JiraField.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetExternalLinkPreviewRequest(): GetExternalLinkPreviewRequest {
  return { link: undefined };
}

export const GetExternalLinkPreviewRequest: MessageFns<GetExternalLinkPreviewRequest> = {
  encode(message: GetExternalLinkPreviewRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.link !== undefined) {
      ExternalLink.encode(message.link, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetExternalLinkPreviewRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetExternalLinkPreviewRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.link = ExternalLink.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetExternalLinkPreviewRequest {
    return { link: isSet(object.link) ? ExternalLink.fromJSON(object.link) : undefined };
  },

  toJSON(message: GetExternalLinkPreviewRequest): unknown {
    const obj: any = {};
    if (message.link !== undefined) {
      obj.link = ExternalLink.toJSON(message.link);
    }
    return obj;
  },

  create(base?: DeepPartial<GetExternalLinkPreviewRequest>): GetExternalLinkPreviewRequest {
    return GetExternalLinkPreviewRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetExternalLinkPreviewRequest>): GetExternalLinkPreviewRequest {
    const message = createBaseGetExternalLinkPreviewRequest();
    message.link = (object.link !== undefined && object.link !== null)
      ? ExternalLink.fromPartial(object.link)
      : undefined;
    return message;
  },
};

function createBaseGetExternalLinkPreviewResponse(): GetExternalLinkPreviewResponse {
  return { preview: undefined };
}

export const GetExternalLinkPreviewResponse: MessageFns<GetExternalLinkPreviewResponse> = {
  encode(message: GetExternalLinkPreviewResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.preview !== undefined) {
      ExternalLinkPreview.encode(message.preview, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetExternalLinkPreviewResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetExternalLinkPreviewResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.preview = ExternalLinkPreview.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetExternalLinkPreviewResponse {
    return { preview: isSet(object.preview) ? ExternalLinkPreview.fromJSON(object.preview) : undefined };
  },

  toJSON(message: GetExternalLinkPreviewResponse): unknown {
    const obj: any = {};
    if (message.preview !== undefined) {
      obj.preview = ExternalLinkPreview.toJSON(message.preview);
    }
    return obj;
  },

  create(base?: DeepPartial<GetExternalLinkPreviewResponse>): GetExternalLinkPreviewResponse {
    return GetExternalLinkPreviewResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetExternalLinkPreviewResponse>): GetExternalLinkPreviewResponse {
    const message = createBaseGetExternalLinkPreviewResponse();
    message.preview = (object.preview !== undefined && object.preview !== null)
      ? ExternalLinkPreview.fromPartial(object.preview)
      : undefined;
    return message;
  },
};

function createBaseGetTemplatesRequest(): GetTemplatesRequest {
  return {};
}

export const GetTemplatesRequest: MessageFns<GetTemplatesRequest> = {
  encode(_: GetTemplatesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTemplatesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTemplatesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GetTemplatesRequest {
    return {};
  },

  toJSON(_: GetTemplatesRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<GetTemplatesRequest>): GetTemplatesRequest {
    return GetTemplatesRequest.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<GetTemplatesRequest>): GetTemplatesRequest {
    const message = createBaseGetTemplatesRequest();
    return message;
  },
};

function createBaseGetTemplatesResponse(): GetTemplatesResponse {
  return { projectTemplates: [] };
}

export const GetTemplatesResponse: MessageFns<GetTemplatesResponse> = {
  encode(message: GetTemplatesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.projectTemplates) {
      ProjectTemplate.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTemplatesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTemplatesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.projectTemplates.push(ProjectTemplate.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTemplatesResponse {
    return {
      projectTemplates: globalThis.Array.isArray(object?.projectTemplates)
        ? object.projectTemplates.map((e: any) => ProjectTemplate.fromJSON(e))
        : globalThis.Array.isArray(object?.project_templates)
        ? object.project_templates.map((e: any) => ProjectTemplate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetTemplatesResponse): unknown {
    const obj: any = {};
    if (message.projectTemplates?.length) {
      obj.projectTemplates = message.projectTemplates.map((e) => ProjectTemplate.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetTemplatesResponse>): GetTemplatesResponse {
    return GetTemplatesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetTemplatesResponse>): GetTemplatesResponse {
    const message = createBaseGetTemplatesResponse();
    message.projectTemplates = object.projectTemplates?.map((e) => ProjectTemplate.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetDevRuleResponse(): GetDevRuleResponse {
  return { rule: "" };
}

export const GetDevRuleResponse: MessageFns<GetDevRuleResponse> = {
  encode(message: GetDevRuleResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rule !== "") {
      writer.uint32(10).string(message.rule);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDevRuleResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDevRuleResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.rule = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDevRuleResponse {
    return { rule: isSet(object.rule) ? globalThis.String(object.rule) : "" };
  },

  toJSON(message: GetDevRuleResponse): unknown {
    const obj: any = {};
    if (message.rule !== "") {
      obj.rule = message.rule;
    }
    return obj;
  },

  create(base?: DeepPartial<GetDevRuleResponse>): GetDevRuleResponse {
    return GetDevRuleResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetDevRuleResponse>): GetDevRuleResponse {
    const message = createBaseGetDevRuleResponse();
    message.rule = object.rule ?? "";
    return message;
  },
};

function createBaseGetDevRecipeResponse(): GetDevRecipeResponse {
  return { jsonRecipe: "" };
}

export const GetDevRecipeResponse: MessageFns<GetDevRecipeResponse> = {
  encode(message: GetDevRecipeResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jsonRecipe !== "") {
      writer.uint32(10).string(message.jsonRecipe);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDevRecipeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDevRecipeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jsonRecipe = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDevRecipeResponse {
    return {
      jsonRecipe: isSet(object.jsonRecipe)
        ? globalThis.String(object.jsonRecipe)
        : isSet(object.json_recipe)
        ? globalThis.String(object.json_recipe)
        : "",
    };
  },

  toJSON(message: GetDevRecipeResponse): unknown {
    const obj: any = {};
    if (message.jsonRecipe !== "") {
      obj.jsonRecipe = message.jsonRecipe;
    }
    return obj;
  },

  create(base?: DeepPartial<GetDevRecipeResponse>): GetDevRecipeResponse {
    return GetDevRecipeResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetDevRecipeResponse>): GetDevRecipeResponse {
    const message = createBaseGetDevRecipeResponse();
    message.jsonRecipe = object.jsonRecipe ?? "";
    return message;
  },
};

function createBaseGetTaskRecipeResponse(): GetTaskRecipeResponse {
  return { jsonRecipe: "" };
}

export const GetTaskRecipeResponse: MessageFns<GetTaskRecipeResponse> = {
  encode(message: GetTaskRecipeResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jsonRecipe !== "") {
      writer.uint32(10).string(message.jsonRecipe);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTaskRecipeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTaskRecipeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jsonRecipe = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTaskRecipeResponse {
    return {
      jsonRecipe: isSet(object.jsonRecipe)
        ? globalThis.String(object.jsonRecipe)
        : isSet(object.json_recipe)
        ? globalThis.String(object.json_recipe)
        : "",
    };
  },

  toJSON(message: GetTaskRecipeResponse): unknown {
    const obj: any = {};
    if (message.jsonRecipe !== "") {
      obj.jsonRecipe = message.jsonRecipe;
    }
    return obj;
  },

  create(base?: DeepPartial<GetTaskRecipeResponse>): GetTaskRecipeResponse {
    return GetTaskRecipeResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetTaskRecipeResponse>): GetTaskRecipeResponse {
    const message = createBaseGetTaskRecipeResponse();
    message.jsonRecipe = object.jsonRecipe ?? "";
    return message;
  },
};

function createBaseGetUserStoryRecipeResponse(): GetUserStoryRecipeResponse {
  return { jsonRecipe: "" };
}

export const GetUserStoryRecipeResponse: MessageFns<GetUserStoryRecipeResponse> = {
  encode(message: GetUserStoryRecipeResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jsonRecipe !== "") {
      writer.uint32(10).string(message.jsonRecipe);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUserStoryRecipeResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUserStoryRecipeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jsonRecipe = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUserStoryRecipeResponse {
    return {
      jsonRecipe: isSet(object.jsonRecipe)
        ? globalThis.String(object.jsonRecipe)
        : isSet(object.json_recipe)
        ? globalThis.String(object.json_recipe)
        : "",
    };
  },

  toJSON(message: GetUserStoryRecipeResponse): unknown {
    const obj: any = {};
    if (message.jsonRecipe !== "") {
      obj.jsonRecipe = message.jsonRecipe;
    }
    return obj;
  },

  create(base?: DeepPartial<GetUserStoryRecipeResponse>): GetUserStoryRecipeResponse {
    return GetUserStoryRecipeResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetUserStoryRecipeResponse>): GetUserStoryRecipeResponse {
    const message = createBaseGetUserStoryRecipeResponse();
    message.jsonRecipe = object.jsonRecipe ?? "";
    return message;
  },
};

function createBaseSubmitWorkLogRequest(): SubmitWorkLogRequest {
  return { item: undefined };
}

export const SubmitWorkLogRequest: MessageFns<SubmitWorkLogRequest> = {
  encode(message: SubmitWorkLogRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.item !== undefined) {
      WorkLogItem.encode(message.item, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubmitWorkLogRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubmitWorkLogRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.item = WorkLogItem.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubmitWorkLogRequest {
    return { item: isSet(object.item) ? WorkLogItem.fromJSON(object.item) : undefined };
  },

  toJSON(message: SubmitWorkLogRequest): unknown {
    const obj: any = {};
    if (message.item !== undefined) {
      obj.item = WorkLogItem.toJSON(message.item);
    }
    return obj;
  },

  create(base?: DeepPartial<SubmitWorkLogRequest>): SubmitWorkLogRequest {
    return SubmitWorkLogRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SubmitWorkLogRequest>): SubmitWorkLogRequest {
    const message = createBaseSubmitWorkLogRequest();
    message.item = (object.item !== undefined && object.item !== null)
      ? WorkLogItem.fromPartial(object.item)
      : undefined;
    return message;
  },
};

function createBaseSubmitWorkLogResponse(): SubmitWorkLogResponse {
  return { id: "" };
}

export const SubmitWorkLogResponse: MessageFns<SubmitWorkLogResponse> = {
  encode(message: SubmitWorkLogResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubmitWorkLogResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubmitWorkLogResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubmitWorkLogResponse {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: SubmitWorkLogResponse): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<SubmitWorkLogResponse>): SubmitWorkLogResponse {
    return SubmitWorkLogResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SubmitWorkLogResponse>): SubmitWorkLogResponse {
    const message = createBaseSubmitWorkLogResponse();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseGetProjectWorkLogEntriesResponse(): GetProjectWorkLogEntriesResponse {
  return { entries: [] };
}

export const GetProjectWorkLogEntriesResponse: MessageFns<GetProjectWorkLogEntriesResponse> = {
  encode(message: GetProjectWorkLogEntriesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.entries) {
      WorkLogItem.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetProjectWorkLogEntriesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetProjectWorkLogEntriesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entries.push(WorkLogItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetProjectWorkLogEntriesResponse {
    return {
      entries: globalThis.Array.isArray(object?.entries) ? object.entries.map((e: any) => WorkLogItem.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetProjectWorkLogEntriesResponse): unknown {
    const obj: any = {};
    if (message.entries?.length) {
      obj.entries = message.entries.map((e) => WorkLogItem.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetProjectWorkLogEntriesResponse>): GetProjectWorkLogEntriesResponse {
    return GetProjectWorkLogEntriesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetProjectWorkLogEntriesResponse>): GetProjectWorkLogEntriesResponse {
    const message = createBaseGetProjectWorkLogEntriesResponse();
    message.entries = object.entries?.map((e) => WorkLogItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUploadSpecRequest(): UploadSpecRequest {
  return { content: "", name: "", checksum: "" };
}

export const UploadSpecRequest: MessageFns<UploadSpecRequest> = {
  encode(message: UploadSpecRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.content !== "") {
      writer.uint32(10).string(message.content);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.checksum !== "") {
      writer.uint32(26).string(message.checksum);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadSpecRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadSpecRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.checksum = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadSpecRequest {
    return {
      content: isSet(object.content) ? globalThis.String(object.content) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      checksum: isSet(object.checksum) ? globalThis.String(object.checksum) : "",
    };
  },

  toJSON(message: UploadSpecRequest): unknown {
    const obj: any = {};
    if (message.content !== "") {
      obj.content = message.content;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.checksum !== "") {
      obj.checksum = message.checksum;
    }
    return obj;
  },

  create(base?: DeepPartial<UploadSpecRequest>): UploadSpecRequest {
    return UploadSpecRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UploadSpecRequest>): UploadSpecRequest {
    const message = createBaseUploadSpecRequest();
    message.content = object.content ?? "";
    message.name = object.name ?? "";
    message.checksum = object.checksum ?? "";
    return message;
  },
};

function createBaseUploadSpecResponse(): UploadSpecResponse {
  return { id: "" };
}

export const UploadSpecResponse: MessageFns<UploadSpecResponse> = {
  encode(message: UploadSpecResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadSpecResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadSpecResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadSpecResponse {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: UploadSpecResponse): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<UploadSpecResponse>): UploadSpecResponse {
    return UploadSpecResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UploadSpecResponse>): UploadSpecResponse {
    const message = createBaseUploadSpecResponse();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseGetTaskSpecsResponse(): GetTaskSpecsResponse {
  return { specs: [], pathsInfo: undefined };
}

export const GetTaskSpecsResponse: MessageFns<GetTaskSpecsResponse> = {
  encode(message: GetTaskSpecsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.specs) {
      SpecDetails.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.pathsInfo !== undefined) {
      SpecPathsInfo.encode(message.pathsInfo, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTaskSpecsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTaskSpecsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.specs.push(SpecDetails.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pathsInfo = SpecPathsInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTaskSpecsResponse {
    return {
      specs: globalThis.Array.isArray(object?.specs) ? object.specs.map((e: any) => SpecDetails.fromJSON(e)) : [],
      pathsInfo: isSet(object.pathsInfo)
        ? SpecPathsInfo.fromJSON(object.pathsInfo)
        : isSet(object.paths_info)
        ? SpecPathsInfo.fromJSON(object.paths_info)
        : undefined,
    };
  },

  toJSON(message: GetTaskSpecsResponse): unknown {
    const obj: any = {};
    if (message.specs?.length) {
      obj.specs = message.specs.map((e) => SpecDetails.toJSON(e));
    }
    if (message.pathsInfo !== undefined) {
      obj.pathsInfo = SpecPathsInfo.toJSON(message.pathsInfo);
    }
    return obj;
  },

  create(base?: DeepPartial<GetTaskSpecsResponse>): GetTaskSpecsResponse {
    return GetTaskSpecsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetTaskSpecsResponse>): GetTaskSpecsResponse {
    const message = createBaseGetTaskSpecsResponse();
    message.specs = object.specs?.map((e) => SpecDetails.fromPartial(e)) || [];
    message.pathsInfo = (object.pathsInfo !== undefined && object.pathsInfo !== null)
      ? SpecPathsInfo.fromPartial(object.pathsInfo)
      : undefined;
    return message;
  },
};

function createBaseStartDevJobRequest(): StartDevJobRequest {
  return { job: undefined };
}

export const StartDevJobRequest: MessageFns<StartDevJobRequest> = {
  encode(message: StartDevJobRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.job !== undefined) {
      DevJob.encode(message.job, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartDevJobRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartDevJobRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.job = DevJob.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartDevJobRequest {
    return { job: isSet(object.job) ? DevJob.fromJSON(object.job) : undefined };
  },

  toJSON(message: StartDevJobRequest): unknown {
    const obj: any = {};
    if (message.job !== undefined) {
      obj.job = DevJob.toJSON(message.job);
    }
    return obj;
  },

  create(base?: DeepPartial<StartDevJobRequest>): StartDevJobRequest {
    return StartDevJobRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartDevJobRequest>): StartDevJobRequest {
    const message = createBaseStartDevJobRequest();
    message.job = (object.job !== undefined && object.job !== null) ? DevJob.fromPartial(object.job) : undefined;
    return message;
  },
};

function createBaseStartDevJobResponse(): StartDevJobResponse {
  return { jobId: "" };
}

export const StartDevJobResponse: MessageFns<StartDevJobResponse> = {
  encode(message: StartDevJobResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobId !== "") {
      writer.uint32(10).string(message.jobId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartDevJobResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartDevJobResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jobId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartDevJobResponse {
    return {
      jobId: isSet(object.jobId)
        ? globalThis.String(object.jobId)
        : isSet(object.job_id)
        ? globalThis.String(object.job_id)
        : "",
    };
  },

  toJSON(message: StartDevJobResponse): unknown {
    const obj: any = {};
    if (message.jobId !== "") {
      obj.jobId = message.jobId;
    }
    return obj;
  },

  create(base?: DeepPartial<StartDevJobResponse>): StartDevJobResponse {
    return StartDevJobResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartDevJobResponse>): StartDevJobResponse {
    const message = createBaseStartDevJobResponse();
    message.jobId = object.jobId ?? "";
    return message;
  },
};

function createBaseGetJobStatusRequest(): GetJobStatusRequest {
  return { jobId: "" };
}

export const GetJobStatusRequest: MessageFns<GetJobStatusRequest> = {
  encode(message: GetJobStatusRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobId !== "") {
      writer.uint32(10).string(message.jobId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetJobStatusRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetJobStatusRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jobId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetJobStatusRequest {
    return {
      jobId: isSet(object.jobId)
        ? globalThis.String(object.jobId)
        : isSet(object.job_id)
        ? globalThis.String(object.job_id)
        : "",
    };
  },

  toJSON(message: GetJobStatusRequest): unknown {
    const obj: any = {};
    if (message.jobId !== "") {
      obj.jobId = message.jobId;
    }
    return obj;
  },

  create(base?: DeepPartial<GetJobStatusRequest>): GetJobStatusRequest {
    return GetJobStatusRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetJobStatusRequest>): GetJobStatusRequest {
    const message = createBaseGetJobStatusRequest();
    message.jobId = object.jobId ?? "";
    return message;
  },
};

function createBaseGetJobStatusResponse(): GetJobStatusResponse {
  return { statusJson: "" };
}

export const GetJobStatusResponse: MessageFns<GetJobStatusResponse> = {
  encode(message: GetJobStatusResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.statusJson !== "") {
      writer.uint32(10).string(message.statusJson);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetJobStatusResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetJobStatusResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.statusJson = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetJobStatusResponse {
    return {
      statusJson: isSet(object.statusJson)
        ? globalThis.String(object.statusJson)
        : isSet(object.status_json)
        ? globalThis.String(object.status_json)
        : "",
    };
  },

  toJSON(message: GetJobStatusResponse): unknown {
    const obj: any = {};
    if (message.statusJson !== "") {
      obj.statusJson = message.statusJson;
    }
    return obj;
  },

  create(base?: DeepPartial<GetJobStatusResponse>): GetJobStatusResponse {
    return GetJobStatusResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetJobStatusResponse>): GetJobStatusResponse {
    const message = createBaseGetJobStatusResponse();
    message.statusJson = object.statusJson ?? "";
    return message;
  },
};

function createBaseGetTagsResponse(): GetTagsResponse {
  return { tags: [] };
}

export const GetTagsResponse: MessageFns<GetTagsResponse> = {
  encode(message: GetTagsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tags) {
      Tag.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTagsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTagsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tags.push(Tag.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTagsResponse {
    return { tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e: any) => Tag.fromJSON(e)) : [] };
  },

  toJSON(message: GetTagsResponse): unknown {
    const obj: any = {};
    if (message.tags?.length) {
      obj.tags = message.tags.map((e) => Tag.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetTagsResponse>): GetTagsResponse {
    return GetTagsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetTagsResponse>): GetTagsResponse {
    const message = createBaseGetTagsResponse();
    message.tags = object.tags?.map((e) => Tag.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateTagRequest(): CreateTagRequest {
  return { tag: undefined };
}

export const CreateTagRequest: MessageFns<CreateTagRequest> = {
  encode(message: CreateTagRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tag !== undefined) {
      Tag.encode(message.tag, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateTagRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateTagRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tag = Tag.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateTagRequest {
    return { tag: isSet(object.tag) ? Tag.fromJSON(object.tag) : undefined };
  },

  toJSON(message: CreateTagRequest): unknown {
    const obj: any = {};
    if (message.tag !== undefined) {
      obj.tag = Tag.toJSON(message.tag);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateTagRequest>): CreateTagRequest {
    return CreateTagRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateTagRequest>): CreateTagRequest {
    const message = createBaseCreateTagRequest();
    message.tag = (object.tag !== undefined && object.tag !== null) ? Tag.fromPartial(object.tag) : undefined;
    return message;
  },
};

function createBaseCreateTagResponse(): CreateTagResponse {
  return { tag: undefined };
}

export const CreateTagResponse: MessageFns<CreateTagResponse> = {
  encode(message: CreateTagResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tag !== undefined) {
      Tag.encode(message.tag, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateTagResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateTagResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tag = Tag.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateTagResponse {
    return { tag: isSet(object.tag) ? Tag.fromJSON(object.tag) : undefined };
  },

  toJSON(message: CreateTagResponse): unknown {
    const obj: any = {};
    if (message.tag !== undefined) {
      obj.tag = Tag.toJSON(message.tag);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateTagResponse>): CreateTagResponse {
    return CreateTagResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateTagResponse>): CreateTagResponse {
    const message = createBaseCreateTagResponse();
    message.tag = (object.tag !== undefined && object.tag !== null) ? Tag.fromPartial(object.tag) : undefined;
    return message;
  },
};

function createBaseUpdateTagRequest(): UpdateTagRequest {
  return { tag: undefined };
}

export const UpdateTagRequest: MessageFns<UpdateTagRequest> = {
  encode(message: UpdateTagRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tag !== undefined) {
      Tag.encode(message.tag, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateTagRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateTagRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tag = Tag.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateTagRequest {
    return { tag: isSet(object.tag) ? Tag.fromJSON(object.tag) : undefined };
  },

  toJSON(message: UpdateTagRequest): unknown {
    const obj: any = {};
    if (message.tag !== undefined) {
      obj.tag = Tag.toJSON(message.tag);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateTagRequest>): UpdateTagRequest {
    return UpdateTagRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateTagRequest>): UpdateTagRequest {
    const message = createBaseUpdateTagRequest();
    message.tag = (object.tag !== undefined && object.tag !== null) ? Tag.fromPartial(object.tag) : undefined;
    return message;
  },
};

function createBaseUpdateTagResponse(): UpdateTagResponse {
  return { tag: undefined };
}

export const UpdateTagResponse: MessageFns<UpdateTagResponse> = {
  encode(message: UpdateTagResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tag !== undefined) {
      Tag.encode(message.tag, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateTagResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateTagResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tag = Tag.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateTagResponse {
    return { tag: isSet(object.tag) ? Tag.fromJSON(object.tag) : undefined };
  },

  toJSON(message: UpdateTagResponse): unknown {
    const obj: any = {};
    if (message.tag !== undefined) {
      obj.tag = Tag.toJSON(message.tag);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateTagResponse>): UpdateTagResponse {
    return UpdateTagResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateTagResponse>): UpdateTagResponse {
    const message = createBaseUpdateTagResponse();
    message.tag = (object.tag !== undefined && object.tag !== null) ? Tag.fromPartial(object.tag) : undefined;
    return message;
  },
};

function createBaseDeleteTagRequest(): DeleteTagRequest {
  return { tagId: "" };
}

export const DeleteTagRequest: MessageFns<DeleteTagRequest> = {
  encode(message: DeleteTagRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tagId !== "") {
      writer.uint32(10).string(message.tagId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteTagRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteTagRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tagId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteTagRequest {
    return {
      tagId: isSet(object.tagId)
        ? globalThis.String(object.tagId)
        : isSet(object.tag_id)
        ? globalThis.String(object.tag_id)
        : "",
    };
  },

  toJSON(message: DeleteTagRequest): unknown {
    const obj: any = {};
    if (message.tagId !== "") {
      obj.tagId = message.tagId;
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteTagRequest>): DeleteTagRequest {
    return DeleteTagRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteTagRequest>): DeleteTagRequest {
    const message = createBaseDeleteTagRequest();
    message.tagId = object.tagId ?? "";
    return message;
  },
};

function createBaseDeleteTagResponse(): DeleteTagResponse {
  return {};
}

export const DeleteTagResponse: MessageFns<DeleteTagResponse> = {
  encode(_: DeleteTagResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteTagResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteTagResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteTagResponse {
    return {};
  },

  toJSON(_: DeleteTagResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<DeleteTagResponse>): DeleteTagResponse {
    return DeleteTagResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<DeleteTagResponse>): DeleteTagResponse {
    const message = createBaseDeleteTagResponse();
    return message;
  },
};

function createBaseGetReleasesResponse(): GetReleasesResponse {
  return { releases: [] };
}

export const GetReleasesResponse: MessageFns<GetReleasesResponse> = {
  encode(message: GetReleasesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.releases) {
      Release.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetReleasesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetReleasesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.releases.push(Release.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetReleasesResponse {
    return {
      releases: globalThis.Array.isArray(object?.releases) ? object.releases.map((e: any) => Release.fromJSON(e)) : [],
    };
  },

  toJSON(message: GetReleasesResponse): unknown {
    const obj: any = {};
    if (message.releases?.length) {
      obj.releases = message.releases.map((e) => Release.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetReleasesResponse>): GetReleasesResponse {
    return GetReleasesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetReleasesResponse>): GetReleasesResponse {
    const message = createBaseGetReleasesResponse();
    message.releases = object.releases?.map((e) => Release.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateReleaseRequest(): CreateReleaseRequest {
  return { release: undefined };
}

export const CreateReleaseRequest: MessageFns<CreateReleaseRequest> = {
  encode(message: CreateReleaseRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.release !== undefined) {
      Release.encode(message.release, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateReleaseRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateReleaseRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.release = Release.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateReleaseRequest {
    return { release: isSet(object.release) ? Release.fromJSON(object.release) : undefined };
  },

  toJSON(message: CreateReleaseRequest): unknown {
    const obj: any = {};
    if (message.release !== undefined) {
      obj.release = Release.toJSON(message.release);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateReleaseRequest>): CreateReleaseRequest {
    return CreateReleaseRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateReleaseRequest>): CreateReleaseRequest {
    const message = createBaseCreateReleaseRequest();
    message.release = (object.release !== undefined && object.release !== null)
      ? Release.fromPartial(object.release)
      : undefined;
    return message;
  },
};

function createBaseCreateReleaseResponse(): CreateReleaseResponse {
  return { release: undefined };
}

export const CreateReleaseResponse: MessageFns<CreateReleaseResponse> = {
  encode(message: CreateReleaseResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.release !== undefined) {
      Release.encode(message.release, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateReleaseResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateReleaseResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.release = Release.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateReleaseResponse {
    return { release: isSet(object.release) ? Release.fromJSON(object.release) : undefined };
  },

  toJSON(message: CreateReleaseResponse): unknown {
    const obj: any = {};
    if (message.release !== undefined) {
      obj.release = Release.toJSON(message.release);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateReleaseResponse>): CreateReleaseResponse {
    return CreateReleaseResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateReleaseResponse>): CreateReleaseResponse {
    const message = createBaseCreateReleaseResponse();
    message.release = (object.release !== undefined && object.release !== null)
      ? Release.fromPartial(object.release)
      : undefined;
    return message;
  },
};

function createBaseUpdateReleaseRequest(): UpdateReleaseRequest {
  return { id: "", name: undefined, archived: undefined, targetDate: undefined, projectOrder: undefined };
}

export const UpdateReleaseRequest: MessageFns<UpdateReleaseRequest> = {
  encode(message: UpdateReleaseRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.archived !== undefined) {
      writer.uint32(24).bool(message.archived);
    }
    if (message.targetDate !== undefined) {
      ReleaseTargetDateUpdate.encode(message.targetDate, writer.uint32(34).fork()).join();
    }
    if (message.projectOrder !== undefined) {
      ReleaseProjectOrderUpdate.encode(message.projectOrder, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateReleaseRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateReleaseRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.targetDate = ReleaseTargetDateUpdate.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.projectOrder = ReleaseProjectOrderUpdate.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateReleaseRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : undefined,
      targetDate: isSet(object.targetDate)
        ? ReleaseTargetDateUpdate.fromJSON(object.targetDate)
        : isSet(object.target_date)
        ? ReleaseTargetDateUpdate.fromJSON(object.target_date)
        : undefined,
      projectOrder: isSet(object.projectOrder)
        ? ReleaseProjectOrderUpdate.fromJSON(object.projectOrder)
        : isSet(object.project_order)
        ? ReleaseProjectOrderUpdate.fromJSON(object.project_order)
        : undefined,
    };
  },

  toJSON(message: UpdateReleaseRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.archived !== undefined) {
      obj.archived = message.archived;
    }
    if (message.targetDate !== undefined) {
      obj.targetDate = ReleaseTargetDateUpdate.toJSON(message.targetDate);
    }
    if (message.projectOrder !== undefined) {
      obj.projectOrder = ReleaseProjectOrderUpdate.toJSON(message.projectOrder);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateReleaseRequest>): UpdateReleaseRequest {
    return UpdateReleaseRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateReleaseRequest>): UpdateReleaseRequest {
    const message = createBaseUpdateReleaseRequest();
    message.id = object.id ?? "";
    message.name = object.name ?? undefined;
    message.archived = object.archived ?? undefined;
    message.targetDate = (object.targetDate !== undefined && object.targetDate !== null)
      ? ReleaseTargetDateUpdate.fromPartial(object.targetDate)
      : undefined;
    message.projectOrder = (object.projectOrder !== undefined && object.projectOrder !== null)
      ? ReleaseProjectOrderUpdate.fromPartial(object.projectOrder)
      : undefined;
    return message;
  },
};

function createBaseReleaseTargetDateUpdate(): ReleaseTargetDateUpdate {
  return { value: undefined };
}

export const ReleaseTargetDateUpdate: MessageFns<ReleaseTargetDateUpdate> = {
  encode(message: ReleaseTargetDateUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.value !== undefined) {
      Timestamp.encode(toTimestamp(message.value), writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReleaseTargetDateUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReleaseTargetDateUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.value = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReleaseTargetDateUpdate {
    return { value: isSet(object.value) ? fromJsonTimestamp(object.value) : undefined };
  },

  toJSON(message: ReleaseTargetDateUpdate): unknown {
    const obj: any = {};
    if (message.value !== undefined) {
      obj.value = message.value.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<ReleaseTargetDateUpdate>): ReleaseTargetDateUpdate {
    return ReleaseTargetDateUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ReleaseTargetDateUpdate>): ReleaseTargetDateUpdate {
    const message = createBaseReleaseTargetDateUpdate();
    message.value = object.value ?? undefined;
    return message;
  },
};

function createBaseReleaseProjectOrderUpdate(): ReleaseProjectOrderUpdate {
  return { projectIds: [] };
}

export const ReleaseProjectOrderUpdate: MessageFns<ReleaseProjectOrderUpdate> = {
  encode(message: ReleaseProjectOrderUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.projectIds) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReleaseProjectOrderUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReleaseProjectOrderUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.projectIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReleaseProjectOrderUpdate {
    return {
      projectIds: globalThis.Array.isArray(object?.projectIds)
        ? object.projectIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.project_ids)
        ? object.project_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ReleaseProjectOrderUpdate): unknown {
    const obj: any = {};
    if (message.projectIds?.length) {
      obj.projectIds = message.projectIds;
    }
    return obj;
  },

  create(base?: DeepPartial<ReleaseProjectOrderUpdate>): ReleaseProjectOrderUpdate {
    return ReleaseProjectOrderUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ReleaseProjectOrderUpdate>): ReleaseProjectOrderUpdate {
    const message = createBaseReleaseProjectOrderUpdate();
    message.projectIds = object.projectIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseUpdateReleaseResponse(): UpdateReleaseResponse {
  return { release: undefined };
}

export const UpdateReleaseResponse: MessageFns<UpdateReleaseResponse> = {
  encode(message: UpdateReleaseResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.release !== undefined) {
      Release.encode(message.release, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateReleaseResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateReleaseResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.release = Release.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateReleaseResponse {
    return { release: isSet(object.release) ? Release.fromJSON(object.release) : undefined };
  },

  toJSON(message: UpdateReleaseResponse): unknown {
    const obj: any = {};
    if (message.release !== undefined) {
      obj.release = Release.toJSON(message.release);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateReleaseResponse>): UpdateReleaseResponse {
    return UpdateReleaseResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateReleaseResponse>): UpdateReleaseResponse {
    const message = createBaseUpdateReleaseResponse();
    message.release = (object.release !== undefined && object.release !== null)
      ? Release.fromPartial(object.release)
      : undefined;
    return message;
  },
};

function createBaseArchiveReleaseRequest(): ArchiveReleaseRequest {
  return { releaseId: "", archived: false };
}

export const ArchiveReleaseRequest: MessageFns<ArchiveReleaseRequest> = {
  encode(message: ArchiveReleaseRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.releaseId !== "") {
      writer.uint32(10).string(message.releaseId);
    }
    if (message.archived !== false) {
      writer.uint32(16).bool(message.archived);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArchiveReleaseRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArchiveReleaseRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.releaseId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArchiveReleaseRequest {
    return {
      releaseId: isSet(object.releaseId)
        ? globalThis.String(object.releaseId)
        : isSet(object.release_id)
        ? globalThis.String(object.release_id)
        : "",
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : false,
    };
  },

  toJSON(message: ArchiveReleaseRequest): unknown {
    const obj: any = {};
    if (message.releaseId !== "") {
      obj.releaseId = message.releaseId;
    }
    if (message.archived !== false) {
      obj.archived = message.archived;
    }
    return obj;
  },

  create(base?: DeepPartial<ArchiveReleaseRequest>): ArchiveReleaseRequest {
    return ArchiveReleaseRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ArchiveReleaseRequest>): ArchiveReleaseRequest {
    const message = createBaseArchiveReleaseRequest();
    message.releaseId = object.releaseId ?? "";
    message.archived = object.archived ?? false;
    return message;
  },
};

function createBaseArchiveReleaseResponse(): ArchiveReleaseResponse {
  return { release: undefined };
}

export const ArchiveReleaseResponse: MessageFns<ArchiveReleaseResponse> = {
  encode(message: ArchiveReleaseResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.release !== undefined) {
      Release.encode(message.release, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArchiveReleaseResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArchiveReleaseResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.release = Release.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArchiveReleaseResponse {
    return { release: isSet(object.release) ? Release.fromJSON(object.release) : undefined };
  },

  toJSON(message: ArchiveReleaseResponse): unknown {
    const obj: any = {};
    if (message.release !== undefined) {
      obj.release = Release.toJSON(message.release);
    }
    return obj;
  },

  create(base?: DeepPartial<ArchiveReleaseResponse>): ArchiveReleaseResponse {
    return ArchiveReleaseResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ArchiveReleaseResponse>): ArchiveReleaseResponse {
    const message = createBaseArchiveReleaseResponse();
    message.release = (object.release !== undefined && object.release !== null)
      ? Release.fromPartial(object.release)
      : undefined;
    return message;
  },
};

function createBaseFetchJobsRequest(): FetchJobsRequest {
  return {};
}

export const FetchJobsRequest: MessageFns<FetchJobsRequest> = {
  encode(_: FetchJobsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FetchJobsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFetchJobsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): FetchJobsRequest {
    return {};
  },

  toJSON(_: FetchJobsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<FetchJobsRequest>): FetchJobsRequest {
    return FetchJobsRequest.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<FetchJobsRequest>): FetchJobsRequest {
    const message = createBaseFetchJobsRequest();
    return message;
  },
};

function createBaseFetchJobResponse(): FetchJobResponse {
  return { jobJson: undefined };
}

export const FetchJobResponse: MessageFns<FetchJobResponse> = {
  encode(message: FetchJobResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobJson !== undefined) {
      writer.uint32(10).string(message.jobJson);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FetchJobResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFetchJobResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jobJson = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FetchJobResponse {
    return {
      jobJson: isSet(object.jobJson)
        ? globalThis.String(object.jobJson)
        : isSet(object.job_json)
        ? globalThis.String(object.job_json)
        : undefined,
    };
  },

  toJSON(message: FetchJobResponse): unknown {
    const obj: any = {};
    if (message.jobJson !== undefined) {
      obj.jobJson = message.jobJson;
    }
    return obj;
  },

  create(base?: DeepPartial<FetchJobResponse>): FetchJobResponse {
    return FetchJobResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FetchJobResponse>): FetchJobResponse {
    const message = createBaseFetchJobResponse();
    message.jobJson = object.jobJson ?? undefined;
    return message;
  },
};

function createBaseFetchJobRunResponse(): FetchJobRunResponse {
  return { jobJson: undefined, jobRunJson: undefined, compressedLogs: new Uint8Array(0) };
}

export const FetchJobRunResponse: MessageFns<FetchJobRunResponse> = {
  encode(message: FetchJobRunResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.jobJson !== undefined) {
      writer.uint32(10).string(message.jobJson);
    }
    if (message.jobRunJson !== undefined) {
      writer.uint32(18).string(message.jobRunJson);
    }
    if (message.compressedLogs.length !== 0) {
      writer.uint32(26).bytes(message.compressedLogs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FetchJobRunResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFetchJobRunResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jobJson = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.jobRunJson = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.compressedLogs = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FetchJobRunResponse {
    return {
      jobJson: isSet(object.jobJson)
        ? globalThis.String(object.jobJson)
        : isSet(object.job_json)
        ? globalThis.String(object.job_json)
        : undefined,
      jobRunJson: isSet(object.jobRunJson)
        ? globalThis.String(object.jobRunJson)
        : isSet(object.job_run_json)
        ? globalThis.String(object.job_run_json)
        : undefined,
      compressedLogs: isSet(object.compressedLogs)
        ? bytesFromBase64(object.compressedLogs)
        : isSet(object.compressed_logs)
        ? bytesFromBase64(object.compressed_logs)
        : new Uint8Array(0),
    };
  },

  toJSON(message: FetchJobRunResponse): unknown {
    const obj: any = {};
    if (message.jobJson !== undefined) {
      obj.jobJson = message.jobJson;
    }
    if (message.jobRunJson !== undefined) {
      obj.jobRunJson = message.jobRunJson;
    }
    if (message.compressedLogs.length !== 0) {
      obj.compressedLogs = base64FromBytes(message.compressedLogs);
    }
    return obj;
  },

  create(base?: DeepPartial<FetchJobRunResponse>): FetchJobRunResponse {
    return FetchJobRunResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FetchJobRunResponse>): FetchJobRunResponse {
    const message = createBaseFetchJobRunResponse();
    message.jobJson = object.jobJson ?? undefined;
    message.jobRunJson = object.jobRunJson ?? undefined;
    message.compressedLogs = object.compressedLogs ?? new Uint8Array(0);
    return message;
  },
};

function createBaseFetchJobRunsResponse(): FetchJobRunsResponse {
  return { runsJson: [] };
}

export const FetchJobRunsResponse: MessageFns<FetchJobRunsResponse> = {
  encode(message: FetchJobRunsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.runsJson) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FetchJobRunsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFetchJobRunsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.runsJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FetchJobRunsResponse {
    return {
      runsJson: globalThis.Array.isArray(object?.runsJson)
        ? object.runsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.runs_json)
        ? object.runs_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: FetchJobRunsResponse): unknown {
    const obj: any = {};
    if (message.runsJson?.length) {
      obj.runsJson = message.runsJson;
    }
    return obj;
  },

  create(base?: DeepPartial<FetchJobRunsResponse>): FetchJobRunsResponse {
    return FetchJobRunsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FetchJobRunsResponse>): FetchJobRunsResponse {
    const message = createBaseFetchJobRunsResponse();
    message.runsJson = object.runsJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetProjectsViewSettingsRequest(): GetProjectsViewSettingsRequest {
  return { companyId: 0, viewId: "" };
}

export const GetProjectsViewSettingsRequest: MessageFns<GetProjectsViewSettingsRequest> = {
  encode(message: GetProjectsViewSettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    if (message.viewId !== "") {
      writer.uint32(18).string(message.viewId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetProjectsViewSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetProjectsViewSettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.viewId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetProjectsViewSettingsRequest {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      viewId: isSet(object.viewId)
        ? globalThis.String(object.viewId)
        : isSet(object.view_id)
        ? globalThis.String(object.view_id)
        : "",
    };
  },

  toJSON(message: GetProjectsViewSettingsRequest): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.viewId !== "") {
      obj.viewId = message.viewId;
    }
    return obj;
  },

  create(base?: DeepPartial<GetProjectsViewSettingsRequest>): GetProjectsViewSettingsRequest {
    return GetProjectsViewSettingsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetProjectsViewSettingsRequest>): GetProjectsViewSettingsRequest {
    const message = createBaseGetProjectsViewSettingsRequest();
    message.companyId = object.companyId ?? 0;
    message.viewId = object.viewId ?? "";
    return message;
  },
};

function createBaseGetProjectsViewSettingsResponse(): GetProjectsViewSettingsResponse {
  return { settings: undefined };
}

export const GetProjectsViewSettingsResponse: MessageFns<GetProjectsViewSettingsResponse> = {
  encode(message: GetProjectsViewSettingsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.settings !== undefined) {
      ProjectsViewSettings.encode(message.settings, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetProjectsViewSettingsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetProjectsViewSettingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.settings = ProjectsViewSettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetProjectsViewSettingsResponse {
    return { settings: isSet(object.settings) ? ProjectsViewSettings.fromJSON(object.settings) : undefined };
  },

  toJSON(message: GetProjectsViewSettingsResponse): unknown {
    const obj: any = {};
    if (message.settings !== undefined) {
      obj.settings = ProjectsViewSettings.toJSON(message.settings);
    }
    return obj;
  },

  create(base?: DeepPartial<GetProjectsViewSettingsResponse>): GetProjectsViewSettingsResponse {
    return GetProjectsViewSettingsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetProjectsViewSettingsResponse>): GetProjectsViewSettingsResponse {
    const message = createBaseGetProjectsViewSettingsResponse();
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? ProjectsViewSettings.fromPartial(object.settings)
      : undefined;
    return message;
  },
};

function createBaseUpdateProjectsViewSettingsRequest(): UpdateProjectsViewSettingsRequest {
  return { settings: undefined };
}

export const UpdateProjectsViewSettingsRequest: MessageFns<UpdateProjectsViewSettingsRequest> = {
  encode(message: UpdateProjectsViewSettingsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.settings !== undefined) {
      ProjectsViewSettings.encode(message.settings, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateProjectsViewSettingsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateProjectsViewSettingsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.settings = ProjectsViewSettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateProjectsViewSettingsRequest {
    return { settings: isSet(object.settings) ? ProjectsViewSettings.fromJSON(object.settings) : undefined };
  },

  toJSON(message: UpdateProjectsViewSettingsRequest): unknown {
    const obj: any = {};
    if (message.settings !== undefined) {
      obj.settings = ProjectsViewSettings.toJSON(message.settings);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateProjectsViewSettingsRequest>): UpdateProjectsViewSettingsRequest {
    return UpdateProjectsViewSettingsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateProjectsViewSettingsRequest>): UpdateProjectsViewSettingsRequest {
    const message = createBaseUpdateProjectsViewSettingsRequest();
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? ProjectsViewSettings.fromPartial(object.settings)
      : undefined;
    return message;
  },
};

function createBaseUpdateProjectsViewSettingsResponse(): UpdateProjectsViewSettingsResponse {
  return { settings: undefined };
}

export const UpdateProjectsViewSettingsResponse: MessageFns<UpdateProjectsViewSettingsResponse> = {
  encode(message: UpdateProjectsViewSettingsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.settings !== undefined) {
      ProjectsViewSettings.encode(message.settings, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateProjectsViewSettingsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateProjectsViewSettingsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.settings = ProjectsViewSettings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateProjectsViewSettingsResponse {
    return { settings: isSet(object.settings) ? ProjectsViewSettings.fromJSON(object.settings) : undefined };
  },

  toJSON(message: UpdateProjectsViewSettingsResponse): unknown {
    const obj: any = {};
    if (message.settings !== undefined) {
      obj.settings = ProjectsViewSettings.toJSON(message.settings);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateProjectsViewSettingsResponse>): UpdateProjectsViewSettingsResponse {
    return UpdateProjectsViewSettingsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateProjectsViewSettingsResponse>): UpdateProjectsViewSettingsResponse {
    const message = createBaseUpdateProjectsViewSettingsResponse();
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? ProjectsViewSettings.fromPartial(object.settings)
      : undefined;
    return message;
  },
};

function createBaseSecretMetadataPayload(): SecretMetadataPayload {
  return { name: "", metadataJson: "" };
}

export const SecretMetadataPayload: MessageFns<SecretMetadataPayload> = {
  encode(message: SecretMetadataPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.metadataJson !== "") {
      writer.uint32(18).string(message.metadataJson);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SecretMetadataPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSecretMetadataPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metadataJson = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SecretMetadataPayload {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      metadataJson: isSet(object.metadataJson)
        ? globalThis.String(object.metadataJson)
        : isSet(object.metadata_json)
        ? globalThis.String(object.metadata_json)
        : "",
    };
  },

  toJSON(message: SecretMetadataPayload): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.metadataJson !== "") {
      obj.metadataJson = message.metadataJson;
    }
    return obj;
  },

  create(base?: DeepPartial<SecretMetadataPayload>): SecretMetadataPayload {
    return SecretMetadataPayload.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SecretMetadataPayload>): SecretMetadataPayload {
    const message = createBaseSecretMetadataPayload();
    message.name = object.name ?? "";
    message.metadataJson = object.metadataJson ?? "";
    return message;
  },
};

function createBaseListSecretsResponse(): ListSecretsResponse {
  return { secrets: [] };
}

export const ListSecretsResponse: MessageFns<ListSecretsResponse> = {
  encode(message: ListSecretsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.secrets) {
      SecretMetadataPayload.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListSecretsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListSecretsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.secrets.push(SecretMetadataPayload.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListSecretsResponse {
    return {
      secrets: globalThis.Array.isArray(object?.secrets)
        ? object.secrets.map((e: any) => SecretMetadataPayload.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListSecretsResponse): unknown {
    const obj: any = {};
    if (message.secrets?.length) {
      obj.secrets = message.secrets.map((e) => SecretMetadataPayload.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ListSecretsResponse>): ListSecretsResponse {
    return ListSecretsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListSecretsResponse>): ListSecretsResponse {
    const message = createBaseListSecretsResponse();
    message.secrets = object.secrets?.map((e) => SecretMetadataPayload.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateSecretRequest(): CreateSecretRequest {
  return { name: "", value: "" };
}

export const CreateSecretRequest: MessageFns<CreateSecretRequest> = {
  encode(message: CreateSecretRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateSecretRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateSecretRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateSecretRequest {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: CreateSecretRequest): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateSecretRequest>): CreateSecretRequest {
    return CreateSecretRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateSecretRequest>): CreateSecretRequest {
    const message = createBaseCreateSecretRequest();
    message.name = object.name ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseCreateSecretResponse(): CreateSecretResponse {
  return { secret: undefined };
}

export const CreateSecretResponse: MessageFns<CreateSecretResponse> = {
  encode(message: CreateSecretResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.secret !== undefined) {
      SecretMetadataPayload.encode(message.secret, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateSecretResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateSecretResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.secret = SecretMetadataPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateSecretResponse {
    return { secret: isSet(object.secret) ? SecretMetadataPayload.fromJSON(object.secret) : undefined };
  },

  toJSON(message: CreateSecretResponse): unknown {
    const obj: any = {};
    if (message.secret !== undefined) {
      obj.secret = SecretMetadataPayload.toJSON(message.secret);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateSecretResponse>): CreateSecretResponse {
    return CreateSecretResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateSecretResponse>): CreateSecretResponse {
    const message = createBaseCreateSecretResponse();
    message.secret = (object.secret !== undefined && object.secret !== null)
      ? SecretMetadataPayload.fromPartial(object.secret)
      : undefined;
    return message;
  },
};

function createBaseUpdateSecretValueRequest(): UpdateSecretValueRequest {
  return { secretId: "", value: "" };
}

export const UpdateSecretValueRequest: MessageFns<UpdateSecretValueRequest> = {
  encode(message: UpdateSecretValueRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.secretId !== "") {
      writer.uint32(10).string(message.secretId);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateSecretValueRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateSecretValueRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.secretId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateSecretValueRequest {
    return {
      secretId: isSet(object.secretId)
        ? globalThis.String(object.secretId)
        : isSet(object.secret_id)
        ? globalThis.String(object.secret_id)
        : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: UpdateSecretValueRequest): unknown {
    const obj: any = {};
    if (message.secretId !== "") {
      obj.secretId = message.secretId;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateSecretValueRequest>): UpdateSecretValueRequest {
    return UpdateSecretValueRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateSecretValueRequest>): UpdateSecretValueRequest {
    const message = createBaseUpdateSecretValueRequest();
    message.secretId = object.secretId ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseUpdateSecretValueResponse(): UpdateSecretValueResponse {
  return { secret: undefined };
}

export const UpdateSecretValueResponse: MessageFns<UpdateSecretValueResponse> = {
  encode(message: UpdateSecretValueResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.secret !== undefined) {
      SecretMetadataPayload.encode(message.secret, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateSecretValueResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateSecretValueResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.secret = SecretMetadataPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateSecretValueResponse {
    return { secret: isSet(object.secret) ? SecretMetadataPayload.fromJSON(object.secret) : undefined };
  },

  toJSON(message: UpdateSecretValueResponse): unknown {
    const obj: any = {};
    if (message.secret !== undefined) {
      obj.secret = SecretMetadataPayload.toJSON(message.secret);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateSecretValueResponse>): UpdateSecretValueResponse {
    return UpdateSecretValueResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateSecretValueResponse>): UpdateSecretValueResponse {
    const message = createBaseUpdateSecretValueResponse();
    message.secret = (object.secret !== undefined && object.secret !== null)
      ? SecretMetadataPayload.fromPartial(object.secret)
      : undefined;
    return message;
  },
};

function createBaseDeleteSecretRequest(): DeleteSecretRequest {
  return { secretId: "" };
}

export const DeleteSecretRequest: MessageFns<DeleteSecretRequest> = {
  encode(message: DeleteSecretRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.secretId !== "") {
      writer.uint32(10).string(message.secretId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteSecretRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteSecretRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.secretId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteSecretRequest {
    return {
      secretId: isSet(object.secretId)
        ? globalThis.String(object.secretId)
        : isSet(object.secret_id)
        ? globalThis.String(object.secret_id)
        : "",
    };
  },

  toJSON(message: DeleteSecretRequest): unknown {
    const obj: any = {};
    if (message.secretId !== "") {
      obj.secretId = message.secretId;
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteSecretRequest>): DeleteSecretRequest {
    return DeleteSecretRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteSecretRequest>): DeleteSecretRequest {
    const message = createBaseDeleteSecretRequest();
    message.secretId = object.secretId ?? "";
    return message;
  },
};

function createBaseDeleteSecretResponse(): DeleteSecretResponse {
  return {};
}

export const DeleteSecretResponse: MessageFns<DeleteSecretResponse> = {
  encode(_: DeleteSecretResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteSecretResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteSecretResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteSecretResponse {
    return {};
  },

  toJSON(_: DeleteSecretResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<DeleteSecretResponse>): DeleteSecretResponse {
    return DeleteSecretResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<DeleteSecretResponse>): DeleteSecretResponse {
    const message = createBaseDeleteSecretResponse();
    return message;
  },
};

function createBaseRunRepoSetupTestRequest(): RunRepoSetupTestRequest {
  return { repoFullName: "", provider: "" };
}

export const RunRepoSetupTestRequest: MessageFns<RunRepoSetupTestRequest> = {
  encode(message: RunRepoSetupTestRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.repoFullName !== "") {
      writer.uint32(10).string(message.repoFullName);
    }
    if (message.provider !== "") {
      writer.uint32(18).string(message.provider);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunRepoSetupTestRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunRepoSetupTestRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.repoFullName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.provider = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RunRepoSetupTestRequest {
    return {
      repoFullName: isSet(object.repoFullName)
        ? globalThis.String(object.repoFullName)
        : isSet(object.repo_full_name)
        ? globalThis.String(object.repo_full_name)
        : "",
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
    };
  },

  toJSON(message: RunRepoSetupTestRequest): unknown {
    const obj: any = {};
    if (message.repoFullName !== "") {
      obj.repoFullName = message.repoFullName;
    }
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    return obj;
  },

  create(base?: DeepPartial<RunRepoSetupTestRequest>): RunRepoSetupTestRequest {
    return RunRepoSetupTestRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RunRepoSetupTestRequest>): RunRepoSetupTestRequest {
    const message = createBaseRunRepoSetupTestRequest();
    message.repoFullName = object.repoFullName ?? "";
    message.provider = object.provider ?? "";
    return message;
  },
};

function createBaseRunRepoSetupTestResponse(): RunRepoSetupTestResponse {
  return {};
}

export const RunRepoSetupTestResponse: MessageFns<RunRepoSetupTestResponse> = {
  encode(_: RunRepoSetupTestResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RunRepoSetupTestResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRunRepoSetupTestResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RunRepoSetupTestResponse {
    return {};
  },

  toJSON(_: RunRepoSetupTestResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<RunRepoSetupTestResponse>): RunRepoSetupTestResponse {
    return RunRepoSetupTestResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<RunRepoSetupTestResponse>): RunRepoSetupTestResponse {
    const message = createBaseRunRepoSetupTestResponse();
    return message;
  },
};

function createBasePromoteIdeaRequest(): PromoteIdeaRequest {
  return { projectTemplateId: "" };
}

export const PromoteIdeaRequest: MessageFns<PromoteIdeaRequest> = {
  encode(message: PromoteIdeaRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.projectTemplateId !== "") {
      writer.uint32(10).string(message.projectTemplateId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PromoteIdeaRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePromoteIdeaRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.projectTemplateId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PromoteIdeaRequest {
    return {
      projectTemplateId: isSet(object.projectTemplateId)
        ? globalThis.String(object.projectTemplateId)
        : isSet(object.project_template_id)
        ? globalThis.String(object.project_template_id)
        : "",
    };
  },

  toJSON(message: PromoteIdeaRequest): unknown {
    const obj: any = {};
    if (message.projectTemplateId !== "") {
      obj.projectTemplateId = message.projectTemplateId;
    }
    return obj;
  },

  create(base?: DeepPartial<PromoteIdeaRequest>): PromoteIdeaRequest {
    return PromoteIdeaRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PromoteIdeaRequest>): PromoteIdeaRequest {
    const message = createBasePromoteIdeaRequest();
    message.projectTemplateId = object.projectTemplateId ?? "";
    return message;
  },
};

function createBasePromoteIdeaResponse(): PromoteIdeaResponse {
  return { document: undefined, warning: undefined };
}

export const PromoteIdeaResponse: MessageFns<PromoteIdeaResponse> = {
  encode(message: PromoteIdeaResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.document !== undefined) {
      DocumentEntity.encode(message.document, writer.uint32(10).fork()).join();
    }
    if (message.warning !== undefined) {
      writer.uint32(18).string(message.warning);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PromoteIdeaResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePromoteIdeaResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.document = DocumentEntity.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.warning = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PromoteIdeaResponse {
    return {
      document: isSet(object.document) ? DocumentEntity.fromJSON(object.document) : undefined,
      warning: isSet(object.warning) ? globalThis.String(object.warning) : undefined,
    };
  },

  toJSON(message: PromoteIdeaResponse): unknown {
    const obj: any = {};
    if (message.document !== undefined) {
      obj.document = DocumentEntity.toJSON(message.document);
    }
    if (message.warning !== undefined) {
      obj.warning = message.warning;
    }
    return obj;
  },

  create(base?: DeepPartial<PromoteIdeaResponse>): PromoteIdeaResponse {
    return PromoteIdeaResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PromoteIdeaResponse>): PromoteIdeaResponse {
    const message = createBasePromoteIdeaResponse();
    message.document = (object.document !== undefined && object.document !== null)
      ? DocumentEntity.fromPartial(object.document)
      : undefined;
    message.warning = object.warning ?? undefined;
    return message;
  },
};

function createBaseGetRepoResearchCommentsRequest(): GetRepoResearchCommentsRequest {
  return { repoId: "" };
}

export const GetRepoResearchCommentsRequest: MessageFns<GetRepoResearchCommentsRequest> = {
  encode(message: GetRepoResearchCommentsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.repoId !== "") {
      writer.uint32(10).string(message.repoId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRepoResearchCommentsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRepoResearchCommentsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.repoId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRepoResearchCommentsRequest {
    return {
      repoId: isSet(object.repoId)
        ? globalThis.String(object.repoId)
        : isSet(object.repo_id)
        ? globalThis.String(object.repo_id)
        : "",
    };
  },

  toJSON(message: GetRepoResearchCommentsRequest): unknown {
    const obj: any = {};
    if (message.repoId !== "") {
      obj.repoId = message.repoId;
    }
    return obj;
  },

  create(base?: DeepPartial<GetRepoResearchCommentsRequest>): GetRepoResearchCommentsRequest {
    return GetRepoResearchCommentsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetRepoResearchCommentsRequest>): GetRepoResearchCommentsRequest {
    const message = createBaseGetRepoResearchCommentsRequest();
    message.repoId = object.repoId ?? "";
    return message;
  },
};

function createBaseGetRepoResearchCommentsResponse(): GetRepoResearchCommentsResponse {
  return { comments: [], groupedCounts: undefined };
}

export const GetRepoResearchCommentsResponse: MessageFns<GetRepoResearchCommentsResponse> = {
  encode(message: GetRepoResearchCommentsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.comments) {
      RepoResearchComment.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.groupedCounts !== undefined) {
      RepoResearchCommentsGroupedCounts.encode(message.groupedCounts, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRepoResearchCommentsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRepoResearchCommentsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.comments.push(RepoResearchComment.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.groupedCounts = RepoResearchCommentsGroupedCounts.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRepoResearchCommentsResponse {
    return {
      comments: globalThis.Array.isArray(object?.comments)
        ? object.comments.map((e: any) => RepoResearchComment.fromJSON(e))
        : [],
      groupedCounts: isSet(object.groupedCounts)
        ? RepoResearchCommentsGroupedCounts.fromJSON(object.groupedCounts)
        : isSet(object.grouped_counts)
        ? RepoResearchCommentsGroupedCounts.fromJSON(object.grouped_counts)
        : undefined,
    };
  },

  toJSON(message: GetRepoResearchCommentsResponse): unknown {
    const obj: any = {};
    if (message.comments?.length) {
      obj.comments = message.comments.map((e) => RepoResearchComment.toJSON(e));
    }
    if (message.groupedCounts !== undefined) {
      obj.groupedCounts = RepoResearchCommentsGroupedCounts.toJSON(message.groupedCounts);
    }
    return obj;
  },

  create(base?: DeepPartial<GetRepoResearchCommentsResponse>): GetRepoResearchCommentsResponse {
    return GetRepoResearchCommentsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetRepoResearchCommentsResponse>): GetRepoResearchCommentsResponse {
    const message = createBaseGetRepoResearchCommentsResponse();
    message.comments = object.comments?.map((e) => RepoResearchComment.fromPartial(e)) || [];
    message.groupedCounts = (object.groupedCounts !== undefined && object.groupedCounts !== null)
      ? RepoResearchCommentsGroupedCounts.fromPartial(object.groupedCounts)
      : undefined;
    return message;
  },
};

function createBaseCreateRepoResearchCommentRequest(): CreateRepoResearchCommentRequest {
  return { comment: undefined };
}

export const CreateRepoResearchCommentRequest: MessageFns<CreateRepoResearchCommentRequest> = {
  encode(message: CreateRepoResearchCommentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.comment !== undefined) {
      RepoResearchComment.encode(message.comment, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateRepoResearchCommentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateRepoResearchCommentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.comment = RepoResearchComment.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateRepoResearchCommentRequest {
    return { comment: isSet(object.comment) ? RepoResearchComment.fromJSON(object.comment) : undefined };
  },

  toJSON(message: CreateRepoResearchCommentRequest): unknown {
    const obj: any = {};
    if (message.comment !== undefined) {
      obj.comment = RepoResearchComment.toJSON(message.comment);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateRepoResearchCommentRequest>): CreateRepoResearchCommentRequest {
    return CreateRepoResearchCommentRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateRepoResearchCommentRequest>): CreateRepoResearchCommentRequest {
    const message = createBaseCreateRepoResearchCommentRequest();
    message.comment = (object.comment !== undefined && object.comment !== null)
      ? RepoResearchComment.fromPartial(object.comment)
      : undefined;
    return message;
  },
};

function createBaseCreateRepoResearchCommentResponse(): CreateRepoResearchCommentResponse {
  return { comment: undefined };
}

export const CreateRepoResearchCommentResponse: MessageFns<CreateRepoResearchCommentResponse> = {
  encode(message: CreateRepoResearchCommentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.comment !== undefined) {
      RepoResearchComment.encode(message.comment, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateRepoResearchCommentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateRepoResearchCommentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.comment = RepoResearchComment.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateRepoResearchCommentResponse {
    return { comment: isSet(object.comment) ? RepoResearchComment.fromJSON(object.comment) : undefined };
  },

  toJSON(message: CreateRepoResearchCommentResponse): unknown {
    const obj: any = {};
    if (message.comment !== undefined) {
      obj.comment = RepoResearchComment.toJSON(message.comment);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateRepoResearchCommentResponse>): CreateRepoResearchCommentResponse {
    return CreateRepoResearchCommentResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateRepoResearchCommentResponse>): CreateRepoResearchCommentResponse {
    const message = createBaseCreateRepoResearchCommentResponse();
    message.comment = (object.comment !== undefined && object.comment !== null)
      ? RepoResearchComment.fromPartial(object.comment)
      : undefined;
    return message;
  },
};

function createBaseUpdateRepoResearchCommentRequest(): UpdateRepoResearchCommentRequest {
  return { comment: undefined };
}

export const UpdateRepoResearchCommentRequest: MessageFns<UpdateRepoResearchCommentRequest> = {
  encode(message: UpdateRepoResearchCommentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.comment !== undefined) {
      RepoResearchComment.encode(message.comment, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateRepoResearchCommentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateRepoResearchCommentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.comment = RepoResearchComment.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateRepoResearchCommentRequest {
    return { comment: isSet(object.comment) ? RepoResearchComment.fromJSON(object.comment) : undefined };
  },

  toJSON(message: UpdateRepoResearchCommentRequest): unknown {
    const obj: any = {};
    if (message.comment !== undefined) {
      obj.comment = RepoResearchComment.toJSON(message.comment);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateRepoResearchCommentRequest>): UpdateRepoResearchCommentRequest {
    return UpdateRepoResearchCommentRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateRepoResearchCommentRequest>): UpdateRepoResearchCommentRequest {
    const message = createBaseUpdateRepoResearchCommentRequest();
    message.comment = (object.comment !== undefined && object.comment !== null)
      ? RepoResearchComment.fromPartial(object.comment)
      : undefined;
    return message;
  },
};

function createBaseUpdateRepoResearchCommentResponse(): UpdateRepoResearchCommentResponse {
  return { comment: undefined };
}

export const UpdateRepoResearchCommentResponse: MessageFns<UpdateRepoResearchCommentResponse> = {
  encode(message: UpdateRepoResearchCommentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.comment !== undefined) {
      RepoResearchComment.encode(message.comment, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateRepoResearchCommentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateRepoResearchCommentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.comment = RepoResearchComment.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateRepoResearchCommentResponse {
    return { comment: isSet(object.comment) ? RepoResearchComment.fromJSON(object.comment) : undefined };
  },

  toJSON(message: UpdateRepoResearchCommentResponse): unknown {
    const obj: any = {};
    if (message.comment !== undefined) {
      obj.comment = RepoResearchComment.toJSON(message.comment);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateRepoResearchCommentResponse>): UpdateRepoResearchCommentResponse {
    return UpdateRepoResearchCommentResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateRepoResearchCommentResponse>): UpdateRepoResearchCommentResponse {
    const message = createBaseUpdateRepoResearchCommentResponse();
    message.comment = (object.comment !== undefined && object.comment !== null)
      ? RepoResearchComment.fromPartial(object.comment)
      : undefined;
    return message;
  },
};

function createBaseDeleteRepoResearchCommentRequest(): DeleteRepoResearchCommentRequest {
  return { commentId: "" };
}

export const DeleteRepoResearchCommentRequest: MessageFns<DeleteRepoResearchCommentRequest> = {
  encode(message: DeleteRepoResearchCommentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.commentId !== "") {
      writer.uint32(10).string(message.commentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteRepoResearchCommentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteRepoResearchCommentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.commentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteRepoResearchCommentRequest {
    return {
      commentId: isSet(object.commentId)
        ? globalThis.String(object.commentId)
        : isSet(object.comment_id)
        ? globalThis.String(object.comment_id)
        : "",
    };
  },

  toJSON(message: DeleteRepoResearchCommentRequest): unknown {
    const obj: any = {};
    if (message.commentId !== "") {
      obj.commentId = message.commentId;
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteRepoResearchCommentRequest>): DeleteRepoResearchCommentRequest {
    return DeleteRepoResearchCommentRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteRepoResearchCommentRequest>): DeleteRepoResearchCommentRequest {
    const message = createBaseDeleteRepoResearchCommentRequest();
    message.commentId = object.commentId ?? "";
    return message;
  },
};

function createBaseDeleteRepoResearchCommentResponse(): DeleteRepoResearchCommentResponse {
  return {};
}

export const DeleteRepoResearchCommentResponse: MessageFns<DeleteRepoResearchCommentResponse> = {
  encode(_: DeleteRepoResearchCommentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteRepoResearchCommentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteRepoResearchCommentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteRepoResearchCommentResponse {
    return {};
  },

  toJSON(_: DeleteRepoResearchCommentResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<DeleteRepoResearchCommentResponse>): DeleteRepoResearchCommentResponse {
    return DeleteRepoResearchCommentResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<DeleteRepoResearchCommentResponse>): DeleteRepoResearchCommentResponse {
    const message = createBaseDeleteRepoResearchCommentResponse();
    return message;
  },
};

function createBaseDeleteAllRepoResearchCommentsRequest(): DeleteAllRepoResearchCommentsRequest {
  return {};
}

export const DeleteAllRepoResearchCommentsRequest: MessageFns<DeleteAllRepoResearchCommentsRequest> = {
  encode(_: DeleteAllRepoResearchCommentsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteAllRepoResearchCommentsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteAllRepoResearchCommentsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteAllRepoResearchCommentsRequest {
    return {};
  },

  toJSON(_: DeleteAllRepoResearchCommentsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<DeleteAllRepoResearchCommentsRequest>): DeleteAllRepoResearchCommentsRequest {
    return DeleteAllRepoResearchCommentsRequest.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<DeleteAllRepoResearchCommentsRequest>): DeleteAllRepoResearchCommentsRequest {
    const message = createBaseDeleteAllRepoResearchCommentsRequest();
    return message;
  },
};

function createBaseDeleteAllRepoResearchCommentsResponse(): DeleteAllRepoResearchCommentsResponse {
  return {};
}

export const DeleteAllRepoResearchCommentsResponse: MessageFns<DeleteAllRepoResearchCommentsResponse> = {
  encode(_: DeleteAllRepoResearchCommentsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteAllRepoResearchCommentsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteAllRepoResearchCommentsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteAllRepoResearchCommentsResponse {
    return {};
  },

  toJSON(_: DeleteAllRepoResearchCommentsResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<DeleteAllRepoResearchCommentsResponse>): DeleteAllRepoResearchCommentsResponse {
    return DeleteAllRepoResearchCommentsResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<DeleteAllRepoResearchCommentsResponse>): DeleteAllRepoResearchCommentsResponse {
    const message = createBaseDeleteAllRepoResearchCommentsResponse();
    return message;
  },
};

function createBaseGenerateAndUpsertRepoResearchGuidanceRequest(): GenerateAndUpsertRepoResearchGuidanceRequest {
  return {
    repoId: "",
    commentsByArea: undefined,
    repoSummaryComments: [],
    additionalInstructions: undefined,
    clearProcessedComments: undefined,
  };
}

export const GenerateAndUpsertRepoResearchGuidanceRequest: MessageFns<GenerateAndUpsertRepoResearchGuidanceRequest> = {
  encode(
    message: GenerateAndUpsertRepoResearchGuidanceRequest,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.repoId !== "") {
      writer.uint32(10).string(message.repoId);
    }
    if (message.commentsByArea !== undefined) {
      RepoResearchCommentsByArea.encode(message.commentsByArea, writer.uint32(18).fork()).join();
    }
    for (const v of message.repoSummaryComments) {
      RepoResearchComment.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.additionalInstructions !== undefined) {
      writer.uint32(34).string(message.additionalInstructions);
    }
    if (message.clearProcessedComments !== undefined) {
      writer.uint32(40).bool(message.clearProcessedComments);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateAndUpsertRepoResearchGuidanceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateAndUpsertRepoResearchGuidanceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.repoId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.commentsByArea = RepoResearchCommentsByArea.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.repoSummaryComments.push(RepoResearchComment.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.additionalInstructions = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.clearProcessedComments = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateAndUpsertRepoResearchGuidanceRequest {
    return {
      repoId: isSet(object.repoId)
        ? globalThis.String(object.repoId)
        : isSet(object.repo_id)
        ? globalThis.String(object.repo_id)
        : "",
      commentsByArea: isSet(object.commentsByArea)
        ? RepoResearchCommentsByArea.fromJSON(object.commentsByArea)
        : isSet(object.comments_by_area)
        ? RepoResearchCommentsByArea.fromJSON(object.comments_by_area)
        : undefined,
      repoSummaryComments: globalThis.Array.isArray(object?.repoSummaryComments)
        ? object.repoSummaryComments.map((e: any) => RepoResearchComment.fromJSON(e))
        : globalThis.Array.isArray(object?.repo_summary_comments)
        ? object.repo_summary_comments.map((e: any) => RepoResearchComment.fromJSON(e))
        : [],
      additionalInstructions: isSet(object.additionalInstructions)
        ? globalThis.String(object.additionalInstructions)
        : isSet(object.additional_instructions)
        ? globalThis.String(object.additional_instructions)
        : undefined,
      clearProcessedComments: isSet(object.clearProcessedComments)
        ? globalThis.Boolean(object.clearProcessedComments)
        : isSet(object.clear_processed_comments)
        ? globalThis.Boolean(object.clear_processed_comments)
        : undefined,
    };
  },

  toJSON(message: GenerateAndUpsertRepoResearchGuidanceRequest): unknown {
    const obj: any = {};
    if (message.repoId !== "") {
      obj.repoId = message.repoId;
    }
    if (message.commentsByArea !== undefined) {
      obj.commentsByArea = RepoResearchCommentsByArea.toJSON(message.commentsByArea);
    }
    if (message.repoSummaryComments?.length) {
      obj.repoSummaryComments = message.repoSummaryComments.map((e) => RepoResearchComment.toJSON(e));
    }
    if (message.additionalInstructions !== undefined) {
      obj.additionalInstructions = message.additionalInstructions;
    }
    if (message.clearProcessedComments !== undefined) {
      obj.clearProcessedComments = message.clearProcessedComments;
    }
    return obj;
  },

  create(
    base?: DeepPartial<GenerateAndUpsertRepoResearchGuidanceRequest>,
  ): GenerateAndUpsertRepoResearchGuidanceRequest {
    return GenerateAndUpsertRepoResearchGuidanceRequest.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<GenerateAndUpsertRepoResearchGuidanceRequest>,
  ): GenerateAndUpsertRepoResearchGuidanceRequest {
    const message = createBaseGenerateAndUpsertRepoResearchGuidanceRequest();
    message.repoId = object.repoId ?? "";
    message.commentsByArea = (object.commentsByArea !== undefined && object.commentsByArea !== null)
      ? RepoResearchCommentsByArea.fromPartial(object.commentsByArea)
      : undefined;
    message.repoSummaryComments = object.repoSummaryComments?.map((e) => RepoResearchComment.fromPartial(e)) || [];
    message.additionalInstructions = object.additionalInstructions ?? undefined;
    message.clearProcessedComments = object.clearProcessedComments ?? undefined;
    return message;
  },
};

function createBaseGenerateAndUpsertRepoResearchGuidanceResponse(): GenerateAndUpsertRepoResearchGuidanceResponse {
  return { guidanceUploaded: false, commentsDeleted: false };
}

export const GenerateAndUpsertRepoResearchGuidanceResponse: MessageFns<GenerateAndUpsertRepoResearchGuidanceResponse> =
  {
    encode(
      message: GenerateAndUpsertRepoResearchGuidanceResponse,
      writer: BinaryWriter = new BinaryWriter(),
    ): BinaryWriter {
      if (message.guidanceUploaded !== false) {
        writer.uint32(8).bool(message.guidanceUploaded);
      }
      if (message.commentsDeleted !== false) {
        writer.uint32(16).bool(message.commentsDeleted);
      }
      return writer;
    },

    decode(input: BinaryReader | Uint8Array, length?: number): GenerateAndUpsertRepoResearchGuidanceResponse {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseGenerateAndUpsertRepoResearchGuidanceResponse();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.guidanceUploaded = reader.bool();
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.commentsDeleted = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    },

    fromJSON(object: any): GenerateAndUpsertRepoResearchGuidanceResponse {
      return {
        guidanceUploaded: isSet(object.guidanceUploaded)
          ? globalThis.Boolean(object.guidanceUploaded)
          : isSet(object.guidance_uploaded)
          ? globalThis.Boolean(object.guidance_uploaded)
          : false,
        commentsDeleted: isSet(object.commentsDeleted)
          ? globalThis.Boolean(object.commentsDeleted)
          : isSet(object.comments_deleted)
          ? globalThis.Boolean(object.comments_deleted)
          : false,
      };
    },

    toJSON(message: GenerateAndUpsertRepoResearchGuidanceResponse): unknown {
      const obj: any = {};
      if (message.guidanceUploaded !== false) {
        obj.guidanceUploaded = message.guidanceUploaded;
      }
      if (message.commentsDeleted !== false) {
        obj.commentsDeleted = message.commentsDeleted;
      }
      return obj;
    },

    create(
      base?: DeepPartial<GenerateAndUpsertRepoResearchGuidanceResponse>,
    ): GenerateAndUpsertRepoResearchGuidanceResponse {
      return GenerateAndUpsertRepoResearchGuidanceResponse.fromPartial(base ?? {});
    },
    fromPartial(
      object: DeepPartial<GenerateAndUpsertRepoResearchGuidanceResponse>,
    ): GenerateAndUpsertRepoResearchGuidanceResponse {
      const message = createBaseGenerateAndUpsertRepoResearchGuidanceResponse();
      message.guidanceUploaded = object.guidanceUploaded ?? false;
      message.commentsDeleted = object.commentsDeleted ?? false;
      return message;
    },
  };

function createBaseGetRepoResearchGuidanceRequest(): GetRepoResearchGuidanceRequest {
  return { repoId: "", provider: 0 };
}

export const GetRepoResearchGuidanceRequest: MessageFns<GetRepoResearchGuidanceRequest> = {
  encode(message: GetRepoResearchGuidanceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.repoId !== "") {
      writer.uint32(10).string(message.repoId);
    }
    if (message.provider !== 0) {
      writer.uint32(16).int32(message.provider);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRepoResearchGuidanceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRepoResearchGuidanceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.repoId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRepoResearchGuidanceRequest {
    return {
      repoId: isSet(object.repoId)
        ? globalThis.String(object.repoId)
        : isSet(object.repo_id)
        ? globalThis.String(object.repo_id)
        : "",
      provider: isSet(object.provider) ? gitProviderFromJSON(object.provider) : 0,
    };
  },

  toJSON(message: GetRepoResearchGuidanceRequest): unknown {
    const obj: any = {};
    if (message.repoId !== "") {
      obj.repoId = message.repoId;
    }
    if (message.provider !== 0) {
      obj.provider = gitProviderToJSON(message.provider);
    }
    return obj;
  },

  create(base?: DeepPartial<GetRepoResearchGuidanceRequest>): GetRepoResearchGuidanceRequest {
    return GetRepoResearchGuidanceRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetRepoResearchGuidanceRequest>): GetRepoResearchGuidanceRequest {
    const message = createBaseGetRepoResearchGuidanceRequest();
    message.repoId = object.repoId ?? "";
    message.provider = object.provider ?? 0;
    return message;
  },
};

function createBaseGetRepoResearchGuidanceResponse(): GetRepoResearchGuidanceResponse {
  return { content: undefined };
}

export const GetRepoResearchGuidanceResponse: MessageFns<GetRepoResearchGuidanceResponse> = {
  encode(message: GetRepoResearchGuidanceResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.content !== undefined) {
      writer.uint32(10).string(message.content);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRepoResearchGuidanceResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRepoResearchGuidanceResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.content = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRepoResearchGuidanceResponse {
    return { content: isSet(object.content) ? globalThis.String(object.content) : undefined };
  },

  toJSON(message: GetRepoResearchGuidanceResponse): unknown {
    const obj: any = {};
    if (message.content !== undefined) {
      obj.content = message.content;
    }
    return obj;
  },

  create(base?: DeepPartial<GetRepoResearchGuidanceResponse>): GetRepoResearchGuidanceResponse {
    return GetRepoResearchGuidanceResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetRepoResearchGuidanceResponse>): GetRepoResearchGuidanceResponse {
    const message = createBaseGetRepoResearchGuidanceResponse();
    message.content = object.content ?? undefined;
    return message;
  },
};

function createBaseUpsertRepoResearchGuidanceContentRequest(): UpsertRepoResearchGuidanceContentRequest {
  return { repoId: "", content: "", provider: 0 };
}

export const UpsertRepoResearchGuidanceContentRequest: MessageFns<UpsertRepoResearchGuidanceContentRequest> = {
  encode(message: UpsertRepoResearchGuidanceContentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.repoId !== "") {
      writer.uint32(10).string(message.repoId);
    }
    if (message.content !== "") {
      writer.uint32(18).string(message.content);
    }
    if (message.provider !== 0) {
      writer.uint32(24).int32(message.provider);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpsertRepoResearchGuidanceContentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpsertRepoResearchGuidanceContentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.repoId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpsertRepoResearchGuidanceContentRequest {
    return {
      repoId: isSet(object.repoId)
        ? globalThis.String(object.repoId)
        : isSet(object.repo_id)
        ? globalThis.String(object.repo_id)
        : "",
      content: isSet(object.content) ? globalThis.String(object.content) : "",
      provider: isSet(object.provider) ? gitProviderFromJSON(object.provider) : 0,
    };
  },

  toJSON(message: UpsertRepoResearchGuidanceContentRequest): unknown {
    const obj: any = {};
    if (message.repoId !== "") {
      obj.repoId = message.repoId;
    }
    if (message.content !== "") {
      obj.content = message.content;
    }
    if (message.provider !== 0) {
      obj.provider = gitProviderToJSON(message.provider);
    }
    return obj;
  },

  create(base?: DeepPartial<UpsertRepoResearchGuidanceContentRequest>): UpsertRepoResearchGuidanceContentRequest {
    return UpsertRepoResearchGuidanceContentRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpsertRepoResearchGuidanceContentRequest>): UpsertRepoResearchGuidanceContentRequest {
    const message = createBaseUpsertRepoResearchGuidanceContentRequest();
    message.repoId = object.repoId ?? "";
    message.content = object.content ?? "";
    message.provider = object.provider ?? 0;
    return message;
  },
};

function createBaseUpsertRepoResearchGuidanceContentResponse(): UpsertRepoResearchGuidanceContentResponse {
  return { success: false };
}

export const UpsertRepoResearchGuidanceContentResponse: MessageFns<UpsertRepoResearchGuidanceContentResponse> = {
  encode(message: UpsertRepoResearchGuidanceContentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpsertRepoResearchGuidanceContentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpsertRepoResearchGuidanceContentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpsertRepoResearchGuidanceContentResponse {
    return { success: isSet(object.success) ? globalThis.Boolean(object.success) : false };
  },

  toJSON(message: UpsertRepoResearchGuidanceContentResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    return obj;
  },

  create(base?: DeepPartial<UpsertRepoResearchGuidanceContentResponse>): UpsertRepoResearchGuidanceContentResponse {
    return UpsertRepoResearchGuidanceContentResponse.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<UpsertRepoResearchGuidanceContentResponse>,
  ): UpsertRepoResearchGuidanceContentResponse {
    const message = createBaseUpsertRepoResearchGuidanceContentResponse();
    message.success = object.success ?? false;
    return message;
  },
};

function createBaseAttachmentPresignRequest(): AttachmentPresignRequest {
  return { fileExtension: "", fileType: "", fileSize: 0, originalFileName: "", userDescription: undefined };
}

export const AttachmentPresignRequest: MessageFns<AttachmentPresignRequest> = {
  encode(message: AttachmentPresignRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fileExtension !== "") {
      writer.uint32(10).string(message.fileExtension);
    }
    if (message.fileType !== "") {
      writer.uint32(18).string(message.fileType);
    }
    if (message.fileSize !== 0) {
      writer.uint32(24).int64(message.fileSize);
    }
    if (message.originalFileName !== "") {
      writer.uint32(34).string(message.originalFileName);
    }
    if (message.userDescription !== undefined) {
      writer.uint32(42).string(message.userDescription);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachmentPresignRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachmentPresignRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fileExtension = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fileType = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.fileSize = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.originalFileName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.userDescription = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachmentPresignRequest {
    return {
      fileExtension: isSet(object.fileExtension)
        ? globalThis.String(object.fileExtension)
        : isSet(object.file_extension)
        ? globalThis.String(object.file_extension)
        : "",
      fileType: isSet(object.fileType)
        ? globalThis.String(object.fileType)
        : isSet(object.file_type)
        ? globalThis.String(object.file_type)
        : "",
      fileSize: isSet(object.fileSize)
        ? globalThis.Number(object.fileSize)
        : isSet(object.file_size)
        ? globalThis.Number(object.file_size)
        : 0,
      originalFileName: isSet(object.originalFileName)
        ? globalThis.String(object.originalFileName)
        : isSet(object.original_file_name)
        ? globalThis.String(object.original_file_name)
        : "",
      userDescription: isSet(object.userDescription)
        ? globalThis.String(object.userDescription)
        : isSet(object.user_description)
        ? globalThis.String(object.user_description)
        : undefined,
    };
  },

  toJSON(message: AttachmentPresignRequest): unknown {
    const obj: any = {};
    if (message.fileExtension !== "") {
      obj.fileExtension = message.fileExtension;
    }
    if (message.fileType !== "") {
      obj.fileType = message.fileType;
    }
    if (message.fileSize !== 0) {
      obj.fileSize = Math.round(message.fileSize);
    }
    if (message.originalFileName !== "") {
      obj.originalFileName = message.originalFileName;
    }
    if (message.userDescription !== undefined) {
      obj.userDescription = message.userDescription;
    }
    return obj;
  },

  create(base?: DeepPartial<AttachmentPresignRequest>): AttachmentPresignRequest {
    return AttachmentPresignRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachmentPresignRequest>): AttachmentPresignRequest {
    const message = createBaseAttachmentPresignRequest();
    message.fileExtension = object.fileExtension ?? "";
    message.fileType = object.fileType ?? "";
    message.fileSize = object.fileSize ?? 0;
    message.originalFileName = object.originalFileName ?? "";
    message.userDescription = object.userDescription ?? undefined;
    return message;
  },
};

function createBaseAttachmentPresignResponse(): AttachmentPresignResponse {
  return { attachmentId: "", signedUrl: "" };
}

export const AttachmentPresignResponse: MessageFns<AttachmentPresignResponse> = {
  encode(message: AttachmentPresignResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.attachmentId !== "") {
      writer.uint32(10).string(message.attachmentId);
    }
    if (message.signedUrl !== "") {
      writer.uint32(18).string(message.signedUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachmentPresignResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachmentPresignResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachmentId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.signedUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachmentPresignResponse {
    return {
      attachmentId: isSet(object.attachmentId)
        ? globalThis.String(object.attachmentId)
        : isSet(object.attachment_id)
        ? globalThis.String(object.attachment_id)
        : "",
      signedUrl: isSet(object.signedUrl)
        ? globalThis.String(object.signedUrl)
        : isSet(object.signed_url)
        ? globalThis.String(object.signed_url)
        : "",
    };
  },

  toJSON(message: AttachmentPresignResponse): unknown {
    const obj: any = {};
    if (message.attachmentId !== "") {
      obj.attachmentId = message.attachmentId;
    }
    if (message.signedUrl !== "") {
      obj.signedUrl = message.signedUrl;
    }
    return obj;
  },

  create(base?: DeepPartial<AttachmentPresignResponse>): AttachmentPresignResponse {
    return AttachmentPresignResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachmentPresignResponse>): AttachmentPresignResponse {
    const message = createBaseAttachmentPresignResponse();
    message.attachmentId = object.attachmentId ?? "";
    message.signedUrl = object.signedUrl ?? "";
    return message;
  },
};

function createBaseFetchActivityRequest(): FetchActivityRequest {
  return { filters: undefined };
}

export const FetchActivityRequest: MessageFns<FetchActivityRequest> = {
  encode(message: FetchActivityRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.filters !== undefined) {
      ActivityFilters.encode(message.filters, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FetchActivityRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFetchActivityRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.filters = ActivityFilters.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FetchActivityRequest {
    return { filters: isSet(object.filters) ? ActivityFilters.fromJSON(object.filters) : undefined };
  },

  toJSON(message: FetchActivityRequest): unknown {
    const obj: any = {};
    if (message.filters !== undefined) {
      obj.filters = ActivityFilters.toJSON(message.filters);
    }
    return obj;
  },

  create(base?: DeepPartial<FetchActivityRequest>): FetchActivityRequest {
    return FetchActivityRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<FetchActivityRequest>): FetchActivityRequest {
    const message = createBaseFetchActivityRequest();
    message.filters = (object.filters !== undefined && object.filters !== null)
      ? ActivityFilters.fromPartial(object.filters)
      : undefined;
    return message;
  },
};

function createBaseGetProjectActivityResponse(): GetProjectActivityResponse {
  return { activities: [], nextCursor: undefined };
}

export const GetProjectActivityResponse: MessageFns<GetProjectActivityResponse> = {
  encode(message: GetProjectActivityResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.activities) {
      Activity.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.nextCursor !== undefined) {
      writer.uint32(18).string(message.nextCursor);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetProjectActivityResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetProjectActivityResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.activities.push(Activity.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextCursor = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetProjectActivityResponse {
    return {
      activities: globalThis.Array.isArray(object?.activities)
        ? object.activities.map((e: any) => Activity.fromJSON(e))
        : [],
      nextCursor: isSet(object.nextCursor)
        ? globalThis.String(object.nextCursor)
        : isSet(object.next_cursor)
        ? globalThis.String(object.next_cursor)
        : undefined,
    };
  },

  toJSON(message: GetProjectActivityResponse): unknown {
    const obj: any = {};
    if (message.activities?.length) {
      obj.activities = message.activities.map((e) => Activity.toJSON(e));
    }
    if (message.nextCursor !== undefined) {
      obj.nextCursor = message.nextCursor;
    }
    return obj;
  },

  create(base?: DeepPartial<GetProjectActivityResponse>): GetProjectActivityResponse {
    return GetProjectActivityResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetProjectActivityResponse>): GetProjectActivityResponse {
    const message = createBaseGetProjectActivityResponse();
    message.activities = object.activities?.map((e) => Activity.fromPartial(e)) || [];
    message.nextCursor = object.nextCursor ?? undefined;
    return message;
  },
};

function createBaseGetActivityResponse(): GetActivityResponse {
  return { activities: [], nextCursor: undefined };
}

export const GetActivityResponse: MessageFns<GetActivityResponse> = {
  encode(message: GetActivityResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.activities) {
      Activity.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.nextCursor !== undefined) {
      writer.uint32(18).string(message.nextCursor);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetActivityResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetActivityResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.activities.push(Activity.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextCursor = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetActivityResponse {
    return {
      activities: globalThis.Array.isArray(object?.activities)
        ? object.activities.map((e: any) => Activity.fromJSON(e))
        : [],
      nextCursor: isSet(object.nextCursor)
        ? globalThis.String(object.nextCursor)
        : isSet(object.next_cursor)
        ? globalThis.String(object.next_cursor)
        : undefined,
    };
  },

  toJSON(message: GetActivityResponse): unknown {
    const obj: any = {};
    if (message.activities?.length) {
      obj.activities = message.activities.map((e) => Activity.toJSON(e));
    }
    if (message.nextCursor !== undefined) {
      obj.nextCursor = message.nextCursor;
    }
    return obj;
  },

  create(base?: DeepPartial<GetActivityResponse>): GetActivityResponse {
    return GetActivityResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetActivityResponse>): GetActivityResponse {
    const message = createBaseGetActivityResponse();
    message.activities = object.activities?.map((e) => Activity.fromPartial(e)) || [];
    message.nextCursor = object.nextCursor ?? undefined;
    return message;
  },
};

function createBaseRestoreActivityRequest(): RestoreActivityRequest {
  return { lookup: undefined };
}

export const RestoreActivityRequest: MessageFns<RestoreActivityRequest> = {
  encode(message: RestoreActivityRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    switch (message.lookup?.$case) {
      case "byIds":
        ActivityIdList.encode(message.lookup.value, writer.uint32(10).fork()).join();
        break;
      case "batchId":
        writer.uint32(18).string(message.lookup.value);
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RestoreActivityRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRestoreActivityRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.lookup = { $case: "byIds", value: ActivityIdList.decode(reader, reader.uint32()) };
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.lookup = { $case: "batchId", value: reader.string() };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RestoreActivityRequest {
    return {
      lookup: isSet(object.byIds)
        ? { $case: "byIds", value: ActivityIdList.fromJSON(object.byIds) }
        : isSet(object.by_ids)
        ? { $case: "byIds", value: ActivityIdList.fromJSON(object.by_ids) }
        : isSet(object.batchId)
        ? { $case: "batchId", value: globalThis.String(object.batchId) }
        : isSet(object.batch_id)
        ? { $case: "batchId", value: globalThis.String(object.batch_id) }
        : undefined,
    };
  },

  toJSON(message: RestoreActivityRequest): unknown {
    const obj: any = {};
    if (message.lookup?.$case === "byIds") {
      obj.byIds = ActivityIdList.toJSON(message.lookup.value);
    } else if (message.lookup?.$case === "batchId") {
      obj.batchId = message.lookup.value;
    }
    return obj;
  },

  create(base?: DeepPartial<RestoreActivityRequest>): RestoreActivityRequest {
    return RestoreActivityRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RestoreActivityRequest>): RestoreActivityRequest {
    const message = createBaseRestoreActivityRequest();
    switch (object.lookup?.$case) {
      case "byIds": {
        if (object.lookup?.value !== undefined && object.lookup?.value !== null) {
          message.lookup = { $case: "byIds", value: ActivityIdList.fromPartial(object.lookup.value) };
        }
        break;
      }
      case "batchId": {
        if (object.lookup?.value !== undefined && object.lookup?.value !== null) {
          message.lookup = { $case: "batchId", value: object.lookup.value };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseActivityIdList(): ActivityIdList {
  return { ids: [] };
}

export const ActivityIdList: MessageFns<ActivityIdList> = {
  encode(message: ActivityIdList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.ids) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ActivityIdList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActivityIdList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ids.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActivityIdList {
    return { ids: globalThis.Array.isArray(object?.ids) ? object.ids.map((e: any) => globalThis.String(e)) : [] };
  },

  toJSON(message: ActivityIdList): unknown {
    const obj: any = {};
    if (message.ids?.length) {
      obj.ids = message.ids;
    }
    return obj;
  },

  create(base?: DeepPartial<ActivityIdList>): ActivityIdList {
    return ActivityIdList.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ActivityIdList>): ActivityIdList {
    const message = createBaseActivityIdList();
    message.ids = object.ids?.map((e) => e) || [];
    return message;
  },
};

function createBaseRestoreActivityResponse(): RestoreActivityResponse {
  return { restoredCount: 0 };
}

export const RestoreActivityResponse: MessageFns<RestoreActivityResponse> = {
  encode(message: RestoreActivityResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.restoredCount !== 0) {
      writer.uint32(8).int32(message.restoredCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RestoreActivityResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRestoreActivityResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.restoredCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RestoreActivityResponse {
    return {
      restoredCount: isSet(object.restoredCount)
        ? globalThis.Number(object.restoredCount)
        : isSet(object.restored_count)
        ? globalThis.Number(object.restored_count)
        : 0,
    };
  },

  toJSON(message: RestoreActivityResponse): unknown {
    const obj: any = {};
    if (message.restoredCount !== 0) {
      obj.restoredCount = Math.round(message.restoredCount);
    }
    return obj;
  },

  create(base?: DeepPartial<RestoreActivityResponse>): RestoreActivityResponse {
    return RestoreActivityResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RestoreActivityResponse>): RestoreActivityResponse {
    const message = createBaseRestoreActivityResponse();
    message.restoredCount = object.restoredCount ?? 0;
    return message;
  },
};

function createBaseGetProjectAttachmentsRequest(): GetProjectAttachmentsRequest {
  return { projectId: "" };
}

export const GetProjectAttachmentsRequest: MessageFns<GetProjectAttachmentsRequest> = {
  encode(message: GetProjectAttachmentsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.projectId !== "") {
      writer.uint32(10).string(message.projectId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetProjectAttachmentsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetProjectAttachmentsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetProjectAttachmentsRequest {
    return {
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : "",
    };
  },

  toJSON(message: GetProjectAttachmentsRequest): unknown {
    const obj: any = {};
    if (message.projectId !== "") {
      obj.projectId = message.projectId;
    }
    return obj;
  },

  create(base?: DeepPartial<GetProjectAttachmentsRequest>): GetProjectAttachmentsRequest {
    return GetProjectAttachmentsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetProjectAttachmentsRequest>): GetProjectAttachmentsRequest {
    const message = createBaseGetProjectAttachmentsRequest();
    message.projectId = object.projectId ?? "";
    return message;
  },
};

function createBaseGetProjectAttachmentsResponse(): GetProjectAttachmentsResponse {
  return { attachments: [] };
}

export const GetProjectAttachmentsResponse: MessageFns<GetProjectAttachmentsResponse> = {
  encode(message: GetProjectAttachmentsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.attachments) {
      AttachmentDetails.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetProjectAttachmentsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetProjectAttachmentsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachments.push(AttachmentDetails.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetProjectAttachmentsResponse {
    return {
      attachments: globalThis.Array.isArray(object?.attachments)
        ? object.attachments.map((e: any) => AttachmentDetails.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetProjectAttachmentsResponse): unknown {
    const obj: any = {};
    if (message.attachments?.length) {
      obj.attachments = message.attachments.map((e) => AttachmentDetails.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetProjectAttachmentsResponse>): GetProjectAttachmentsResponse {
    return GetProjectAttachmentsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetProjectAttachmentsResponse>): GetProjectAttachmentsResponse {
    const message = createBaseGetProjectAttachmentsResponse();
    message.attachments = object.attachments?.map((e) => AttachmentDetails.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDeleteAttachmentRequest(): DeleteAttachmentRequest {
  return { attachmentId: "" };
}

export const DeleteAttachmentRequest: MessageFns<DeleteAttachmentRequest> = {
  encode(message: DeleteAttachmentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.attachmentId !== "") {
      writer.uint32(10).string(message.attachmentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteAttachmentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteAttachmentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachmentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteAttachmentRequest {
    return {
      attachmentId: isSet(object.attachmentId)
        ? globalThis.String(object.attachmentId)
        : isSet(object.attachment_id)
        ? globalThis.String(object.attachment_id)
        : "",
    };
  },

  toJSON(message: DeleteAttachmentRequest): unknown {
    const obj: any = {};
    if (message.attachmentId !== "") {
      obj.attachmentId = message.attachmentId;
    }
    return obj;
  },

  create(base?: DeepPartial<DeleteAttachmentRequest>): DeleteAttachmentRequest {
    return DeleteAttachmentRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteAttachmentRequest>): DeleteAttachmentRequest {
    const message = createBaseDeleteAttachmentRequest();
    message.attachmentId = object.attachmentId ?? "";
    return message;
  },
};

function createBaseDeleteAttachmentResponse(): DeleteAttachmentResponse {
  return {};
}

export const DeleteAttachmentResponse: MessageFns<DeleteAttachmentResponse> = {
  encode(_: DeleteAttachmentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteAttachmentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteAttachmentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteAttachmentResponse {
    return {};
  },

  toJSON(_: DeleteAttachmentResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<DeleteAttachmentResponse>): DeleteAttachmentResponse {
    return DeleteAttachmentResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<DeleteAttachmentResponse>): DeleteAttachmentResponse {
    const message = createBaseDeleteAttachmentResponse();
    return message;
  },
};

function createBaseGetAttachmentDownloadUrlRequest(): GetAttachmentDownloadUrlRequest {
  return { attachmentId: "" };
}

export const GetAttachmentDownloadUrlRequest: MessageFns<GetAttachmentDownloadUrlRequest> = {
  encode(message: GetAttachmentDownloadUrlRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.attachmentId !== "") {
      writer.uint32(10).string(message.attachmentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAttachmentDownloadUrlRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAttachmentDownloadUrlRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachmentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAttachmentDownloadUrlRequest {
    return {
      attachmentId: isSet(object.attachmentId)
        ? globalThis.String(object.attachmentId)
        : isSet(object.attachment_id)
        ? globalThis.String(object.attachment_id)
        : "",
    };
  },

  toJSON(message: GetAttachmentDownloadUrlRequest): unknown {
    const obj: any = {};
    if (message.attachmentId !== "") {
      obj.attachmentId = message.attachmentId;
    }
    return obj;
  },

  create(base?: DeepPartial<GetAttachmentDownloadUrlRequest>): GetAttachmentDownloadUrlRequest {
    return GetAttachmentDownloadUrlRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetAttachmentDownloadUrlRequest>): GetAttachmentDownloadUrlRequest {
    const message = createBaseGetAttachmentDownloadUrlRequest();
    message.attachmentId = object.attachmentId ?? "";
    return message;
  },
};

function createBaseGetAttachmentDownloadUrlResponse(): GetAttachmentDownloadUrlResponse {
  return { downloadUrl: "" };
}

export const GetAttachmentDownloadUrlResponse: MessageFns<GetAttachmentDownloadUrlResponse> = {
  encode(message: GetAttachmentDownloadUrlResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.downloadUrl !== "") {
      writer.uint32(10).string(message.downloadUrl);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAttachmentDownloadUrlResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAttachmentDownloadUrlResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.downloadUrl = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAttachmentDownloadUrlResponse {
    return {
      downloadUrl: isSet(object.downloadUrl)
        ? globalThis.String(object.downloadUrl)
        : isSet(object.download_url)
        ? globalThis.String(object.download_url)
        : "",
    };
  },

  toJSON(message: GetAttachmentDownloadUrlResponse): unknown {
    const obj: any = {};
    if (message.downloadUrl !== "") {
      obj.downloadUrl = message.downloadUrl;
    }
    return obj;
  },

  create(base?: DeepPartial<GetAttachmentDownloadUrlResponse>): GetAttachmentDownloadUrlResponse {
    return GetAttachmentDownloadUrlResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetAttachmentDownloadUrlResponse>): GetAttachmentDownloadUrlResponse {
    const message = createBaseGetAttachmentDownloadUrlResponse();
    message.downloadUrl = object.downloadUrl ?? "";
    return message;
  },
};

function createBaseProcessAttachmentRequest(): ProcessAttachmentRequest {
  return { attachmentId: "", projectId: undefined, companyContextSection: undefined };
}

export const ProcessAttachmentRequest: MessageFns<ProcessAttachmentRequest> = {
  encode(message: ProcessAttachmentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.attachmentId !== "") {
      writer.uint32(10).string(message.attachmentId);
    }
    if (message.projectId !== undefined) {
      writer.uint32(18).string(message.projectId);
    }
    if (message.companyContextSection !== undefined) {
      writer.uint32(32).int32(message.companyContextSection);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProcessAttachmentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProcessAttachmentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachmentId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.companyContextSection = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProcessAttachmentRequest {
    return {
      attachmentId: isSet(object.attachmentId)
        ? globalThis.String(object.attachmentId)
        : isSet(object.attachment_id)
        ? globalThis.String(object.attachment_id)
        : "",
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : undefined,
      companyContextSection: isSet(object.companyContextSection)
        ? companyContextSectionFromJSON(object.companyContextSection)
        : isSet(object.company_context_section)
        ? companyContextSectionFromJSON(object.company_context_section)
        : undefined,
    };
  },

  toJSON(message: ProcessAttachmentRequest): unknown {
    const obj: any = {};
    if (message.attachmentId !== "") {
      obj.attachmentId = message.attachmentId;
    }
    if (message.projectId !== undefined) {
      obj.projectId = message.projectId;
    }
    if (message.companyContextSection !== undefined) {
      obj.companyContextSection = companyContextSectionToJSON(message.companyContextSection);
    }
    return obj;
  },

  create(base?: DeepPartial<ProcessAttachmentRequest>): ProcessAttachmentRequest {
    return ProcessAttachmentRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProcessAttachmentRequest>): ProcessAttachmentRequest {
    const message = createBaseProcessAttachmentRequest();
    message.attachmentId = object.attachmentId ?? "";
    message.projectId = object.projectId ?? undefined;
    message.companyContextSection = object.companyContextSection ?? undefined;
    return message;
  },
};

function createBaseProcessAttachmentResponse(): ProcessAttachmentResponse {
  return {};
}

export const ProcessAttachmentResponse: MessageFns<ProcessAttachmentResponse> = {
  encode(_: ProcessAttachmentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProcessAttachmentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProcessAttachmentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ProcessAttachmentResponse {
    return {};
  },

  toJSON(_: ProcessAttachmentResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<ProcessAttachmentResponse>): ProcessAttachmentResponse {
    return ProcessAttachmentResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<ProcessAttachmentResponse>): ProcessAttachmentResponse {
    const message = createBaseProcessAttachmentResponse();
    return message;
  },
};

function createBaseGetCatalogueFeaturesResponse(): GetCatalogueFeaturesResponse {
  return { featuresJson: [], productCatalogueJson: "", featureUpdatesJson: [] };
}

export const GetCatalogueFeaturesResponse: MessageFns<GetCatalogueFeaturesResponse> = {
  encode(message: GetCatalogueFeaturesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.featuresJson) {
      writer.uint32(10).string(v!);
    }
    if (message.productCatalogueJson !== "") {
      writer.uint32(18).string(message.productCatalogueJson);
    }
    for (const v of message.featureUpdatesJson) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCatalogueFeaturesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCatalogueFeaturesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.featuresJson.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.productCatalogueJson = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.featureUpdatesJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCatalogueFeaturesResponse {
    return {
      featuresJson: globalThis.Array.isArray(object?.featuresJson)
        ? object.featuresJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.features_json)
        ? object.features_json.map((e: any) => globalThis.String(e))
        : [],
      productCatalogueJson: isSet(object.productCatalogueJson)
        ? globalThis.String(object.productCatalogueJson)
        : isSet(object.product_catalogue_json)
        ? globalThis.String(object.product_catalogue_json)
        : "",
      featureUpdatesJson: globalThis.Array.isArray(object?.featureUpdatesJson)
        ? object.featureUpdatesJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.feature_updates_json)
        ? object.feature_updates_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetCatalogueFeaturesResponse): unknown {
    const obj: any = {};
    if (message.featuresJson?.length) {
      obj.featuresJson = message.featuresJson;
    }
    if (message.productCatalogueJson !== "") {
      obj.productCatalogueJson = message.productCatalogueJson;
    }
    if (message.featureUpdatesJson?.length) {
      obj.featureUpdatesJson = message.featureUpdatesJson;
    }
    return obj;
  },

  create(base?: DeepPartial<GetCatalogueFeaturesResponse>): GetCatalogueFeaturesResponse {
    return GetCatalogueFeaturesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetCatalogueFeaturesResponse>): GetCatalogueFeaturesResponse {
    const message = createBaseGetCatalogueFeaturesResponse();
    message.featuresJson = object.featuresJson?.map((e) => e) || [];
    message.productCatalogueJson = object.productCatalogueJson ?? "";
    message.featureUpdatesJson = object.featureUpdatesJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetCatalogueFeatureUpdatesResponse(): GetCatalogueFeatureUpdatesResponse {
  return { featureUpdatesJson: [] };
}

export const GetCatalogueFeatureUpdatesResponse: MessageFns<GetCatalogueFeatureUpdatesResponse> = {
  encode(message: GetCatalogueFeatureUpdatesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.featureUpdatesJson) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCatalogueFeatureUpdatesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCatalogueFeatureUpdatesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.featureUpdatesJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCatalogueFeatureUpdatesResponse {
    return {
      featureUpdatesJson: globalThis.Array.isArray(object?.featureUpdatesJson)
        ? object.featureUpdatesJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.feature_updates_json)
        ? object.feature_updates_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetCatalogueFeatureUpdatesResponse): unknown {
    const obj: any = {};
    if (message.featureUpdatesJson?.length) {
      obj.featureUpdatesJson = message.featureUpdatesJson;
    }
    return obj;
  },

  create(base?: DeepPartial<GetCatalogueFeatureUpdatesResponse>): GetCatalogueFeatureUpdatesResponse {
    return GetCatalogueFeatureUpdatesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetCatalogueFeatureUpdatesResponse>): GetCatalogueFeatureUpdatesResponse {
    const message = createBaseGetCatalogueFeatureUpdatesResponse();
    message.featureUpdatesJson = object.featureUpdatesJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseCreateCatalogueSectionRequest(): CreateCatalogueSectionRequest {
  return { title: "", description: "" };
}

export const CreateCatalogueSectionRequest: MessageFns<CreateCatalogueSectionRequest> = {
  encode(message: CreateCatalogueSectionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateCatalogueSectionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateCatalogueSectionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateCatalogueSectionRequest {
    return {
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
    };
  },

  toJSON(message: CreateCatalogueSectionRequest): unknown {
    const obj: any = {};
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateCatalogueSectionRequest>): CreateCatalogueSectionRequest {
    return CreateCatalogueSectionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateCatalogueSectionRequest>): CreateCatalogueSectionRequest {
    const message = createBaseCreateCatalogueSectionRequest();
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseRenameCatalogueSectionRequest(): RenameCatalogueSectionRequest {
  return { title: "", description: "" };
}

export const RenameCatalogueSectionRequest: MessageFns<RenameCatalogueSectionRequest> = {
  encode(message: RenameCatalogueSectionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RenameCatalogueSectionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRenameCatalogueSectionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RenameCatalogueSectionRequest {
    return {
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
    };
  },

  toJSON(message: RenameCatalogueSectionRequest): unknown {
    const obj: any = {};
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create(base?: DeepPartial<RenameCatalogueSectionRequest>): RenameCatalogueSectionRequest {
    return RenameCatalogueSectionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RenameCatalogueSectionRequest>): RenameCatalogueSectionRequest {
    const message = createBaseRenameCatalogueSectionRequest();
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseMoveCatalogueFeaturesRequest(): MoveCatalogueFeaturesRequest {
  return { featureIds: [], targetSectionIndex: 0 };
}

export const MoveCatalogueFeaturesRequest: MessageFns<MoveCatalogueFeaturesRequest> = {
  encode(message: MoveCatalogueFeaturesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.featureIds) {
      writer.uint32(10).string(v!);
    }
    if (message.targetSectionIndex !== 0) {
      writer.uint32(16).int32(message.targetSectionIndex);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MoveCatalogueFeaturesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMoveCatalogueFeaturesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.featureIds.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.targetSectionIndex = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MoveCatalogueFeaturesRequest {
    return {
      featureIds: globalThis.Array.isArray(object?.featureIds)
        ? object.featureIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.feature_ids)
        ? object.feature_ids.map((e: any) => globalThis.String(e))
        : [],
      targetSectionIndex: isSet(object.targetSectionIndex)
        ? globalThis.Number(object.targetSectionIndex)
        : isSet(object.target_section_index)
        ? globalThis.Number(object.target_section_index)
        : 0,
    };
  },

  toJSON(message: MoveCatalogueFeaturesRequest): unknown {
    const obj: any = {};
    if (message.featureIds?.length) {
      obj.featureIds = message.featureIds;
    }
    if (message.targetSectionIndex !== 0) {
      obj.targetSectionIndex = Math.round(message.targetSectionIndex);
    }
    return obj;
  },

  create(base?: DeepPartial<MoveCatalogueFeaturesRequest>): MoveCatalogueFeaturesRequest {
    return MoveCatalogueFeaturesRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MoveCatalogueFeaturesRequest>): MoveCatalogueFeaturesRequest {
    const message = createBaseMoveCatalogueFeaturesRequest();
    message.featureIds = object.featureIds?.map((e) => e) || [];
    message.targetSectionIndex = object.targetSectionIndex ?? 0;
    return message;
  },
};

function createBaseMutateProductCatalogueResponse(): MutateProductCatalogueResponse {
  return { productCatalogueJson: "" };
}

export const MutateProductCatalogueResponse: MessageFns<MutateProductCatalogueResponse> = {
  encode(message: MutateProductCatalogueResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.productCatalogueJson !== "") {
      writer.uint32(10).string(message.productCatalogueJson);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MutateProductCatalogueResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMutateProductCatalogueResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.productCatalogueJson = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MutateProductCatalogueResponse {
    return {
      productCatalogueJson: isSet(object.productCatalogueJson)
        ? globalThis.String(object.productCatalogueJson)
        : isSet(object.product_catalogue_json)
        ? globalThis.String(object.product_catalogue_json)
        : "",
    };
  },

  toJSON(message: MutateProductCatalogueResponse): unknown {
    const obj: any = {};
    if (message.productCatalogueJson !== "") {
      obj.productCatalogueJson = message.productCatalogueJson;
    }
    return obj;
  },

  create(base?: DeepPartial<MutateProductCatalogueResponse>): MutateProductCatalogueResponse {
    return MutateProductCatalogueResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MutateProductCatalogueResponse>): MutateProductCatalogueResponse {
    const message = createBaseMutateProductCatalogueResponse();
    message.productCatalogueJson = object.productCatalogueJson ?? "";
    return message;
  },
};

function createBaseCheckCatalogueExistsResponse(): CheckCatalogueExistsResponse {
  return { hasCatalogue: false };
}

export const CheckCatalogueExistsResponse: MessageFns<CheckCatalogueExistsResponse> = {
  encode(message: CheckCatalogueExistsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hasCatalogue !== false) {
      writer.uint32(8).bool(message.hasCatalogue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CheckCatalogueExistsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCheckCatalogueExistsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.hasCatalogue = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CheckCatalogueExistsResponse {
    return {
      hasCatalogue: isSet(object.hasCatalogue)
        ? globalThis.Boolean(object.hasCatalogue)
        : isSet(object.has_catalogue)
        ? globalThis.Boolean(object.has_catalogue)
        : false,
    };
  },

  toJSON(message: CheckCatalogueExistsResponse): unknown {
    const obj: any = {};
    if (message.hasCatalogue !== false) {
      obj.hasCatalogue = message.hasCatalogue;
    }
    return obj;
  },

  create(base?: DeepPartial<CheckCatalogueExistsResponse>): CheckCatalogueExistsResponse {
    return CheckCatalogueExistsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CheckCatalogueExistsResponse>): CheckCatalogueExistsResponse {
    const message = createBaseCheckCatalogueExistsResponse();
    message.hasCatalogue = object.hasCatalogue ?? false;
    return message;
  },
};

function createBaseCatalogFeedbackDraft(): CatalogFeedbackDraft {
  return { id: "", companyId: 0, details: undefined, createdAt: undefined, updatedAt: undefined };
}

export const CatalogFeedbackDraft: MessageFns<CatalogFeedbackDraft> = {
  encode(message: CatalogFeedbackDraft, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    if (message.details !== undefined) {
      CatalogFeedbackDraftDetails.encode(message.details, writer.uint32(26).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(34).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CatalogFeedbackDraft {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCatalogFeedbackDraft();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.details = CatalogFeedbackDraftDetails.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CatalogFeedbackDraft {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      details: isSet(object.details) ? CatalogFeedbackDraftDetails.fromJSON(object.details) : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: CatalogFeedbackDraft): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.details !== undefined) {
      obj.details = CatalogFeedbackDraftDetails.toJSON(message.details);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<CatalogFeedbackDraft>): CatalogFeedbackDraft {
    return CatalogFeedbackDraft.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CatalogFeedbackDraft>): CatalogFeedbackDraft {
    const message = createBaseCatalogFeedbackDraft();
    message.id = object.id ?? "";
    message.companyId = object.companyId ?? 0;
    message.details = (object.details !== undefined && object.details !== null)
      ? CatalogFeedbackDraftDetails.fromPartial(object.details)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseCatalogFeedbackDraftDetails(): CatalogFeedbackDraftDetails {
  return { comment: "", cleanupError: undefined };
}

export const CatalogFeedbackDraftDetails: MessageFns<CatalogFeedbackDraftDetails> = {
  encode(message: CatalogFeedbackDraftDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.comment !== "") {
      writer.uint32(10).string(message.comment);
    }
    if (message.cleanupError !== undefined) {
      writer.uint32(18).string(message.cleanupError);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CatalogFeedbackDraftDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCatalogFeedbackDraftDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.comment = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cleanupError = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CatalogFeedbackDraftDetails {
    return {
      comment: isSet(object.comment) ? globalThis.String(object.comment) : "",
      cleanupError: isSet(object.cleanupError)
        ? globalThis.String(object.cleanupError)
        : isSet(object.cleanup_error)
        ? globalThis.String(object.cleanup_error)
        : undefined,
    };
  },

  toJSON(message: CatalogFeedbackDraftDetails): unknown {
    const obj: any = {};
    if (message.comment !== "") {
      obj.comment = message.comment;
    }
    if (message.cleanupError !== undefined) {
      obj.cleanupError = message.cleanupError;
    }
    return obj;
  },

  create(base?: DeepPartial<CatalogFeedbackDraftDetails>): CatalogFeedbackDraftDetails {
    return CatalogFeedbackDraftDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CatalogFeedbackDraftDetails>): CatalogFeedbackDraftDetails {
    const message = createBaseCatalogFeedbackDraftDetails();
    message.comment = object.comment ?? "";
    message.cleanupError = object.cleanupError ?? undefined;
    return message;
  },
};

function createBaseGetCatalogFeedbackDraftResponse(): GetCatalogFeedbackDraftResponse {
  return { draft: undefined };
}

export const GetCatalogFeedbackDraftResponse: MessageFns<GetCatalogFeedbackDraftResponse> = {
  encode(message: GetCatalogFeedbackDraftResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.draft !== undefined) {
      CatalogFeedbackDraft.encode(message.draft, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCatalogFeedbackDraftResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCatalogFeedbackDraftResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.draft = CatalogFeedbackDraft.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCatalogFeedbackDraftResponse {
    return { draft: isSet(object.draft) ? CatalogFeedbackDraft.fromJSON(object.draft) : undefined };
  },

  toJSON(message: GetCatalogFeedbackDraftResponse): unknown {
    const obj: any = {};
    if (message.draft !== undefined) {
      obj.draft = CatalogFeedbackDraft.toJSON(message.draft);
    }
    return obj;
  },

  create(base?: DeepPartial<GetCatalogFeedbackDraftResponse>): GetCatalogFeedbackDraftResponse {
    return GetCatalogFeedbackDraftResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetCatalogFeedbackDraftResponse>): GetCatalogFeedbackDraftResponse {
    const message = createBaseGetCatalogFeedbackDraftResponse();
    message.draft = (object.draft !== undefined && object.draft !== null)
      ? CatalogFeedbackDraft.fromPartial(object.draft)
      : undefined;
    return message;
  },
};

function createBaseUpdateCatalogFeedbackDraftRequest(): UpdateCatalogFeedbackDraftRequest {
  return { comment: "" };
}

export const UpdateCatalogFeedbackDraftRequest: MessageFns<UpdateCatalogFeedbackDraftRequest> = {
  encode(message: UpdateCatalogFeedbackDraftRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.comment !== "") {
      writer.uint32(10).string(message.comment);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCatalogFeedbackDraftRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCatalogFeedbackDraftRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.comment = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateCatalogFeedbackDraftRequest {
    return { comment: isSet(object.comment) ? globalThis.String(object.comment) : "" };
  },

  toJSON(message: UpdateCatalogFeedbackDraftRequest): unknown {
    const obj: any = {};
    if (message.comment !== "") {
      obj.comment = message.comment;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateCatalogFeedbackDraftRequest>): UpdateCatalogFeedbackDraftRequest {
    return UpdateCatalogFeedbackDraftRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateCatalogFeedbackDraftRequest>): UpdateCatalogFeedbackDraftRequest {
    const message = createBaseUpdateCatalogFeedbackDraftRequest();
    message.comment = object.comment ?? "";
    return message;
  },
};

function createBaseUpdateCatalogFeedbackDraftResponse(): UpdateCatalogFeedbackDraftResponse {
  return { draft: undefined };
}

export const UpdateCatalogFeedbackDraftResponse: MessageFns<UpdateCatalogFeedbackDraftResponse> = {
  encode(message: UpdateCatalogFeedbackDraftResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.draft !== undefined) {
      CatalogFeedbackDraft.encode(message.draft, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateCatalogFeedbackDraftResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateCatalogFeedbackDraftResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.draft = CatalogFeedbackDraft.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateCatalogFeedbackDraftResponse {
    return { draft: isSet(object.draft) ? CatalogFeedbackDraft.fromJSON(object.draft) : undefined };
  },

  toJSON(message: UpdateCatalogFeedbackDraftResponse): unknown {
    const obj: any = {};
    if (message.draft !== undefined) {
      obj.draft = CatalogFeedbackDraft.toJSON(message.draft);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateCatalogFeedbackDraftResponse>): UpdateCatalogFeedbackDraftResponse {
    return UpdateCatalogFeedbackDraftResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateCatalogFeedbackDraftResponse>): UpdateCatalogFeedbackDraftResponse {
    const message = createBaseUpdateCatalogFeedbackDraftResponse();
    message.draft = (object.draft !== undefined && object.draft !== null)
      ? CatalogFeedbackDraft.fromPartial(object.draft)
      : undefined;
    return message;
  },
};

function createBaseSubmitCatalogFeedbackRequest(): SubmitCatalogFeedbackRequest {
  return { comment: "" };
}

export const SubmitCatalogFeedbackRequest: MessageFns<SubmitCatalogFeedbackRequest> = {
  encode(message: SubmitCatalogFeedbackRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.comment !== "") {
      writer.uint32(10).string(message.comment);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubmitCatalogFeedbackRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubmitCatalogFeedbackRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.comment = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubmitCatalogFeedbackRequest {
    return { comment: isSet(object.comment) ? globalThis.String(object.comment) : "" };
  },

  toJSON(message: SubmitCatalogFeedbackRequest): unknown {
    const obj: any = {};
    if (message.comment !== "") {
      obj.comment = message.comment;
    }
    return obj;
  },

  create(base?: DeepPartial<SubmitCatalogFeedbackRequest>): SubmitCatalogFeedbackRequest {
    return SubmitCatalogFeedbackRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SubmitCatalogFeedbackRequest>): SubmitCatalogFeedbackRequest {
    const message = createBaseSubmitCatalogFeedbackRequest();
    message.comment = object.comment ?? "";
    return message;
  },
};

function createBaseSubmitCatalogFeedbackResponse(): SubmitCatalogFeedbackResponse {
  return { pendingJobId: "", message: "" };
}

export const SubmitCatalogFeedbackResponse: MessageFns<SubmitCatalogFeedbackResponse> = {
  encode(message: SubmitCatalogFeedbackResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pendingJobId !== "") {
      writer.uint32(10).string(message.pendingJobId);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubmitCatalogFeedbackResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubmitCatalogFeedbackResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pendingJobId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubmitCatalogFeedbackResponse {
    return {
      pendingJobId: isSet(object.pendingJobId)
        ? globalThis.String(object.pendingJobId)
        : isSet(object.pending_job_id)
        ? globalThis.String(object.pending_job_id)
        : "",
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: SubmitCatalogFeedbackResponse): unknown {
    const obj: any = {};
    if (message.pendingJobId !== "") {
      obj.pendingJobId = message.pendingJobId;
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create(base?: DeepPartial<SubmitCatalogFeedbackResponse>): SubmitCatalogFeedbackResponse {
    return SubmitCatalogFeedbackResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SubmitCatalogFeedbackResponse>): SubmitCatalogFeedbackResponse {
    const message = createBaseSubmitCatalogFeedbackResponse();
    message.pendingJobId = object.pendingJobId ?? "";
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseGetRunsResponse(): GetRunsResponse {
  return { runs: [], projects: [], tasks: [], features: [] };
}

export const GetRunsResponse: MessageFns<GetRunsResponse> = {
  encode(message: GetRunsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.runs) {
      RunItem.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.projects) {
      ProjectEntity.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.tasks) {
      DocumentEntity.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.features) {
      DocumentEntity.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRunsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRunsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.runs.push(RunItem.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.projects.push(ProjectEntity.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tasks.push(DocumentEntity.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.features.push(DocumentEntity.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRunsResponse {
    return {
      runs: globalThis.Array.isArray(object?.runs) ? object.runs.map((e: any) => RunItem.fromJSON(e)) : [],
      projects: globalThis.Array.isArray(object?.projects)
        ? object.projects.map((e: any) => ProjectEntity.fromJSON(e))
        : [],
      tasks: globalThis.Array.isArray(object?.tasks) ? object.tasks.map((e: any) => DocumentEntity.fromJSON(e)) : [],
      features: globalThis.Array.isArray(object?.features)
        ? object.features.map((e: any) => DocumentEntity.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetRunsResponse): unknown {
    const obj: any = {};
    if (message.runs?.length) {
      obj.runs = message.runs.map((e) => RunItem.toJSON(e));
    }
    if (message.projects?.length) {
      obj.projects = message.projects.map((e) => ProjectEntity.toJSON(e));
    }
    if (message.tasks?.length) {
      obj.tasks = message.tasks.map((e) => DocumentEntity.toJSON(e));
    }
    if (message.features?.length) {
      obj.features = message.features.map((e) => DocumentEntity.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetRunsResponse>): GetRunsResponse {
    return GetRunsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetRunsResponse>): GetRunsResponse {
    const message = createBaseGetRunsResponse();
    message.runs = object.runs?.map((e) => RunItem.fromPartial(e)) || [];
    message.projects = object.projects?.map((e) => ProjectEntity.fromPartial(e)) || [];
    message.tasks = object.tasks?.map((e) => DocumentEntity.fromPartial(e)) || [];
    message.features = object.features?.map((e) => DocumentEntity.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListPendingJobsRequest(): ListPendingJobsRequest {
  return {};
}

export const ListPendingJobsRequest: MessageFns<ListPendingJobsRequest> = {
  encode(_: ListPendingJobsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListPendingJobsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListPendingJobsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ListPendingJobsRequest {
    return {};
  },

  toJSON(_: ListPendingJobsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<ListPendingJobsRequest>): ListPendingJobsRequest {
    return ListPendingJobsRequest.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<ListPendingJobsRequest>): ListPendingJobsRequest {
    const message = createBaseListPendingJobsRequest();
    return message;
  },
};

function createBaseListPendingJobsResponse(): ListPendingJobsResponse {
  return { jobs: [] };
}

export const ListPendingJobsResponse: MessageFns<ListPendingJobsResponse> = {
  encode(message: ListPendingJobsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.jobs) {
      PendingJob.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListPendingJobsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListPendingJobsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.jobs.push(PendingJob.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListPendingJobsResponse {
    return { jobs: globalThis.Array.isArray(object?.jobs) ? object.jobs.map((e: any) => PendingJob.fromJSON(e)) : [] };
  },

  toJSON(message: ListPendingJobsResponse): unknown {
    const obj: any = {};
    if (message.jobs?.length) {
      obj.jobs = message.jobs.map((e) => PendingJob.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ListPendingJobsResponse>): ListPendingJobsResponse {
    return ListPendingJobsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListPendingJobsResponse>): ListPendingJobsResponse {
    const message = createBaseListPendingJobsResponse();
    message.jobs = object.jobs?.map((e) => PendingJob.fromPartial(e)) || [];
    return message;
  },
};

function createBaseStartQuickWinInitRequest(): StartQuickWinInitRequest {
  return { description: "" };
}

export const StartQuickWinInitRequest: MessageFns<StartQuickWinInitRequest> = {
  encode(message: StartQuickWinInitRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.description !== "") {
      writer.uint32(10).string(message.description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartQuickWinInitRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartQuickWinInitRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartQuickWinInitRequest {
    return { description: isSet(object.description) ? globalThis.String(object.description) : "" };
  },

  toJSON(message: StartQuickWinInitRequest): unknown {
    const obj: any = {};
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create(base?: DeepPartial<StartQuickWinInitRequest>): StartQuickWinInitRequest {
    return StartQuickWinInitRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartQuickWinInitRequest>): StartQuickWinInitRequest {
    const message = createBaseStartQuickWinInitRequest();
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseStartQuickWinInitResponse(): StartQuickWinInitResponse {
  return { pendingJobId: "", projectId: "" };
}

export const StartQuickWinInitResponse: MessageFns<StartQuickWinInitResponse> = {
  encode(message: StartQuickWinInitResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pendingJobId !== "") {
      writer.uint32(10).string(message.pendingJobId);
    }
    if (message.projectId !== "") {
      writer.uint32(18).string(message.projectId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartQuickWinInitResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartQuickWinInitResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pendingJobId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartQuickWinInitResponse {
    return {
      pendingJobId: isSet(object.pendingJobId)
        ? globalThis.String(object.pendingJobId)
        : isSet(object.pending_job_id)
        ? globalThis.String(object.pending_job_id)
        : "",
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : "",
    };
  },

  toJSON(message: StartQuickWinInitResponse): unknown {
    const obj: any = {};
    if (message.pendingJobId !== "") {
      obj.pendingJobId = message.pendingJobId;
    }
    if (message.projectId !== "") {
      obj.projectId = message.projectId;
    }
    return obj;
  },

  create(base?: DeepPartial<StartQuickWinInitResponse>): StartQuickWinInitResponse {
    return StartQuickWinInitResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartQuickWinInitResponse>): StartQuickWinInitResponse {
    const message = createBaseStartQuickWinInitResponse();
    message.pendingJobId = object.pendingJobId ?? "";
    message.projectId = object.projectId ?? "";
    return message;
  },
};

function createBaseGetQuickWinInitStatusResponse(): GetQuickWinInitStatusResponse {
  return { status: "", projectId: undefined };
}

export const GetQuickWinInitStatusResponse: MessageFns<GetQuickWinInitStatusResponse> = {
  encode(message: GetQuickWinInitStatusResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== "") {
      writer.uint32(10).string(message.status);
    }
    if (message.projectId !== undefined) {
      writer.uint32(18).string(message.projectId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetQuickWinInitStatusResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetQuickWinInitStatusResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetQuickWinInitStatusResponse {
    return {
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : undefined,
    };
  },

  toJSON(message: GetQuickWinInitStatusResponse): unknown {
    const obj: any = {};
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.projectId !== undefined) {
      obj.projectId = message.projectId;
    }
    return obj;
  },

  create(base?: DeepPartial<GetQuickWinInitStatusResponse>): GetQuickWinInitStatusResponse {
    return GetQuickWinInitStatusResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetQuickWinInitStatusResponse>): GetQuickWinInitStatusResponse {
    const message = createBaseGetQuickWinInitStatusResponse();
    message.status = object.status ?? "";
    message.projectId = object.projectId ?? undefined;
    return message;
  },
};

function createBaseStartBugInitRequest(): StartBugInitRequest {
  return { description: "" };
}

export const StartBugInitRequest: MessageFns<StartBugInitRequest> = {
  encode(message: StartBugInitRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.description !== "") {
      writer.uint32(10).string(message.description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartBugInitRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartBugInitRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartBugInitRequest {
    return { description: isSet(object.description) ? globalThis.String(object.description) : "" };
  },

  toJSON(message: StartBugInitRequest): unknown {
    const obj: any = {};
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create(base?: DeepPartial<StartBugInitRequest>): StartBugInitRequest {
    return StartBugInitRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartBugInitRequest>): StartBugInitRequest {
    const message = createBaseStartBugInitRequest();
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseStartBugInitResponse(): StartBugInitResponse {
  return { pendingJobId: "", projectId: "" };
}

export const StartBugInitResponse: MessageFns<StartBugInitResponse> = {
  encode(message: StartBugInitResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pendingJobId !== "") {
      writer.uint32(10).string(message.pendingJobId);
    }
    if (message.projectId !== "") {
      writer.uint32(18).string(message.projectId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartBugInitResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartBugInitResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pendingJobId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartBugInitResponse {
    return {
      pendingJobId: isSet(object.pendingJobId)
        ? globalThis.String(object.pendingJobId)
        : isSet(object.pending_job_id)
        ? globalThis.String(object.pending_job_id)
        : "",
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : "",
    };
  },

  toJSON(message: StartBugInitResponse): unknown {
    const obj: any = {};
    if (message.pendingJobId !== "") {
      obj.pendingJobId = message.pendingJobId;
    }
    if (message.projectId !== "") {
      obj.projectId = message.projectId;
    }
    return obj;
  },

  create(base?: DeepPartial<StartBugInitResponse>): StartBugInitResponse {
    return StartBugInitResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StartBugInitResponse>): StartBugInitResponse {
    const message = createBaseStartBugInitResponse();
    message.pendingJobId = object.pendingJobId ?? "";
    message.projectId = object.projectId ?? "";
    return message;
  },
};

function createBaseGetBugInitStatusResponse(): GetBugInitStatusResponse {
  return { status: "", projectId: undefined };
}

export const GetBugInitStatusResponse: MessageFns<GetBugInitStatusResponse> = {
  encode(message: GetBugInitStatusResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== "") {
      writer.uint32(10).string(message.status);
    }
    if (message.projectId !== undefined) {
      writer.uint32(18).string(message.projectId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetBugInitStatusResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetBugInitStatusResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.status = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetBugInitStatusResponse {
    return {
      status: isSet(object.status) ? globalThis.String(object.status) : "",
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : undefined,
    };
  },

  toJSON(message: GetBugInitStatusResponse): unknown {
    const obj: any = {};
    if (message.status !== "") {
      obj.status = message.status;
    }
    if (message.projectId !== undefined) {
      obj.projectId = message.projectId;
    }
    return obj;
  },

  create(base?: DeepPartial<GetBugInitStatusResponse>): GetBugInitStatusResponse {
    return GetBugInitStatusResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetBugInitStatusResponse>): GetBugInitStatusResponse {
    const message = createBaseGetBugInitStatusResponse();
    message.status = object.status ?? "";
    message.projectId = object.projectId ?? undefined;
    return message;
  },
};

function createBaseGetPulseFeedResponse(): GetPulseFeedResponse {
  return { items: [], hasCatalogue: false };
}

export const GetPulseFeedResponse: MessageFns<GetPulseFeedResponse> = {
  encode(message: GetPulseFeedResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      PulseFeedItem.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.hasCatalogue !== false) {
      writer.uint32(16).bool(message.hasCatalogue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPulseFeedResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPulseFeedResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.items.push(PulseFeedItem.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.hasCatalogue = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPulseFeedResponse {
    return {
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => PulseFeedItem.fromJSON(e)) : [],
      hasCatalogue: isSet(object.hasCatalogue)
        ? globalThis.Boolean(object.hasCatalogue)
        : isSet(object.has_catalogue)
        ? globalThis.Boolean(object.has_catalogue)
        : false,
    };
  },

  toJSON(message: GetPulseFeedResponse): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => PulseFeedItem.toJSON(e));
    }
    if (message.hasCatalogue !== false) {
      obj.hasCatalogue = message.hasCatalogue;
    }
    return obj;
  },

  create(base?: DeepPartial<GetPulseFeedResponse>): GetPulseFeedResponse {
    return GetPulseFeedResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetPulseFeedResponse>): GetPulseFeedResponse {
    const message = createBaseGetPulseFeedResponse();
    message.items = object.items?.map((e) => PulseFeedItem.fromPartial(e)) || [];
    message.hasCatalogue = object.hasCatalogue ?? false;
    return message;
  },
};

function createBaseGetSignalsResponse(): GetSignalsResponse {
  return { signalsJson: [] };
}

export const GetSignalsResponse: MessageFns<GetSignalsResponse> = {
  encode(message: GetSignalsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.signalsJson) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSignalsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSignalsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.signalsJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSignalsResponse {
    return {
      signalsJson: globalThis.Array.isArray(object?.signalsJson)
        ? object.signalsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.signals_json)
        ? object.signals_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetSignalsResponse): unknown {
    const obj: any = {};
    if (message.signalsJson?.length) {
      obj.signalsJson = message.signalsJson;
    }
    return obj;
  },

  create(base?: DeepPartial<GetSignalsResponse>): GetSignalsResponse {
    return GetSignalsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetSignalsResponse>): GetSignalsResponse {
    const message = createBaseGetSignalsResponse();
    message.signalsJson = object.signalsJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetDiscussionTopicsByIdsRequest(): GetDiscussionTopicsByIdsRequest {
  return { topicIds: [] };
}

export const GetDiscussionTopicsByIdsRequest: MessageFns<GetDiscussionTopicsByIdsRequest> = {
  encode(message: GetDiscussionTopicsByIdsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.topicIds) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDiscussionTopicsByIdsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDiscussionTopicsByIdsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.topicIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDiscussionTopicsByIdsRequest {
    return {
      topicIds: globalThis.Array.isArray(object?.topicIds)
        ? object.topicIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.topic_ids)
        ? object.topic_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetDiscussionTopicsByIdsRequest): unknown {
    const obj: any = {};
    if (message.topicIds?.length) {
      obj.topicIds = message.topicIds;
    }
    return obj;
  },

  create(base?: DeepPartial<GetDiscussionTopicsByIdsRequest>): GetDiscussionTopicsByIdsRequest {
    return GetDiscussionTopicsByIdsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetDiscussionTopicsByIdsRequest>): GetDiscussionTopicsByIdsRequest {
    const message = createBaseGetDiscussionTopicsByIdsRequest();
    message.topicIds = object.topicIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetDiscussionTopicsByIdsResponse(): GetDiscussionTopicsByIdsResponse {
  return { topicsJson: [] };
}

export const GetDiscussionTopicsByIdsResponse: MessageFns<GetDiscussionTopicsByIdsResponse> = {
  encode(message: GetDiscussionTopicsByIdsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.topicsJson) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDiscussionTopicsByIdsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDiscussionTopicsByIdsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.topicsJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDiscussionTopicsByIdsResponse {
    return {
      topicsJson: globalThis.Array.isArray(object?.topicsJson)
        ? object.topicsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.topics_json)
        ? object.topics_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetDiscussionTopicsByIdsResponse): unknown {
    const obj: any = {};
    if (message.topicsJson?.length) {
      obj.topicsJson = message.topicsJson;
    }
    return obj;
  },

  create(base?: DeepPartial<GetDiscussionTopicsByIdsResponse>): GetDiscussionTopicsByIdsResponse {
    return GetDiscussionTopicsByIdsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetDiscussionTopicsByIdsResponse>): GetDiscussionTopicsByIdsResponse {
    const message = createBaseGetDiscussionTopicsByIdsResponse();
    message.topicsJson = object.topicsJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetCallNoteByProviderRefRequest(): GetCallNoteByProviderRefRequest {
  return { providerType: "", noteId: "" };
}

export const GetCallNoteByProviderRefRequest: MessageFns<GetCallNoteByProviderRefRequest> = {
  encode(message: GetCallNoteByProviderRefRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.providerType !== "") {
      writer.uint32(10).string(message.providerType);
    }
    if (message.noteId !== "") {
      writer.uint32(18).string(message.noteId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCallNoteByProviderRefRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCallNoteByProviderRefRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.providerType = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.noteId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCallNoteByProviderRefRequest {
    return {
      providerType: isSet(object.providerType)
        ? globalThis.String(object.providerType)
        : isSet(object.provider_type)
        ? globalThis.String(object.provider_type)
        : "",
      noteId: isSet(object.noteId)
        ? globalThis.String(object.noteId)
        : isSet(object.note_id)
        ? globalThis.String(object.note_id)
        : "",
    };
  },

  toJSON(message: GetCallNoteByProviderRefRequest): unknown {
    const obj: any = {};
    if (message.providerType !== "") {
      obj.providerType = message.providerType;
    }
    if (message.noteId !== "") {
      obj.noteId = message.noteId;
    }
    return obj;
  },

  create(base?: DeepPartial<GetCallNoteByProviderRefRequest>): GetCallNoteByProviderRefRequest {
    return GetCallNoteByProviderRefRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetCallNoteByProviderRefRequest>): GetCallNoteByProviderRefRequest {
    const message = createBaseGetCallNoteByProviderRefRequest();
    message.providerType = object.providerType ?? "";
    message.noteId = object.noteId ?? "";
    return message;
  },
};

function createBaseGetCallNoteByProviderRefResponse(): GetCallNoteByProviderRefResponse {
  return { callNoteJson: undefined };
}

export const GetCallNoteByProviderRefResponse: MessageFns<GetCallNoteByProviderRefResponse> = {
  encode(message: GetCallNoteByProviderRefResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.callNoteJson !== undefined) {
      writer.uint32(10).string(message.callNoteJson);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCallNoteByProviderRefResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCallNoteByProviderRefResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.callNoteJson = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCallNoteByProviderRefResponse {
    return {
      callNoteJson: isSet(object.callNoteJson)
        ? globalThis.String(object.callNoteJson)
        : isSet(object.call_note_json)
        ? globalThis.String(object.call_note_json)
        : undefined,
    };
  },

  toJSON(message: GetCallNoteByProviderRefResponse): unknown {
    const obj: any = {};
    if (message.callNoteJson !== undefined) {
      obj.callNoteJson = message.callNoteJson;
    }
    return obj;
  },

  create(base?: DeepPartial<GetCallNoteByProviderRefResponse>): GetCallNoteByProviderRefResponse {
    return GetCallNoteByProviderRefResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetCallNoteByProviderRefResponse>): GetCallNoteByProviderRefResponse {
    const message = createBaseGetCallNoteByProviderRefResponse();
    message.callNoteJson = object.callNoteJson ?? undefined;
    return message;
  },
};

function createBaseGetInsightsResponse(): GetInsightsResponse {
  return { entries: [] };
}

export const GetInsightsResponse: MessageFns<GetInsightsResponse> = {
  encode(message: GetInsightsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.entries) {
      InsightEntry.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetInsightsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetInsightsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.entries.push(InsightEntry.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetInsightsResponse {
    return {
      entries: globalThis.Array.isArray(object?.entries)
        ? object.entries.map((e: any) => InsightEntry.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetInsightsResponse): unknown {
    const obj: any = {};
    if (message.entries?.length) {
      obj.entries = message.entries.map((e) => InsightEntry.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GetInsightsResponse>): GetInsightsResponse {
    return GetInsightsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetInsightsResponse>): GetInsightsResponse {
    const message = createBaseGetInsightsResponse();
    message.entries = object.entries?.map((e) => InsightEntry.fromPartial(e)) || [];
    return message;
  },
};

function createBaseInsightEntry(): InsightEntry {
  return { insightJson: "", linkedSignalsJson: [], linkedChangesJson: [] };
}

export const InsightEntry: MessageFns<InsightEntry> = {
  encode(message: InsightEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.insightJson !== "") {
      writer.uint32(10).string(message.insightJson);
    }
    for (const v of message.linkedSignalsJson) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.linkedChangesJson) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InsightEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInsightEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.insightJson = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.linkedSignalsJson.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.linkedChangesJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InsightEntry {
    return {
      insightJson: isSet(object.insightJson)
        ? globalThis.String(object.insightJson)
        : isSet(object.insight_json)
        ? globalThis.String(object.insight_json)
        : "",
      linkedSignalsJson: globalThis.Array.isArray(object?.linkedSignalsJson)
        ? object.linkedSignalsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.linked_signals_json)
        ? object.linked_signals_json.map((e: any) => globalThis.String(e))
        : [],
      linkedChangesJson: globalThis.Array.isArray(object?.linkedChangesJson)
        ? object.linkedChangesJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.linked_changes_json)
        ? object.linked_changes_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: InsightEntry): unknown {
    const obj: any = {};
    if (message.insightJson !== "") {
      obj.insightJson = message.insightJson;
    }
    if (message.linkedSignalsJson?.length) {
      obj.linkedSignalsJson = message.linkedSignalsJson;
    }
    if (message.linkedChangesJson?.length) {
      obj.linkedChangesJson = message.linkedChangesJson;
    }
    return obj;
  },

  create(base?: DeepPartial<InsightEntry>): InsightEntry {
    return InsightEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<InsightEntry>): InsightEntry {
    const message = createBaseInsightEntry();
    message.insightJson = object.insightJson ?? "";
    message.linkedSignalsJson = object.linkedSignalsJson?.map((e) => e) || [];
    message.linkedChangesJson = object.linkedChangesJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseArchiveInsightRequest(): ArchiveInsightRequest {
  return { archived: undefined };
}

export const ArchiveInsightRequest: MessageFns<ArchiveInsightRequest> = {
  encode(message: ArchiveInsightRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.archived !== undefined) {
      writer.uint32(8).bool(message.archived);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArchiveInsightRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArchiveInsightRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArchiveInsightRequest {
    return { archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : undefined };
  },

  toJSON(message: ArchiveInsightRequest): unknown {
    const obj: any = {};
    if (message.archived !== undefined) {
      obj.archived = message.archived;
    }
    return obj;
  },

  create(base?: DeepPartial<ArchiveInsightRequest>): ArchiveInsightRequest {
    return ArchiveInsightRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ArchiveInsightRequest>): ArchiveInsightRequest {
    const message = createBaseArchiveInsightRequest();
    message.archived = object.archived ?? undefined;
    return message;
  },
};

function createBaseGetChangesReportsResponse(): GetChangesReportsResponse {
  return { reportsJson: [], changesJson: [], personsJson: [], projectLinksJson: [] };
}

export const GetChangesReportsResponse: MessageFns<GetChangesReportsResponse> = {
  encode(message: GetChangesReportsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.reportsJson) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.changesJson) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.personsJson) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.projectLinksJson) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetChangesReportsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetChangesReportsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.reportsJson.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.changesJson.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.personsJson.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.projectLinksJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetChangesReportsResponse {
    return {
      reportsJson: globalThis.Array.isArray(object?.reportsJson)
        ? object.reportsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.reports_json)
        ? object.reports_json.map((e: any) => globalThis.String(e))
        : [],
      changesJson: globalThis.Array.isArray(object?.changesJson)
        ? object.changesJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.changes_json)
        ? object.changes_json.map((e: any) => globalThis.String(e))
        : [],
      personsJson: globalThis.Array.isArray(object?.personsJson)
        ? object.personsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.persons_json)
        ? object.persons_json.map((e: any) => globalThis.String(e))
        : [],
      projectLinksJson: globalThis.Array.isArray(object?.projectLinksJson)
        ? object.projectLinksJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.project_links_json)
        ? object.project_links_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetChangesReportsResponse): unknown {
    const obj: any = {};
    if (message.reportsJson?.length) {
      obj.reportsJson = message.reportsJson;
    }
    if (message.changesJson?.length) {
      obj.changesJson = message.changesJson;
    }
    if (message.personsJson?.length) {
      obj.personsJson = message.personsJson;
    }
    if (message.projectLinksJson?.length) {
      obj.projectLinksJson = message.projectLinksJson;
    }
    return obj;
  },

  create(base?: DeepPartial<GetChangesReportsResponse>): GetChangesReportsResponse {
    return GetChangesReportsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetChangesReportsResponse>): GetChangesReportsResponse {
    const message = createBaseGetChangesReportsResponse();
    message.reportsJson = object.reportsJson?.map((e) => e) || [];
    message.changesJson = object.changesJson?.map((e) => e) || [];
    message.personsJson = object.personsJson?.map((e) => e) || [];
    message.projectLinksJson = object.projectLinksJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetCurrentProjectSummaryResponse(): GetCurrentProjectSummaryResponse {
  return { summaryJson: undefined };
}

export const GetCurrentProjectSummaryResponse: MessageFns<GetCurrentProjectSummaryResponse> = {
  encode(message: GetCurrentProjectSummaryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.summaryJson !== undefined) {
      writer.uint32(10).string(message.summaryJson);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCurrentProjectSummaryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCurrentProjectSummaryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.summaryJson = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCurrentProjectSummaryResponse {
    return {
      summaryJson: isSet(object.summaryJson)
        ? globalThis.String(object.summaryJson)
        : isSet(object.summary_json)
        ? globalThis.String(object.summary_json)
        : undefined,
    };
  },

  toJSON(message: GetCurrentProjectSummaryResponse): unknown {
    const obj: any = {};
    if (message.summaryJson !== undefined) {
      obj.summaryJson = message.summaryJson;
    }
    return obj;
  },

  create(base?: DeepPartial<GetCurrentProjectSummaryResponse>): GetCurrentProjectSummaryResponse {
    return GetCurrentProjectSummaryResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetCurrentProjectSummaryResponse>): GetCurrentProjectSummaryResponse {
    const message = createBaseGetCurrentProjectSummaryResponse();
    message.summaryJson = object.summaryJson ?? undefined;
    return message;
  },
};

function createBaseGetCurrentGoalSummaryResponse(): GetCurrentGoalSummaryResponse {
  return { summaryJson: undefined };
}

export const GetCurrentGoalSummaryResponse: MessageFns<GetCurrentGoalSummaryResponse> = {
  encode(message: GetCurrentGoalSummaryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.summaryJson !== undefined) {
      writer.uint32(10).string(message.summaryJson);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCurrentGoalSummaryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCurrentGoalSummaryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.summaryJson = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCurrentGoalSummaryResponse {
    return {
      summaryJson: isSet(object.summaryJson)
        ? globalThis.String(object.summaryJson)
        : isSet(object.summary_json)
        ? globalThis.String(object.summary_json)
        : undefined,
    };
  },

  toJSON(message: GetCurrentGoalSummaryResponse): unknown {
    const obj: any = {};
    if (message.summaryJson !== undefined) {
      obj.summaryJson = message.summaryJson;
    }
    return obj;
  },

  create(base?: DeepPartial<GetCurrentGoalSummaryResponse>): GetCurrentGoalSummaryResponse {
    return GetCurrentGoalSummaryResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetCurrentGoalSummaryResponse>): GetCurrentGoalSummaryResponse {
    const message = createBaseGetCurrentGoalSummaryResponse();
    message.summaryJson = object.summaryJson ?? undefined;
    return message;
  },
};

function createBaseBatchGetGoalSummariesRequest(): BatchGetGoalSummariesRequest {
  return { goalIds: [] };
}

export const BatchGetGoalSummariesRequest: MessageFns<BatchGetGoalSummariesRequest> = {
  encode(message: BatchGetGoalSummariesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.goalIds) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BatchGetGoalSummariesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBatchGetGoalSummariesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.goalIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BatchGetGoalSummariesRequest {
    return {
      goalIds: globalThis.Array.isArray(object?.goalIds)
        ? object.goalIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.goal_ids)
        ? object.goal_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: BatchGetGoalSummariesRequest): unknown {
    const obj: any = {};
    if (message.goalIds?.length) {
      obj.goalIds = message.goalIds;
    }
    return obj;
  },

  create(base?: DeepPartial<BatchGetGoalSummariesRequest>): BatchGetGoalSummariesRequest {
    return BatchGetGoalSummariesRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BatchGetGoalSummariesRequest>): BatchGetGoalSummariesRequest {
    const message = createBaseBatchGetGoalSummariesRequest();
    message.goalIds = object.goalIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseBatchGetGoalSummariesResponse(): BatchGetGoalSummariesResponse {
  return { summariesJson: [] };
}

export const BatchGetGoalSummariesResponse: MessageFns<BatchGetGoalSummariesResponse> = {
  encode(message: BatchGetGoalSummariesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.summariesJson) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BatchGetGoalSummariesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBatchGetGoalSummariesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.summariesJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BatchGetGoalSummariesResponse {
    return {
      summariesJson: globalThis.Array.isArray(object?.summariesJson)
        ? object.summariesJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.summaries_json)
        ? object.summaries_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: BatchGetGoalSummariesResponse): unknown {
    const obj: any = {};
    if (message.summariesJson?.length) {
      obj.summariesJson = message.summariesJson;
    }
    return obj;
  },

  create(base?: DeepPartial<BatchGetGoalSummariesResponse>): BatchGetGoalSummariesResponse {
    return BatchGetGoalSummariesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BatchGetGoalSummariesResponse>): BatchGetGoalSummariesResponse {
    const message = createBaseBatchGetGoalSummariesResponse();
    message.summariesJson = object.summariesJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseBatchGetProjectSummariesRequest(): BatchGetProjectSummariesRequest {
  return { projectIds: [] };
}

export const BatchGetProjectSummariesRequest: MessageFns<BatchGetProjectSummariesRequest> = {
  encode(message: BatchGetProjectSummariesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.projectIds) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BatchGetProjectSummariesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBatchGetProjectSummariesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.projectIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BatchGetProjectSummariesRequest {
    return {
      projectIds: globalThis.Array.isArray(object?.projectIds)
        ? object.projectIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.project_ids)
        ? object.project_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: BatchGetProjectSummariesRequest): unknown {
    const obj: any = {};
    if (message.projectIds?.length) {
      obj.projectIds = message.projectIds;
    }
    return obj;
  },

  create(base?: DeepPartial<BatchGetProjectSummariesRequest>): BatchGetProjectSummariesRequest {
    return BatchGetProjectSummariesRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BatchGetProjectSummariesRequest>): BatchGetProjectSummariesRequest {
    const message = createBaseBatchGetProjectSummariesRequest();
    message.projectIds = object.projectIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseBatchGetProjectSummariesResponse(): BatchGetProjectSummariesResponse {
  return { summariesJson: [] };
}

export const BatchGetProjectSummariesResponse: MessageFns<BatchGetProjectSummariesResponse> = {
  encode(message: BatchGetProjectSummariesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.summariesJson) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BatchGetProjectSummariesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBatchGetProjectSummariesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.summariesJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BatchGetProjectSummariesResponse {
    return {
      summariesJson: globalThis.Array.isArray(object?.summariesJson)
        ? object.summariesJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.summaries_json)
        ? object.summaries_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: BatchGetProjectSummariesResponse): unknown {
    const obj: any = {};
    if (message.summariesJson?.length) {
      obj.summariesJson = message.summariesJson;
    }
    return obj;
  },

  create(base?: DeepPartial<BatchGetProjectSummariesResponse>): BatchGetProjectSummariesResponse {
    return BatchGetProjectSummariesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BatchGetProjectSummariesResponse>): BatchGetProjectSummariesResponse {
    const message = createBaseBatchGetProjectSummariesResponse();
    message.summariesJson = object.summariesJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseBatchGetProjectAnalysisStateResponse(): BatchGetProjectAnalysisStateResponse {
  return { hasActiveAnalysisJob: false };
}

export const BatchGetProjectAnalysisStateResponse: MessageFns<BatchGetProjectAnalysisStateResponse> = {
  encode(message: BatchGetProjectAnalysisStateResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hasActiveAnalysisJob !== false) {
      writer.uint32(8).bool(message.hasActiveAnalysisJob);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BatchGetProjectAnalysisStateResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBatchGetProjectAnalysisStateResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.hasActiveAnalysisJob = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BatchGetProjectAnalysisStateResponse {
    return {
      hasActiveAnalysisJob: isSet(object.hasActiveAnalysisJob)
        ? globalThis.Boolean(object.hasActiveAnalysisJob)
        : isSet(object.has_active_analysis_job)
        ? globalThis.Boolean(object.has_active_analysis_job)
        : false,
    };
  },

  toJSON(message: BatchGetProjectAnalysisStateResponse): unknown {
    const obj: any = {};
    if (message.hasActiveAnalysisJob !== false) {
      obj.hasActiveAnalysisJob = message.hasActiveAnalysisJob;
    }
    return obj;
  },

  create(base?: DeepPartial<BatchGetProjectAnalysisStateResponse>): BatchGetProjectAnalysisStateResponse {
    return BatchGetProjectAnalysisStateResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<BatchGetProjectAnalysisStateResponse>): BatchGetProjectAnalysisStateResponse {
    const message = createBaseBatchGetProjectAnalysisStateResponse();
    message.hasActiveAnalysisJob = object.hasActiveAnalysisJob ?? false;
    return message;
  },
};

function createBaseListProjectUpdatesResponse(): ListProjectUpdatesResponse {
  return { updatesJson: [] };
}

export const ListProjectUpdatesResponse: MessageFns<ListProjectUpdatesResponse> = {
  encode(message: ListProjectUpdatesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.updatesJson) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListProjectUpdatesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListProjectUpdatesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.updatesJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListProjectUpdatesResponse {
    return {
      updatesJson: globalThis.Array.isArray(object?.updatesJson)
        ? object.updatesJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.updates_json)
        ? object.updates_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ListProjectUpdatesResponse): unknown {
    const obj: any = {};
    if (message.updatesJson?.length) {
      obj.updatesJson = message.updatesJson;
    }
    return obj;
  },

  create(base?: DeepPartial<ListProjectUpdatesResponse>): ListProjectUpdatesResponse {
    return ListProjectUpdatesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListProjectUpdatesResponse>): ListProjectUpdatesResponse {
    const message = createBaseListProjectUpdatesResponse();
    message.updatesJson = object.updatesJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseListGoalUpdatesResponse(): ListGoalUpdatesResponse {
  return { updatesJson: [] };
}

export const ListGoalUpdatesResponse: MessageFns<ListGoalUpdatesResponse> = {
  encode(message: ListGoalUpdatesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.updatesJson) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListGoalUpdatesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListGoalUpdatesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.updatesJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListGoalUpdatesResponse {
    return {
      updatesJson: globalThis.Array.isArray(object?.updatesJson)
        ? object.updatesJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.updates_json)
        ? object.updates_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ListGoalUpdatesResponse): unknown {
    const obj: any = {};
    if (message.updatesJson?.length) {
      obj.updatesJson = message.updatesJson;
    }
    return obj;
  },

  create(base?: DeepPartial<ListGoalUpdatesResponse>): ListGoalUpdatesResponse {
    return ListGoalUpdatesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListGoalUpdatesResponse>): ListGoalUpdatesResponse {
    const message = createBaseListGoalUpdatesResponse();
    message.updatesJson = object.updatesJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseListInsightUpdatesResponse(): ListInsightUpdatesResponse {
  return { updatesJson: [] };
}

export const ListInsightUpdatesResponse: MessageFns<ListInsightUpdatesResponse> = {
  encode(message: ListInsightUpdatesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.updatesJson) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListInsightUpdatesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListInsightUpdatesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.updatesJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListInsightUpdatesResponse {
    return {
      updatesJson: globalThis.Array.isArray(object?.updatesJson)
        ? object.updatesJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.updates_json)
        ? object.updates_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ListInsightUpdatesResponse): unknown {
    const obj: any = {};
    if (message.updatesJson?.length) {
      obj.updatesJson = message.updatesJson;
    }
    return obj;
  },

  create(base?: DeepPartial<ListInsightUpdatesResponse>): ListInsightUpdatesResponse {
    return ListInsightUpdatesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListInsightUpdatesResponse>): ListInsightUpdatesResponse {
    const message = createBaseListInsightUpdatesResponse();
    message.updatesJson = object.updatesJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetProjectSignalsAndChangesResponse(): GetProjectSignalsAndChangesResponse {
  return { signalsJson: [], changesJson: [], personsJson: [] };
}

export const GetProjectSignalsAndChangesResponse: MessageFns<GetProjectSignalsAndChangesResponse> = {
  encode(message: GetProjectSignalsAndChangesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.signalsJson) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.changesJson) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.personsJson) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetProjectSignalsAndChangesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetProjectSignalsAndChangesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.signalsJson.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.changesJson.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.personsJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetProjectSignalsAndChangesResponse {
    return {
      signalsJson: globalThis.Array.isArray(object?.signalsJson)
        ? object.signalsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.signals_json)
        ? object.signals_json.map((e: any) => globalThis.String(e))
        : [],
      changesJson: globalThis.Array.isArray(object?.changesJson)
        ? object.changesJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.changes_json)
        ? object.changes_json.map((e: any) => globalThis.String(e))
        : [],
      personsJson: globalThis.Array.isArray(object?.personsJson)
        ? object.personsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.persons_json)
        ? object.persons_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetProjectSignalsAndChangesResponse): unknown {
    const obj: any = {};
    if (message.signalsJson?.length) {
      obj.signalsJson = message.signalsJson;
    }
    if (message.changesJson?.length) {
      obj.changesJson = message.changesJson;
    }
    if (message.personsJson?.length) {
      obj.personsJson = message.personsJson;
    }
    return obj;
  },

  create(base?: DeepPartial<GetProjectSignalsAndChangesResponse>): GetProjectSignalsAndChangesResponse {
    return GetProjectSignalsAndChangesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetProjectSignalsAndChangesResponse>): GetProjectSignalsAndChangesResponse {
    const message = createBaseGetProjectSignalsAndChangesResponse();
    message.signalsJson = object.signalsJson?.map((e) => e) || [];
    message.changesJson = object.changesJson?.map((e) => e) || [];
    message.personsJson = object.personsJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseListWorkspaceChatsRequest(): ListWorkspaceChatsRequest {
  return { companyId: 0 };
}

export const ListWorkspaceChatsRequest: MessageFns<ListWorkspaceChatsRequest> = {
  encode(message: ListWorkspaceChatsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListWorkspaceChatsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListWorkspaceChatsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListWorkspaceChatsRequest {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
    };
  },

  toJSON(message: ListWorkspaceChatsRequest): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    return obj;
  },

  create(base?: DeepPartial<ListWorkspaceChatsRequest>): ListWorkspaceChatsRequest {
    return ListWorkspaceChatsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListWorkspaceChatsRequest>): ListWorkspaceChatsRequest {
    const message = createBaseListWorkspaceChatsRequest();
    message.companyId = object.companyId ?? 0;
    return message;
  },
};

function createBaseListWorkspaceChatsResponse(): ListWorkspaceChatsResponse {
  return { chats: [] };
}

export const ListWorkspaceChatsResponse: MessageFns<ListWorkspaceChatsResponse> = {
  encode(message: ListWorkspaceChatsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.chats) {
      WorkspaceChat.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListWorkspaceChatsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListWorkspaceChatsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chats.push(WorkspaceChat.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListWorkspaceChatsResponse {
    return {
      chats: globalThis.Array.isArray(object?.chats) ? object.chats.map((e: any) => WorkspaceChat.fromJSON(e)) : [],
    };
  },

  toJSON(message: ListWorkspaceChatsResponse): unknown {
    const obj: any = {};
    if (message.chats?.length) {
      obj.chats = message.chats.map((e) => WorkspaceChat.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ListWorkspaceChatsResponse>): ListWorkspaceChatsResponse {
    return ListWorkspaceChatsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListWorkspaceChatsResponse>): ListWorkspaceChatsResponse {
    const message = createBaseListWorkspaceChatsResponse();
    message.chats = object.chats?.map((e) => WorkspaceChat.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateWorkspaceChatRequest(): CreateWorkspaceChatRequest {
  return { companyId: 0, details: undefined };
}

export const CreateWorkspaceChatRequest: MessageFns<CreateWorkspaceChatRequest> = {
  encode(message: CreateWorkspaceChatRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.companyId !== 0) {
      writer.uint32(8).int32(message.companyId);
    }
    if (message.details !== undefined) {
      WorkspaceChatDetails.encode(message.details, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateWorkspaceChatRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateWorkspaceChatRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.details = WorkspaceChatDetails.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateWorkspaceChatRequest {
    return {
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      details: isSet(object.details) ? WorkspaceChatDetails.fromJSON(object.details) : undefined,
    };
  },

  toJSON(message: CreateWorkspaceChatRequest): unknown {
    const obj: any = {};
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.details !== undefined) {
      obj.details = WorkspaceChatDetails.toJSON(message.details);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateWorkspaceChatRequest>): CreateWorkspaceChatRequest {
    return CreateWorkspaceChatRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateWorkspaceChatRequest>): CreateWorkspaceChatRequest {
    const message = createBaseCreateWorkspaceChatRequest();
    message.companyId = object.companyId ?? 0;
    message.details = (object.details !== undefined && object.details !== null)
      ? WorkspaceChatDetails.fromPartial(object.details)
      : undefined;
    return message;
  },
};

function createBaseCreateWorkspaceChatResponse(): CreateWorkspaceChatResponse {
  return { chat: undefined, warning: undefined };
}

export const CreateWorkspaceChatResponse: MessageFns<CreateWorkspaceChatResponse> = {
  encode(message: CreateWorkspaceChatResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chat !== undefined) {
      WorkspaceChat.encode(message.chat, writer.uint32(10).fork()).join();
    }
    if (message.warning !== undefined) {
      writer.uint32(18).string(message.warning);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateWorkspaceChatResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateWorkspaceChatResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chat = WorkspaceChat.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.warning = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateWorkspaceChatResponse {
    return {
      chat: isSet(object.chat) ? WorkspaceChat.fromJSON(object.chat) : undefined,
      warning: isSet(object.warning) ? globalThis.String(object.warning) : undefined,
    };
  },

  toJSON(message: CreateWorkspaceChatResponse): unknown {
    const obj: any = {};
    if (message.chat !== undefined) {
      obj.chat = WorkspaceChat.toJSON(message.chat);
    }
    if (message.warning !== undefined) {
      obj.warning = message.warning;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateWorkspaceChatResponse>): CreateWorkspaceChatResponse {
    return CreateWorkspaceChatResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateWorkspaceChatResponse>): CreateWorkspaceChatResponse {
    const message = createBaseCreateWorkspaceChatResponse();
    message.chat = (object.chat !== undefined && object.chat !== null)
      ? WorkspaceChat.fromPartial(object.chat)
      : undefined;
    message.warning = object.warning ?? undefined;
    return message;
  },
};

function createBaseGetWorkspaceChatRequest(): GetWorkspaceChatRequest {
  return { id: "", companyId: 0 };
}

export const GetWorkspaceChatRequest: MessageFns<GetWorkspaceChatRequest> = {
  encode(message: GetWorkspaceChatRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetWorkspaceChatRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetWorkspaceChatRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetWorkspaceChatRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
    };
  },

  toJSON(message: GetWorkspaceChatRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    return obj;
  },

  create(base?: DeepPartial<GetWorkspaceChatRequest>): GetWorkspaceChatRequest {
    return GetWorkspaceChatRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetWorkspaceChatRequest>): GetWorkspaceChatRequest {
    const message = createBaseGetWorkspaceChatRequest();
    message.id = object.id ?? "";
    message.companyId = object.companyId ?? 0;
    return message;
  },
};

function createBaseGetWorkspaceChatResponse(): GetWorkspaceChatResponse {
  return { chat: undefined };
}

export const GetWorkspaceChatResponse: MessageFns<GetWorkspaceChatResponse> = {
  encode(message: GetWorkspaceChatResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chat !== undefined) {
      WorkspaceChat.encode(message.chat, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetWorkspaceChatResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetWorkspaceChatResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chat = WorkspaceChat.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetWorkspaceChatResponse {
    return { chat: isSet(object.chat) ? WorkspaceChat.fromJSON(object.chat) : undefined };
  },

  toJSON(message: GetWorkspaceChatResponse): unknown {
    const obj: any = {};
    if (message.chat !== undefined) {
      obj.chat = WorkspaceChat.toJSON(message.chat);
    }
    return obj;
  },

  create(base?: DeepPartial<GetWorkspaceChatResponse>): GetWorkspaceChatResponse {
    return GetWorkspaceChatResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetWorkspaceChatResponse>): GetWorkspaceChatResponse {
    const message = createBaseGetWorkspaceChatResponse();
    message.chat = (object.chat !== undefined && object.chat !== null)
      ? WorkspaceChat.fromPartial(object.chat)
      : undefined;
    return message;
  },
};

function createBaseUpdateWorkspaceChatRequest(): UpdateWorkspaceChatRequest {
  return { id: "", companyId: 0, title: undefined, favorite: undefined };
}

export const UpdateWorkspaceChatRequest: MessageFns<UpdateWorkspaceChatRequest> = {
  encode(message: UpdateWorkspaceChatRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.companyId !== 0) {
      writer.uint32(16).int32(message.companyId);
    }
    if (message.title !== undefined) {
      writer.uint32(26).string(message.title);
    }
    if (message.favorite !== undefined) {
      writer.uint32(32).bool(message.favorite);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateWorkspaceChatRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateWorkspaceChatRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.favorite = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateWorkspaceChatRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      title: isSet(object.title) ? globalThis.String(object.title) : undefined,
      favorite: isSet(object.favorite) ? globalThis.Boolean(object.favorite) : undefined,
    };
  },

  toJSON(message: UpdateWorkspaceChatRequest): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.title !== undefined) {
      obj.title = message.title;
    }
    if (message.favorite !== undefined) {
      obj.favorite = message.favorite;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateWorkspaceChatRequest>): UpdateWorkspaceChatRequest {
    return UpdateWorkspaceChatRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateWorkspaceChatRequest>): UpdateWorkspaceChatRequest {
    const message = createBaseUpdateWorkspaceChatRequest();
    message.id = object.id ?? "";
    message.companyId = object.companyId ?? 0;
    message.title = object.title ?? undefined;
    message.favorite = object.favorite ?? undefined;
    return message;
  },
};

function createBaseUpdateWorkspaceChatResponse(): UpdateWorkspaceChatResponse {
  return { chat: undefined };
}

export const UpdateWorkspaceChatResponse: MessageFns<UpdateWorkspaceChatResponse> = {
  encode(message: UpdateWorkspaceChatResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chat !== undefined) {
      WorkspaceChat.encode(message.chat, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateWorkspaceChatResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateWorkspaceChatResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chat = WorkspaceChat.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateWorkspaceChatResponse {
    return { chat: isSet(object.chat) ? WorkspaceChat.fromJSON(object.chat) : undefined };
  },

  toJSON(message: UpdateWorkspaceChatResponse): unknown {
    const obj: any = {};
    if (message.chat !== undefined) {
      obj.chat = WorkspaceChat.toJSON(message.chat);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateWorkspaceChatResponse>): UpdateWorkspaceChatResponse {
    return UpdateWorkspaceChatResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateWorkspaceChatResponse>): UpdateWorkspaceChatResponse {
    const message = createBaseUpdateWorkspaceChatResponse();
    message.chat = (object.chat !== undefined && object.chat !== null)
      ? WorkspaceChat.fromPartial(object.chat)
      : undefined;
    return message;
  },
};

function createBaseDeleteWorkspaceChatResponse(): DeleteWorkspaceChatResponse {
  return {};
}

export const DeleteWorkspaceChatResponse: MessageFns<DeleteWorkspaceChatResponse> = {
  encode(_: DeleteWorkspaceChatResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteWorkspaceChatResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteWorkspaceChatResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DeleteWorkspaceChatResponse {
    return {};
  },

  toJSON(_: DeleteWorkspaceChatResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<DeleteWorkspaceChatResponse>): DeleteWorkspaceChatResponse {
    return DeleteWorkspaceChatResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<DeleteWorkspaceChatResponse>): DeleteWorkspaceChatResponse {
    const message = createBaseDeleteWorkspaceChatResponse();
    return message;
  },
};

function createBaseGenerateWorkspaceChatTitleRequest(): GenerateWorkspaceChatTitleRequest {
  return { message: "" };
}

export const GenerateWorkspaceChatTitleRequest: MessageFns<GenerateWorkspaceChatTitleRequest> = {
  encode(message: GenerateWorkspaceChatTitleRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== "") {
      writer.uint32(10).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateWorkspaceChatTitleRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateWorkspaceChatTitleRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateWorkspaceChatTitleRequest {
    return { message: isSet(object.message) ? globalThis.String(object.message) : "" };
  },

  toJSON(message: GenerateWorkspaceChatTitleRequest): unknown {
    const obj: any = {};
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create(base?: DeepPartial<GenerateWorkspaceChatTitleRequest>): GenerateWorkspaceChatTitleRequest {
    return GenerateWorkspaceChatTitleRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GenerateWorkspaceChatTitleRequest>): GenerateWorkspaceChatTitleRequest {
    const message = createBaseGenerateWorkspaceChatTitleRequest();
    message.message = object.message ?? "";
    return message;
  },
};

function createBaseGenerateWorkspaceChatTitleResponse(): GenerateWorkspaceChatTitleResponse {
  return { chat: undefined };
}

export const GenerateWorkspaceChatTitleResponse: MessageFns<GenerateWorkspaceChatTitleResponse> = {
  encode(message: GenerateWorkspaceChatTitleResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chat !== undefined) {
      WorkspaceChat.encode(message.chat, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateWorkspaceChatTitleResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateWorkspaceChatTitleResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chat = WorkspaceChat.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateWorkspaceChatTitleResponse {
    return { chat: isSet(object.chat) ? WorkspaceChat.fromJSON(object.chat) : undefined };
  },

  toJSON(message: GenerateWorkspaceChatTitleResponse): unknown {
    const obj: any = {};
    if (message.chat !== undefined) {
      obj.chat = WorkspaceChat.toJSON(message.chat);
    }
    return obj;
  },

  create(base?: DeepPartial<GenerateWorkspaceChatTitleResponse>): GenerateWorkspaceChatTitleResponse {
    return GenerateWorkspaceChatTitleResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GenerateWorkspaceChatTitleResponse>): GenerateWorkspaceChatTitleResponse {
    const message = createBaseGenerateWorkspaceChatTitleResponse();
    message.chat = (object.chat !== undefined && object.chat !== null)
      ? WorkspaceChat.fromPartial(object.chat)
      : undefined;
    return message;
  },
};

function createBaseGetWorkspaceChatActionPromptResponse(): GetWorkspaceChatActionPromptResponse {
  return { prompt: "" };
}

export const GetWorkspaceChatActionPromptResponse: MessageFns<GetWorkspaceChatActionPromptResponse> = {
  encode(message: GetWorkspaceChatActionPromptResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.prompt !== "") {
      writer.uint32(10).string(message.prompt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetWorkspaceChatActionPromptResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetWorkspaceChatActionPromptResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.prompt = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetWorkspaceChatActionPromptResponse {
    return { prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : "" };
  },

  toJSON(message: GetWorkspaceChatActionPromptResponse): unknown {
    const obj: any = {};
    if (message.prompt !== "") {
      obj.prompt = message.prompt;
    }
    return obj;
  },

  create(base?: DeepPartial<GetWorkspaceChatActionPromptResponse>): GetWorkspaceChatActionPromptResponse {
    return GetWorkspaceChatActionPromptResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetWorkspaceChatActionPromptResponse>): GetWorkspaceChatActionPromptResponse {
    const message = createBaseGetWorkspaceChatActionPromptResponse();
    message.prompt = object.prompt ?? "";
    return message;
  },
};

function createBaseHistoryHeatmapRequest(): HistoryHeatmapRequest {
  return { cadence: "", startDate: undefined, endDate: undefined };
}

export const HistoryHeatmapRequest: MessageFns<HistoryHeatmapRequest> = {
  encode(message: HistoryHeatmapRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cadence !== "") {
      writer.uint32(10).string(message.cadence);
    }
    if (message.startDate !== undefined) {
      Timestamp.encode(toTimestamp(message.startDate), writer.uint32(18).fork()).join();
    }
    if (message.endDate !== undefined) {
      Timestamp.encode(toTimestamp(message.endDate), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HistoryHeatmapRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoryHeatmapRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.cadence = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.startDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.endDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HistoryHeatmapRequest {
    return {
      cadence: isSet(object.cadence) ? globalThis.String(object.cadence) : "",
      startDate: isSet(object.startDate)
        ? fromJsonTimestamp(object.startDate)
        : isSet(object.start_date)
        ? fromJsonTimestamp(object.start_date)
        : undefined,
      endDate: isSet(object.endDate)
        ? fromJsonTimestamp(object.endDate)
        : isSet(object.end_date)
        ? fromJsonTimestamp(object.end_date)
        : undefined,
    };
  },

  toJSON(message: HistoryHeatmapRequest): unknown {
    const obj: any = {};
    if (message.cadence !== "") {
      obj.cadence = message.cadence;
    }
    if (message.startDate !== undefined) {
      obj.startDate = message.startDate.toISOString();
    }
    if (message.endDate !== undefined) {
      obj.endDate = message.endDate.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<HistoryHeatmapRequest>): HistoryHeatmapRequest {
    return HistoryHeatmapRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HistoryHeatmapRequest>): HistoryHeatmapRequest {
    const message = createBaseHistoryHeatmapRequest();
    message.cadence = object.cadence ?? "";
    message.startDate = object.startDate ?? undefined;
    message.endDate = object.endDate ?? undefined;
    return message;
  },
};

function createBaseHistoryHeatmapResponse(): HistoryHeatmapResponse {
  return { data: undefined };
}

export const HistoryHeatmapResponse: MessageFns<HistoryHeatmapResponse> = {
  encode(message: HistoryHeatmapResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      HistoryHeatmapData.encode(message.data, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HistoryHeatmapResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHistoryHeatmapResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = HistoryHeatmapData.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HistoryHeatmapResponse {
    return { data: isSet(object.data) ? HistoryHeatmapData.fromJSON(object.data) : undefined };
  },

  toJSON(message: HistoryHeatmapResponse): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = HistoryHeatmapData.toJSON(message.data);
    }
    return obj;
  },

  create(base?: DeepPartial<HistoryHeatmapResponse>): HistoryHeatmapResponse {
    return HistoryHeatmapResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HistoryHeatmapResponse>): HistoryHeatmapResponse {
    const message = createBaseHistoryHeatmapResponse();
    message.data = (object.data !== undefined && object.data !== null)
      ? HistoryHeatmapData.fromPartial(object.data)
      : undefined;
    return message;
  },
};

function createBaseListGoogleDriveFoldersRequest(): ListGoogleDriveFoldersRequest {
  return { query: undefined, pageToken: undefined, parentId: undefined };
}

export const ListGoogleDriveFoldersRequest: MessageFns<ListGoogleDriveFoldersRequest> = {
  encode(message: ListGoogleDriveFoldersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.query !== undefined) {
      writer.uint32(10).string(message.query);
    }
    if (message.pageToken !== undefined) {
      writer.uint32(18).string(message.pageToken);
    }
    if (message.parentId !== undefined) {
      writer.uint32(26).string(message.parentId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListGoogleDriveFoldersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListGoogleDriveFoldersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.query = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListGoogleDriveFoldersRequest {
    return {
      query: isSet(object.query) ? globalThis.String(object.query) : undefined,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : undefined,
      parentId: isSet(object.parentId)
        ? globalThis.String(object.parentId)
        : isSet(object.parent_id)
        ? globalThis.String(object.parent_id)
        : undefined,
    };
  },

  toJSON(message: ListGoogleDriveFoldersRequest): unknown {
    const obj: any = {};
    if (message.query !== undefined) {
      obj.query = message.query;
    }
    if (message.pageToken !== undefined) {
      obj.pageToken = message.pageToken;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    return obj;
  },

  create(base?: DeepPartial<ListGoogleDriveFoldersRequest>): ListGoogleDriveFoldersRequest {
    return ListGoogleDriveFoldersRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListGoogleDriveFoldersRequest>): ListGoogleDriveFoldersRequest {
    const message = createBaseListGoogleDriveFoldersRequest();
    message.query = object.query ?? undefined;
    message.pageToken = object.pageToken ?? undefined;
    message.parentId = object.parentId ?? undefined;
    return message;
  },
};

function createBaseListGoogleDriveFoldersResponse(): ListGoogleDriveFoldersResponse {
  return { folders: [], nextPageToken: undefined, files: [] };
}

export const ListGoogleDriveFoldersResponse: MessageFns<ListGoogleDriveFoldersResponse> = {
  encode(message: ListGoogleDriveFoldersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.folders) {
      GoogleDriveFolder.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.nextPageToken !== undefined) {
      writer.uint32(18).string(message.nextPageToken);
    }
    for (const v of message.files) {
      GoogleDriveFile.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListGoogleDriveFoldersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListGoogleDriveFoldersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.folders.push(GoogleDriveFolder.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.files.push(GoogleDriveFile.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListGoogleDriveFoldersResponse {
    return {
      folders: globalThis.Array.isArray(object?.folders)
        ? object.folders.map((e: any) => GoogleDriveFolder.fromJSON(e))
        : [],
      nextPageToken: isSet(object.nextPageToken)
        ? globalThis.String(object.nextPageToken)
        : isSet(object.next_page_token)
        ? globalThis.String(object.next_page_token)
        : undefined,
      files: globalThis.Array.isArray(object?.files) ? object.files.map((e: any) => GoogleDriveFile.fromJSON(e)) : [],
    };
  },

  toJSON(message: ListGoogleDriveFoldersResponse): unknown {
    const obj: any = {};
    if (message.folders?.length) {
      obj.folders = message.folders.map((e) => GoogleDriveFolder.toJSON(e));
    }
    if (message.nextPageToken !== undefined) {
      obj.nextPageToken = message.nextPageToken;
    }
    if (message.files?.length) {
      obj.files = message.files.map((e) => GoogleDriveFile.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ListGoogleDriveFoldersResponse>): ListGoogleDriveFoldersResponse {
    return ListGoogleDriveFoldersResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListGoogleDriveFoldersResponse>): ListGoogleDriveFoldersResponse {
    const message = createBaseListGoogleDriveFoldersResponse();
    message.folders = object.folders?.map((e) => GoogleDriveFolder.fromPartial(e)) || [];
    message.nextPageToken = object.nextPageToken ?? undefined;
    message.files = object.files?.map((e) => GoogleDriveFile.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAddGoogleDriveFolderRequest(): AddGoogleDriveFolderRequest {
  return { folderId: "", area: 0, workspace: false };
}

export const AddGoogleDriveFolderRequest: MessageFns<AddGoogleDriveFolderRequest> = {
  encode(message: AddGoogleDriveFolderRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.folderId !== "") {
      writer.uint32(10).string(message.folderId);
    }
    if (message.area !== 0) {
      writer.uint32(16).int32(message.area);
    }
    if (message.workspace !== false) {
      writer.uint32(32).bool(message.workspace);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddGoogleDriveFolderRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddGoogleDriveFolderRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.area = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.workspace = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddGoogleDriveFolderRequest {
    return {
      folderId: isSet(object.folderId)
        ? globalThis.String(object.folderId)
        : isSet(object.folder_id)
        ? globalThis.String(object.folder_id)
        : "",
      area: isSet(object.area) ? contextAreaFromJSON(object.area) : 0,
      workspace: isSet(object.workspace) ? globalThis.Boolean(object.workspace) : false,
    };
  },

  toJSON(message: AddGoogleDriveFolderRequest): unknown {
    const obj: any = {};
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.area !== 0) {
      obj.area = contextAreaToJSON(message.area);
    }
    if (message.workspace !== false) {
      obj.workspace = message.workspace;
    }
    return obj;
  },

  create(base?: DeepPartial<AddGoogleDriveFolderRequest>): AddGoogleDriveFolderRequest {
    return AddGoogleDriveFolderRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AddGoogleDriveFolderRequest>): AddGoogleDriveFolderRequest {
    const message = createBaseAddGoogleDriveFolderRequest();
    message.folderId = object.folderId ?? "";
    message.area = object.area ?? 0;
    message.workspace = object.workspace ?? false;
    return message;
  },
};

function createBaseAddGoogleDriveFolderResponse(): AddGoogleDriveFolderResponse {
  return { folderId: "", folderName: "", success: false, error: undefined };
}

export const AddGoogleDriveFolderResponse: MessageFns<AddGoogleDriveFolderResponse> = {
  encode(message: AddGoogleDriveFolderResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.folderId !== "") {
      writer.uint32(10).string(message.folderId);
    }
    if (message.folderName !== "") {
      writer.uint32(18).string(message.folderName);
    }
    if (message.success !== false) {
      writer.uint32(24).bool(message.success);
    }
    if (message.error !== undefined) {
      writer.uint32(34).string(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddGoogleDriveFolderResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddGoogleDriveFolderResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.folderName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.error = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddGoogleDriveFolderResponse {
    return {
      folderId: isSet(object.folderId)
        ? globalThis.String(object.folderId)
        : isSet(object.folder_id)
        ? globalThis.String(object.folder_id)
        : "",
      folderName: isSet(object.folderName)
        ? globalThis.String(object.folderName)
        : isSet(object.folder_name)
        ? globalThis.String(object.folder_name)
        : "",
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      error: isSet(object.error) ? globalThis.String(object.error) : undefined,
    };
  },

  toJSON(message: AddGoogleDriveFolderResponse): unknown {
    const obj: any = {};
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.folderName !== "") {
      obj.folderName = message.folderName;
    }
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.error !== undefined) {
      obj.error = message.error;
    }
    return obj;
  },

  create(base?: DeepPartial<AddGoogleDriveFolderResponse>): AddGoogleDriveFolderResponse {
    return AddGoogleDriveFolderResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AddGoogleDriveFolderResponse>): AddGoogleDriveFolderResponse {
    const message = createBaseAddGoogleDriveFolderResponse();
    message.folderId = object.folderId ?? "";
    message.folderName = object.folderName ?? "";
    message.success = object.success ?? false;
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseRemoveGoogleDriveFolderRequest(): RemoveGoogleDriveFolderRequest {
  return { folderId: "", area: 0, workspace: false };
}

export const RemoveGoogleDriveFolderRequest: MessageFns<RemoveGoogleDriveFolderRequest> = {
  encode(message: RemoveGoogleDriveFolderRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.folderId !== "") {
      writer.uint32(10).string(message.folderId);
    }
    if (message.area !== 0) {
      writer.uint32(16).int32(message.area);
    }
    if (message.workspace !== false) {
      writer.uint32(32).bool(message.workspace);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveGoogleDriveFolderRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveGoogleDriveFolderRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.area = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.workspace = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveGoogleDriveFolderRequest {
    return {
      folderId: isSet(object.folderId)
        ? globalThis.String(object.folderId)
        : isSet(object.folder_id)
        ? globalThis.String(object.folder_id)
        : "",
      area: isSet(object.area) ? contextAreaFromJSON(object.area) : 0,
      workspace: isSet(object.workspace) ? globalThis.Boolean(object.workspace) : false,
    };
  },

  toJSON(message: RemoveGoogleDriveFolderRequest): unknown {
    const obj: any = {};
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    if (message.area !== 0) {
      obj.area = contextAreaToJSON(message.area);
    }
    if (message.workspace !== false) {
      obj.workspace = message.workspace;
    }
    return obj;
  },

  create(base?: DeepPartial<RemoveGoogleDriveFolderRequest>): RemoveGoogleDriveFolderRequest {
    return RemoveGoogleDriveFolderRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RemoveGoogleDriveFolderRequest>): RemoveGoogleDriveFolderRequest {
    const message = createBaseRemoveGoogleDriveFolderRequest();
    message.folderId = object.folderId ?? "";
    message.area = object.area ?? 0;
    message.workspace = object.workspace ?? false;
    return message;
  },
};

function createBaseRemoveGoogleDriveFolderResponse(): RemoveGoogleDriveFolderResponse {
  return { success: false };
}

export const RemoveGoogleDriveFolderResponse: MessageFns<RemoveGoogleDriveFolderResponse> = {
  encode(message: RemoveGoogleDriveFolderResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveGoogleDriveFolderResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveGoogleDriveFolderResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveGoogleDriveFolderResponse {
    return { success: isSet(object.success) ? globalThis.Boolean(object.success) : false };
  },

  toJSON(message: RemoveGoogleDriveFolderResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    return obj;
  },

  create(base?: DeepPartial<RemoveGoogleDriveFolderResponse>): RemoveGoogleDriveFolderResponse {
    return RemoveGoogleDriveFolderResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RemoveGoogleDriveFolderResponse>): RemoveGoogleDriveFolderResponse {
    const message = createBaseRemoveGoogleDriveFolderResponse();
    message.success = object.success ?? false;
    return message;
  },
};

function createBaseAddGoogleDriveFileResponse(): AddGoogleDriveFileResponse {
  return { fileId: "", fileName: "", url: "", mimeType: "", success: false, error: undefined };
}

export const AddGoogleDriveFileResponse: MessageFns<AddGoogleDriveFileResponse> = {
  encode(message: AddGoogleDriveFileResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fileId !== "") {
      writer.uint32(10).string(message.fileId);
    }
    if (message.fileName !== "") {
      writer.uint32(18).string(message.fileName);
    }
    if (message.url !== "") {
      writer.uint32(26).string(message.url);
    }
    if (message.mimeType !== "") {
      writer.uint32(34).string(message.mimeType);
    }
    if (message.success !== false) {
      writer.uint32(40).bool(message.success);
    }
    if (message.error !== undefined) {
      writer.uint32(50).string(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddGoogleDriveFileResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddGoogleDriveFileResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.mimeType = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.error = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddGoogleDriveFileResponse {
    return {
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : "",
      fileName: isSet(object.fileName)
        ? globalThis.String(object.fileName)
        : isSet(object.file_name)
        ? globalThis.String(object.file_name)
        : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      mimeType: isSet(object.mimeType)
        ? globalThis.String(object.mimeType)
        : isSet(object.mime_type)
        ? globalThis.String(object.mime_type)
        : "",
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      error: isSet(object.error) ? globalThis.String(object.error) : undefined,
    };
  },

  toJSON(message: AddGoogleDriveFileResponse): unknown {
    const obj: any = {};
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.mimeType !== "") {
      obj.mimeType = message.mimeType;
    }
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.error !== undefined) {
      obj.error = message.error;
    }
    return obj;
  },

  create(base?: DeepPartial<AddGoogleDriveFileResponse>): AddGoogleDriveFileResponse {
    return AddGoogleDriveFileResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AddGoogleDriveFileResponse>): AddGoogleDriveFileResponse {
    const message = createBaseAddGoogleDriveFileResponse();
    message.fileId = object.fileId ?? "";
    message.fileName = object.fileName ?? "";
    message.url = object.url ?? "";
    message.mimeType = object.mimeType ?? "";
    message.success = object.success ?? false;
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseAttachGoogleDriveFolderInput(): AttachGoogleDriveFolderInput {
  return { folderId: "" };
}

export const AttachGoogleDriveFolderInput: MessageFns<AttachGoogleDriveFolderInput> = {
  encode(message: AttachGoogleDriveFolderInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.folderId !== "") {
      writer.uint32(10).string(message.folderId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachGoogleDriveFolderInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachGoogleDriveFolderInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.folderId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachGoogleDriveFolderInput {
    return {
      folderId: isSet(object.folderId)
        ? globalThis.String(object.folderId)
        : isSet(object.folder_id)
        ? globalThis.String(object.folder_id)
        : "",
    };
  },

  toJSON(message: AttachGoogleDriveFolderInput): unknown {
    const obj: any = {};
    if (message.folderId !== "") {
      obj.folderId = message.folderId;
    }
    return obj;
  },

  create(base?: DeepPartial<AttachGoogleDriveFolderInput>): AttachGoogleDriveFolderInput {
    return AttachGoogleDriveFolderInput.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachGoogleDriveFolderInput>): AttachGoogleDriveFolderInput {
    const message = createBaseAttachGoogleDriveFolderInput();
    message.folderId = object.folderId ?? "";
    return message;
  },
};

function createBaseAttachGoogleDriveFileInput(): AttachGoogleDriveFileInput {
  return { fileId: "", parentTitle: "" };
}

export const AttachGoogleDriveFileInput: MessageFns<AttachGoogleDriveFileInput> = {
  encode(message: AttachGoogleDriveFileInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fileId !== "") {
      writer.uint32(10).string(message.fileId);
    }
    if (message.parentTitle !== "") {
      writer.uint32(18).string(message.parentTitle);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachGoogleDriveFileInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachGoogleDriveFileInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.parentTitle = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachGoogleDriveFileInput {
    return {
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : "",
      parentTitle: isSet(object.parentTitle)
        ? globalThis.String(object.parentTitle)
        : isSet(object.parent_title)
        ? globalThis.String(object.parent_title)
        : "",
    };
  },

  toJSON(message: AttachGoogleDriveFileInput): unknown {
    const obj: any = {};
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    if (message.parentTitle !== "") {
      obj.parentTitle = message.parentTitle;
    }
    return obj;
  },

  create(base?: DeepPartial<AttachGoogleDriveFileInput>): AttachGoogleDriveFileInput {
    return AttachGoogleDriveFileInput.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachGoogleDriveFileInput>): AttachGoogleDriveFileInput {
    const message = createBaseAttachGoogleDriveFileInput();
    message.fileId = object.fileId ?? "";
    message.parentTitle = object.parentTitle ?? "";
    return message;
  },
};

function createBaseAttachGoogleDriveItemsRequest(): AttachGoogleDriveItemsRequest {
  return { folders: [], files: [], area: 0, workspace: false };
}

export const AttachGoogleDriveItemsRequest: MessageFns<AttachGoogleDriveItemsRequest> = {
  encode(message: AttachGoogleDriveItemsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.folders) {
      AttachGoogleDriveFolderInput.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.files) {
      AttachGoogleDriveFileInput.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.area !== 0) {
      writer.uint32(24).int32(message.area);
    }
    if (message.workspace !== false) {
      writer.uint32(32).bool(message.workspace);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachGoogleDriveItemsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachGoogleDriveItemsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.folders.push(AttachGoogleDriveFolderInput.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.files.push(AttachGoogleDriveFileInput.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.area = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.workspace = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachGoogleDriveItemsRequest {
    return {
      folders: globalThis.Array.isArray(object?.folders)
        ? object.folders.map((e: any) => AttachGoogleDriveFolderInput.fromJSON(e))
        : [],
      files: globalThis.Array.isArray(object?.files)
        ? object.files.map((e: any) => AttachGoogleDriveFileInput.fromJSON(e))
        : [],
      area: isSet(object.area) ? contextAreaFromJSON(object.area) : 0,
      workspace: isSet(object.workspace) ? globalThis.Boolean(object.workspace) : false,
    };
  },

  toJSON(message: AttachGoogleDriveItemsRequest): unknown {
    const obj: any = {};
    if (message.folders?.length) {
      obj.folders = message.folders.map((e) => AttachGoogleDriveFolderInput.toJSON(e));
    }
    if (message.files?.length) {
      obj.files = message.files.map((e) => AttachGoogleDriveFileInput.toJSON(e));
    }
    if (message.area !== 0) {
      obj.area = contextAreaToJSON(message.area);
    }
    if (message.workspace !== false) {
      obj.workspace = message.workspace;
    }
    return obj;
  },

  create(base?: DeepPartial<AttachGoogleDriveItemsRequest>): AttachGoogleDriveItemsRequest {
    return AttachGoogleDriveItemsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachGoogleDriveItemsRequest>): AttachGoogleDriveItemsRequest {
    const message = createBaseAttachGoogleDriveItemsRequest();
    message.folders = object.folders?.map((e) => AttachGoogleDriveFolderInput.fromPartial(e)) || [];
    message.files = object.files?.map((e) => AttachGoogleDriveFileInput.fromPartial(e)) || [];
    message.area = object.area ?? 0;
    message.workspace = object.workspace ?? false;
    return message;
  },
};

function createBaseAttachGoogleDriveItemsResponse(): AttachGoogleDriveItemsResponse {
  return { folders: [], files: [] };
}

export const AttachGoogleDriveItemsResponse: MessageFns<AttachGoogleDriveItemsResponse> = {
  encode(message: AttachGoogleDriveItemsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.folders) {
      AddGoogleDriveFolderResponse.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.files) {
      AddGoogleDriveFileResponse.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachGoogleDriveItemsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachGoogleDriveItemsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.folders.push(AddGoogleDriveFolderResponse.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.files.push(AddGoogleDriveFileResponse.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachGoogleDriveItemsResponse {
    return {
      folders: globalThis.Array.isArray(object?.folders)
        ? object.folders.map((e: any) => AddGoogleDriveFolderResponse.fromJSON(e))
        : [],
      files: globalThis.Array.isArray(object?.files)
        ? object.files.map((e: any) => AddGoogleDriveFileResponse.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AttachGoogleDriveItemsResponse): unknown {
    const obj: any = {};
    if (message.folders?.length) {
      obj.folders = message.folders.map((e) => AddGoogleDriveFolderResponse.toJSON(e));
    }
    if (message.files?.length) {
      obj.files = message.files.map((e) => AddGoogleDriveFileResponse.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<AttachGoogleDriveItemsResponse>): AttachGoogleDriveItemsResponse {
    return AttachGoogleDriveItemsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachGoogleDriveItemsResponse>): AttachGoogleDriveItemsResponse {
    const message = createBaseAttachGoogleDriveItemsResponse();
    message.folders = object.folders?.map((e) => AddGoogleDriveFolderResponse.fromPartial(e)) || [];
    message.files = object.files?.map((e) => AddGoogleDriveFileResponse.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRemoveGoogleDriveFileRequest(): RemoveGoogleDriveFileRequest {
  return { fileId: "" };
}

export const RemoveGoogleDriveFileRequest: MessageFns<RemoveGoogleDriveFileRequest> = {
  encode(message: RemoveGoogleDriveFileRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fileId !== "") {
      writer.uint32(10).string(message.fileId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveGoogleDriveFileRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveGoogleDriveFileRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveGoogleDriveFileRequest {
    return {
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : "",
    };
  },

  toJSON(message: RemoveGoogleDriveFileRequest): unknown {
    const obj: any = {};
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    return obj;
  },

  create(base?: DeepPartial<RemoveGoogleDriveFileRequest>): RemoveGoogleDriveFileRequest {
    return RemoveGoogleDriveFileRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RemoveGoogleDriveFileRequest>): RemoveGoogleDriveFileRequest {
    const message = createBaseRemoveGoogleDriveFileRequest();
    message.fileId = object.fileId ?? "";
    return message;
  },
};

function createBaseRemoveGoogleDriveFileResponse(): RemoveGoogleDriveFileResponse {
  return { success: false };
}

export const RemoveGoogleDriveFileResponse: MessageFns<RemoveGoogleDriveFileResponse> = {
  encode(message: RemoveGoogleDriveFileResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveGoogleDriveFileResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveGoogleDriveFileResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveGoogleDriveFileResponse {
    return { success: isSet(object.success) ? globalThis.Boolean(object.success) : false };
  },

  toJSON(message: RemoveGoogleDriveFileResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    return obj;
  },

  create(base?: DeepPartial<RemoveGoogleDriveFileResponse>): RemoveGoogleDriveFileResponse {
    return RemoveGoogleDriveFileResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RemoveGoogleDriveFileResponse>): RemoveGoogleDriveFileResponse {
    const message = createBaseRemoveGoogleDriveFileResponse();
    message.success = object.success ?? false;
    return message;
  },
};

function createBaseRemoveNotionRootRequest(): RemoveNotionRootRequest {
  return { rootId: "" };
}

export const RemoveNotionRootRequest: MessageFns<RemoveNotionRootRequest> = {
  encode(message: RemoveNotionRootRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rootId !== "") {
      writer.uint32(10).string(message.rootId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveNotionRootRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveNotionRootRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.rootId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveNotionRootRequest {
    return {
      rootId: isSet(object.rootId)
        ? globalThis.String(object.rootId)
        : isSet(object.root_id)
        ? globalThis.String(object.root_id)
        : "",
    };
  },

  toJSON(message: RemoveNotionRootRequest): unknown {
    const obj: any = {};
    if (message.rootId !== "") {
      obj.rootId = message.rootId;
    }
    return obj;
  },

  create(base?: DeepPartial<RemoveNotionRootRequest>): RemoveNotionRootRequest {
    return RemoveNotionRootRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RemoveNotionRootRequest>): RemoveNotionRootRequest {
    const message = createBaseRemoveNotionRootRequest();
    message.rootId = object.rootId ?? "";
    return message;
  },
};

function createBaseRemoveNotionRootResponse(): RemoveNotionRootResponse {
  return { success: false };
}

export const RemoveNotionRootResponse: MessageFns<RemoveNotionRootResponse> = {
  encode(message: RemoveNotionRootResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveNotionRootResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveNotionRootResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveNotionRootResponse {
    return { success: isSet(object.success) ? globalThis.Boolean(object.success) : false };
  },

  toJSON(message: RemoveNotionRootResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    return obj;
  },

  create(base?: DeepPartial<RemoveNotionRootResponse>): RemoveNotionRootResponse {
    return RemoveNotionRootResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RemoveNotionRootResponse>): RemoveNotionRootResponse {
    const message = createBaseRemoveNotionRootResponse();
    message.success = object.success ?? false;
    return message;
  },
};

function createBaseUpdateProjectPhaseDatesRequest(): UpdateProjectPhaseDatesRequest {
  return { details: undefined };
}

export const UpdateProjectPhaseDatesRequest: MessageFns<UpdateProjectPhaseDatesRequest> = {
  encode(message: UpdateProjectPhaseDatesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.details !== undefined) {
      ProjectDetails.encode(message.details, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateProjectPhaseDatesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateProjectPhaseDatesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.details = ProjectDetails.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateProjectPhaseDatesRequest {
    return { details: isSet(object.details) ? ProjectDetails.fromJSON(object.details) : undefined };
  },

  toJSON(message: UpdateProjectPhaseDatesRequest): unknown {
    const obj: any = {};
    if (message.details !== undefined) {
      obj.details = ProjectDetails.toJSON(message.details);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateProjectPhaseDatesRequest>): UpdateProjectPhaseDatesRequest {
    return UpdateProjectPhaseDatesRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateProjectPhaseDatesRequest>): UpdateProjectPhaseDatesRequest {
    const message = createBaseUpdateProjectPhaseDatesRequest();
    message.details = (object.details !== undefined && object.details !== null)
      ? ProjectDetails.fromPartial(object.details)
      : undefined;
    return message;
  },
};

function createBaseUpdateProjectPhaseDatesResponse(): UpdateProjectPhaseDatesResponse {
  return { project: undefined };
}

export const UpdateProjectPhaseDatesResponse: MessageFns<UpdateProjectPhaseDatesResponse> = {
  encode(message: UpdateProjectPhaseDatesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.project !== undefined) {
      ProjectEntity.encode(message.project, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateProjectPhaseDatesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateProjectPhaseDatesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.project = ProjectEntity.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateProjectPhaseDatesResponse {
    return { project: isSet(object.project) ? ProjectEntity.fromJSON(object.project) : undefined };
  },

  toJSON(message: UpdateProjectPhaseDatesResponse): unknown {
    const obj: any = {};
    if (message.project !== undefined) {
      obj.project = ProjectEntity.toJSON(message.project);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateProjectPhaseDatesResponse>): UpdateProjectPhaseDatesResponse {
    return UpdateProjectPhaseDatesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateProjectPhaseDatesResponse>): UpdateProjectPhaseDatesResponse {
    const message = createBaseUpdateProjectPhaseDatesResponse();
    message.project = (object.project !== undefined && object.project !== null)
      ? ProjectEntity.fromPartial(object.project)
      : undefined;
    return message;
  },
};

function createBaseUpdateProjectDescriptionRequest(): UpdateProjectDescriptionRequest {
  return { description: "" };
}

export const UpdateProjectDescriptionRequest: MessageFns<UpdateProjectDescriptionRequest> = {
  encode(message: UpdateProjectDescriptionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.description !== "") {
      writer.uint32(10).string(message.description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateProjectDescriptionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateProjectDescriptionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateProjectDescriptionRequest {
    return { description: isSet(object.description) ? globalThis.String(object.description) : "" };
  },

  toJSON(message: UpdateProjectDescriptionRequest): unknown {
    const obj: any = {};
    if (message.description !== "") {
      obj.description = message.description;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateProjectDescriptionRequest>): UpdateProjectDescriptionRequest {
    return UpdateProjectDescriptionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateProjectDescriptionRequest>): UpdateProjectDescriptionRequest {
    const message = createBaseUpdateProjectDescriptionRequest();
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseUpdateProjectDescriptionResponse(): UpdateProjectDescriptionResponse {
  return { project: undefined };
}

export const UpdateProjectDescriptionResponse: MessageFns<UpdateProjectDescriptionResponse> = {
  encode(message: UpdateProjectDescriptionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.project !== undefined) {
      ProjectEntity.encode(message.project, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateProjectDescriptionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateProjectDescriptionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.project = ProjectEntity.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateProjectDescriptionResponse {
    return { project: isSet(object.project) ? ProjectEntity.fromJSON(object.project) : undefined };
  },

  toJSON(message: UpdateProjectDescriptionResponse): unknown {
    const obj: any = {};
    if (message.project !== undefined) {
      obj.project = ProjectEntity.toJSON(message.project);
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateProjectDescriptionResponse>): UpdateProjectDescriptionResponse {
    return UpdateProjectDescriptionResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateProjectDescriptionResponse>): UpdateProjectDescriptionResponse {
    const message = createBaseUpdateProjectDescriptionResponse();
    message.project = (object.project !== undefined && object.project !== null)
      ? ProjectEntity.fromPartial(object.project)
      : undefined;
    return message;
  },
};

function createBaseAttachNotionItemsRequest(): AttachNotionItemsRequest {
  return { items: [] };
}

export const AttachNotionItemsRequest: MessageFns<AttachNotionItemsRequest> = {
  encode(message: AttachNotionItemsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      AttachNotionItem.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachNotionItemsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachNotionItemsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.items.push(AttachNotionItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachNotionItemsRequest {
    return {
      items: globalThis.Array.isArray(object?.items) ? object.items.map((e: any) => AttachNotionItem.fromJSON(e)) : [],
    };
  },

  toJSON(message: AttachNotionItemsRequest): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => AttachNotionItem.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<AttachNotionItemsRequest>): AttachNotionItemsRequest {
    return AttachNotionItemsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachNotionItemsRequest>): AttachNotionItemsRequest {
    const message = createBaseAttachNotionItemsRequest();
    message.items = object.items?.map((e) => AttachNotionItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAttachNotionItemsResponse(): AttachNotionItemsResponse {
  return { attachmentsJson: [] };
}

export const AttachNotionItemsResponse: MessageFns<AttachNotionItemsResponse> = {
  encode(message: AttachNotionItemsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.attachmentsJson) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachNotionItemsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachNotionItemsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachmentsJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachNotionItemsResponse {
    return {
      attachmentsJson: globalThis.Array.isArray(object?.attachmentsJson)
        ? object.attachmentsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.attachments_json)
        ? object.attachments_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: AttachNotionItemsResponse): unknown {
    const obj: any = {};
    if (message.attachmentsJson?.length) {
      obj.attachmentsJson = message.attachmentsJson;
    }
    return obj;
  },

  create(base?: DeepPartial<AttachNotionItemsResponse>): AttachNotionItemsResponse {
    return AttachNotionItemsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachNotionItemsResponse>): AttachNotionItemsResponse {
    const message = createBaseAttachNotionItemsResponse();
    message.attachmentsJson = object.attachmentsJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseListNotionAttachmentsResponse(): ListNotionAttachmentsResponse {
  return { attachmentsJson: [] };
}

export const ListNotionAttachmentsResponse: MessageFns<ListNotionAttachmentsResponse> = {
  encode(message: ListNotionAttachmentsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.attachmentsJson) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListNotionAttachmentsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListNotionAttachmentsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachmentsJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListNotionAttachmentsResponse {
    return {
      attachmentsJson: globalThis.Array.isArray(object?.attachmentsJson)
        ? object.attachmentsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.attachments_json)
        ? object.attachments_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ListNotionAttachmentsResponse): unknown {
    const obj: any = {};
    if (message.attachmentsJson?.length) {
      obj.attachmentsJson = message.attachmentsJson;
    }
    return obj;
  },

  create(base?: DeepPartial<ListNotionAttachmentsResponse>): ListNotionAttachmentsResponse {
    return ListNotionAttachmentsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListNotionAttachmentsResponse>): ListNotionAttachmentsResponse {
    const message = createBaseListNotionAttachmentsResponse();
    message.attachmentsJson = object.attachmentsJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseDetachNotionItemResponse(): DetachNotionItemResponse {
  return { success: false };
}

export const DetachNotionItemResponse: MessageFns<DetachNotionItemResponse> = {
  encode(message: DetachNotionItemResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DetachNotionItemResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDetachNotionItemResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DetachNotionItemResponse {
    return { success: isSet(object.success) ? globalThis.Boolean(object.success) : false };
  },

  toJSON(message: DetachNotionItemResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    return obj;
  },

  create(base?: DeepPartial<DetachNotionItemResponse>): DetachNotionItemResponse {
    return DetachNotionItemResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DetachNotionItemResponse>): DetachNotionItemResponse {
    const message = createBaseDetachNotionItemResponse();
    message.success = object.success ?? false;
    return message;
  },
};

function createBaseListNotionDatabaseChildrenResponse(): ListNotionDatabaseChildrenResponse {
  return { children: [] };
}

export const ListNotionDatabaseChildrenResponse: MessageFns<ListNotionDatabaseChildrenResponse> = {
  encode(message: ListNotionDatabaseChildrenResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.children) {
      NotionPageSummary.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListNotionDatabaseChildrenResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListNotionDatabaseChildrenResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.children.push(NotionPageSummary.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListNotionDatabaseChildrenResponse {
    return {
      children: globalThis.Array.isArray(object?.children)
        ? object.children.map((e: any) => NotionPageSummary.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListNotionDatabaseChildrenResponse): unknown {
    const obj: any = {};
    if (message.children?.length) {
      obj.children = message.children.map((e) => NotionPageSummary.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ListNotionDatabaseChildrenResponse>): ListNotionDatabaseChildrenResponse {
    return ListNotionDatabaseChildrenResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListNotionDatabaseChildrenResponse>): ListNotionDatabaseChildrenResponse {
    const message = createBaseListNotionDatabaseChildrenResponse();
    message.children = object.children?.map((e) => NotionPageSummary.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRemoveConfluenceRootRequest(): RemoveConfluenceRootRequest {
  return { rootId: "" };
}

export const RemoveConfluenceRootRequest: MessageFns<RemoveConfluenceRootRequest> = {
  encode(message: RemoveConfluenceRootRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rootId !== "") {
      writer.uint32(10).string(message.rootId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveConfluenceRootRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveConfluenceRootRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.rootId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveConfluenceRootRequest {
    return {
      rootId: isSet(object.rootId)
        ? globalThis.String(object.rootId)
        : isSet(object.root_id)
        ? globalThis.String(object.root_id)
        : "",
    };
  },

  toJSON(message: RemoveConfluenceRootRequest): unknown {
    const obj: any = {};
    if (message.rootId !== "") {
      obj.rootId = message.rootId;
    }
    return obj;
  },

  create(base?: DeepPartial<RemoveConfluenceRootRequest>): RemoveConfluenceRootRequest {
    return RemoveConfluenceRootRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RemoveConfluenceRootRequest>): RemoveConfluenceRootRequest {
    const message = createBaseRemoveConfluenceRootRequest();
    message.rootId = object.rootId ?? "";
    return message;
  },
};

function createBaseAttachConfluenceItemsRequest(): AttachConfluenceItemsRequest {
  return { items: [] };
}

export const AttachConfluenceItemsRequest: MessageFns<AttachConfluenceItemsRequest> = {
  encode(message: AttachConfluenceItemsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.items) {
      AttachConfluenceItem.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachConfluenceItemsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachConfluenceItemsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.items.push(AttachConfluenceItem.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachConfluenceItemsRequest {
    return {
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => AttachConfluenceItem.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AttachConfluenceItemsRequest): unknown {
    const obj: any = {};
    if (message.items?.length) {
      obj.items = message.items.map((e) => AttachConfluenceItem.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<AttachConfluenceItemsRequest>): AttachConfluenceItemsRequest {
    return AttachConfluenceItemsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachConfluenceItemsRequest>): AttachConfluenceItemsRequest {
    const message = createBaseAttachConfluenceItemsRequest();
    message.items = object.items?.map((e) => AttachConfluenceItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAttachConfluenceItemsResponse(): AttachConfluenceItemsResponse {
  return { attachmentsJson: [] };
}

export const AttachConfluenceItemsResponse: MessageFns<AttachConfluenceItemsResponse> = {
  encode(message: AttachConfluenceItemsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.attachmentsJson) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AttachConfluenceItemsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttachConfluenceItemsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachmentsJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AttachConfluenceItemsResponse {
    return {
      attachmentsJson: globalThis.Array.isArray(object?.attachmentsJson)
        ? object.attachmentsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.attachments_json)
        ? object.attachments_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: AttachConfluenceItemsResponse): unknown {
    const obj: any = {};
    if (message.attachmentsJson?.length) {
      obj.attachmentsJson = message.attachmentsJson;
    }
    return obj;
  },

  create(base?: DeepPartial<AttachConfluenceItemsResponse>): AttachConfluenceItemsResponse {
    return AttachConfluenceItemsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AttachConfluenceItemsResponse>): AttachConfluenceItemsResponse {
    const message = createBaseAttachConfluenceItemsResponse();
    message.attachmentsJson = object.attachmentsJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseListConfluenceAttachmentsResponse(): ListConfluenceAttachmentsResponse {
  return { attachmentsJson: [] };
}

export const ListConfluenceAttachmentsResponse: MessageFns<ListConfluenceAttachmentsResponse> = {
  encode(message: ListConfluenceAttachmentsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.attachmentsJson) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListConfluenceAttachmentsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListConfluenceAttachmentsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachmentsJson.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListConfluenceAttachmentsResponse {
    return {
      attachmentsJson: globalThis.Array.isArray(object?.attachmentsJson)
        ? object.attachmentsJson.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.attachments_json)
        ? object.attachments_json.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ListConfluenceAttachmentsResponse): unknown {
    const obj: any = {};
    if (message.attachmentsJson?.length) {
      obj.attachmentsJson = message.attachmentsJson;
    }
    return obj;
  },

  create(base?: DeepPartial<ListConfluenceAttachmentsResponse>): ListConfluenceAttachmentsResponse {
    return ListConfluenceAttachmentsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListConfluenceAttachmentsResponse>): ListConfluenceAttachmentsResponse {
    const message = createBaseListConfluenceAttachmentsResponse();
    message.attachmentsJson = object.attachmentsJson?.map((e) => e) || [];
    return message;
  },
};

function createBaseDetachConfluenceItemResponse(): DetachConfluenceItemResponse {
  return { success: false };
}

export const DetachConfluenceItemResponse: MessageFns<DetachConfluenceItemResponse> = {
  encode(message: DetachConfluenceItemResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DetachConfluenceItemResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDetachConfluenceItemResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DetachConfluenceItemResponse {
    return { success: isSet(object.success) ? globalThis.Boolean(object.success) : false };
  },

  toJSON(message: DetachConfluenceItemResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    return obj;
  },

  create(base?: DeepPartial<DetachConfluenceItemResponse>): DetachConfluenceItemResponse {
    return DetachConfluenceItemResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DetachConfluenceItemResponse>): DetachConfluenceItemResponse {
    const message = createBaseDetachConfluenceItemResponse();
    message.success = object.success ?? false;
    return message;
  },
};

function createBaseListConfluenceSpaceChildrenResponse(): ListConfluenceSpaceChildrenResponse {
  return { children: [] };
}

export const ListConfluenceSpaceChildrenResponse: MessageFns<ListConfluenceSpaceChildrenResponse> = {
  encode(message: ListConfluenceSpaceChildrenResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.children) {
      ConfluencePageSummary.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListConfluenceSpaceChildrenResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListConfluenceSpaceChildrenResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.children.push(ConfluencePageSummary.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListConfluenceSpaceChildrenResponse {
    return {
      children: globalThis.Array.isArray(object?.children)
        ? object.children.map((e: any) => ConfluencePageSummary.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListConfluenceSpaceChildrenResponse): unknown {
    const obj: any = {};
    if (message.children?.length) {
      obj.children = message.children.map((e) => ConfluencePageSummary.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ListConfluenceSpaceChildrenResponse>): ListConfluenceSpaceChildrenResponse {
    return ListConfluenceSpaceChildrenResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListConfluenceSpaceChildrenResponse>): ListConfluenceSpaceChildrenResponse {
    const message = createBaseListConfluenceSpaceChildrenResponse();
    message.children = object.children?.map((e) => ConfluencePageSummary.fromPartial(e)) || [];
    return message;
  },
};

function createBaseListConfluenceRootsResponse(): ListConfluenceRootsResponse {
  return { roots: [], cloudId: "" };
}

export const ListConfluenceRootsResponse: MessageFns<ListConfluenceRootsResponse> = {
  encode(message: ListConfluenceRootsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.roots) {
      ConfluenceRoot.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.cloudId !== "") {
      writer.uint32(18).string(message.cloudId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListConfluenceRootsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListConfluenceRootsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.roots.push(ConfluenceRoot.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cloudId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListConfluenceRootsResponse {
    return {
      roots: globalThis.Array.isArray(object?.roots) ? object.roots.map((e: any) => ConfluenceRoot.fromJSON(e)) : [],
      cloudId: isSet(object.cloudId)
        ? globalThis.String(object.cloudId)
        : isSet(object.cloud_id)
        ? globalThis.String(object.cloud_id)
        : "",
    };
  },

  toJSON(message: ListConfluenceRootsResponse): unknown {
    const obj: any = {};
    if (message.roots?.length) {
      obj.roots = message.roots.map((e) => ConfluenceRoot.toJSON(e));
    }
    if (message.cloudId !== "") {
      obj.cloudId = message.cloudId;
    }
    return obj;
  },

  create(base?: DeepPartial<ListConfluenceRootsResponse>): ListConfluenceRootsResponse {
    return ListConfluenceRootsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListConfluenceRootsResponse>): ListConfluenceRootsResponse {
    const message = createBaseListConfluenceRootsResponse();
    message.roots = object.roots?.map((e) => ConfluenceRoot.fromPartial(e)) || [];
    message.cloudId = object.cloudId ?? "";
    return message;
  },
};

function createBaseGetWorkspaceGraphSubgraphRequest(): GetWorkspaceGraphSubgraphRequest {
  return { rootType: 0, rootId: "", maxDegree: 0, nodeCap: 0, edgeCap: 0 };
}

export const GetWorkspaceGraphSubgraphRequest: MessageFns<GetWorkspaceGraphSubgraphRequest> = {
  encode(message: GetWorkspaceGraphSubgraphRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rootType !== 0) {
      writer.uint32(8).int32(message.rootType);
    }
    if (message.rootId !== "") {
      writer.uint32(18).string(message.rootId);
    }
    if (message.maxDegree !== 0) {
      writer.uint32(24).int32(message.maxDegree);
    }
    if (message.nodeCap !== 0) {
      writer.uint32(32).int32(message.nodeCap);
    }
    if (message.edgeCap !== 0) {
      writer.uint32(40).int32(message.edgeCap);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetWorkspaceGraphSubgraphRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetWorkspaceGraphSubgraphRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.rootType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.rootId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.maxDegree = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.nodeCap = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.edgeCap = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetWorkspaceGraphSubgraphRequest {
    return {
      rootType: isSet(object.rootType)
        ? workspaceGraphRootTypeFromJSON(object.rootType)
        : isSet(object.root_type)
        ? workspaceGraphRootTypeFromJSON(object.root_type)
        : 0,
      rootId: isSet(object.rootId)
        ? globalThis.String(object.rootId)
        : isSet(object.root_id)
        ? globalThis.String(object.root_id)
        : "",
      maxDegree: isSet(object.maxDegree)
        ? globalThis.Number(object.maxDegree)
        : isSet(object.max_degree)
        ? globalThis.Number(object.max_degree)
        : 0,
      nodeCap: isSet(object.nodeCap)
        ? globalThis.Number(object.nodeCap)
        : isSet(object.node_cap)
        ? globalThis.Number(object.node_cap)
        : 0,
      edgeCap: isSet(object.edgeCap)
        ? globalThis.Number(object.edgeCap)
        : isSet(object.edge_cap)
        ? globalThis.Number(object.edge_cap)
        : 0,
    };
  },

  toJSON(message: GetWorkspaceGraphSubgraphRequest): unknown {
    const obj: any = {};
    if (message.rootType !== 0) {
      obj.rootType = workspaceGraphRootTypeToJSON(message.rootType);
    }
    if (message.rootId !== "") {
      obj.rootId = message.rootId;
    }
    if (message.maxDegree !== 0) {
      obj.maxDegree = Math.round(message.maxDegree);
    }
    if (message.nodeCap !== 0) {
      obj.nodeCap = Math.round(message.nodeCap);
    }
    if (message.edgeCap !== 0) {
      obj.edgeCap = Math.round(message.edgeCap);
    }
    return obj;
  },

  create(base?: DeepPartial<GetWorkspaceGraphSubgraphRequest>): GetWorkspaceGraphSubgraphRequest {
    return GetWorkspaceGraphSubgraphRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetWorkspaceGraphSubgraphRequest>): GetWorkspaceGraphSubgraphRequest {
    const message = createBaseGetWorkspaceGraphSubgraphRequest();
    message.rootType = object.rootType ?? 0;
    message.rootId = object.rootId ?? "";
    message.maxDegree = object.maxDegree ?? 0;
    message.nodeCap = object.nodeCap ?? 0;
    message.edgeCap = object.edgeCap ?? 0;
    return message;
  },
};

function createBaseWorkspaceGraphProperty(): WorkspaceGraphProperty {
  return { name: "", valueType: 0, value: "" };
}

export const WorkspaceGraphProperty: MessageFns<WorkspaceGraphProperty> = {
  encode(message: WorkspaceGraphProperty, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.valueType !== 0) {
      writer.uint32(16).int32(message.valueType);
    }
    if (message.value !== "") {
      writer.uint32(26).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorkspaceGraphProperty {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorkspaceGraphProperty();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.valueType = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorkspaceGraphProperty {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      valueType: isSet(object.valueType)
        ? workspaceGraphPropertyValueTypeFromJSON(object.valueType)
        : isSet(object.value_type)
        ? workspaceGraphPropertyValueTypeFromJSON(object.value_type)
        : 0,
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: WorkspaceGraphProperty): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.valueType !== 0) {
      obj.valueType = workspaceGraphPropertyValueTypeToJSON(message.valueType);
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<WorkspaceGraphProperty>): WorkspaceGraphProperty {
    return WorkspaceGraphProperty.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WorkspaceGraphProperty>): WorkspaceGraphProperty {
    const message = createBaseWorkspaceGraphProperty();
    message.name = object.name ?? "";
    message.valueType = object.valueType ?? 0;
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseWorkspaceGraphNode(): WorkspaceGraphNode {
  return { id: "", type: "", label: "", properties: [], root: false };
}

export const WorkspaceGraphNode: MessageFns<WorkspaceGraphNode> = {
  encode(message: WorkspaceGraphNode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.type !== "") {
      writer.uint32(18).string(message.type);
    }
    if (message.label !== "") {
      writer.uint32(26).string(message.label);
    }
    for (const v of message.properties) {
      WorkspaceGraphProperty.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.root !== false) {
      writer.uint32(40).bool(message.root);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorkspaceGraphNode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorkspaceGraphNode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.label = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.properties.push(WorkspaceGraphProperty.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.root = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorkspaceGraphNode {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      properties: globalThis.Array.isArray(object?.properties)
        ? object.properties.map((e: any) => WorkspaceGraphProperty.fromJSON(e))
        : [],
      root: isSet(object.root) ? globalThis.Boolean(object.root) : false,
    };
  },

  toJSON(message: WorkspaceGraphNode): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.label !== "") {
      obj.label = message.label;
    }
    if (message.properties?.length) {
      obj.properties = message.properties.map((e) => WorkspaceGraphProperty.toJSON(e));
    }
    if (message.root !== false) {
      obj.root = message.root;
    }
    return obj;
  },

  create(base?: DeepPartial<WorkspaceGraphNode>): WorkspaceGraphNode {
    return WorkspaceGraphNode.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WorkspaceGraphNode>): WorkspaceGraphNode {
    const message = createBaseWorkspaceGraphNode();
    message.id = object.id ?? "";
    message.type = object.type ?? "";
    message.label = object.label ?? "";
    message.properties = object.properties?.map((e) => WorkspaceGraphProperty.fromPartial(e)) || [];
    message.root = object.root ?? false;
    return message;
  },
};

function createBaseWorkspaceGraphEdge(): WorkspaceGraphEdge {
  return { id: "", sourceId: "", targetId: "", type: "", properties: [] };
}

export const WorkspaceGraphEdge: MessageFns<WorkspaceGraphEdge> = {
  encode(message: WorkspaceGraphEdge, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.sourceId !== "") {
      writer.uint32(18).string(message.sourceId);
    }
    if (message.targetId !== "") {
      writer.uint32(26).string(message.targetId);
    }
    if (message.type !== "") {
      writer.uint32(34).string(message.type);
    }
    for (const v of message.properties) {
      WorkspaceGraphProperty.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): WorkspaceGraphEdge {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWorkspaceGraphEdge();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sourceId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.targetId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.properties.push(WorkspaceGraphProperty.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WorkspaceGraphEdge {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      sourceId: isSet(object.sourceId)
        ? globalThis.String(object.sourceId)
        : isSet(object.source_id)
        ? globalThis.String(object.source_id)
        : "",
      targetId: isSet(object.targetId)
        ? globalThis.String(object.targetId)
        : isSet(object.target_id)
        ? globalThis.String(object.target_id)
        : "",
      type: isSet(object.type) ? globalThis.String(object.type) : "",
      properties: globalThis.Array.isArray(object?.properties)
        ? object.properties.map((e: any) => WorkspaceGraphProperty.fromJSON(e))
        : [],
    };
  },

  toJSON(message: WorkspaceGraphEdge): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.sourceId !== "") {
      obj.sourceId = message.sourceId;
    }
    if (message.targetId !== "") {
      obj.targetId = message.targetId;
    }
    if (message.type !== "") {
      obj.type = message.type;
    }
    if (message.properties?.length) {
      obj.properties = message.properties.map((e) => WorkspaceGraphProperty.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<WorkspaceGraphEdge>): WorkspaceGraphEdge {
    return WorkspaceGraphEdge.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<WorkspaceGraphEdge>): WorkspaceGraphEdge {
    const message = createBaseWorkspaceGraphEdge();
    message.id = object.id ?? "";
    message.sourceId = object.sourceId ?? "";
    message.targetId = object.targetId ?? "";
    message.type = object.type ?? "";
    message.properties = object.properties?.map((e) => WorkspaceGraphProperty.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetWorkspaceGraphSubgraphResponse(): GetWorkspaceGraphSubgraphResponse {
  return { nodes: [], edges: [], truncated: false, nodeCap: 0, edgeCap: 0 };
}

export const GetWorkspaceGraphSubgraphResponse: MessageFns<GetWorkspaceGraphSubgraphResponse> = {
  encode(message: GetWorkspaceGraphSubgraphResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.nodes) {
      WorkspaceGraphNode.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.edges) {
      WorkspaceGraphEdge.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.truncated !== false) {
      writer.uint32(24).bool(message.truncated);
    }
    if (message.nodeCap !== 0) {
      writer.uint32(32).int32(message.nodeCap);
    }
    if (message.edgeCap !== 0) {
      writer.uint32(40).int32(message.edgeCap);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetWorkspaceGraphSubgraphResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetWorkspaceGraphSubgraphResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nodes.push(WorkspaceGraphNode.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.edges.push(WorkspaceGraphEdge.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.truncated = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.nodeCap = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.edgeCap = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetWorkspaceGraphSubgraphResponse {
    return {
      nodes: globalThis.Array.isArray(object?.nodes)
        ? object.nodes.map((e: any) => WorkspaceGraphNode.fromJSON(e))
        : [],
      edges: globalThis.Array.isArray(object?.edges)
        ? object.edges.map((e: any) => WorkspaceGraphEdge.fromJSON(e))
        : [],
      truncated: isSet(object.truncated) ? globalThis.Boolean(object.truncated) : false,
      nodeCap: isSet(object.nodeCap)
        ? globalThis.Number(object.nodeCap)
        : isSet(object.node_cap)
        ? globalThis.Number(object.node_cap)
        : 0,
      edgeCap: isSet(object.edgeCap)
        ? globalThis.Number(object.edgeCap)
        : isSet(object.edge_cap)
        ? globalThis.Number(object.edge_cap)
        : 0,
    };
  },

  toJSON(message: GetWorkspaceGraphSubgraphResponse): unknown {
    const obj: any = {};
    if (message.nodes?.length) {
      obj.nodes = message.nodes.map((e) => WorkspaceGraphNode.toJSON(e));
    }
    if (message.edges?.length) {
      obj.edges = message.edges.map((e) => WorkspaceGraphEdge.toJSON(e));
    }
    if (message.truncated !== false) {
      obj.truncated = message.truncated;
    }
    if (message.nodeCap !== 0) {
      obj.nodeCap = Math.round(message.nodeCap);
    }
    if (message.edgeCap !== 0) {
      obj.edgeCap = Math.round(message.edgeCap);
    }
    return obj;
  },

  create(base?: DeepPartial<GetWorkspaceGraphSubgraphResponse>): GetWorkspaceGraphSubgraphResponse {
    return GetWorkspaceGraphSubgraphResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetWorkspaceGraphSubgraphResponse>): GetWorkspaceGraphSubgraphResponse {
    const message = createBaseGetWorkspaceGraphSubgraphResponse();
    message.nodes = object.nodes?.map((e) => WorkspaceGraphNode.fromPartial(e)) || [];
    message.edges = object.edges?.map((e) => WorkspaceGraphEdge.fromPartial(e)) || [];
    message.truncated = object.truncated ?? false;
    message.nodeCap = object.nodeCap ?? 0;
    message.edgeCap = object.edgeCap ?? 0;
    return message;
  },
};

function createBaseGrantPlgRewardRequest(): GrantPlgRewardRequest {
  return { kind: 0 };
}

export const GrantPlgRewardRequest: MessageFns<GrantPlgRewardRequest> = {
  encode(message: GrantPlgRewardRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.kind !== 0) {
      writer.uint32(8).int32(message.kind);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GrantPlgRewardRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGrantPlgRewardRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.kind = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GrantPlgRewardRequest {
    return { kind: isSet(object.kind) ? plgRewardKindFromJSON(object.kind) : 0 };
  },

  toJSON(message: GrantPlgRewardRequest): unknown {
    const obj: any = {};
    if (message.kind !== 0) {
      obj.kind = plgRewardKindToJSON(message.kind);
    }
    return obj;
  },

  create(base?: DeepPartial<GrantPlgRewardRequest>): GrantPlgRewardRequest {
    return GrantPlgRewardRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GrantPlgRewardRequest>): GrantPlgRewardRequest {
    const message = createBaseGrantPlgRewardRequest();
    message.kind = object.kind ?? 0;
    return message;
  },
};

function createBaseGrantPlgRewardResponse(): GrantPlgRewardResponse {
  return {};
}

export const GrantPlgRewardResponse: MessageFns<GrantPlgRewardResponse> = {
  encode(_: GrantPlgRewardResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GrantPlgRewardResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGrantPlgRewardResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GrantPlgRewardResponse {
    return {};
  },

  toJSON(_: GrantPlgRewardResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create(base?: DeepPartial<GrantPlgRewardResponse>): GrantPlgRewardResponse {
    return GrantPlgRewardResponse.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<GrantPlgRewardResponse>): GrantPlgRewardResponse {
    const message = createBaseGrantPlgRewardResponse();
    return message;
  },
};

function createBaseCreateTicketBatchRequest(): CreateTicketBatchRequest {
  return { tickets: [] };
}

export const CreateTicketBatchRequest: MessageFns<CreateTicketBatchRequest> = {
  encode(message: CreateTicketBatchRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tickets) {
      TicketDraft.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateTicketBatchRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateTicketBatchRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tickets.push(TicketDraft.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateTicketBatchRequest {
    return {
      tickets: globalThis.Array.isArray(object?.tickets) ? object.tickets.map((e: any) => TicketDraft.fromJSON(e)) : [],
    };
  },

  toJSON(message: CreateTicketBatchRequest): unknown {
    const obj: any = {};
    if (message.tickets?.length) {
      obj.tickets = message.tickets.map((e) => TicketDraft.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<CreateTicketBatchRequest>): CreateTicketBatchRequest {
    return CreateTicketBatchRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateTicketBatchRequest>): CreateTicketBatchRequest {
    const message = createBaseCreateTicketBatchRequest();
    message.tickets = object.tickets?.map((e) => TicketDraft.fromPartial(e)) || [];
    return message;
  },
};

function createBaseTicketDraft(): TicketDraft {
  return { provider: 0, title: "", description: "", destinationId: "" };
}

export const TicketDraft: MessageFns<TicketDraft> = {
  encode(message: TicketDraft, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.provider !== 0) {
      writer.uint32(8).int32(message.provider);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.destinationId !== "") {
      writer.uint32(34).string(message.destinationId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TicketDraft {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTicketDraft();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.destinationId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TicketDraft {
    return {
      provider: isSet(object.provider) ? ticketProviderFromJSON(object.provider) : 0,
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      destinationId: isSet(object.destinationId)
        ? globalThis.String(object.destinationId)
        : isSet(object.destination_id)
        ? globalThis.String(object.destination_id)
        : "",
    };
  },

  toJSON(message: TicketDraft): unknown {
    const obj: any = {};
    if (message.provider !== 0) {
      obj.provider = ticketProviderToJSON(message.provider);
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.destinationId !== "") {
      obj.destinationId = message.destinationId;
    }
    return obj;
  },

  create(base?: DeepPartial<TicketDraft>): TicketDraft {
    return TicketDraft.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TicketDraft>): TicketDraft {
    const message = createBaseTicketDraft();
    message.provider = object.provider ?? 0;
    message.title = object.title ?? "";
    message.description = object.description ?? "";
    message.destinationId = object.destinationId ?? "";
    return message;
  },
};

function createBaseTicketCreationResult(): TicketCreationResult {
  return {
    index: 0,
    provider: 0,
    success: false,
    ticketId: undefined,
    identifier: undefined,
    url: undefined,
    error: undefined,
  };
}

export const TicketCreationResult: MessageFns<TicketCreationResult> = {
  encode(message: TicketCreationResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.index !== 0) {
      writer.uint32(8).int32(message.index);
    }
    if (message.provider !== 0) {
      writer.uint32(16).int32(message.provider);
    }
    if (message.success !== false) {
      writer.uint32(24).bool(message.success);
    }
    if (message.ticketId !== undefined) {
      writer.uint32(34).string(message.ticketId);
    }
    if (message.identifier !== undefined) {
      writer.uint32(42).string(message.identifier);
    }
    if (message.url !== undefined) {
      writer.uint32(50).string(message.url);
    }
    if (message.error !== undefined) {
      writer.uint32(58).string(message.error);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TicketCreationResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTicketCreationResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.index = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.provider = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ticketId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.identifier = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.error = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TicketCreationResult {
    return {
      index: isSet(object.index) ? globalThis.Number(object.index) : 0,
      provider: isSet(object.provider) ? ticketProviderFromJSON(object.provider) : 0,
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      ticketId: isSet(object.ticketId)
        ? globalThis.String(object.ticketId)
        : isSet(object.ticket_id)
        ? globalThis.String(object.ticket_id)
        : undefined,
      identifier: isSet(object.identifier) ? globalThis.String(object.identifier) : undefined,
      url: isSet(object.url) ? globalThis.String(object.url) : undefined,
      error: isSet(object.error) ? globalThis.String(object.error) : undefined,
    };
  },

  toJSON(message: TicketCreationResult): unknown {
    const obj: any = {};
    if (message.index !== 0) {
      obj.index = Math.round(message.index);
    }
    if (message.provider !== 0) {
      obj.provider = ticketProviderToJSON(message.provider);
    }
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.ticketId !== undefined) {
      obj.ticketId = message.ticketId;
    }
    if (message.identifier !== undefined) {
      obj.identifier = message.identifier;
    }
    if (message.url !== undefined) {
      obj.url = message.url;
    }
    if (message.error !== undefined) {
      obj.error = message.error;
    }
    return obj;
  },

  create(base?: DeepPartial<TicketCreationResult>): TicketCreationResult {
    return TicketCreationResult.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TicketCreationResult>): TicketCreationResult {
    const message = createBaseTicketCreationResult();
    message.index = object.index ?? 0;
    message.provider = object.provider ?? 0;
    message.success = object.success ?? false;
    message.ticketId = object.ticketId ?? undefined;
    message.identifier = object.identifier ?? undefined;
    message.url = object.url ?? undefined;
    message.error = object.error ?? undefined;
    return message;
  },
};

function createBaseCreateTicketBatchResponse(): CreateTicketBatchResponse {
  return { results: [] };
}

export const CreateTicketBatchResponse: MessageFns<CreateTicketBatchResponse> = {
  encode(message: CreateTicketBatchResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.results) {
      TicketCreationResult.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateTicketBatchResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateTicketBatchResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.results.push(TicketCreationResult.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateTicketBatchResponse {
    return {
      results: globalThis.Array.isArray(object?.results)
        ? object.results.map((e: any) => TicketCreationResult.fromJSON(e))
        : [],
    };
  },

  toJSON(message: CreateTicketBatchResponse): unknown {
    const obj: any = {};
    if (message.results?.length) {
      obj.results = message.results.map((e) => TicketCreationResult.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<CreateTicketBatchResponse>): CreateTicketBatchResponse {
    return CreateTicketBatchResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateTicketBatchResponse>): CreateTicketBatchResponse {
    const message = createBaseCreateTicketBatchResponse();
    message.results = object.results?.map((e) => TicketCreationResult.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetDashboardGenerationPromptResponse(): GetDashboardGenerationPromptResponse {
  return { prompt: "" };
}

export const GetDashboardGenerationPromptResponse: MessageFns<GetDashboardGenerationPromptResponse> = {
  encode(message: GetDashboardGenerationPromptResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.prompt !== "") {
      writer.uint32(10).string(message.prompt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDashboardGenerationPromptResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDashboardGenerationPromptResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.prompt = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDashboardGenerationPromptResponse {
    return { prompt: isSet(object.prompt) ? globalThis.String(object.prompt) : "" };
  },

  toJSON(message: GetDashboardGenerationPromptResponse): unknown {
    const obj: any = {};
    if (message.prompt !== "") {
      obj.prompt = message.prompt;
    }
    return obj;
  },

  create(base?: DeepPartial<GetDashboardGenerationPromptResponse>): GetDashboardGenerationPromptResponse {
    return GetDashboardGenerationPromptResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetDashboardGenerationPromptResponse>): GetDashboardGenerationPromptResponse {
    const message = createBaseGetDashboardGenerationPromptResponse();
    message.prompt = object.prompt ?? "";
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from((globalThis as any).Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return (globalThis as any).Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
